// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/nucleo-outline.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/nucleo-outline.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-outline.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-outline.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

 =========================================================
 * Now UI Kit Pro - v1.3.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit-pro
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*     brand Colors              */
/*      light colors         */
/* ========================================================================
 * bootstrap-switch - v3.3.2
 * http://www.bootstrap-switch.org
 * ========================================================================
 * Copyright 2012-2013 Mattia Larentis
 * http://www.apache.org/licenses/LICENSE-2.0
 */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  margin-bottom: 10px;
  line-height: 8px;
  width: 59px !important;
  height: 22px;
  outline: none;
  z-index: 0;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  margin-right: 20px;
  background: rgba(44, 44, 44, 0.2);
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 22px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 12px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  line-height: 11px;
  width: 50% !important;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {
  color: #fff;
  background: #f96332;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {
  color: #fff;
  background: #2CA8FF;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {
  color: #fff;
  background: #18ce0f;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {
  background: #FFB236;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {
  color: #fff;
  background: #FF3636;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px !important;
  margin: 0px -11px;
  border-radius: 20px;
  position: absolute;
  float: left;
  top: 0;
  left: 50%;
  padding: 0;
  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label {
  background-color: rgba(23, 23, 23, 0.4);
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -16px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 27px !important;
  margin-left: -11px;
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -39px !important;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label:before {
  background-color: #FFFFFF;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default {
  background-color: #FF3636;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default {
  background-color: #FFB236;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default {
  background-color: #18ce0f;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default {
  background-color: #f96332;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default {
  background-color: #2CA8FF;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green {
  background-color: #E3E3E3;
}

.bootstrap-switch-off .bootstrap-switch-handle-on {
  opacity: 0;
}

.bootstrap-switch-on .bootstrap-switch-handle-off {
  opacity: 0;
}

/*! nouislider - 13.1.4 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transform-origin: 0 0;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  position: absolute;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 1px;
}

.noUi-horizontal .noUi-handle {
  border-radius: 50%;
  background-color: #FFFFFF;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-top: -7px;
  outline: none;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -15px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #888888;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
  -webkit-transition: 300ms ease 0s;
  -moz-transition: 300ms ease 0s;
  -ms-transition: 300ms ease 0s;
  -o-transform: 300ms ease 0s;
  transition: 300ms ease 0s;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  display: none;
}

.noUi-handle:after {
  left: 17px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%, 0);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider.slider-neutral .noUi-connect, .slider.slider-neutral.noUi-connect {
  background-color: #FFFFFF;
}
.slider.slider-neutral.noUi-target {
  background-color: rgba(255, 255, 255, 0.3);
}
.slider.slider-neutral .noUi-handle {
  background-color: #FFFFFF;
}
.slider.slider-primary .noUi-connect, .slider.slider-primary.noUi-connect {
  background-color: #f96332;
}
.slider.slider-primary.noUi-target {
  background-color: rgba(249, 99, 50, 0.3);
}
.slider.slider-primary .noUi-handle {
  background-color: #f96332;
}
.slider.slider-info .noUi-connect, .slider.slider-info.noUi-connect {
  background-color: #2CA8FF;
}
.slider.slider-info.noUi-target {
  background-color: rgba(44, 168, 255, 0.3);
}
.slider.slider-info .noUi-handle {
  background-color: #2CA8FF;
}
.slider.slider-success .noUi-connect, .slider.slider-success.noUi-connect {
  background-color: #18ce0f;
}
.slider.slider-success.noUi-target {
  background-color: rgba(24, 206, 15, 0.3);
}
.slider.slider-success .noUi-handle {
  background-color: #18ce0f;
}
.slider.slider-warning .noUi-connect, .slider.slider-warning.noUi-connect {
  background-color: #FFB236;
}
.slider.slider-warning.noUi-target {
  background-color: rgba(255, 178, 54, 0.3);
}
.slider.slider-warning .noUi-handle {
  background-color: #FFB236;
}
.slider.slider-danger .noUi-connect, .slider.slider-danger.noUi-connect {
  background-color: #FF3636;
}
.slider.slider-danger.noUi-target {
  background-color: rgba(255, 54, 54, 0.3);
}
.slider.slider-danger .noUi-handle {
  background-color: #FF3636;
}

/*!
 * Bootstrap-select v1.13.1 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2018 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
.bootstrap-select > select.bs-select-hidden,
select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  width: 220px \\0 ;
  /*IE9 and below*/
}
.bootstrap-select > .dropdown-menu {
  overflow: visible !important;
}
.bootstrap-select .dropdown-item.active, .bootstrap-select .dropdown-item:active {
  background-color: inherit;
}
.bootstrap-select.dropup .dropdown-menu:not(.inner) {
  top: auto !important;
  bottom: 100%;
}

.bootstrap-select > .dropdown-toggle {
  position: relative;
  width: 100%;
  z-index: 1;
  text-align: right;
  white-space: nowrap;
  margin: 0;
}

.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
}

.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2;
}

.has-error .bootstrap-select .dropdown-toggle,
.error .bootstrap-select .dropdown-toggle,
.bootstrap-select.is-invalid .dropdown-toggle,
.was-validated .bootstrap-select .selectpicker:invalid + .dropdown-toggle {
  border-color: #b94a48;
}

.bootstrap-select.is-valid .dropdown-toggle,
.was-validated .bootstrap-select .selectpicker:valid + .dropdown-toggle {
  border-color: #28a745;
}

.bootstrap-select.fit-width {
  width: auto !important;
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
  width: 220px;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}

:not(.input-group) > .bootstrap-select.form-control:not([class*=col-]) {
  width: 100%;
}

.bootstrap-select.form-control.input-group-btn {
  z-index: auto;
}

.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.bootstrap-select:not(.input-group-btn),
.bootstrap-select[class*=col-] {
  float: none;
  display: inline-block;
  margin-left: 0;
}

.bootstrap-select.dropdown-menu-right,
.bootstrap-select[class*=col-].dropdown-menu-right,
.row .bootstrap-select[class*=col-].dropdown-menu-right {
  float: right;
}

.form-inline .bootstrap-select,
.form-horizontal .bootstrap-select,
.form-group .bootstrap-select {
  margin-bottom: 0;
}

.form-group-lg .bootstrap-select.form-control,
.form-group-sm .bootstrap-select.form-control {
  padding: 0;
}

.form-group-lg .bootstrap-select.form-control .dropdown-toggle,
.form-group-sm .bootstrap-select.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.bootstrap-select.form-control-sm .dropdown-toggle,
.bootstrap-select.form-control-lg .dropdown-toggle {
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.bootstrap-select.form-control-sm .dropdown-toggle {
  padding: 0.25rem 0.5rem;
}

.bootstrap-select.form-control-lg .dropdown-toggle {
  padding: 0.5rem 1rem;
}

.form-inline .bootstrap-select .form-control {
  width: 100%;
}

.bootstrap-select.disabled,
.bootstrap-select > .disabled {
  cursor: not-allowed;
}

.bootstrap-select.disabled:focus,
.bootstrap-select > .disabled:focus {
  outline: none !important;
}

.bootstrap-select.bs-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 0 !important;
  padding: 0 !important;
}

.bootstrap-select.bs-container .dropdown-menu {
  z-index: 1060;
}

.bootstrap-select .dropdown-toggle:before {
  content: "";
  display: inline-block;
}

.bootstrap-select .dropdown-toggle .filter-option {
  position: absolute;
  top: 0;
  left: 0;
  padding-top: inherit;
  padding-right: inherit;
  padding-bottom: inherit;
  padding-left: inherit;
  height: 100%;
  width: 100%;
  text-align: left;
  outline: none;
}

.bootstrap-select .dropdown-toggle .filter-option-inner {
  padding-right: inherit;
}

.bootstrap-select .dropdown-toggle .filter-option-inner-inner {
  overflow: hidden;
}

.bootstrap-select .dropdown-toggle .caret {
  position: absolute;
  top: 50%;
  right: 12px;
  margin-top: -2px;
  vertical-align: middle;
}

.input-group .bootstrap-select.form-control .dropdown-toggle {
  border-radius: inherit;
}

.bootstrap-select[class*=col-] .dropdown-toggle {
  width: 100%;
}

.bootstrap-select .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
}

.bootstrap-select .dropdown-menu > .inner:focus {
  outline: none !important;
}

.bootstrap-select .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
  border-radius: 0;
  box-shadow: none;
}

.bootstrap-select .dropdown-menu li {
  position: relative;
}

.bootstrap-select .dropdown-menu li.active small {
  color: #fff;
}

.bootstrap-select .dropdown-menu li.disabled a {
  cursor: not-allowed;
}

.bootstrap-select .dropdown-menu li a {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.bootstrap-select .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}

.bootstrap-select .dropdown-menu li a span.check-mark {
  display: none;
}

.bootstrap-select .dropdown-menu li a span.text {
  display: inline-block;
}

.bootstrap-select .dropdown-menu li small {
  padding-left: 0.5em;
}

.bootstrap-select .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: #f5f5f5;
  border: 1px solid #e3e3e3;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}

.bootstrap-select .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}

.bootstrap-select.fit-width .dropdown-toggle .filter-option {
  position: static;
  display: inline;
  padding: 0;
}

.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner,
.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner-inner {
  display: inline;
}

.bootstrap-select.fit-width .dropdown-toggle .caret {
  position: static;
  top: auto;
  margin-top: -1px;
}

.bootstrap-select.show-tick .dropdown-menu .selected span.check-mark {
  position: absolute;
  display: inline-block;
  right: 15px;
  top: 14px;
}

.bootstrap-select.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select .bs-ok-default:after {
  content: "";
  display: block;
  width: 0.5em;
  height: 1em;
  border-style: solid;
  border-width: 0 0.26em 0.26em 0;
  transform: rotate(45deg);
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {
  z-index: 1061;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:before {
  bottom: auto;
  top: -4px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:after {
  bottom: auto;
  top: -4px;
  border-top: 6px solid white;
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:before {
  right: 12px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:after {
  right: 13px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:before,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:before,
.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:after,
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:after {
  display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}

.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}

.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}

.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}


/*
 * bootstrap-tagsinput v0.8.0
 *
 */
.bootstrap-tagsinput {
  display: inline-block;
  padding: 4px 6px;
  max-width: 100%;
  line-height: 22px;
  background-color: transparent !important;
}
.bootstrap-tagsinput input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  margin: 0;
  width: 74px;
  max-width: inherit;
}
.bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}
.bootstrap-tagsinput.form-control input::-moz-placeholder {
  color: #777;
  opacity: 1;
}
.bootstrap-tagsinput.form-control input:-ms-input-placeholder, .bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
  color: #777;
}
.bootstrap-tagsinput .tag {
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 3px 8px;
  border-radius: 12px;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 0.75em;
  text-transform: uppercase;
  display: inline-block;
  line-height: 1.5em;
  padding-left: 0.8em;
}
.bootstrap-tagsinput .tag:hover {
  padding-right: 22px;
}
.bootstrap-tagsinput .tag:hover [data-role=remove] {
  opacity: 1;
  padding-right: 4px;
}
.bootstrap-tagsinput .tag [data-role=remove] {
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  opacity: 0;
  background-color: transparent;
}
.bootstrap-tagsinput .tag [data-role=remove]:after {
  font-family: "Nucleo Outline";
  content: "\\ea53";
  padding: 0px 2px;
}
.bootstrap-tagsinput.badge-primary .badge {
  background-color: #f96332;
  color: #FFFFFF;
  border: none;
}
.bootstrap-tagsinput.badge-primary .badge .tagsinput-remove-link {
  color: #FFFFFF;
}
.bootstrap-tagsinput.badge-primary .badge .tagsinput-add {
  color: #f96332;
}
.bootstrap-tagsinput.badge-info .badge {
  background-color: #2CA8FF;
  color: #FFFFFF;
  border: none;
}
.bootstrap-tagsinput.badge-info .badge .tagsinput-remove-link {
  color: #FFFFFF;
}
.bootstrap-tagsinput.badge-info .badge .tagsinput-add {
  color: #2CA8FF;
}
.bootstrap-tagsinput.badge-success .badge {
  background-color: #18ce0f;
  color: #FFFFFF;
  border: none;
}
.bootstrap-tagsinput.badge-success .badge .tagsinput-remove-link {
  color: #FFFFFF;
}
.bootstrap-tagsinput.badge-success .badge .tagsinput-add {
  color: #18ce0f;
}
.bootstrap-tagsinput.badge-warning .badge {
  background-color: #FFB236;
  color: #FFFFFF;
  border: none;
}
.bootstrap-tagsinput.badge-warning .badge .tagsinput-remove-link {
  color: #FFFFFF;
}
.bootstrap-tagsinput.badge-warning .badge .tagsinput-add {
  color: #FFB236;
}
.bootstrap-tagsinput.badge-danger .badge {
  background-color: #FF3636;
  color: #FFFFFF;
  border: none;
}
.bootstrap-tagsinput.badge-danger .badge .tagsinput-remove-link {
  color: #FFFFFF;
}
.bootstrap-tagsinput.badge-danger .badge .tagsinput-add {
  color: #FF3636;
}

.btn-file {
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.btn-file > input {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.fileinput {
  display: inline-block;
  margin-bottom: 9px;
}

.fileinput .form-control {
  display: inline-block;
  padding-top: 7px;
  padding-bottom: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: text;
}

.fileinput .thumbnail {
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 360px;
}
.fileinput .thumbnail.img-circle {
  border-radius: 50%;
  max-width: 100px;
}

.fileinput .thumbnail > img {
  max-height: 100%;
}

.fileinput .btn {
  vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput-inline .fileinput-controls {
  display: inline;
}

.fileinput-filename {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.form-control .fileinput-filename {
  vertical-align: bottom;
}

.fileinput.input-group {
  display: table;
}

.fileinput.input-group > * {
  position: relative;
  z-index: 2;
}

.fileinput.input-group > .btn-file {
  z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
  border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
  border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
  border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
  color: #FFB236;
}

.form-group.has-warning .fileinput .thumbnail {
  border-color: #FFB236;
}

.form-group.has-error .fileinput .fileinput-preview {
  color: #FF3636;
}

.form-group.has-error .fileinput .thumbnail {
  border-color: #FF3636;
}

.form-group.has-success .fileinput .fileinput-preview {
  color: #18ce0f;
}

.form-group.has-success .fileinput .thumbnail {
  border-color: #18ce0f;
}

.input-group-text:not(:first-child) {
  border-left: 0;
}

.thumbnail {
  border: 0 none;
  border-radius: 0;
  padding: 0;
}

.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after,
.bootstrap-datetimepicker-widget .btn[data-action=clear]::after,
.bootstrap-datetimepicker-widget .btn[data-action=today]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 8px 6px;
  width: 254px;
  max-width: 254px;
}
.bootstrap-datetimepicker-widget.dropdown-menu .now-ui-icons {
  opacity: 1;
  top: 2px;
}

@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #FFFFFF;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top:before {
  display: none;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -6px;
  right: auto;
  left: 10px;
  color: #FFFFFF;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
  padding: 0;
  border-width: 0;
  background-color: transparent;
}
.bootstrap-datetimepicker-widget a[data-action], .bootstrap-datetimepicker-widget a[data-action]:active {
  color: #66615B !important;
}

.bootstrap-datetimepicker-widget a[data-action=togglePicker],
.bootstrap-datetimepicker-widget a[data-action=togglePicker]:hover {
  color: #f96332;
}

.bootstrap-datetimepicker-widget a[data-action]:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 300;
  font-size: 1.5em;
  margin: 3px;
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget button[data-action] {
  width: 38px;
  border-color: transparent;
  background-color: #f96332 !important;
  color: #FFFFFF !important;
  height: 38px;
  padding: 0;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.bootstrap-datetimepicker-widget .btn {
  margin: 0 !important;
}
.bootstrap-datetimepicker-widget .btn:not([data-action=togglePeriod]):hover, .bootstrap-datetimepicker-widget .btn:not([data-action=togglePeriod]):active, .bootstrap-datetimepicker-widget .btn:not([data-action=togglePeriod]):focus {
  box-shadow: none !important;
  background-color: transparent !important;
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after {
  content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after {
  content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after {
  content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after {
  content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after {
  content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after {
  content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action=clear]::after {
  content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action=today]::after {
  content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 3px;
  color: #f96332;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 3px;
  margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}

.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
  font-weight: 300;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
  color: #f96332;
}

.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  color: #f96332;
  padding-bottom: 5px;
  padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #eee;
}

.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day > div,
.bootstrap-datetimepicker-widget table td.minute > div,
.bootstrap-datetimepicker-widget table td.hour > div {
  height: 30px;
  line-height: 2.2;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  position: relative;
  font-weight: 300;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: all 300ms ease 0s;
}

.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #eee;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {
  color: #888888;
}

.bootstrap-datetimepicker-widget table td.today > div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #68B3C8;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #f96332;
  color: #FFFFFF;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
}

.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 0 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td span:hover {
  background: #eee;
}

.bootstrap-datetimepicker-widget table td span.active {
  background-color: #f96332;
  color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td span.old {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-text {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
  text-align: center;
  z-index: 1;
  cursor: pointer;
}

input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .picker-switch,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table th.prev span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table th.next span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.day > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget a[data-action=togglePicker],
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget a[data-action=togglePicker]:hover,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .timepicker-hours span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .timepicker-minutes span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget .separator,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.minute > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.hour > div {
  color: #FFFFFF;
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table th.dow {
  color: rgba(255, 255, 255, 0.8);
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.old > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.new > div {
  color: rgba(255, 255, 255, 0.4);
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget button[data-action] {
  background-color: #FFFFFF !important;
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #FFFFFF;
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td:not(.active).day:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.hour:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.minute:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td.second:hover > div,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table td span:hover {
  background: rgba(255, 255, 255, 0.2);
}
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table thead tr:first-child th:hover span,
input.datetimepicker[data-color] + .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget {
  background-color: #f96332;
}
input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=orange] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #f96332 !important;
}

input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget {
  background-color: #2CA8FF;
}
input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=blue] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #2CA8FF;
}

input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget {
  background-color: #18ce0f;
}
input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=green] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #18ce0f;
}

input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget {
  background-color: #FF3636;
}
input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=red] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #FF3636;
}

input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget {
  background-color: #FFB236;
}
input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget table td.active > div,
input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget table td.active:hover > div,
input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget button[data-action], input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget.dropdown-menu.top:after, input.datetimepicker[data-color=yellow] + .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  color: #FFB236;
}

/* --------------------------------

Nucleo Outline Web Font - nucleoapp.com/
License - nucleoapp.com/license/
Created using IcoMoon - icomoon.io

-------------------------------- */
@font-face {
  font-family: "Nucleo Outline";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.now-ui-icons {
  display: inline-block;
  font: normal normal normal 14px/1 "Nucleo Outline";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
/*----------------------------------
  add a square/circle background
-----------------------------------*/
.now-ui-icons.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.now-ui-icons.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .now-ui-icons {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .now-ui-icons.circle {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.now-ui-icons.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
/*------------------------
	font icons
-------------------------*/
.now-ui-icons.ui-1_check:before {
  content: "\\ea22";
}

.now-ui-icons.ui-1_email-85:before {
  content: "\\ea2a";
}

.now-ui-icons.arrows-1_cloud-download-93:before {
  content: "\\ea21";
}

.now-ui-icons.arrows-1_cloud-upload-94:before {
  content: "\\ea24";
}

.now-ui-icons.arrows-1_minimal-down:before {
  content: "\\ea39";
}

.now-ui-icons.arrows-1_minimal-left:before {
  content: "\\ea3a";
}

.now-ui-icons.arrows-1_minimal-right:before {
  content: "\\ea3b";
}

.now-ui-icons.arrows-1_minimal-up:before {
  content: "\\ea3c";
}

.now-ui-icons.arrows-1_refresh-69:before {
  content: "\\ea44";
}

.now-ui-icons.arrows-1_share-66:before {
  content: "\\ea4c";
}

.now-ui-icons.business_badge:before {
  content: "\\ea09";
}

.now-ui-icons.business_bank:before {
  content: "\\ea0a";
}

.now-ui-icons.business_briefcase-24:before {
  content: "\\ea13";
}

.now-ui-icons.business_bulb-63:before {
  content: "\\ea15";
}

.now-ui-icons.business_chart-bar-32:before {
  content: "\\ea1e";
}

.now-ui-icons.business_chart-pie-36:before {
  content: "\\ea1f";
}

.now-ui-icons.business_globe:before {
  content: "\\ea2f";
}

.now-ui-icons.business_money-coins:before {
  content: "\\ea40";
}

.now-ui-icons.clothes_tie-bow:before {
  content: "\\ea5b";
}

.now-ui-icons.design_vector:before {
  content: "\\ea61";
}

.now-ui-icons.design_app:before {
  content: "\\ea08";
}

.now-ui-icons.design_bullet-list-67:before {
  content: "\\ea14";
}

.now-ui-icons.design_image:before {
  content: "\\ea33";
}

.now-ui-icons.design_palette:before {
  content: "\\ea41";
}

.now-ui-icons.design_scissors:before {
  content: "\\ea4a";
}

.now-ui-icons.design-2_html5:before {
  content: "\\ea32";
}

.now-ui-icons.design-2_ruler-pencil:before {
  content: "\\ea48";
}

.now-ui-icons.emoticons_satisfied:before {
  content: "\\ea49";
}

.now-ui-icons.files_box:before {
  content: "\\ea12";
}

.now-ui-icons.files_paper:before {
  content: "\\ea43";
}

.now-ui-icons.files_single-copy-04:before {
  content: "\\ea52";
}

.now-ui-icons.health_ambulance:before {
  content: "\\ea07";
}

.now-ui-icons.loader_gear:before {
  content: "\\ea4e";
}

.now-ui-icons.loader_refresh:before {
  content: "\\ea44";
}

.now-ui-icons.location_bookmark:before {
  content: "\\ea10";
}

.now-ui-icons.location_compass-05:before {
  content: "\\ea25";
}

.now-ui-icons.location_map-big:before {
  content: "\\ea3d";
}

.now-ui-icons.location_pin:before {
  content: "\\ea47";
}

.now-ui-icons.location_world:before {
  content: "\\ea63";
}

.now-ui-icons.media-1_album:before {
  content: "\\ea02";
}

.now-ui-icons.media-1_button-pause:before {
  content: "\\ea16";
}

.now-ui-icons.media-1_button-play:before {
  content: "\\ea18";
}

.now-ui-icons.media-1_button-power:before {
  content: "\\ea19";
}

.now-ui-icons.media-1_camera-compact:before {
  content: "\\ea1c";
}

.now-ui-icons.media-2_note-03:before {
  content: "\\ea3f";
}

.now-ui-icons.media-2_sound-wave:before {
  content: "\\ea57";
}

.now-ui-icons.objects_diamond:before {
  content: "\\ea29";
}

.now-ui-icons.objects_globe:before {
  content: "\\ea2f";
}

.now-ui-icons.objects_key-25:before {
  content: "\\ea38";
}

.now-ui-icons.objects_planet:before {
  content: "\\ea46";
}

.now-ui-icons.objects_spaceship:before {
  content: "\\ea55";
}

.now-ui-icons.objects_support-17:before {
  content: "\\ea56";
}

.now-ui-icons.objects_umbrella-13:before {
  content: "\\ea5f";
}

.now-ui-icons.education_agenda-bookmark:before {
  content: "\\ea01";
}

.now-ui-icons.education_atom:before {
  content: "\\ea0c";
}

.now-ui-icons.education_glasses:before {
  content: "\\ea2d";
}

.now-ui-icons.education_hat:before {
  content: "\\ea30";
}

.now-ui-icons.education_paper:before {
  content: "\\ea42";
}

.now-ui-icons.shopping_bag-16:before {
  content: "\\ea0d";
}

.now-ui-icons.shopping_basket:before {
  content: "\\ea0b";
}

.now-ui-icons.shopping_box:before {
  content: "\\ea11";
}

.now-ui-icons.shopping_cart-simple:before {
  content: "\\ea1d";
}

.now-ui-icons.shopping_credit-card:before {
  content: "\\ea28";
}

.now-ui-icons.shopping_delivery-fast:before {
  content: "\\ea27";
}

.now-ui-icons.shopping_shop:before {
  content: "\\ea50";
}

.now-ui-icons.shopping_tag-content:before {
  content: "\\ea59";
}

.now-ui-icons.sport_trophy:before {
  content: "\\ea5d";
}

.now-ui-icons.sport_user-run:before {
  content: "\\ea60";
}

.now-ui-icons.tech_controller-modern:before {
  content: "\\ea26";
}

.now-ui-icons.tech_headphones:before {
  content: "\\ea31";
}

.now-ui-icons.tech_laptop:before {
  content: "\\ea36";
}

.now-ui-icons.tech_mobile:before {
  content: "\\ea3e";
}

.now-ui-icons.tech_tablet:before {
  content: "\\ea58";
}

.now-ui-icons.tech_tv:before {
  content: "\\ea5e";
}

.now-ui-icons.tech_watch-time:before {
  content: "\\ea62";
}

.now-ui-icons.text_align-center:before {
  content: "\\ea05";
}

.now-ui-icons.text_align-left:before {
  content: "\\ea06";
}

.now-ui-icons.text_bold:before {
  content: "\\ea0e";
}

.now-ui-icons.text_caps-small:before {
  content: "\\ea1b";
}

.now-ui-icons.gestures_tap-01:before {
  content: "\\ea5a";
}

.now-ui-icons.transportation_air-baloon:before {
  content: "\\ea03";
}

.now-ui-icons.transportation_bus-front-12:before {
  content: "\\ea17";
}

.now-ui-icons.travel_info:before {
  content: "\\ea04";
}

.now-ui-icons.travel_istanbul:before {
  content: "\\ea34";
}

.now-ui-icons.ui-1_bell-53:before {
  content: "\\ea0f";
}

.now-ui-icons.ui-1_calendar-60:before {
  content: "\\ea1a";
}

.now-ui-icons.ui-1_lock-circle-open:before {
  content: "\\ea35";
}

.now-ui-icons.ui-1_send:before {
  content: "\\ea4d";
}

.now-ui-icons.ui-1_settings-gear-63:before {
  content: "\\ea4e";
}

.now-ui-icons.ui-1_simple-add:before {
  content: "\\ea4f";
}

.now-ui-icons.ui-1_simple-delete:before {
  content: "\\ea54";
}

.now-ui-icons.ui-1_simple-remove:before {
  content: "\\ea53";
}

.now-ui-icons.ui-1_zoom-bold:before {
  content: "\\ea64";
}

.now-ui-icons.ui-2_chat-round:before {
  content: "\\ea20";
}

.now-ui-icons.ui-2_favourite-28:before {
  content: "\\ea2b";
}

.now-ui-icons.ui-2_like:before {
  content: "\\ea37";
}

.now-ui-icons.ui-2_settings-90:before {
  content: "\\ea4b";
}

.now-ui-icons.ui-2_time-alarm:before {
  content: "\\ea5c";
}

.now-ui-icons.users_circle-08:before {
  content: "\\ea23";
}

.now-ui-icons.users_single-02:before {
  content: "\\ea51";
}

.all-icons .font-icon-detail {
  text-align: center;
  padding: 45px 0px 30px;
  border: 1px solid #e5e5e5;
  border-radius: 0.1875rem;
  margin: 15px 0;
  min-height: 168px;
}

.all-icons [class*=now-ui-icons] {
  font-size: 32px;
}

.all-icons .font-icon-detail p {
  margin: 25px auto 0;
  width: 100%;
  text-align: center;
  display: block;
  color: #B8B8B8;
  padding: 0 10px;
  font-size: 0.7142em;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #FFFFFF;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
}
.alert .alert-link {
  color: #FFFFFF;
  opacity: 0.8;
}
.alert.alert-success {
  background-color: rgba(24, 206, 15, 0.8);
}
.alert.alert-danger {
  background-color: rgba(255, 54, 54, 0.8);
}
.alert.alert-warning {
  background-color: rgba(255, 178, 54, 0.8);
}
.alert.alert-info {
  background-color: rgba(44, 168, 255, 0.8);
}
.alert.alert-primary {
  background-color: rgba(249, 99, 50, 0.8);
}
.alert .alert-icon {
  display: block;
  float: left;
  margin-right: 15px;
  margin-top: -1px;
}
.alert strong {
  text-transform: uppercase;
  font-size: 12px;
}
.alert i.fa,
.alert i.now-ui-icons {
  font-size: 20px;
}
.alert .close {
  color: #FFFFFF;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
  display: inline-block;
  cursor: pointer;
}

.form-check {
  margin-top: 0.65rem;
  padding-left: 0;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
  transition: color 0.3s linear;
}

.radio .form-check-sign {
  padding-left: 28px;
}

.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 26px;
  height: 26px;
  left: 0;
  cursor: pointer;
  border-radius: 3px;
  top: 0;
  background-color: transparent;
  border: 1px solid #E3E3E3;
  transition: opacity 0.3s linear;
}

.form-check .form-check-sign::after {
  font-family: "Nucleo Outline";
  content: "\\ea22";
  top: 0px;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #555555;
  border: 0;
  background-color: inherit;
}

.form-check.disabled .form-check-label,
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check input[type=checkbox]:disabled + .form-check-sign,
.form-check input[type=radio]:disabled + .form-check-sign {
  pointer-events: none;
}

.form-check-radio .form-check-sign::before,
.form-check-radio .form-check-sign::after {
  content: " ";
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E3E3E3;
  display: inline-block;
  position: absolute;
  left: 3px;
  top: 3px;
  padding: 1px;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  width: 4px;
  height: 4px;
  background-color: #555555;
  border-color: #555555;
  top: 11px;
  left: 11px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign {
  color: #9A9A9A;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

/*           badges             */
.badge {
  border-radius: 8px;
  padding: 4px 8px;
  text-transform: uppercase;
  font-size: 0.7142em;
  line-height: 12px;
  background-color: transparent;
  border: 1px solid;
  margin-bottom: 5px;
  color: #FFFFFF;
  border-radius: 0.875rem;
}
.badge:hover, .badge:focus {
  text-decoration: none;
}

.badge-icon {
  padding: 0.4em 0.55em;
}
.badge-icon i {
  font-size: 0.8em;
}

.badge-default, .badge-default[href]:focus, .badge-default[href]:hover {
  border-color: #888888;
  background-color: #888888;
  color: #FFFFFF;
}

.badge-primary, .badge-primary[href]:focus, .badge-primary[href]:hover {
  border-color: #f96332;
  background-color: #f96332;
  color: #FFFFFF;
}

.badge-info, .badge-info[href]:focus, .badge-info[href]:hover {
  border-color: #2CA8FF;
  background-color: #2CA8FF;
  color: #FFFFFF;
}

.badge-success, .badge-success[href]:focus, .badge-success[href]:hover {
  border-color: #18ce0f;
  background-color: #18ce0f;
  color: #FFFFFF;
}

.badge-warning, .badge-warning[href]:focus, .badge-warning[href]:hover {
  border-color: #FFB236;
  background-color: #FFB236;
  color: #FFFFFF;
}

.badge-danger, .badge-danger[href]:focus, .badge-danger[href]:hover {
  border-color: #FF3636;
  background-color: #FF3636;
  color: #FFFFFF;
}

.badge-neutral {
  color: inherit !important;
}
.badge-neutral, .badge-neutral[href]:focus, .badge-neutral[href]:hover {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
  color: #FFFFFF;
}

.pagination .page-item .page-link {
  border: 0;
  border-radius: 30px !important;
  transition: all 0.3s;
  padding: 0px 11px;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  box-shadow: none;
  height: 30px;
  line-height: 30px;
  color: #2c2c2c;
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  background: transparent;
}
.pagination .page-item .page-link:hover, .pagination .page-item .page-link:focus {
  color: #2c2c2c;
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}
.pagination .arrow-margin-left,
.pagination .arrow-margin-right {
  position: absolute;
}
.pagination .arrow-margin-right {
  right: 0;
}
.pagination .arrow-margin-left {
  left: 0;
}
.pagination .page-item.active > .page-link {
  color: #E3E3E3;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.pagination .page-item.active > .page-link, .pagination .page-item.active > .page-link:focus, .pagination .page-item.active > .page-link:hover {
  background-color: #888888;
  border-color: #888888;
  color: #FFFFFF;
}
.pagination .page-item.disabled > .page-link {
  opacity: 0.5;
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.pagination.pagination-info .page-item.active > .page-link, .pagination.pagination-info .page-item.active > .page-link:focus, .pagination.pagination-info .page-item.active > .page-link:hover {
  background-color: #2CA8FF;
  border-color: #2CA8FF;
}
.pagination.pagination-success .page-item.active > .page-link, .pagination.pagination-success .page-item.active > .page-link:focus, .pagination.pagination-success .page-item.active > .page-link:hover {
  background-color: #18ce0f;
  border-color: #18ce0f;
}
.pagination.pagination-primary .page-item.active > .page-link, .pagination.pagination-primary .page-item.active > .page-link:focus, .pagination.pagination-primary .page-item.active > .page-link:hover {
  background-color: #f96332;
  border-color: #f96332;
}
.pagination.pagination-warning .page-item.active > .page-link, .pagination.pagination-warning .page-item.active > .page-link:focus, .pagination.pagination-warning .page-item.active > .page-link:hover {
  background-color: #FFB236;
  border-color: #FFB236;
}
.pagination.pagination-danger .page-item.active > .page-link, .pagination.pagination-danger .page-item.active > .page-link:focus, .pagination.pagination-danger .page-item.active > .page-link:hover {
  background-color: #FF3636;
  border-color: #FF3636;
}
.pagination.pagination-neutral .page-item > .page-link {
  color: #FFFFFF;
}
.pagination.pagination-neutral .page-item > .page-link:focus, .pagination.pagination-neutral .page-item > .page-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.pagination.pagination-neutral .page-item.active > .page-link, .pagination.pagination-neutral .page-item.active > .page-link:focus, .pagination.pagination-neutral .page-item.active > .page-link:hover {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: #f96332;
}

.pagination-container {
  display: flex;
  align-items: center;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
}

small {
  font-size: 60%;
}

a {
  color: #f96332;
}
a:hover, a:focus {
  color: #f96332;
}

h1, .h1 {
  font-size: 3.5em;
  line-height: 1.15;
  margin-bottom: 30px;
}
h1 small, .h1 small {
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  font-size: 2.5em;
  margin-bottom: 30px;
}

h3, .h3 {
  font-size: 1.825em;
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  font-size: 1.5em;
  line-height: 1.45em;
  margin-top: 30px;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -5px;
}

h5, .h5 {
  font-size: 1.3em;
  line-height: 1.4em;
  margin-bottom: 15px;
}
h5.category, .h5.category {
  font-weight: 400;
}

h6, .h6 {
  font-size: 0.9em;
  font-weight: 700;
  text-transform: uppercase;
}

p {
  line-height: 1.61em;
  font-weight: 300;
  font-size: 1.2em;
}

.title {
  font-weight: 700;
  padding-top: 30px;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #2c2c2c;
  text-decoration: none;
}
.title + .category {
  margin-top: -25px;
}

.description,
.card-description,
.footer-big p {
  color: #9A9A9A;
  font-weight: 300;
}

.category {
  text-transform: capitalize;
  font-weight: 700;
  color: #9A9A9A;
}

.text-primary {
  color: #f96332 !important;
}

.text-info {
  color: #2CA8FF !important;
}

.text-success {
  color: #18ce0f !important;
}

.text-warning {
  color: #FFB236 !important;
}

.text-danger {
  color: #FF3636 !important;
}

.text-black {
  color: #444;
}

.blockquote {
  border-left: none;
  border: 1px solid #888888;
  padding: 20px;
  font-size: 1.1em;
  line-height: 1.8;
}
.blockquote small {
  color: #888888;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #f96332;
  color: #f96332;
}
.blockquote.blockquote-primary small {
  color: #f96332;
}
.blockquote.blockquote-danger {
  border-color: #FF3636;
  color: #FF3636;
}
.blockquote.blockquote-danger small {
  color: #FF3636;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #FFFFFF;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

body {
  color: #2c2c2c;
  font-size: 14px;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
  overflow-x: hidden;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.main {
  position: relative;
  background: #FFFFFF;
}

/* Animations */
.nav-pills .nav-link,
.nav-item .nav-link,
.navbar,
.nav-tabs .nav-link,
.tag,
.tag [data-role=remove] {
  transition: all 300ms ease 0s;
}

.card a,
.bootstrap-switch-label:before {
  transition: all 150ms ease 0s;
}

.dropdown-toggle:after,
[data-toggle=collapse][data-parent="#accordion"] i {
  transition: transform 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
[data-toggle=collapse][data-parent="#accordion"][aria-expanded=true] i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.button-bar {
  display: block;
  position: relative;
  width: 22px;
  height: 1px;
  border-radius: 1px;
  background: #FFFFFF;
}
.button-bar + .button-bar {
  margin-top: 7px;
}
.button-bar:nth-child(2) {
  width: 17px;
}

.separator-line {
  height: 2px;
  width: 44px;
  background-color: #888888;
  margin: 20px auto;
}
.separator-line.separator-primary {
  background-color: #f96332;
}

.section-space {
  height: 62px;
  display: block;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.title-up {
  text-transform: uppercase;
}

.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  font-weight: 400;
  font-size: 0.8571em;
  line-height: 1.35em;
  margin: 10px 1px;
  border: none;
  border-radius: 0.1875rem;
  padding: 11px 22px;
  cursor: pointer;
  background-color: #888888;
  color: #FFFFFF;
}
.btn:hover, .btn:focus, .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active, .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus, .btn:active:hover, .btn.active:hover, .show > .btn.dropdown-toggle, .show > .btn.dropdown-toggle:focus, .show > .btn.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled).active,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled):active:focus,
.navbar .navbar-nav > a.btn:not(:disabled):not(.disabled).active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:hover,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {
  background-color: #979797;
  color: #FFFFFF;
  box-shadow: none;
}
.btn:hover,
.navbar .navbar-nav > a.btn:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #888888;
  border-color: #888888;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #888888;
  border-color: #888888;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-simple:active:hover, .btn.btn-simple.active:hover, .show > .btn.btn-simple.dropdown-toggle, .show > .btn.btn-simple.dropdown-toggle:focus, .show > .btn.btn-simple.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled).active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active:focus,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled).active:focus,
.navbar .navbar-nav > a.btn.btn-simple:active:hover,
.navbar .navbar-nav > a.btn.btn-simple.active:hover,
.show > .navbar .navbar-nav > a.btn.btn-simple.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.btn-simple.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #979797;
  border-color: #979797;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #888888;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:not(:disabled):not(.disabled):active, .btn.btn-link:not(:disabled):not(.disabled).active, .btn.btn-link:not(:disabled):not(.disabled):active:focus, .btn.btn-link:not(:disabled):not(.disabled).active:focus, .btn.btn-link:active:hover, .btn.btn-link.active:hover, .show > .btn.btn-link.dropdown-toggle, .show > .btn.btn-link.dropdown-toggle:focus, .show > .btn.btn-link.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled).active,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled):active:focus,
.navbar .navbar-nav > a.btn.btn-link:not(:disabled):not(.disabled).active:focus,
.navbar .navbar-nav > a.btn.btn-link:active:hover,
.navbar .navbar-nav > a.btn.btn-link.active:hover,
.show > .navbar .navbar-nav > a.btn.btn-link.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.btn-link.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #979797;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon[class*=btn-outline-],
.navbar .navbar-nav > a.btn.btn-icon[class*=btn-outline-] {
  padding: 0;
}
.btn.btn-icon.btn-sm,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm i.fab,
.btn.btn-icon.btn-sm i.now-ui-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm i.fab,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm i.now-ui-icons {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg i.now-ui-icons,
.btn.btn-icon.btn-lg i.fab,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg i.now-ui-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg i.fab {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) i.now-ui-icons, .btn.btn-icon:not(.btn-footer) i.fab,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) i.now-ui-icons,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) i.fab {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 23px;
}
.btn:not(.btn-icon) .now-ui-icons,
.navbar .navbar-nav > a.btn:not(.btn-icon) .now-ui-icons {
  position: relative;
  top: 1px;
}

.btn-primary {
  background-color: #f96332;
  color: #FFFFFF;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:active:hover, .btn-primary.active:hover, .show > .btn-primary.dropdown-toggle, .show > .btn-primary.dropdown-toggle:focus, .show > .btn-primary.dropdown-toggle:hover {
  background-color: #fa7a50;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-primary:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #f96332;
  border-color: #f96332;
}
.btn-primary.btn-simple {
  color: #f96332;
  border-color: #f96332;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:not(:disabled):not(.disabled):active, .btn-primary.btn-simple:not(:disabled):not(.disabled).active, .btn-primary.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-primary.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-primary.btn-simple:active:hover, .btn-primary.btn-simple.active:hover, .show > .btn-primary.btn-simple.dropdown-toggle, .show > .btn-primary.btn-simple.dropdown-toggle:focus, .show > .btn-primary.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #fa7a50;
  border-color: #fa7a50;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #f96332;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:not(:disabled):not(.disabled):active, .btn-primary.btn-link:not(:disabled):not(.disabled).active, .btn-primary.btn-link:not(:disabled):not(.disabled):active:focus, .btn-primary.btn-link:not(:disabled):not(.disabled).active:focus, .btn-primary.btn-link:active:hover, .btn-primary.btn-link.active:hover, .show > .btn-primary.btn-link.dropdown-toggle, .show > .btn-primary.btn-link.dropdown-toggle:focus, .show > .btn-primary.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #fa7a50;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background-color: #18ce0f;
  color: #FFFFFF;
}
.btn-success:hover, .btn-success:focus, .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .btn-success:active:hover, .btn-success.active:hover, .show > .btn-success.dropdown-toggle, .show > .btn-success.dropdown-toggle:focus, .show > .btn-success.dropdown-toggle:hover {
  background-color: #1beb11;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-success:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #18ce0f;
  border-color: #18ce0f;
}
.btn-success.btn-simple {
  color: #18ce0f;
  border-color: #18ce0f;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:not(:disabled):not(.disabled):active, .btn-success.btn-simple:not(:disabled):not(.disabled).active, .btn-success.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-success.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-success.btn-simple:active:hover, .btn-success.btn-simple.active:hover, .show > .btn-success.btn-simple.dropdown-toggle, .show > .btn-success.btn-simple.dropdown-toggle:focus, .show > .btn-success.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #1beb11;
  border-color: #1beb11;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #18ce0f;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:not(:disabled):not(.disabled):active, .btn-success.btn-link:not(:disabled):not(.disabled).active, .btn-success.btn-link:not(:disabled):not(.disabled):active:focus, .btn-success.btn-link:not(:disabled):not(.disabled).active:focus, .btn-success.btn-link:active:hover, .btn-success.btn-link.active:hover, .show > .btn-success.btn-link.dropdown-toggle, .show > .btn-success.btn-link.dropdown-toggle:focus, .show > .btn-success.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #1beb11;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background-color: #2CA8FF;
  color: #FFFFFF;
}
.btn-info:hover, .btn-info:focus, .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .btn-info:active:hover, .btn-info.active:hover, .show > .btn-info.dropdown-toggle, .show > .btn-info.dropdown-toggle:focus, .show > .btn-info.dropdown-toggle:hover {
  background-color: #4bb5ff;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-info:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #2CA8FF;
  border-color: #2CA8FF;
}
.btn-info.btn-simple {
  color: #2CA8FF;
  border-color: #2CA8FF;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:not(:disabled):not(.disabled):active, .btn-info.btn-simple:not(:disabled):not(.disabled).active, .btn-info.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-info.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-info.btn-simple:active:hover, .btn-info.btn-simple.active:hover, .show > .btn-info.btn-simple.dropdown-toggle, .show > .btn-info.btn-simple.dropdown-toggle:focus, .show > .btn-info.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #4bb5ff;
  border-color: #4bb5ff;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #2CA8FF;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:not(:disabled):not(.disabled):active, .btn-info.btn-link:not(:disabled):not(.disabled).active, .btn-info.btn-link:not(:disabled):not(.disabled):active:focus, .btn-info.btn-link:not(:disabled):not(.disabled).active:focus, .btn-info.btn-link:active:hover, .btn-info.btn-link.active:hover, .show > .btn-info.btn-link.dropdown-toggle, .show > .btn-info.btn-link.dropdown-toggle:focus, .show > .btn-info.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #4bb5ff;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background-color: #FFB236;
  color: #FFFFFF;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .btn-warning:active:hover, .btn-warning.active:hover, .show > .btn-warning.dropdown-toggle, .show > .btn-warning.dropdown-toggle:focus, .show > .btn-warning.dropdown-toggle:hover {
  background-color: #ffbe55;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-warning:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #FFB236;
  border-color: #FFB236;
}
.btn-warning.btn-simple {
  color: #FFB236;
  border-color: #FFB236;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:not(:disabled):not(.disabled):active, .btn-warning.btn-simple:not(:disabled):not(.disabled).active, .btn-warning.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-warning.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-warning.btn-simple:active:hover, .btn-warning.btn-simple.active:hover, .show > .btn-warning.btn-simple.dropdown-toggle, .show > .btn-warning.btn-simple.dropdown-toggle:focus, .show > .btn-warning.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #ffbe55;
  border-color: #ffbe55;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #FFB236;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:not(:disabled):not(.disabled):active, .btn-warning.btn-link:not(:disabled):not(.disabled).active, .btn-warning.btn-link:not(:disabled):not(.disabled):active:focus, .btn-warning.btn-link:not(:disabled):not(.disabled).active:focus, .btn-warning.btn-link:active:hover, .btn-warning.btn-link.active:hover, .show > .btn-warning.btn-link.dropdown-toggle, .show > .btn-warning.btn-link.dropdown-toggle:focus, .show > .btn-warning.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #ffbe55;
  text-decoration: none;
  box-shadow: none;
}

.btn-danger {
  background-color: #FF3636;
  color: #FFFFFF;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .btn-danger:active:hover, .btn-danger.active:hover, .show > .btn-danger.dropdown-toggle, .show > .btn-danger.dropdown-toggle:focus, .show > .btn-danger.dropdown-toggle:hover {
  background-color: #ff5555;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-danger:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #FF3636;
  border-color: #FF3636;
}
.btn-danger.btn-simple {
  color: #FF3636;
  border-color: #FF3636;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:not(:disabled):not(.disabled):active, .btn-danger.btn-simple:not(:disabled):not(.disabled).active, .btn-danger.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-danger.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-danger.btn-simple:active:hover, .btn-danger.btn-simple.active:hover, .show > .btn-danger.btn-simple.dropdown-toggle, .show > .btn-danger.btn-simple.dropdown-toggle:focus, .show > .btn-danger.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #ff5555;
  border-color: #ff5555;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #FF3636;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:not(:disabled):not(.disabled):active, .btn-danger.btn-link:not(:disabled):not(.disabled).active, .btn-danger.btn-link:not(:disabled):not(.disabled):active:focus, .btn-danger.btn-link:not(:disabled):not(.disabled).active:focus, .btn-danger.btn-link:active:hover, .btn-danger.btn-link.active:hover, .show > .btn-danger.btn-link.dropdown-toggle, .show > .btn-danger.btn-link.dropdown-toggle:focus, .show > .btn-danger.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #ff5555;
  text-decoration: none;
  box-shadow: none;
}

.btn-neutral {
  background-color: #FFFFFF;
  color: #f96332;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .btn-neutral:active:hover, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF;
  color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral:hover {
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.17);
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-danger {
  color: #FF3636;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active {
  color: #ff5555 !important;
}
.btn-neutral.btn-primary {
  color: #f96332;
}
.btn-neutral.btn-primary:hover, .btn-neutral.btn-primary:focus, .btn-neutral.btn-primary:active {
  color: #fa7a50 !important;
}
.btn-neutral.btn-info {
  color: #2CA8FF;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active {
  color: #4bb5ff !important;
}
.btn-neutral.btn-warning {
  color: #FFB236;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active {
  color: #ffbe55 !important;
}
.btn-neutral.btn-success {
  color: #18ce0f;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active {
  color: #1beb11 !important;
}
.btn-neutral.btn-default {
  color: #888888;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active {
  color: #979797 !important;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .btn-neutral:active:hover, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF;
  color: #fa7a50;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #fa7a50 !important;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active, .btn-neutral.btn-simple:not(:disabled):not(.disabled).active, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active:focus, .btn-neutral.btn-simple:not(:disabled):not(.disabled).active:focus, .btn-neutral.btn-simple:active:hover, .btn-neutral.btn-simple.active:hover, .show > .btn-neutral.btn-simple.dropdown-toggle, .show > .btn-neutral.btn-simple.dropdown-toggle:focus, .show > .btn-neutral.btn-simple.dropdown-toggle:hover {
  background-color: transparent;
  color: #FFFFFF;
  border-color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #FFFFFF;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:not(:disabled):not(.disabled):active, .btn-neutral.btn-link:not(:disabled):not(.disabled).active, .btn-neutral.btn-link:not(:disabled):not(.disabled):active:focus, .btn-neutral.btn-link:not(:disabled):not(.disabled).active:focus, .btn-neutral.btn-link:active:hover, .btn-neutral.btn-link.active:hover, .show > .btn-neutral.btn-link.dropdown-toggle, .show > .btn-neutral.btn-link.dropdown-toggle:focus, .show > .btn-neutral.btn-link.dropdown-toggle:hover {
  background-color: transparent;
  color: #FFFFFF;
  text-decoration: none;
  box-shadow: none;
}

.btn-outline-primary {
  color: #f96332;
  border-color: #f96332;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .btn-outline-primary:active:hover, .btn-outline-primary.active:hover, .show > .btn-outline-primary.dropdown-toggle, .show > .btn-outline-primary.dropdown-toggle:focus, .show > .btn-outline-primary.dropdown-toggle:hover {
  background-color: transparent;
  color: #fa7a50;
  border-color: #fa7a50;
  box-shadow: none;
}

.btn-outline-success {
  color: #18ce0f;
  border-color: #18ce0f;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .btn-outline-success:active:hover, .btn-outline-success.active:hover, .show > .btn-outline-success.dropdown-toggle, .show > .btn-outline-success.dropdown-toggle:focus, .show > .btn-outline-success.dropdown-toggle:hover {
  background-color: transparent;
  color: #1beb11;
  border-color: #1beb11;
  box-shadow: none;
}

.btn-outline-info {
  color: #2CA8FF;
  border-color: #2CA8FF;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .btn-outline-info:active:hover, .btn-outline-info.active:hover, .show > .btn-outline-info.dropdown-toggle, .show > .btn-outline-info.dropdown-toggle:focus, .show > .btn-outline-info.dropdown-toggle:hover {
  background-color: transparent;
  color: #4bb5ff;
  border-color: #4bb5ff;
  box-shadow: none;
}

.btn-outline-warning {
  color: #FFB236;
  border-color: #FFB236;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .btn-outline-warning:active:hover, .btn-outline-warning.active:hover, .show > .btn-outline-warning.dropdown-toggle, .show > .btn-outline-warning.dropdown-toggle:focus, .show > .btn-outline-warning.dropdown-toggle:hover {
  background-color: transparent;
  color: #ffbe55;
  border-color: #ffbe55;
  box-shadow: none;
}

.btn-outline-danger {
  color: #FF3636;
  border-color: #FF3636;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .btn-outline-danger:active:hover, .btn-outline-danger.active:hover, .show > .btn-outline-danger.dropdown-toggle, .show > .btn-outline-danger.dropdown-toggle:focus, .show > .btn-outline-danger.dropdown-toggle:hover {
  background-color: transparent;
  color: #ff5555;
  border-color: #ff5555;
  box-shadow: none;
}

.btn-outline-default {
  color: #888888;
  border-color: #888888;
}
.btn-outline-default:hover, .btn-outline-default:focus, .btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .btn-outline-default:active:hover, .btn-outline-default.active:hover, .show > .btn-outline-default.dropdown-toggle, .show > .btn-outline-default.dropdown-toggle:focus, .show > .btn-outline-default.dropdown-toggle:hover {
  background-color: transparent;
  color: #979797;
  border-color: #979797;
  box-shadow: none;
}

.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 11px 23px;
}
.btn-round[class*=btn-outline-] {
  padding: 10px 22px;
}

[class*=btn-outline-] {
  border: 1px solid;
  padding: 10px 22px;
  background-color: transparent;
}

[class*=btn-outline-].disabled, [class*=btn-outline-].disabled:hover, [class*=btn-outline-].disabled:focus, [class*=btn-outline-].disabled.focus, [class*=btn-outline-].disabled:active, [class*=btn-outline-].disabled.active, [class*=btn-outline-]:disabled, [class*=btn-outline-]:disabled:hover, [class*=btn-outline-]:disabled:focus, [class*=btn-outline-]:disabled.focus, [class*=btn-outline-]:disabled:active, [class*=btn-outline-]:disabled.active, [class*=btn-outline-][disabled], [class*=btn-outline-][disabled]:hover, [class*=btn-outline-][disabled]:focus, [class*=btn-outline-][disabled].focus, [class*=btn-outline-][disabled]:active, [class*=btn-outline-][disabled].active, fieldset[disabled] [class*=btn-outline-], fieldset[disabled] [class*=btn-outline-]:hover, fieldset[disabled] [class*=btn-outline-]:focus, fieldset[disabled] [class*=btn-outline-].focus, fieldset[disabled] [class*=btn-outline-]:active, fieldset[disabled] [class*=btn-outline-].active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background-color: transparent;
}

.btn-lg {
  font-size: 1em;
  border-radius: 0.25rem;
  padding: 15px 48px;
}
.btn-lg[class*=btn-outline-] {
  padding: 14px 47px;
}

.btn-sm {
  font-size: 14px;
  border-radius: 0.1875rem;
  padding: 5px 15px;
}
.btn-sm[class*=btn-outline-] {
  padding: 4px 14px;
}

.btn-link {
  border: 0;
  padding: 0.5rem 0.7rem;
  background-color: transparent;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn.btn-facebook {
  background-color: #3b5998;
  color: #fff;
}
.btn.btn-facebook:hover, .btn.btn-facebook:focus, .btn.btn-facebook:not(:disabled):not(.disabled):active, .btn.btn-facebook:not(:disabled):not(.disabled).active, .btn.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn.btn-facebook:not(:disabled):not(.disabled).active:focus, .btn.btn-facebook:active:hover, .btn.btn-facebook.active:hover, .show > .btn.btn-facebook.dropdown-toggle, .show > .btn.btn-facebook.dropdown-toggle:focus, .show > .btn.btn-facebook.dropdown-toggle:hover {
  background-color: #4466ae;
  color: #fff;
}
.btn.btn-facebook.btn-simple {
  color: #3b5998;
  box-shadow: none;
  background-color: transparent;
  border-color: #3b5998;
}
.btn.btn-facebook.btn-simple:hover, .btn.btn-facebook.btn-simple:focus, .btn.btn-facebook.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-facebook.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-facebook.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-facebook.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-facebook.btn-simple:active:hover, .btn.btn-facebook.btn-simple.active:hover, .show > .btn.btn-facebook.btn-simple.dropdown-toggle, .show > .btn.btn-facebook.btn-simple.dropdown-toggle:focus, .show > .btn.btn-facebook.btn-simple.dropdown-toggle:hover {
  color: #4466ae;
  border-color: #4466ae;
  background-color: transparent;
}
.btn.btn-facebook.btn-neutral {
  color: #3b5998;
  background-color: #FFFFFF;
}
.btn.btn-facebook.btn-neutral:hover, .btn.btn-facebook.btn-neutral:focus, .btn.btn-facebook.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-facebook.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-facebook.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-facebook.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-facebook.btn-neutral:active:hover, .btn.btn-facebook.btn-neutral.active:hover, .show > .btn.btn-facebook.btn-neutral.dropdown-toggle, .show > .btn.btn-facebook.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-facebook.btn-neutral.dropdown-toggle:hover {
  color: #4466ae;
  background-color: #FFFFFF;
}
.btn.btn-twitter {
  background-color: #55acee;
  color: #fff;
}
.btn.btn-twitter:hover, .btn.btn-twitter:focus, .btn.btn-twitter:not(:disabled):not(.disabled):active, .btn.btn-twitter:not(:disabled):not(.disabled).active, .btn.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn.btn-twitter:not(:disabled):not(.disabled).active:focus, .btn.btn-twitter:active:hover, .btn.btn-twitter.active:hover, .show > .btn.btn-twitter.dropdown-toggle, .show > .btn.btn-twitter.dropdown-toggle:focus, .show > .btn.btn-twitter.dropdown-toggle:hover {
  background-color: #71baf1;
  color: #fff;
}
.btn.btn-twitter.btn-simple {
  color: #55acee;
  box-shadow: none;
  background-color: transparent;
  border-color: #55acee;
}
.btn.btn-twitter.btn-simple:hover, .btn.btn-twitter.btn-simple:focus, .btn.btn-twitter.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-twitter.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-twitter.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-twitter.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-twitter.btn-simple:active:hover, .btn.btn-twitter.btn-simple.active:hover, .show > .btn.btn-twitter.btn-simple.dropdown-toggle, .show > .btn.btn-twitter.btn-simple.dropdown-toggle:focus, .show > .btn.btn-twitter.btn-simple.dropdown-toggle:hover {
  color: #71baf1;
  border-color: #71baf1;
  background-color: transparent;
}
.btn.btn-twitter.btn-neutral {
  color: #55acee;
  background-color: #FFFFFF;
}
.btn.btn-twitter.btn-neutral:hover, .btn.btn-twitter.btn-neutral:focus, .btn.btn-twitter.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-twitter.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-twitter.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-twitter.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-twitter.btn-neutral:active:hover, .btn.btn-twitter.btn-neutral.active:hover, .show > .btn.btn-twitter.btn-neutral.dropdown-toggle, .show > .btn.btn-twitter.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-twitter.btn-neutral.dropdown-toggle:hover {
  color: #71baf1;
  background-color: #FFFFFF;
}
.btn.btn-pinterest {
  background-color: #cc2127;
  color: #fff;
}
.btn.btn-pinterest:hover, .btn.btn-pinterest:focus, .btn.btn-pinterest:not(:disabled):not(.disabled):active, .btn.btn-pinterest:not(:disabled):not(.disabled).active, .btn.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn.btn-pinterest:not(:disabled):not(.disabled).active:focus, .btn.btn-pinterest:active:hover, .btn.btn-pinterest.active:hover, .show > .btn.btn-pinterest.dropdown-toggle, .show > .btn.btn-pinterest.dropdown-toggle:focus, .show > .btn.btn-pinterest.dropdown-toggle:hover {
  background-color: #dd2e34;
  color: #fff;
}
.btn.btn-pinterest.btn-simple {
  color: #cc2127;
  box-shadow: none;
  background-color: transparent;
  border-color: #cc2127;
}
.btn.btn-pinterest.btn-simple:hover, .btn.btn-pinterest.btn-simple:focus, .btn.btn-pinterest.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-pinterest.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-pinterest.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-pinterest.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-pinterest.btn-simple:active:hover, .btn.btn-pinterest.btn-simple.active:hover, .show > .btn.btn-pinterest.btn-simple.dropdown-toggle, .show > .btn.btn-pinterest.btn-simple.dropdown-toggle:focus, .show > .btn.btn-pinterest.btn-simple.dropdown-toggle:hover {
  color: #dd2e34;
  border-color: #dd2e34;
  background-color: transparent;
}
.btn.btn-pinterest.btn-neutral {
  color: #cc2127;
  background-color: #FFFFFF;
}
.btn.btn-pinterest.btn-neutral:hover, .btn.btn-pinterest.btn-neutral:focus, .btn.btn-pinterest.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-pinterest.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-pinterest.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-pinterest.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-pinterest.btn-neutral:active:hover, .btn.btn-pinterest.btn-neutral.active:hover, .show > .btn.btn-pinterest.btn-neutral.dropdown-toggle, .show > .btn.btn-pinterest.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-pinterest.btn-neutral.dropdown-toggle:hover {
  color: #dd2e34;
  background-color: #FFFFFF;
}
.btn.btn-google {
  background-color: #dd4b39;
  color: #fff;
}
.btn.btn-google:hover, .btn.btn-google:focus, .btn.btn-google:not(:disabled):not(.disabled):active, .btn.btn-google:not(:disabled):not(.disabled).active, .btn.btn-google:not(:disabled):not(.disabled):active:focus, .btn.btn-google:not(:disabled):not(.disabled).active:focus, .btn.btn-google:active:hover, .btn.btn-google.active:hover, .show > .btn.btn-google.dropdown-toggle, .show > .btn.btn-google.dropdown-toggle:focus, .show > .btn.btn-google.dropdown-toggle:hover {
  background-color: #e16353;
  color: #fff;
}
.btn.btn-google.btn-simple {
  color: #dd4b39;
  box-shadow: none;
  background-color: transparent;
  border-color: #dd4b39;
}
.btn.btn-google.btn-simple:hover, .btn.btn-google.btn-simple:focus, .btn.btn-google.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-google.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-google.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-google.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-google.btn-simple:active:hover, .btn.btn-google.btn-simple.active:hover, .show > .btn.btn-google.btn-simple.dropdown-toggle, .show > .btn.btn-google.btn-simple.dropdown-toggle:focus, .show > .btn.btn-google.btn-simple.dropdown-toggle:hover {
  color: #e16353;
  border-color: #e16353;
  background-color: transparent;
}
.btn.btn-google.btn-neutral {
  color: #dd4b39;
  background-color: #FFFFFF;
}
.btn.btn-google.btn-neutral:hover, .btn.btn-google.btn-neutral:focus, .btn.btn-google.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-google.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-google.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-google.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-google.btn-neutral:active:hover, .btn.btn-google.btn-neutral.active:hover, .show > .btn.btn-google.btn-neutral.dropdown-toggle, .show > .btn.btn-google.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-google.btn-neutral.dropdown-toggle:hover {
  color: #e16353;
  background-color: #FFFFFF;
}
.btn.btn-linkedin {
  background-color: #0077B5;
  color: #fff;
}
.btn.btn-linkedin:hover, .btn.btn-linkedin:focus, .btn.btn-linkedin:not(:disabled):not(.disabled):active, .btn.btn-linkedin:not(:disabled):not(.disabled).active, .btn.btn-linkedin:not(:disabled):not(.disabled):active:focus, .btn.btn-linkedin:not(:disabled):not(.disabled).active:focus, .btn.btn-linkedin:active:hover, .btn.btn-linkedin.active:hover, .show > .btn.btn-linkedin.dropdown-toggle, .show > .btn.btn-linkedin.dropdown-toggle:focus, .show > .btn.btn-linkedin.dropdown-toggle:hover {
  background-color: #008bd4;
  color: #fff;
}
.btn.btn-linkedin.btn-simple {
  color: #0077B5;
  box-shadow: none;
  background-color: transparent;
  border-color: #0077B5;
}
.btn.btn-linkedin.btn-simple:hover, .btn.btn-linkedin.btn-simple:focus, .btn.btn-linkedin.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-linkedin.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-linkedin.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-linkedin.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-linkedin.btn-simple:active:hover, .btn.btn-linkedin.btn-simple.active:hover, .show > .btn.btn-linkedin.btn-simple.dropdown-toggle, .show > .btn.btn-linkedin.btn-simple.dropdown-toggle:focus, .show > .btn.btn-linkedin.btn-simple.dropdown-toggle:hover {
  color: #008bd4;
  border-color: #008bd4;
  background-color: transparent;
}
.btn.btn-linkedin.btn-neutral {
  color: #0077B5;
  background-color: #FFFFFF;
}
.btn.btn-linkedin.btn-neutral:hover, .btn.btn-linkedin.btn-neutral:focus, .btn.btn-linkedin.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-linkedin.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-linkedin.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-linkedin.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-linkedin.btn-neutral:active:hover, .btn.btn-linkedin.btn-neutral.active:hover, .show > .btn.btn-linkedin.btn-neutral.dropdown-toggle, .show > .btn.btn-linkedin.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-linkedin.btn-neutral.dropdown-toggle:hover {
  color: #008bd4;
  background-color: #FFFFFF;
}
.btn.btn-dribbble {
  background-color: #ea4c89;
  color: #fff;
}
.btn.btn-dribbble:hover, .btn.btn-dribbble:focus, .btn.btn-dribbble:not(:disabled):not(.disabled):active, .btn.btn-dribbble:not(:disabled):not(.disabled).active, .btn.btn-dribbble:not(:disabled):not(.disabled):active:focus, .btn.btn-dribbble:not(:disabled):not(.disabled).active:focus, .btn.btn-dribbble:active:hover, .btn.btn-dribbble.active:hover, .show > .btn.btn-dribbble.dropdown-toggle, .show > .btn.btn-dribbble.dropdown-toggle:focus, .show > .btn.btn-dribbble.dropdown-toggle:hover {
  background-color: #ed679b;
  color: #fff;
}
.btn.btn-dribbble.btn-simple {
  color: #ea4c89;
  box-shadow: none;
  background-color: transparent;
  border-color: #ea4c89;
}
.btn.btn-dribbble.btn-simple:hover, .btn.btn-dribbble.btn-simple:focus, .btn.btn-dribbble.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-dribbble.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-dribbble.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-dribbble.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-dribbble.btn-simple:active:hover, .btn.btn-dribbble.btn-simple.active:hover, .show > .btn.btn-dribbble.btn-simple.dropdown-toggle, .show > .btn.btn-dribbble.btn-simple.dropdown-toggle:focus, .show > .btn.btn-dribbble.btn-simple.dropdown-toggle:hover {
  color: #ed679b;
  border-color: #ed679b;
  background-color: transparent;
}
.btn.btn-dribbble.btn-neutral {
  color: #ea4c89;
  background-color: #FFFFFF;
}
.btn.btn-dribbble.btn-neutral:hover, .btn.btn-dribbble.btn-neutral:focus, .btn.btn-dribbble.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-dribbble.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-dribbble.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-dribbble.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-dribbble.btn-neutral:active:hover, .btn.btn-dribbble.btn-neutral.active:hover, .show > .btn.btn-dribbble.btn-neutral.dropdown-toggle, .show > .btn.btn-dribbble.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-dribbble.btn-neutral.dropdown-toggle:hover {
  color: #ed679b;
  background-color: #FFFFFF;
}
.btn.btn-github {
  background-color: #333333;
  color: #fff;
}
.btn.btn-github:hover, .btn.btn-github:focus, .btn.btn-github:not(:disabled):not(.disabled):active, .btn.btn-github:not(:disabled):not(.disabled).active, .btn.btn-github:not(:disabled):not(.disabled):active:focus, .btn.btn-github:not(:disabled):not(.disabled).active:focus, .btn.btn-github:active:hover, .btn.btn-github.active:hover, .show > .btn.btn-github.dropdown-toggle, .show > .btn.btn-github.dropdown-toggle:focus, .show > .btn.btn-github.dropdown-toggle:hover {
  background-color: #424242;
  color: #fff;
}
.btn.btn-github.btn-simple {
  color: #333333;
  box-shadow: none;
  background-color: transparent;
  border-color: #333333;
}
.btn.btn-github.btn-simple:hover, .btn.btn-github.btn-simple:focus, .btn.btn-github.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-github.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-github.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-github.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-github.btn-simple:active:hover, .btn.btn-github.btn-simple.active:hover, .show > .btn.btn-github.btn-simple.dropdown-toggle, .show > .btn.btn-github.btn-simple.dropdown-toggle:focus, .show > .btn.btn-github.btn-simple.dropdown-toggle:hover {
  color: #424242;
  border-color: #424242;
  background-color: transparent;
}
.btn.btn-github.btn-neutral {
  color: #333333;
  background-color: #FFFFFF;
}
.btn.btn-github.btn-neutral:hover, .btn.btn-github.btn-neutral:focus, .btn.btn-github.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-github.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-github.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-github.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-github.btn-neutral:active:hover, .btn.btn-github.btn-neutral.active:hover, .show > .btn.btn-github.btn-neutral.dropdown-toggle, .show > .btn.btn-github.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-github.btn-neutral.dropdown-toggle:hover {
  color: #424242;
  background-color: #FFFFFF;
}
.btn.btn-youtube {
  background-color: #e52d27;
  color: #fff;
}
.btn.btn-youtube:hover, .btn.btn-youtube:focus, .btn.btn-youtube:not(:disabled):not(.disabled):active, .btn.btn-youtube:not(:disabled):not(.disabled).active, .btn.btn-youtube:not(:disabled):not(.disabled):active:focus, .btn.btn-youtube:not(:disabled):not(.disabled).active:focus, .btn.btn-youtube:active:hover, .btn.btn-youtube.active:hover, .show > .btn.btn-youtube.dropdown-toggle, .show > .btn.btn-youtube.dropdown-toggle:focus, .show > .btn.btn-youtube.dropdown-toggle:hover {
  background-color: #e84842;
  color: #fff;
}
.btn.btn-youtube.btn-simple {
  color: #e52d27;
  box-shadow: none;
  background-color: transparent;
  border-color: #e52d27;
}
.btn.btn-youtube.btn-simple:hover, .btn.btn-youtube.btn-simple:focus, .btn.btn-youtube.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-youtube.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-youtube.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-youtube.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-youtube.btn-simple:active:hover, .btn.btn-youtube.btn-simple.active:hover, .show > .btn.btn-youtube.btn-simple.dropdown-toggle, .show > .btn.btn-youtube.btn-simple.dropdown-toggle:focus, .show > .btn.btn-youtube.btn-simple.dropdown-toggle:hover {
  color: #e84842;
  border-color: #e84842;
  background-color: transparent;
}
.btn.btn-youtube.btn-neutral {
  color: #e52d27;
  background-color: #FFFFFF;
}
.btn.btn-youtube.btn-neutral:hover, .btn.btn-youtube.btn-neutral:focus, .btn.btn-youtube.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-youtube.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-youtube.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-youtube.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-youtube.btn-neutral:active:hover, .btn.btn-youtube.btn-neutral.active:hover, .show > .btn.btn-youtube.btn-neutral.dropdown-toggle, .show > .btn.btn-youtube.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-youtube.btn-neutral.dropdown-toggle:hover {
  color: #e84842;
  background-color: #FFFFFF;
}
.btn.btn-instagram {
  background-color: #125688;
  color: #fff;
}
.btn.btn-instagram:hover, .btn.btn-instagram:focus, .btn.btn-instagram:not(:disabled):not(.disabled):active, .btn.btn-instagram:not(:disabled):not(.disabled).active, .btn.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn.btn-instagram:not(:disabled):not(.disabled).active:focus, .btn.btn-instagram:active:hover, .btn.btn-instagram.active:hover, .show > .btn.btn-instagram.dropdown-toggle, .show > .btn.btn-instagram.dropdown-toggle:focus, .show > .btn.btn-instagram.dropdown-toggle:hover {
  background-color: #1667a3;
  color: #fff;
}
.btn.btn-instagram.btn-simple {
  color: #125688;
  box-shadow: none;
  background-color: transparent;
  border-color: #125688;
}
.btn.btn-instagram.btn-simple:hover, .btn.btn-instagram.btn-simple:focus, .btn.btn-instagram.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-instagram.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-instagram.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-instagram.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-instagram.btn-simple:active:hover, .btn.btn-instagram.btn-simple.active:hover, .show > .btn.btn-instagram.btn-simple.dropdown-toggle, .show > .btn.btn-instagram.btn-simple.dropdown-toggle:focus, .show > .btn.btn-instagram.btn-simple.dropdown-toggle:hover {
  color: #1667a3;
  border-color: #1667a3;
  background-color: transparent;
}
.btn.btn-instagram.btn-neutral {
  color: #125688;
  background-color: #FFFFFF;
}
.btn.btn-instagram.btn-neutral:hover, .btn.btn-instagram.btn-neutral:focus, .btn.btn-instagram.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-instagram.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-instagram.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-instagram.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-instagram.btn-neutral:active:hover, .btn.btn-instagram.btn-neutral.active:hover, .show > .btn.btn-instagram.btn-neutral.dropdown-toggle, .show > .btn.btn-instagram.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-instagram.btn-neutral.dropdown-toggle:hover {
  color: #1667a3;
  background-color: #FFFFFF;
}
.btn.btn-reddit {
  background-color: #ff4500;
  color: #fff;
}
.btn.btn-reddit:hover, .btn.btn-reddit:focus, .btn.btn-reddit:not(:disabled):not(.disabled):active, .btn.btn-reddit:not(:disabled):not(.disabled).active, .btn.btn-reddit:not(:disabled):not(.disabled):active:focus, .btn.btn-reddit:not(:disabled):not(.disabled).active:focus, .btn.btn-reddit:active:hover, .btn.btn-reddit.active:hover, .show > .btn.btn-reddit.dropdown-toggle, .show > .btn.btn-reddit.dropdown-toggle:focus, .show > .btn.btn-reddit.dropdown-toggle:hover {
  background-color: #ff5b1f;
  color: #fff;
}
.btn.btn-reddit.btn-simple {
  color: #ff4500;
  box-shadow: none;
  background-color: transparent;
  border-color: #ff4500;
}
.btn.btn-reddit.btn-simple:hover, .btn.btn-reddit.btn-simple:focus, .btn.btn-reddit.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-reddit.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-reddit.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-reddit.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-reddit.btn-simple:active:hover, .btn.btn-reddit.btn-simple.active:hover, .show > .btn.btn-reddit.btn-simple.dropdown-toggle, .show > .btn.btn-reddit.btn-simple.dropdown-toggle:focus, .show > .btn.btn-reddit.btn-simple.dropdown-toggle:hover {
  color: #ff5b1f;
  border-color: #ff5b1f;
  background-color: transparent;
}
.btn.btn-reddit.btn-neutral {
  color: #ff4500;
  background-color: #FFFFFF;
}
.btn.btn-reddit.btn-neutral:hover, .btn.btn-reddit.btn-neutral:focus, .btn.btn-reddit.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-reddit.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-reddit.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-reddit.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-reddit.btn-neutral:active:hover, .btn.btn-reddit.btn-neutral.active:hover, .show > .btn.btn-reddit.btn-neutral.dropdown-toggle, .show > .btn.btn-reddit.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-reddit.btn-neutral.dropdown-toggle:hover {
  color: #ff5b1f;
  background-color: #FFFFFF;
}
.btn.btn-tumblr {
  background-color: #35465c;
  color: #fff;
}
.btn.btn-tumblr:hover, .btn.btn-tumblr:focus, .btn.btn-tumblr:not(:disabled):not(.disabled):active, .btn.btn-tumblr:not(:disabled):not(.disabled).active, .btn.btn-tumblr:not(:disabled):not(.disabled):active:focus, .btn.btn-tumblr:not(:disabled):not(.disabled).active:focus, .btn.btn-tumblr:active:hover, .btn.btn-tumblr.active:hover, .show > .btn.btn-tumblr.dropdown-toggle, .show > .btn.btn-tumblr.dropdown-toggle:focus, .show > .btn.btn-tumblr.dropdown-toggle:hover {
  background-color: #40556f;
  color: #fff;
}
.btn.btn-tumblr.btn-simple {
  color: #35465c;
  box-shadow: none;
  background-color: transparent;
  border-color: #35465c;
}
.btn.btn-tumblr.btn-simple:hover, .btn.btn-tumblr.btn-simple:focus, .btn.btn-tumblr.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-tumblr.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-tumblr.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-tumblr.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-tumblr.btn-simple:active:hover, .btn.btn-tumblr.btn-simple.active:hover, .show > .btn.btn-tumblr.btn-simple.dropdown-toggle, .show > .btn.btn-tumblr.btn-simple.dropdown-toggle:focus, .show > .btn.btn-tumblr.btn-simple.dropdown-toggle:hover {
  color: #40556f;
  border-color: #40556f;
  background-color: transparent;
}
.btn.btn-tumblr.btn-neutral {
  color: #35465c;
  background-color: #FFFFFF;
}
.btn.btn-tumblr.btn-neutral:hover, .btn.btn-tumblr.btn-neutral:focus, .btn.btn-tumblr.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-tumblr.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-tumblr.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-tumblr.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-tumblr.btn-neutral:active:hover, .btn.btn-tumblr.btn-neutral.active:hover, .show > .btn.btn-tumblr.btn-neutral.dropdown-toggle, .show > .btn.btn-tumblr.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-tumblr.btn-neutral.dropdown-toggle:hover {
  color: #40556f;
  background-color: #FFFFFF;
}
.btn.btn-behance {
  background-color: #1769ff;
  color: #fff;
}
.btn.btn-behance:hover, .btn.btn-behance:focus, .btn.btn-behance:not(:disabled):not(.disabled):active, .btn.btn-behance:not(:disabled):not(.disabled).active, .btn.btn-behance:not(:disabled):not(.disabled):active:focus, .btn.btn-behance:not(:disabled):not(.disabled).active:focus, .btn.btn-behance:active:hover, .btn.btn-behance.active:hover, .show > .btn.btn-behance.dropdown-toggle, .show > .btn.btn-behance.dropdown-toggle:focus, .show > .btn.btn-behance.dropdown-toggle:hover {
  background-color: #367dff;
  color: #fff;
}
.btn.btn-behance.btn-simple {
  color: #1769ff;
  box-shadow: none;
  background-color: transparent;
  border-color: #1769ff;
}
.btn.btn-behance.btn-simple:hover, .btn.btn-behance.btn-simple:focus, .btn.btn-behance.btn-simple:not(:disabled):not(.disabled):active, .btn.btn-behance.btn-simple:not(:disabled):not(.disabled).active, .btn.btn-behance.btn-simple:not(:disabled):not(.disabled):active:focus, .btn.btn-behance.btn-simple:not(:disabled):not(.disabled).active:focus, .btn.btn-behance.btn-simple:active:hover, .btn.btn-behance.btn-simple.active:hover, .show > .btn.btn-behance.btn-simple.dropdown-toggle, .show > .btn.btn-behance.btn-simple.dropdown-toggle:focus, .show > .btn.btn-behance.btn-simple.dropdown-toggle:hover {
  color: #367dff;
  border-color: #367dff;
  background-color: transparent;
}
.btn.btn-behance.btn-neutral {
  color: #1769ff;
  background-color: #FFFFFF;
}
.btn.btn-behance.btn-neutral:hover, .btn.btn-behance.btn-neutral:focus, .btn.btn-behance.btn-neutral:not(:disabled):not(.disabled):active, .btn.btn-behance.btn-neutral:not(:disabled):not(.disabled).active, .btn.btn-behance.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn.btn-behance.btn-neutral:not(:disabled):not(.disabled).active:focus, .btn.btn-behance.btn-neutral:active:hover, .btn.btn-behance.btn-neutral.active:hover, .show > .btn.btn-behance.btn-neutral.dropdown-toggle, .show > .btn.btn-behance.btn-neutral.dropdown-toggle:focus, .show > .btn.btn-behance.btn-neutral.dropdown-toggle:hover {
  color: #367dff;
  background-color: #FFFFFF;
}

.form-control::-moz-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control:-moz-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control::-webkit-input-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control:-ms-input-placeholder {
  color: #888888;
  opacity: 0.8;
  filter: alpha(opacity=80);
}

.form-control {
  background-color: transparent;
  border: 1px solid #E3E3E3;
  border-radius: 30px;
  color: #2c2c2c;
  height: auto;
  line-height: normal;
  font-size: 0.8571em;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  box-shadow: none;
}
.has-success .form-control {
  border-color: #E3E3E3;
}
.form-control:focus {
  border: 1px solid #f96332;
  box-shadow: none;
  outline: 0 !important;
  color: #2c2c2c;
}
.form-control:focus + .input-group-text, .form-control:focus ~ .input-group-text {
  border: 1px solid #f96332;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-success .form-control:focus {
  border-color: #1be611;
}
.has-danger .form-control.form-control-success, .has-danger .form-control.form-control-danger, .has-success .form-control.form-control-success, .has-success .form-control.form-control-danger {
  background-image: none;
}
.has-danger .form-control {
  border-color: #ffcfcf;
  color: #FF3636;
  background-color: rgba(222, 222, 222, 0.1);
}
.has-danger .form-control:focus {
  background-color: #FFFFFF;
}
.form-control + .form-control-feedback {
  border-radius: 0.25rem;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 0.25rem 0.25rem 0 0;
  border-bottom-color: transparent;
}

.has-success:after,
.has-danger:after {
  font-family: "Nucleo Outline";
  content: "\\ea22";
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 12px;
  color: #18ce0f;
  font-size: 11px;
}
.has-success.input-lg:after,
.has-danger.input-lg:after {
  font-size: 13px;
  top: 13px;
}

.has-danger:after {
  content: "\\ea53";
  color: #FF3636;
}

.form-group.no-border.input-lg .input-group-text,
.input-group.no-border.input-lg .input-group-text {
  padding: 15px 0 15px 19px;
}
.form-group.no-border.input-lg .form-control,
.input-group.no-border.input-lg .form-control {
  padding: 15px 19px;
}
.form-group.no-border.input-lg .form-control + .input-group-text,
.input-group.no-border.input-lg .form-control + .input-group-text {
  padding: 15px 19px 15px 0;
}

.form-group.input-lg .form-control,
.input-group.input-lg .form-control {
  padding: 14px 18px;
}
.form-group.input-lg .form-control + .input-group-text,
.input-group.input-lg .form-control + .input-group-text {
  padding: 14px 18px 14px 0;
}
.form-group.input-lg .input-group-text,
.input-group.input-lg .input-group-text {
  padding: 14px 0 15px 18px;
}
.form-group.input-lg .input-group-text + .form-control,
.input-group.input-lg .input-group-text + .form-control {
  padding: 15px 18px 15px 16px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 19px;
}
.form-group.no-border .form-control + .input-group-text,
.input-group.no-border .form-control + .input-group-text {
  padding: 11px 19px 11px 0;
}
.form-group.no-border .input-group-text,
.input-group.no-border .input-group-text {
  padding: 11px 0 11px 19px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 18px 10px 18px;
}
.form-group .form-control + .input-group-text,
.input-group .form-control + .input-group-text {
  padding: 10px 18px 10px 0;
}
.form-group .input-group-text,
.input-group .input-group-text {
  padding: 10px 0 10px 18px;
}
.form-group .input-group-text + .form-control, .form-group .input-group-text ~ .form-control,
.input-group .input-group-text + .form-control,
.input-group .input-group-text ~ .form-control {
  padding: 10px 19px 11px 16px;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-text:focus,
.form-group.no-border .form-control + .input-group-text:active,
.form-group.no-border .form-control + .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-text:focus,
.input-group.no-border .form-control + .input-group-text:active,
.input-group.no-border .form-control + .input-group-text:active {
  border: medium none;
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .form-control:focus + .input-group-text,
.input-group.no-border .form-control:focus + .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
  border-left: transparent !important;
}
.form-group.no-border.input-group-focus.no-border .input-group-text,
.input-group.no-border.input-group-focus.no-border .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #FF3636;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #18ce0f;
}

.input-group-text {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 30px;
  color: #555555;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.input-group-focus .input-group-text {
  background-color: #FFFFFF;
  border-color: #f96332;
}
.has-success .input-group-text, .has-danger .input-group-text {
  background-color: #FFFFFF;
}
.has-danger .form-control:focus + .input-group-text {
  color: #FF3636;
}
.has-success .form-control:focus + .input-group-text {
  color: #18ce0f;
}
.input-group-text + .form-control, .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-text i {
  width: 17px;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}

.input-group[disabled] .input-group-text {
  background-color: #E3E3E3;
}

.input-group .input-group-prepend,
.form-group .input-group-prepend {
  margin-right: 0;
}
.input-group .input-group-prepend .input-group-text,
.form-group .input-group-prepend .input-group-text {
  border-left: 1px solid #E3E3E3;
}
.input-group .input-group-append .input-group-text,
.form-group .input-group-append .input-group-text {
  border-right: 1px solid #E3E3E3;
  padding: 10px 18px 10px 0;
}
.input-group.input-group-focus .input-group-prepend .input-group-text,
.form-group.input-group-focus .input-group-prepend .input-group-text {
  border-left: 1px solid #f96332;
}
.input-group.input-group-focus .input-group-append .input-group-text,
.form-group.input-group-focus .input-group-append .input-group-text {
  border-right: 1px solid #f96332;
}
.input-group.input-group-focus.no-border .input-group-prepend .input-group-text,
.form-group.input-group-focus.no-border .input-group-prepend .input-group-text {
  border-left: transparent;
}

.input-group .form-control:first-child,
.input-group-text:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-text:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #E3E3E3;
  color: #888888;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  border: none;
  border-bottom: 1px solid #E3E3E3;
  border-radius: 0;
  line-height: 2;
}
textarea.form-control:focus, textarea.form-control:active {
  border-left: none;
  border-top: none;
  border-right: none;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 40px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.progress-container {
  position: relative;
}
.progress-container + .progress-container, .progress-container ~ .progress-container {
  margin-top: 15px;
}
.progress-container .progress-badge {
  color: #888888;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.progress-container .progress {
  height: 1px;
  border-radius: 0;
  box-shadow: none;
  background: rgba(222, 222, 222, 0.8);
  margin-top: 14px;
}
.progress-container .progress .progress-bar {
  box-shadow: none;
  background-color: #888888;
}
.progress-container .progress .progress-value {
  position: absolute;
  top: 2px;
  right: 0;
  color: #888888;
  font-size: 0.8571em;
}
.progress-container.progress-neutral .progress {
  background: rgba(255, 255, 255, 0.3);
}
.progress-container.progress-neutral .progress-bar {
  background: #FFFFFF;
}
.progress-container.progress-neutral .progress-value,
.progress-container.progress-neutral .progress-badge {
  color: #FFFFFF;
}
.progress-container.progress-primary .progress {
  background: rgba(249, 99, 50, 0.3);
}
.progress-container.progress-primary .progress-bar {
  background: #f96332;
}
.progress-container.progress-primary .progress-value,
.progress-container.progress-primary .progress-badge {
  color: #f96332;
}
.progress-container.progress-info .progress {
  background: rgba(44, 168, 255, 0.3);
}
.progress-container.progress-info .progress-bar {
  background: #2CA8FF;
}
.progress-container.progress-info .progress-value,
.progress-container.progress-info .progress-badge {
  color: #2CA8FF;
}
.progress-container.progress-success .progress {
  background: rgba(24, 206, 15, 0.3);
}
.progress-container.progress-success .progress-bar {
  background: #18ce0f;
}
.progress-container.progress-success .progress-value,
.progress-container.progress-success .progress-badge {
  color: #18ce0f;
}
.progress-container.progress-warning .progress {
  background: rgba(255, 178, 54, 0.3);
}
.progress-container.progress-warning .progress-bar {
  background: #FFB236;
}
.progress-container.progress-warning .progress-value,
.progress-container.progress-warning .progress-badge {
  color: #FFB236;
}
.progress-container.progress-danger .progress {
  background: rgba(255, 54, 54, 0.3);
}
.progress-container.progress-danger .progress-bar {
  background: #FF3636;
}
.progress-container.progress-danger .progress-value,
.progress-container.progress-danger .progress-badge {
  color: #FF3636;
}

.nav-pills.nav-pills-just-icons .nav-item .nav-link {
  text-align: center;
  border-radius: 50%;
  height: 80px;
  width: 80px;
  padding: 0;
  max-width: 80px;
  min-width: auto;
  margin-bottom: 4px;
}
.nav-pills.nav-pills-just-icons .nav-item .nav-link i {
  line-height: 80px;
}
.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
  margin-right: 19px;
}
.nav-pills .nav-item .nav-link {
  padding: 10px 23px;
  background-color: rgba(222, 222, 222, 0.3);
  min-width: 100px;
  font-weight: 400;
  text-align: center;
  color: #444;
}
.nav-pills .nav-item .nav-link:hover {
  background-color: rgba(222, 222, 222, 0.3);
}
.nav-pills .nav-item .nav-link.active, .nav-pills .nav-item .nav-link.active:focus, .nav-pills .nav-item .nav-link.active:hover {
  background-color: #9A9A9A;
  color: #FFFFFF;
  box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);
}
.nav-pills .nav-item .nav-link.disabled, .nav-pills .nav-item .nav-link:disabled, .nav-pills .nav-item .nav-link[disabled] {
  opacity: 0.5;
}
.nav-pills .nav-item i {
  display: block;
  line-height: 60px;
  font-size: 24px;
}
.nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.nav-pills.nav-pills-neutral .nav-item .nav-link.active, .nav-pills.nav-pills-neutral .nav-item .nav-link.active:focus, .nav-pills.nav-pills-neutral .nav-item .nav-link.active:hover {
  background-color: #FFFFFF;
  color: #f96332;
}
.nav-pills.nav-pills-primary .nav-item .nav-link.active, .nav-pills.nav-pills-primary .nav-item .nav-link.active:focus, .nav-pills.nav-pills-primary .nav-item .nav-link.active:hover {
  background-color: #f96332;
}
.nav-pills.nav-pills-info .nav-item .nav-link.active, .nav-pills.nav-pills-info .nav-item .nav-link.active:focus, .nav-pills.nav-pills-info .nav-item .nav-link.active:hover {
  background-color: #2CA8FF;
}
.nav-pills.nav-pills-success .nav-item .nav-link.active, .nav-pills.nav-pills-success .nav-item .nav-link.active:focus, .nav-pills.nav-pills-success .nav-item .nav-link.active:hover {
  background-color: #18ce0f;
}
.nav-pills.nav-pills-warning .nav-item .nav-link.active, .nav-pills.nav-pills-warning .nav-item .nav-link.active:focus, .nav-pills.nav-pills-warning .nav-item .nav-link.active:hover {
  background-color: #FFB236;
}
.nav-pills.nav-pills-danger .nav-item .nav-link.active, .nav-pills.nav-pills-danger .nav-item .nav-link.active:focus, .nav-pills.nav-pills-danger .nav-item .nav-link.active:hover {
  background-color: #FF3636;
}

.tab-space {
  padding: 20px 0 50px 0px;
}

.nav-align-center {
  text-align: center;
}
.nav-align-center .nav-pills {
  display: inline-flex;
}

.nav-pills.flex-column li > a {
  margin-bottom: 15px;
}
.nav-pills:not(.nav-pills-icons):not(.nav-pills-just-icons) .nav-item .nav-link {
  border-radius: 30px;
}
.nav-pills.nav-pills-icons .nav-item .nav-link {
  background-color: transparent;
}
.nav-pills.nav-pills-icons .nav-item i {
  font-size: 20px;
}

.nav-tabs {
  border: 0;
  padding: 15px 0.7rem;
}
.nav-tabs:not(.nav-tabs-neutral) > .nav-item > .nav-link.active {
  box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);
}
.card .nav-tabs {
  border-top-right-radius: 0.1875rem;
  border-top-left-radius: 0.1875rem;
}
.nav-tabs > .nav-item > .nav-link {
  color: #888888;
  margin: 0;
  margin-right: 5px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 30px;
  font-size: 14px;
  padding: 11px 23px;
  line-height: 1.5;
}
.nav-tabs > .nav-item > .nav-link:hover {
  background-color: transparent;
}
.nav-tabs > .nav-item > .nav-link.active {
  background-color: #444;
  border-radius: 30px;
  color: #FFFFFF;
}
.nav-tabs > .nav-item > .nav-link i.now-ui-icons {
  font-size: 14px;
  position: relative;
  top: 1px;
  margin-right: 3px;
}
.nav-tabs > .nav-item.disabled > .nav-link, .nav-tabs > .nav-item.disabled > .nav-link:hover {
  color: rgba(255, 255, 255, 0.5);
}
.nav-tabs.nav-tabs-neutral > .nav-item > .nav-link {
  color: #FFFFFF;
}
.nav-tabs.nav-tabs-neutral > .nav-item > .nav-link.active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.nav-tabs.nav-tabs-primary > .nav-item > .nav-link.active {
  background-color: #f96332;
}
.nav-tabs.nav-tabs-info > .nav-item > .nav-link.active {
  background-color: #2CA8FF;
}
.nav-tabs.nav-tabs-danger > .nav-item > .nav-link.active {
  background-color: #FF3636;
}
.nav-tabs.nav-tabs-warning > .nav-item > .nav-link.active {
  background-color: #FFB236;
}
.nav-tabs.nav-tabs-success > .nav-item > .nav-link.active {
  background-color: #18ce0f;
}

.navbar {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  min-height: 53px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
}
.navbar a {
  vertical-align: middle;
}
.navbar a:not(.btn):not(.dropdown-item) {
  color: #FFFFFF;
}
.navbar p {
  display: inline-block;
  margin: 0;
  line-height: 21px;
  font-weight: inherit;
  font-size: inherit;
}
.navbar .navbar-nav.navbar-logo {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 49px;
  top: -4px;
}
.navbar .navbar-nav .nav-link.btn {
  padding: 11px 22px;
}
.navbar .navbar-nav .nav-link.btn.btn-lg {
  padding: 15px 48px;
}
.navbar .navbar-nav .nav-link.btn.btn-sm {
  padding: 5px 15px;
}
.navbar .navbar-nav .nav-link:not(.btn) {
  text-transform: uppercase;
  font-size: 0.7142em;
  padding: 0.5rem 0.7rem;
  line-height: 1.625rem;
}
.navbar .navbar-nav .nav-link:not(.btn) i.fab + p,
.navbar .navbar-nav .nav-link:not(.btn) i.now-ui-icons + p {
  margin-left: 3px;
}
.navbar .navbar-nav .nav-link:not(.btn) i.fab,
.navbar .navbar-nav .nav-link:not(.btn) i.now-ui-icons {
  font-size: 18px;
  position: relative;
  top: 3px;
  text-align: center;
  width: 21px;
}
.navbar .navbar-nav .nav-link:not(.btn) i.now-ui-icons {
  top: 4px;
  font-size: 16px;
}
.navbar .navbar-nav .nav-link:not(.btn).profile-photo .profile-photo-small {
  width: 27px;
  height: 27px;
}
.navbar .navbar-nav .nav-link:not(.btn).disabled {
  opacity: 0.5;
  color: #FFFFFF;
}
.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 0.1875rem;
}
.navbar .logo-container {
  width: 27px;
  height: 27px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid transparent;
}
.navbar .navbar-brand {
  text-transform: uppercase;
  font-size: 0.8571em;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1.625rem;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler.navbar-toggler-left {
  position: relative;
  left: 0;
  padding-left: 0;
}
.navbar .navbar-toggler .navbar-toggler-bar.middle-bar {
  width: 17px;
  transition: width 0.2s linear;
}
.navbar .navbar-toggler:hover .navbar-toggler-bar.middle-bar {
  width: 22px;
}
.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {
  width: 17px;
}
.navbar.navbar-transparent {
  background-color: transparent !important;
  box-shadow: none;
  color: #FFFFFF;
  padding-top: 20px !important;
}
.navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn) {
  color: #888888;
}
.navbar.bg-white:not(.navbar-transparent) a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #888888;
}
.navbar.bg-white:not(.navbar-transparent) .button-bar {
  background: #888888;
}
.navbar.bg-white:not(.navbar-transparent) .nav-item.active .nav-link:not(.btn),
.navbar.bg-white:not(.navbar-transparent) .nav-item .nav-link:not(.btn):focus,
.navbar.bg-white:not(.navbar-transparent) .nav-item .nav-link:not(.btn):hover,
.navbar.bg-white:not(.navbar-transparent) .nav-item .nav-link:not(.btn):active {
  background-color: rgba(222, 222, 222, 0.3);
}
.navbar.bg-white:not(.navbar-transparent) .logo-container {
  border: 1px solid #888888;
}

.bg-default {
  background-color: #888888 !important;
}

.bg-primary {
  background-color: #f96332 !important;
}

.bg-info {
  background-color: #2CA8FF !important;
}

.bg-success {
  background-color: #18ce0f !important;
}

.bg-danger {
  background-color: #FF3636 !important;
}

.bg-warning {
  background-color: #FFB236 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.navbar p {
  line-height: 1.8em;
  font-size: 1em;
  font-weight: 400;
}
.navbar.navbar-absolute {
  position: absolute;
  width: 100%;
  padding-top: 10px;
  z-index: 1029;
}
.navbar .navbar-toggler {
  vertical-align: middle;
}
.navbar .navbar-toggler.navbar-toggler-left {
  top: 0;
}
.navbar .navbar-toggler.navbar-toggler-right {
  padding-right: 0;
  top: 8px;
}

.dropdown-menu {
  border: 0;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.125rem;
  transition: all 150ms linear;
  font-size: 14px;
}
.dropdown-menu.dropdown-menu-right:before {
  left: auto;
  right: 10px;
}
.dropdown .dropdown-menu {
  transform: translate3d(0, -25px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 100% !important;
}
.dropdown.show .dropdown-menu, .dropdown-menu.open {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
  transform: translate3d(0, 0px, 0) !important;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
  outline: none;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus, .bootstrap-select .dropdown-menu.inner li a:hover, .bootstrap-select .dropdown-menu.inner li a:focus {
  background-color: rgba(222, 222, 222, 0.3);
}
.dropdown-menu .dropdown-item.disabled, .dropdown-menu .dropdown-item:disabled, .bootstrap-select .dropdown-menu.inner li a.disabled, .bootstrap-select .dropdown-menu.inner li a:disabled {
  color: rgba(182, 182, 182, 0.6);
}
.dropdown-menu .dropdown-item.disabled:hover, .dropdown-menu .dropdown-item.disabled:focus, .dropdown-menu .dropdown-item:disabled:hover, .dropdown-menu .dropdown-item:disabled:focus, .bootstrap-select .dropdown-menu.inner li a.disabled:hover, .bootstrap-select .dropdown-menu.inner li a.disabled:focus, .bootstrap-select .dropdown-menu.inner li a:disabled:hover, .bootstrap-select .dropdown-menu.inner li a:disabled:focus {
  background-color: transparent;
}
.dropdown-menu:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #FFFFFF;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu .dropdown-divider {
  background-color: rgba(222, 222, 222, 0.5);
}
.dropdown-menu .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(182, 182, 182, 0.6);
  font-size: 0.7142em;
  text-transform: uppercase;
  font-weight: 700;
}
.dropdown-menu.dropdown-primary {
  background-color: #f95823;
}
.dropdown-menu.dropdown-primary:before {
  color: #f95823;
}
.dropdown-menu.dropdown-primary .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-primary .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-primary .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info {
  background-color: #1da2ff;
}
.dropdown-menu.dropdown-info:before {
  color: #1da2ff;
}
.dropdown-menu.dropdown-info .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-info .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger {
  background-color: #ff2727;
}
.dropdown-menu.dropdown-danger:before {
  color: #ff2727;
}
.dropdown-menu.dropdown-danger .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-danger .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success {
  background-color: #16c00e;
}
.dropdown-menu.dropdown-success:before {
  color: #16c00e;
}
.dropdown-menu.dropdown-success .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-success .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning {
  background-color: #ffac27;
}
.dropdown-menu.dropdown-warning:before {
  color: #ffac27;
}
.dropdown-menu.dropdown-warning .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-warning .dropdown-item {
  color: #FFFFFF;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}

.button-dropdown {
  padding-right: 0.7rem;
  cursor: pointer;
}
.button-dropdown .dropdown-toggle {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: block;
}
.button-dropdown .dropdown-toggle:after {
  display: none;
}

.dropdown-menu i {
  margin-right: 5px;
  position: relative;
  top: 1px;
}
.dropdown-menu .now-ui-icons {
  margin-right: 10px;
  position: relative;
  top: 4px;
  font-size: 18px;
  margin-top: -5px;
  opacity: 0.5;
}
.dropdown-menu .dropdown-item.active, .dropdown-menu .dropdown-item:active {
  color: inherit;
}
.dropup .dropdown-menu:before {
  display: none;
}
.dropup .dropdown-menu:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -5px;
  right: auto;
  left: 10px;
  color: #FFFFFF;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropup .dropdown-menu.dropdown-menu-right:after {
  right: 10px;
  left: auto;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus, .bootstrap-select .dropdown-menu.inner li a:hover, .bootstrap-select .dropdown-menu.inner li a:focus {
  background-color: rgba(222, 222, 222, 0.3);
}
.dropdown-menu .dropdown-item.disabled, .dropdown-menu .dropdown-item:disabled, .bootstrap-select .dropdown-menu.inner li a.disabled, .bootstrap-select .dropdown-menu.inner li a:disabled {
  color: rgba(182, 182, 182, 0.6);
}
.dropdown-menu .dropdown-item.disabled:hover, .dropdown-menu .dropdown-item.disabled:focus, .dropdown-menu .dropdown-item:disabled:hover, .dropdown-menu .dropdown-item:disabled:focus, .bootstrap-select .dropdown-menu.inner li a.disabled:hover, .bootstrap-select .dropdown-menu.inner li a.disabled:focus, .bootstrap-select .dropdown-menu.inner li a:disabled:hover, .bootstrap-select .dropdown-menu.inner li a:disabled:focus {
  background-color: transparent;
}
.dropdown .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget {
  transform: translate3d(0, -25px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 100% !important;
}
.dropdown.show .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open, .dropdown-menu.bootstrap-datetimepicker-widget.top.open {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
  transform: translate3d(0, 0px, 0) !important;
}
.dropup .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.top {
  visibility: hidden;
  opacity: 0;
  filter: alpha(opacity=0);
  transform: translate3d(0, 25px, 0) !important;
  display: block;
  top: auto !important;
  bottom: 100% !important;
}
.dropup.show .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.top.open {
  visibility: visible;
  opacity: 1;
  filter: alpha(opacity=100);
  transform: translate3d(0, -1px, 0) !important;
}

img {
  max-width: 100%;
  border-radius: 1px;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.popover {
  font-size: 14px;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border: none;
  line-height: 1.7;
  max-width: 240px;
}
.popover.bs-popover-top .arrow:before, .popover.bs-popover-left .arrow:before, .popover.bs-popover-right .arrow:before, .popover.bs-popover-bottom .arrow:before {
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.popover .popover-header {
  color: rgba(182, 182, 182, 0.6);
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 600;
  margin: 0;
  margin-top: 5px;
  border: none;
  background-color: transparent;
}
.popover:before {
  display: none;
}
.popover.bs-tether-element-attached-top:after {
  border-bottom-color: #FFFFFF;
  top: -9px;
}
.popover.popover-primary {
  background-color: #f96332;
}
.popover.popover-primary .popover-body {
  color: #FFFFFF;
}
.popover.popover-primary.bs-popover-right .arrow:after {
  border-right-color: #f96332;
}
.popover.popover-primary.bs-popover-top .arrow:after {
  border-top-color: #f96332;
}
.popover.popover-primary.bs-popover-bottom .arrow:after {
  border-bottom-color: #f96332;
}
.popover.popover-primary.bs-popover-left .arrow:after {
  border-left-color: #f96332;
}
.popover.popover-primary .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-info {
  background-color: #2CA8FF;
}
.popover.popover-info .popover-body {
  color: #FFFFFF;
}
.popover.popover-info.bs-popover-right .arrow:after {
  border-right-color: #2CA8FF;
}
.popover.popover-info.bs-popover-top .arrow:after {
  border-top-color: #2CA8FF;
}
.popover.popover-info.bs-popover-bottom .arrow:after {
  border-bottom-color: #2CA8FF;
}
.popover.popover-info.bs-popover-left .arrow:after {
  border-left-color: #2CA8FF;
}
.popover.popover-info .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-warning {
  background-color: #FFB236;
}
.popover.popover-warning .popover-body {
  color: #FFFFFF;
}
.popover.popover-warning.bs-popover-right .arrow:after {
  border-right-color: #FFB236;
}
.popover.popover-warning.bs-popover-top .arrow:after {
  border-top-color: #FFB236;
}
.popover.popover-warning.bs-popover-bottom .arrow:after {
  border-bottom-color: #FFB236;
}
.popover.popover-warning.bs-popover-left .arrow:after {
  border-left-color: #FFB236;
}
.popover.popover-warning .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-danger {
  background-color: #FF3636;
}
.popover.popover-danger .popover-body {
  color: #FFFFFF;
}
.popover.popover-danger.bs-popover-right .arrow:after {
  border-right-color: #FF3636;
}
.popover.popover-danger.bs-popover-top .arrow:after {
  border-top-color: #FF3636;
}
.popover.popover-danger.bs-popover-bottom .arrow:after {
  border-bottom-color: #FF3636;
}
.popover.popover-danger.bs-popover-left .arrow:after {
  border-left-color: #FF3636;
}
.popover.popover-danger .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-success {
  background-color: #18ce0f;
}
.popover.popover-success .popover-body {
  color: #FFFFFF;
}
.popover.popover-success.bs-popover-right .arrow:after {
  border-right-color: #18ce0f;
}
.popover.popover-success.bs-popover-top .arrow:after {
  border-top-color: #18ce0f;
}
.popover.popover-success.bs-popover-bottom .arrow:after {
  border-bottom-color: #18ce0f;
}
.popover.popover-success.bs-popover-left .arrow:after {
  border-left-color: #18ce0f;
}
.popover.popover-success .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}

.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: #FFFFFF;
}
.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: #FFFFFF;
}
.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: #FFFFFF;
}
.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: #FFFFFF;
}

.tooltip-inner {
  padding: 0.5rem 0.7rem;
  min-width: 130px;
  background-color: #FFFFFF;
  font-size: 14px;
  color: inherit;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}

.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 1.3em;
  font-weight: 300;
  border: 0;
}
.table .btn {
  margin: 0;
}
.table .form-check,
.table .form-check.form-check-radio {
  margin: 0;
  padding: 0;
  width: 15px;
}
.table .form-check .icons,
.table .form-check.form-check-radio .icons {
  position: relative;
}
.table .form-check label.form-check-label .form-check-sign:after, .table .form-check label.form-check-label .form-check-sign:before,
.table .form-check.form-check-radio label.form-check-label .form-check-sign:after,
.table .form-check.form-check-radio label.form-check-label .form-check-sign:before {
  top: -17px;
  left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 7px;
  vertical-align: middle;
}
.table .th-description {
  max-width: 150px;
}
.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}
.table .td-total {
  font-weight: 700;
  font-size: 1.3em;
  padding-top: 20px;
  text-align: right;
}
.table .td-actions .btn {
  margin: 0px;
}
.table > tbody > tr {
  position: relative;
}

.table-shopping > thead > tr > th {
  font-size: 0.9em;
  text-transform: uppercase;
}
.table-shopping > tbody > tr > td {
  font-size: 1.2em;
}
.table-shopping > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}
.table-shopping .td-name {
  font-weight: 400;
  font-size: 1.5em;
}
.table-shopping .td-name small {
  color: #9A9A9A;
  font-size: 0.75em;
  font-weight: 300;
}
.table-shopping .td-number {
  font-weight: 300;
  font-size: 1.5em;
}
.table-shopping .td-name {
  min-width: 200px;
}
.table-shopping .td-number {
  text-align: right;
  min-width: 145px;
}
.table-shopping .td-number small {
  margin-right: 3px;
}
.table-shopping .img-container {
  width: 120px;
  max-height: 160px;
  overflow: hidden;
  display: block;
}
.table-shopping .img-container img {
  width: 100%;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

.info {
  max-width: 360px;
  margin: 0 auto;
  padding: 70px 0 30px;
  text-align: center;
}
.info.info-hover .info-title {
  transition: color 0.4s;
}
.info.info-hover:hover .icon {
  transform: translate3d(0, -0.5rem, 0);
}
.info.info-hover:hover .icon.icon-primary.icon-circle {
  box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.35);
}
.info.info-hover:hover .icon.icon-info.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.35);
}
.info.info-hover:hover .icon.icon-success.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.35);
}
.info.info-hover:hover .icon.icon-warning.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.35);
}
.info.info-hover:hover .icon.icon-danger.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.35);
}
.info.info-hover:hover .icon.icon-info + .info-title {
  color: #2CA8FF;
}
.info.info-hover:hover .icon.icon-warning + .info-title {
  color: #FFB236;
}
.info.info-hover:hover .icon.icon-danger + .info-title {
  color: #FF3636;
}
.info.info-hover:hover .icon.icon-primary + .info-title {
  color: #f96332;
}
.info.info-hover:hover .icon.icon-success + .info-title {
  color: #18ce0f;
}
.info .icon {
  color: #888888;
  transition: transform 0.4s, box-shadow 0.4s;
}
.info .icon > i {
  font-size: 3em;
}
.info .icon.icon-circle {
  max-width: 80px;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);
  font-size: 0.7142em;
  background-color: #FFFFFF;
  position: relative;
}
.info .icon.icon-circle i {
  line-height: 2.7;
}
.info .info-title {
  margin: 25px 0 15px;
  padding: 0 15px;
  color: #2c2c2c;
}
.info p {
  color: #888888;
  padding: 0 15px;
  font-size: 1.1em;
}

.info-horizontal {
  text-align: left !important;
}
.info-horizontal .icon {
  float: left;
  margin-top: 23px;
  margin-right: 10px;
}
.info-horizontal .icon > i {
  font-size: 2em;
}
.info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.info-horizontal .description {
  overflow: hidden;
}

.icon.icon-primary {
  color: #f96332;
}
.icon.icon-primary.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(249, 99, 50, 0.3);
}
.icon.icon-info {
  color: #2CA8FF;
}
.icon.icon-info.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(44, 168, 255, 0.3);
}
.icon.icon-success {
  color: #18ce0f;
}
.icon.icon-success.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(24, 206, 15, 0.3);
}
.icon.icon-warning {
  color: #FFB236;
}
.icon.icon-warning.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(255, 178, 54, 0.3);
}
.icon.icon-danger {
  color: #FF3636;
}
.icon.icon-danger.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(255, 54, 54, 0.3);
}
.icon.icon-white {
  color: #FFFFFF;
}

.media .avatar {
  margin: 0 auto;
  width: 64px;
  height: 64px;
  margin-right: 15px;
}
.media .avatar img {
  width: 100%;
  border-radius: 50%;
}
.media textarea {
  margin-bottom: 20px;
}
.media .media-heading small {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}
.media .media-body {
  padding-right: 10px;
}
.media .media-body .media .media-body {
  padding-right: 0px;
}
.media.media-post .form-group,
.media.media-post .input-group {
  margin-top: 25px;
}
.media .media-footer .btn {
  margin-bottom: 20px;
}
.media .media-footer:after {
  display: table;
  content: " ";
  clear: both;
}
.media p {
  color: #888888;
  font-size: 1.104em;
  line-height: 1.61em;
}

.media-left,
.media > .pull-left {
  padding: 10px;
}

.modal-content {
  border-radius: 0.1875rem;
  border: none;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);
}
.modal-content .modal-header {
  border-bottom: none;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
}
.modal-content .modal-header button {
  position: absolute;
  right: 27px;
  top: 30px;
  outline: 0;
}
.modal-content .modal-header .title {
  margin-top: 5px;
  margin-bottom: 0;
}
.modal-content .modal-body {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  line-height: 1.9;
}
.modal-content .modal-footer {
  border-top: none;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px; /* Safari 6.1+ */
  justify-content: space-between;
}
.modal-content .modal-footer button {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal-content .modal-footer button.pull-left {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  left: -5px;
}
.modal-content .modal-body + .modal-footer {
  padding-top: 0;
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.3);
}

.modal.modal-mini p {
  text-align: center;
}
.modal.modal-mini .modal-dialog {
  max-width: 255px;
  margin: 0 auto;
}
.modal.modal-mini .modal-profile {
  width: 70px;
  height: 70px;
  background-color: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  line-height: 5.7;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.3);
}
.modal.modal-mini .modal-profile i {
  color: #f96332;
  font-size: 21px;
}
.modal.modal-mini .modal-profile[class*=modal-profile-] i {
  color: #FFFFFF;
}
.modal.modal-mini .modal-profile.modal-profile-primary {
  background-color: #f96332;
}
.modal.modal-mini .modal-profile.modal-profile-danger {
  background-color: #FF3636;
}
.modal.modal-mini .modal-profile.modal-profile-warning {
  background-color: #FFB236;
}
.modal.modal-mini .modal-profile.modal-profile-success {
  background-color: #18ce0f;
}
.modal.modal-mini .modal-profile.modal-profile-info {
  background-color: #2CA8FF;
}
.modal.modal-mini .modal-footer button {
  text-transform: uppercase;
}
.modal.modal-mini .modal-footer button:first-child {
  opacity: 0.5;
}
.modal.modal-default .modal-content {
  background-color: #FFFFFF;
  color: #2c2c2c;
}
.modal.modal-default .modal-header .close {
  color: #2c2c2c;
}
.modal.modal-primary .modal-content {
  background-color: #f96332;
  color: #FFFFFF;
}
.modal.modal-primary .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-danger .modal-content {
  background-color: #FF3636;
  color: #FFFFFF;
}
.modal.modal-danger .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-warning .modal-content {
  background-color: #FFB236;
  color: #FFFFFF;
}
.modal.modal-warning .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-success .modal-content {
  background-color: #18ce0f;
  color: #FFFFFF;
}
.modal.modal-success .modal-header .close {
  color: #FFFFFF;
}
.modal.modal-info .modal-content {
  background-color: #2CA8FF;
  color: #FFFFFF;
}
.modal.modal-info .modal-header .close {
  color: #FFFFFF;
}
.modal.show.modal-mini .modal-dialog {
  transform: translate(0, 30%);
}
.modal .modal-header .close {
  color: #FF3636;
  text-shadow: none;
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus {
  opacity: 1;
}

.modal .modal-login {
  max-width: 320px;
}
.modal .modal-login .card-login .logo-container {
  width: 65px;
  margin-bottom: 38px;
  margin-top: 27px;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.carousel .carousel-inner {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0.1875rem;
}
.carousel .card {
  max-width: 650px;
  margin: 60px auto;
  display: block;
}

.footer {
  padding: 1.125rem 0;
  text-align: center;
}
.footer.footer-default {
  background-color: #f2f2f2;
}
.footer.footer-white {
  background-color: #FFFFFF;
}
.footer nav {
  display: inline-block;
  float: left;
}
.footer .content {
  text-align: left;
}
.footer .nav-link {
  display: inline;
}
.footer.footer-big {
  padding: 30px 0;
}
.footer.footer-big .social-feed i {
  font-size: 20px;
  float: left;
  padding-right: 10px;
  padding-bottom: 30px;
}
.footer.footer-big .gallery-feed img {
  width: 20%;
  margin-right: 5%;
  margin-bottom: 5%;
  float: left;
}
.footer .footer-brand {
  float: left;
  font-size: 0.875rem;
  line-height: 44px;
}
.footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
.footer ul:not(.links-vertical) {
  line-height: 3.1;
}
.footer ul.links-vertical {
  line-height: 1.6;
}
.footer ul.links-vertical li {
  display: block;
  margin-left: -5px;
  margin-right: -5px;
  margin-bottom: 0px;
}
.footer ul.links-vertical li a {
  padding: 5px;
  display: block;
}
.footer ul li {
  display: inline-block;
}
.footer ul li a {
  color: inherit;
  padding: 13px 0.5rem;
  font-size: 0.8571em;
  text-transform: uppercase;
  text-decoration: none;
}
.footer ul li a:hover {
  text-decoration: none;
}
.footer .social-buttons a,
.footer .social-buttons .btn {
  margin: 0;
}
.footer .pull-center {
  display: inline-block;
  float: none;
}
.footer .copyright {
  font-size: 0.8571em;
  line-height: 3.5;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

.card {
  border: 0;
  border-radius: 0.1875rem;
  display: inline-block;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.card .card-header {
  background-color: transparent;
  border-bottom: 0;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
}
.card .card-footer {
  padding: 0;
  margin-top: 15px;
  background-color: transparent;
  border: 0;
}
.card[data-background-color=orange] {
  background-color: #f96332;
}
.card[data-background-color=red] {
  background-color: #FF3636;
}
.card[data-background-color=yellow] {
  background-color: #FFB236;
}
.card[data-background-color=blue] {
  background-color: #2CA8FF;
}
.card[data-background-color=green] {
  background-color: #15b60d;
}

.card .rounded {
  border-radius: 0.1875rem !important;
}
.card:not(.card-plain) .rounded {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.card a[data-toggle=collapse] {
  text-decoration: none;
}
.card a:not(.btn):not(.nav-link):not([data-toggle=collapse]):not(.footer-link) {
  text-decoration: none;
  border-bottom: 2px solid transparent;
  color: #444;
}
.card a:not(.btn):not(.nav-link):not([data-toggle=collapse]):not(.footer-link):hover, .card a:not(.btn):not(.nav-link):not([data-toggle=collapse]):not(.footer-link):focus {
  border-color: #444;
}
.card-collapse .card .card-header {
  padding: 0.75rem 0;
  position: relative;
}
.card-collapse .card .card-header:after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #E3E3E3;
}
.card-collapse .card .card-header a[data-toggle=collapse] {
  display: block;
  color: #444;
}
.card-collapse .card .card-header a[data-toggle=collapse][aria-expanded=true] i, .card-collapse .card .card-header a[data-toggle=collapse].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}
.card-collapse .card .card-header a[data-toggle=collapse] i {
  float: right;
  position: relative;
  color: #f96332;
  top: 1px;
  transition: all 300ms ease 0s;
}
.card .card-image {
  position: relative;
}
.card .card-footer div {
  display: inline-block;
}
.card .card-footer .stats.stats-right {
  float: right;
  line-height: 30px;
}
.card .card-footer .stats span:first-child {
  margin-right: 30px;
}
.card:not(.card-product) .card-footer .stats .now-ui-icons {
  position: relative;
  top: 3px;
  font-size: 18px;
  margin-right: 5px;
}
.card:not(.card-product) .card-footer .stats i {
  color: #a2a2a2;
}
.card .card-title {
  margin-top: 15px;
  line-height: 1.25em;
}
.card .author .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.card .author span {
  color: #9A9A9A;
}
.card .info {
  padding: 40px 0 40px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.card-background {
  background-position: center center;
  background-size: cover;
  text-align: center;
}
.card-background .card-body {
  position: relative;
  z-index: 2;
  min-height: 370px;
  max-width: 530px;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 60px;
}
.card-background.card-background-product .card-body {
  max-width: 400px;
}
.card-background.card-background-product .card-body .card-title {
  margin-top: 30px;
}
.card-background .stats {
  color: #FFFFFF;
}
.card-background .card-footer .stats-link > a {
  color: #FFFFFF;
  line-height: 1.9;
}
.card-background .category,
.card-background .card-description,
.card-background small {
  color: rgba(255, 255, 255, 0.8);
}
.card-background .card-title {
  color: #FFFFFF;
  margin-top: 130px;
}
.card-background:not(.card-pricing) .btn {
  margin-bottom: 0;
}
.card-background:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.63);
  border-radius: 0.25rem;
}

.card-blog .row .category {
  margin-bottom: 0;
}
.card-blog .card-image + .category {
  margin-top: 20px;
}

.card-contact .header .title {
  margin: 10px 0 10px;
}

.card-fashion {
  min-height: 500px;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  display: block;
}
.card-container .card-fashion {
  width: 50%;
  float: left;
}
.card-fashion:not(.card-background) .card-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 85%;
}
.card-fashion h4 {
  margin-top: 0;
}
.card-fashion.card-background::after {
  border-radius: 0;
}
.card-fashion.card-background a {
  color: #FFFFFF !important;
}
.card-fashion.card-background a:hover, .card-fashion.card-background a:focus {
  border-color: #FFFFFF !important;
}
.card-fashion:not(.card-background) .stats span,
.card-fashion .stats-link {
  color: initial;
}
.card-fashion .card-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2rem 2rem 1.4rem;
  color: #fff;
  min-height: auto;
}
.card-fashion:not(.card-background):before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  z-index: 2;
  position: absolute;
  pointer-events: none;
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #ffffff;
  border-width: 10px;
  margin-top: -10px;
}
.card-fashion.arrow-left:not(.card-background):before {
  right: 100%;
  border-right-color: #fff;
  left: auto;
  border-left: none;
}

.card-form-horizontal .card-body {
  padding-left: 15px;
  padding-right: 15px;
}
.card-form-horizontal .form-group {
  padding-bottom: 0px;
  margin: 3px 0 0 0;
}
.card-form-horizontal .form-group .form-control {
  margin-bottom: 0;
}
.card-form-horizontal .btn {
  margin: 0;
}
.card-form-horizontal .input-group,
.card-form-horizontal .form-group {
  margin: 0;
}

.card-no-shadow {
  box-shadow: none;
  border-radius: 0;
  margin: 0;
}
.card-no-shadow:after {
  border-radius: 0;
}

.card-plain {
  background: transparent;
  box-shadow: none;
}
.card-plain .card-body,
.card-plain .card-header {
  padding-left: 5px;
  padding-right: 5px;
}
.card-plain .card-header:after {
  width: 100%;
  left: 0;
}

.card-pricing {
  text-align: center;
}
.card-pricing .card-title {
  margin-top: 30px;
}
.card-pricing .icon {
  padding: 10px 0 0px;
}
.card-pricing .icon i {
  font-size: 30px;
  line-height: 2.7;
  max-width: 80px;
  color: #888888;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);
  background-color: #FFFFFF;
  position: relative;
}
.card-pricing .icon.icon-primary i {
  box-shadow: 0px 9px 30px -6px #f96332;
  color: #f96332;
}
.card-pricing .icon.icon-info i {
  box-shadow: 0px 9px 30px -6px #2CA8FF;
  color: #2CA8FF;
}
.card-pricing .icon.icon-success i {
  color: #18ce0f;
  box-shadow: 0px 9px 30px -6px rgba(22, 199, 13, 0.85);
}
.card-pricing .icon.icon-warning i {
  box-shadow: 0px 9px 30px -6px #FFB236;
  color: #FFB236;
}
.card-pricing .icon.icon-danger i {
  box-shadow: 0px 9px 30px -6px #FF3636;
  color: #FF3636;
}
.card-pricing h1 small {
  font-size: 18px;
}
.card-pricing h1 small:first-child {
  position: relative;
  top: -17px;
  font-size: 26px;
}
.card-pricing ul {
  list-style: none;
  padding: 0;
  max-width: 240px;
  margin: 10px auto;
}
.card-pricing ul li {
  color: #888888;
  text-align: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(136, 136, 136, 0.3);
}
.card-pricing ul li:last-child {
  border: 0;
}
.card-pricing ul li b {
  color: #2c2c2c;
}
.card-pricing ul li i {
  top: 3px;
  right: 3px;
  position: relative;
  font-size: 20px;
}
.card-pricing.card-background ul li {
  color: #FFFFFF;
  border-color: rgba(255, 255, 255, 0.3);
}
.card-pricing.card-background ul li b {
  color: #FFFFFF;
}
.card-pricing.card-background [class*=text-] {
  color: #FFFFFF !important;
}
.card-pricing.card-background .card-body {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.card-pricing.card-background:after {
  background-color: rgba(0, 0, 0, 0.65);
}

.card-testimonial, .card-profile {
  margin-top: 60px;
  text-align: center;
}
.card-testimonial .card-body .card-title, .card-profile .card-body .card-title {
  margin-top: 0;
}
.card-testimonial [class*=col-] .card-description, .card-profile [class*=col-] .card-description {
  margin-bottom: 0;
}
.card-testimonial [class*=col-] .card-description + .card-footer, .card-profile [class*=col-] .card-description + .card-footer {
  margin-top: 8px;
}
.card-testimonial .card-avatar, .card-profile .card-avatar {
  max-width: 130px;
  max-height: 130px;
  margin: -60px auto 0;
}
.card-testimonial .card-avatar img, .card-profile .card-avatar img {
  border-radius: 50% !important;
}
.card-testimonial .card-avatar + .card-body, .card-profile .card-avatar + .card-body {
  margin-top: 15px;
}
.card-plain.card-testimonial .card-avatar, .card-plain.card-profile .card-avatar {
  margin-top: 0;
}
.card-testimonial .card-body .card-avatar, .card-profile .card-body .card-avatar {
  margin: 0 auto 30px;
}

.card-product {
  margin-top: 30px;
}
.card-product .price-container {
  margin-top: 9px;
}
.card-product .btn {
  margin: 0;
}
.card-product .image {
  overflow: hidden;
  border-radius: 0.25rem;
}
.card-product .card-footer {
  margin-top: 5px;
}
.card-product .card-footer .price h4 {
  margin-bottom: 0;
  margin-top: 0;
}
.card-product .card-footer .stats {
  margin-top: 5px;
}
.card-product .card-footer .stats .btn {
  position: relative;
  top: -3px;
}
.card-product .card-title,
.card-product .category,
.card-product .card-description {
  text-align: center;
}
.card-product .category {
  margin-bottom: 0;
}
.card-product .category ~ .card-title {
  margin-top: 0;
}
.card-product .price {
  font-size: 16px;
  color: #888888;
}
.card-product .price-old {
  text-decoration: line-through;
  font-size: 16px;
  color: #888888;
}
.card-product .price-new {
  color: #FF3636;
}
.card-product:not(.card-plain) .card-image {
  padding: 15px;
}

.card-raised {
  box-shadow: 0px 20px 50px 0px rgba(0, 0, 0, 0.3);
}
.card-raised.card-plain {
  box-shadow: none;
}

.card-signup {
  max-width: 350px;
  margin: 0 auto;
}
.card-signup .card-header {
  margin: 0 20px;
  padding: 30px 0;
}
.card-signup .card-title {
  margin-top: 15px;
  margin-bottom: 15px;
}
.card-signup .card-footer {
  margin-bottom: 10px;
  margin-top: 24px;
  padding: 24px 0;
}
.card-signup .card-body {
  padding-top: 0px;
  padding-bottom: 0px;
  min-height: auto;
}
.card-signup .form-check,
.card-signup .form-check.form-check-radio {
  margin-top: 20px;
}
.card-signup .form-check label,
.card-signup .form-check.form-check-radio label {
  margin-left: 11px;
  color: initial;
  padding-left: 40px;
}
.card-signup .card-description {
  margin-top: 15px;
  margin-bottom: 20px;
}
.card-signup .social-line {
  margin-top: 20px;
  text-align: center;
}
.card-signup .social-line .btn.btn-icon,
.card-signup .social-line .btn.btn-icon .btn-icon {
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 0;
  margin-bottom: 0;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);
}

.card-testimonial .card-body {
  padding-top: 25px;
}
.card-testimonial .card-avatar {
  max-width: 100px;
  max-height: 100px;
  margin-top: -50px;
}
.card-testimonial .card-footer {
  margin-top: 0;
  margin-bottom: 2.5rem;
}
.card-testimonial .card-description + .card-title {
  margin-top: 30px;
}
.card-testimonial .icon i {
  font-size: 32px;
}
.card-testimonial .icon.icon-primary i {
  color: #f96332;
}
.card-testimonial .icon.icon-info i {
  color: #2CA8FF;
}
.card-testimonial .icon.icon-danger i {
  color: #FF3636;
}
.card-testimonial .icon.icon-warning i {
  color: #FFB236;
}
.card-testimonial .icon.icon-success i {
  color: #18ce0f;
}
.card-testimonial .card-description + .card-title {
  margin-top: 20px;
}

.index-page .page-header,
.presentation-page .page-header {
  height: 125vh;
}
.index-page .page-header .container > .content-center,
.presentation-page .page-header .container > .content-center {
  top: 37%;
}

.index-page .category-absolute,
.presentation-page .category-absolute {
  position: absolute;
  top: 100vh;
  margin-top: -60px;
  padding: 0 15px;
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
}

.presentation-page .section-sections .section-description {
  text-align: center;
  margin-bottom: 60px;
}
.presentation-page .section-sections .col-md-3 {
  padding: 7.5px;
}
.presentation-page .section-sections img {
  width: 100%;
  border-radius: 0.1875rem;
  transition: all 0.2s ease 0s;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.presentation-page .section-sections img:hover {
  transform: scale(1.02);
}
.presentation-page .section-pricing .card-pricing {
  margin-top: 45px;
}
.presentation-page .section-pricing .card-margin {
  margin-top: 90px;
}

.blog-posts .projects-4 {
  padding-top: 0;
}

.ecommerce-page .container {
  position: relative;
  z-index: 2;
}
.ecommerce-page .card-header {
  padding-left: 0;
  padding-right: 0;
}
.ecommerce-page .card-header:after {
  width: 100%;
  left: 0;
}
.ecommerce-page .slider-refine {
  margin: 15px 0;
}
.ecommerce-page .card-refine > .card-title {
  margin-bottom: 30px;
}
.ecommerce-page .card-refine [role=tabpanel] {
  max-height: 273px;
  overflow-y: scroll;
}
.ecommerce-page .card-refine h6 {
  margin-top: 0.5rem;
}
.ecommerce-page .card-refine .card-body {
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 0;
}
.ecommerce-page .card-refine .card-body.panel-refine {
  padding-left: 15px;
  padding-right: 15px;
}
.ecommerce-page .card-refine .price-right,
.ecommerce-page .card-refine .price-left {
  font-weight: 500;
}
.ecommerce-page .card-refine .btn {
  margin: -5px -12px;
}
.ecommerce-page .card-refine .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background: #f96332;
}
.ecommerce-page .card-product .card-image {
  width: 200px;
  margin: 0 auto;
}

.product-page {
  background-color: #eee;
}
.product-page .carousel {
  margin: -90px 0px 0;
}
.product-page .carousel img {
  border-radius: 0.1875rem;
  height: auto;
}
.product-page .section {
  padding-top: 30px;
}
.product-page .main-price {
  margin: 10px 0 25px;
  font-weight: 300;
}
.product-page .blockquote {
  width: 90%;
  margin-top: -10px;
  margin-left: 5%;
}
.product-page .pick-size {
  margin-top: 15px;
  margin-bottom: 15px;
}
.product-page .pick-size .form-group {
  margin-top: 5px;
}
.product-page .related-products .title {
  margin-bottom: 80px;
}
.product-page .features {
  padding-top: 30px;
}
.product-page .accordeon .card {
  margin-bottom: 15px;
}

.landing-page .page-header {
  height: 100vh;
  position: relative;
}
.landing-page .page-header .share {
  margin-top: 150px;
}
.landing-page .page-header h1 {
  font-weight: 600;
}
.landing-page .page-header .title {
  color: #FFFFFF;
}
.landing-page .section-team .team .team-player img {
  max-width: 100px;
}
.landing-page .section-team .team-player {
  margin-bottom: 15px;
}
.landing-page .section-contact-us .title {
  margin-bottom: 15px;
}
.landing-page .section-contact-us .description {
  margin-bottom: 30px;
}
.landing-page .section-contact-us .input-group,
.landing-page .section-contact-us .send-button,
.landing-page .section-contact-us .textarea-container {
  padding: 0 40px;
}
.landing-page .section-contact-us .textarea-container {
  margin: 40px 0;
}
.landing-page .section-contact-us a.btn {
  margin-top: 35px;
}

.profile-page .button-container,
.blog-post .button-container {
  text-align: center;
  margin-top: -112px;
  position: relative;
  z-index: 100;
}

.profile-page .profile-container {
  color: #FFFFFF;
}
.profile-page .photo-container {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.profile-page .title {
  text-align: center;
  margin-top: 30px;
}
.profile-page .category {
  text-align: center;
}
.profile-page h5.description {
  max-width: 700px;
  margin: 20px auto 75px;
}
.profile-page .nav-align-center {
  margin-top: 30px;
}
.profile-page .info-horizontal {
  padding: 15px 0 0;
}
.profile-page .content {
  max-width: 450px;
  margin: 0 auto;
}
.profile-page .content .social-description {
  display: inline-block;
  max-width: 150px;
  width: 145px;
  text-align: center;
  margin: 15px 0 0px;
}
.profile-page .content .social-description h2 {
  margin-bottom: 5px;
}
.profile-page .collections img {
  margin-bottom: 30px;
}
.profile-page .gallery {
  margin-top: 45px;
  padding-bottom: 50px;
}

.section-full-page:after, .section-full-page:before {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.section-full-page:before {
  background-color: rgba(0, 0, 0, 0.5);
}
.section-full-page[filter-color=purple]:after, .section-full-page[filter-color=primary]:after {
  background: rgba(227, 227, 227, 0.26); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(227, 227, 227, 0.26), rgba(249, 99, 50, 0.95)); /* Standard syntax */
}
.section-full-page[data-image]:after {
  opacity: 0.5;
}
.section-full-page > .content,
.section-full-page > .footer {
  position: relative;
  z-index: 4;
}
.section-full-page > .content {
  min-height: calc(100vh - 80px);
}
.section-full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.section-full-page .footer nav > ul a:not(.btn),
.section-full-page .footer,
.section-full-page .footer .copyright a {
  color: #FFFFFF;
}

.signup-page .section {
  padding-top: 180px;
  padding-bottom: 0;
}
.signup-page .input-group, .signup-page .form-group {
  margin-bottom: 20px;
}
.signup-page .card-signup {
  max-width: 100%;
  margin-bottom: 130px;
  padding: 15px 0px;
}
.signup-page .card-signup:not([data-background-color]) .card-title {
  color: initial;
}
.signup-page .card-signup .checkbox label {
  margin-left: 14px;
  padding-left: 39px;
  color: initial;
}
.signup-page .info-horizontal {
  padding: 0px 0px 20px;
}
.signup-page .social .btn {
  margin: 5px;
}
.signup-page .social h4 {
  margin-top: 20px;
}

.login-page .page-header {
  display: block;
  align-items: unset;
}
.login-page .card-login {
  border-radius: 0.25rem;
  padding-bottom: 0.7rem;
  max-width: 320px;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 40px;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-focus .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus, .login-page .card-login.card-plain .form-group.no-border .form-control:active, .login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text:focus, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text:active, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-text {
  color: rgba(255, 255, 255, 0.8);
}
.login-page .link {
  font-size: 10px;
  color: #FFFFFF !important;
  text-decoration: none;
}
.login-page .link:hover, .login-page .link:focus {
  border-color: #FFFFFF !important;
}

.contact-page .contact-content {
  padding-bottom: 40px;
  padding-top: 40px;
}
.contact-page .container {
  max-width: 970px;
}
.contact-page .big-map {
  height: 55vh;
  width: 100%;
  display: block;
  position: relative;
}
.contact-page .message {
  margin-top: 20px;
}
.contact-page .info {
  padding-bottom: 10px;
  padding-top: 0px;
}
.contact-page .info .title {
  margin: 25px 0 10px;
}

.blog-post .section-blog-info {
  padding-top: 30px;
  padding-bottom: 0px;
}
.blog-post .section-blog-info .btn {
  margin-top: 0;
  margin-bottom: 0;
}
.blog-post .section-blog-info .blog-tags {
  padding-top: 8px;
}
.blog-post .section-blog-info .card-profile {
  margin-top: 0;
  text-align: left;
}
.blog-post .section-blog-info .card-profile .description {
  font-size: 14px;
}
.blog-post .section-blog-info .card-profile .btn {
  margin-top: 25px;
}
.blog-post .section-comments .title {
  margin-bottom: 30px;
}
.blog-post .media p {
  color: #888888;
}

.about-us .page-header .container {
  color: #FFFFFF;
  text-align: center;
}
.about-us .page-header .title {
  color: #FFFFFF;
}
.about-us .about-description {
  padding: 70px 0px 0px 0px;
}
.about-us .about-services {
  padding-top: 10px;
}
.about-us .about-office .description {
  margin-bottom: 70px;
}
.about-us .about-office img {
  margin: 20px 0px;
}
.about-us .about-contact,
.about-us .about-office {
  padding: 80px 0px;
}
.about-us .about-contact .description,
.about-us .about-office .description {
  margin-bottom: 70px;
}

.sections-page .page-header {
  display: flex;
  align-items: center;
}

.section {
  padding: 70px 0;
  position: relative;
  background: #FFFFFF;
}
.section .row + .category {
  margin-top: 15px;
}

.section-navbars {
  padding-bottom: 0;
}

.section-full-screen {
  height: 100vh;
}

.section-signup {
  padding-top: 20vh;
}

.page-header {
  min-height: 100vh;
  max-height: 999px;
  padding: 0;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
}
.page-header > .content {
  margin-top: 12%;
  text-align: center;
  margin-bottom: 50px;
}
.page-header.page-header-small {
  min-height: 60vh;
  max-height: 440px;
}
.page-header:before {
  background-color: rgba(0, 0, 0, 0.3);
}
.page-header > .container {
  z-index: 2;
  padding-top: 12vh;
  padding-bottom: 40px;
}
.page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.page-header .content-center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #FFFFFF;
  padding: 0 15px;
  width: 100%;
  max-width: 880px;
}
.page-header footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.page-header .container {
  height: 100%;
  z-index: 1;
  text-align: center;
  position: relative;
}
.page-header .category,
.page-header .description {
  color: rgba(255, 255, 255, 0.8);
}
.page-header:after, .page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}

.clear-filter:after, .clear-filter:before {
  display: none;
}
.clear-filter[filter-color=orange] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(224, 23, 3, 0.6)); /* Standard syntax */
}

.section-story-overview {
  padding: 50px 0;
}
.section-story-overview .image-container {
  height: 335px;
  position: relative;
  background-position: center center;
  background-size: cover;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0.25rem;
}
.section-story-overview .image-container + .category {
  padding-top: 15px;
}
.section-story-overview .image-container.image-right {
  z-index: 2;
}
.section-story-overview .image-container.image-right + h3.title {
  margin-top: 120px;
}
.section-story-overview .image-container.image-left {
  z-index: 1;
}
.section-story-overview .image-container:nth-child(2) {
  margin-top: 420px;
  margin-left: -105px;
}
.section-story-overview p.blockquote {
  width: 220px;
  min-height: 180px;
  text-align: left;
  position: absolute;
  top: 376px;
  right: 155px;
  z-index: 0;
}

.section-nucleo-icons .nucleo-container img {
  width: auto;
  left: 0;
  top: 0;
  height: 100%;
  position: absolute;
}
.section-nucleo-icons .nucleo-container {
  height: 335px;
  position: relative;
}
.section-nucleo-icons h5 {
  margin-bottom: 35px;
}
.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 450px;
  height: 300px;
  max-height: 300px;
  margin: 0 auto;
}
.section-nucleo-icons .icons-container i {
  font-size: 34px;
  position: absolute;
  left: 0;
  top: 0;
}
.section-nucleo-icons .icons-container i:nth-child(1) {
  top: 5%;
  left: 7%;
}
.section-nucleo-icons .icons-container i:nth-child(2) {
  top: 28%;
  left: 24%;
}
.section-nucleo-icons .icons-container i:nth-child(3) {
  top: 40%;
}
.section-nucleo-icons .icons-container i:nth-child(4) {
  top: 18%;
  left: 62%;
}
.section-nucleo-icons .icons-container i:nth-child(5) {
  top: 74%;
  left: 3%;
}
.section-nucleo-icons .icons-container i:nth-child(6) {
  top: 36%;
  left: 44%;
  font-size: 65px;
  color: #f96332;
  padding: 1px;
}
.section-nucleo-icons .icons-container i:nth-child(7) {
  top: 59%;
  left: 26%;
}
.section-nucleo-icons .icons-container i:nth-child(8) {
  top: 60%;
  left: 69%;
}
.section-nucleo-icons .icons-container i:nth-child(9) {
  top: 72%;
  left: 47%;
}
.section-nucleo-icons .icons-container i:nth-child(10) {
  top: 88%;
  left: 27%;
}
.section-nucleo-icons .icons-container i:nth-child(11) {
  top: 31%;
  left: 80%;
}
.section-nucleo-icons .icons-container i:nth-child(12) {
  top: 88%;
  left: 68%;
}
.section-nucleo-icons .icons-container i:nth-child(13) {
  top: 5%;
  left: 81%;
}
.section-nucleo-icons .icons-container i:nth-child(14) {
  top: 58%;
  left: 90%;
}
.section-nucleo-icons .icons-container i:nth-child(15) {
  top: 6%;
  left: 40%;
}

.section-images {
  max-height: 670px;
  height: 670px;
}
.section-images .hero-images-container,
.section-images .hero-images-container-1,
.section-images .hero-images-container-2 {
  margin-top: -38vh;
}
.section-images .hero-images-container {
  max-width: 670px;
}
.section-images .hero-images-container-1 {
  max-width: 390px;
  position: absolute;
  top: 55%;
  right: 18%;
}
.section-images .hero-images-container-2 {
  max-width: 225px;
  position: absolute;
  top: 68%;
  right: 12%;
}

[data-background-color=orange] {
  background-color: #e95e38;
}

[data-background-color=black] {
  background-color: #2c2c2c;
}

[data-background-color]:not([data-background-color=gray]) {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .title,
[data-background-color]:not([data-background-color=gray]) .social-description h2,
[data-background-color]:not([data-background-color=gray]) p,
[data-background-color]:not([data-background-color=gray]) p.blockquote,
[data-background-color]:not([data-background-color=gray]) p.blockquote small {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .separator {
  background-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .navbar.bg-white p {
  color: #888888;
}
[data-background-color]:not([data-background-color=gray]) h1, [data-background-color]:not([data-background-color=gray]) h2, [data-background-color]:not([data-background-color=gray]) h3, [data-background-color]:not([data-background-color=gray]) h4, [data-background-color]:not([data-background-color=gray]) h5, [data-background-color]:not([data-background-color=gray]) h6, [data-background-color]:not([data-background-color=gray]) a:not(.btn):not(.dropdown-item),
[data-background-color]:not([data-background-color=gray]) .icons-container {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .input-group-text,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-text {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) .description,
[data-background-color]:not([data-background-color=gray]) .social-description p {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) p.blockquote {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .checkbox label::before,
[data-background-color]:not([data-background-color=gray]) .checkbox label::after,
[data-background-color]:not([data-background-color=gray]) .radio label::before,
[data-background-color]:not([data-background-color=gray]) .radio label::after {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .checkbox label::after,
[data-background-color]:not([data-background-color=gray]) .checkbox label,
[data-background-color]:not([data-background-color=gray]) .radio label {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .checkbox input[type=checkbox]:disabled + label,
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:disabled + label {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:not(:disabled):hover + label::after,
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:checked + label::after {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .has-success:after,
[data-background-color]:not([data-background-color=gray]) .has-danger:after {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .has-danger .form-control {
  background-color: transparent;
}
[data-background-color]:not([data-background-color=gray]) .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .input-group-focus .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:active, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text:focus, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text:active, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus + .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus + .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border.input-group-focus .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border.input-group-focus .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-] {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:hover, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:focus, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled):active, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled).active, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled):active:focus, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:not(:disabled):not(.disabled).active:focus, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-]:active:hover, [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].active:hover, .show > [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].dropdown-toggle, .show > [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].dropdown-toggle:focus, .show > [data-background-color]:not([data-background-color=gray]) .btn[class*=btn-outline-].dropdown-toggle:hover {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .nav-tabs > .nav-item > .nav-link i.now-ui-icons {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).section-nucleo-icons .icons-container i:nth-child(6) {
  color: #FFFFFF;
}

.parallax-s {
  overflow: hidden;
  height: 500px;
  width: 100%;
}

.section-image {
  background-size: cover;
  background-position: center center;
  position: relative;
  width: 100%;
}
.section-image .title,
.section-image .card-plain .card-title {
  color: #FFFFFF;
}
.section-image .nav-pills .nav-link {
  background-color: #FFFFFF;
}
.section-image .nav-pills .nav-link:hover, .section-image .nav-pills .nav-link:focus {
  background-color: #FFFFFF;
}
.section-image .info-title,
.section-image .info.info-horizontal .icon i,
.section-image .card-pricing.card-plain ul li {
  color: #FFFFFF;
}
.section-image .description,
.section-image .info .icon:not(.icon-circle) {
  color: rgba(255, 255, 255, 0.8);
}
.section-image .card:not(.card-plain) .info-title {
  color: #2c2c2c;
}
.section-image .card:not(.card-plain) .info p,
.section-image .card:not(.card-plain) .info .icon,
.section-image .card:not(.card-plain) .description {
  color: #9A9A9A;
}
.section-image .footer {
  color: #FFFFFF;
}
.section-image .card-plain [class*=text-],
.section-image .card-plain ul li b {
  color: #FFFFFF;
}
.section-image .card-plain .category {
  color: rgba(255, 255, 255, 0.5);
}
.section-image:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.7);
}
.section-image .container {
  z-index: 2;
  position: relative;
}

.signup-page .page-header {
  max-height: fit-content;
  display: block;
  align-items: unset;
}
.page-header.page-header-mini {
  min-height: 40vh;
  max-height: 340px;
}
.page-header .title {
  margin-bottom: 15px;
}
.page-header .title + h4 {
  margin-top: 10px;
}

.section-story-overview {
  padding: 50px 0;
}
.section-story-overview .image-container img {
  width: 100%;
  left: 0;
  top: 0;
  height: auto;
  position: absolute;
}

[data-background-color=gray] {
  background-color: #eeeeee;
}

[data-background-color]:not([data-background-color=gray]) .separator-line {
  background-color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color=gray]) .footer.footer-white .footer-brand, [data-background-color]:not([data-background-color=gray]) .footer.footer-white ul li > a.nav-link:not(.btn-icon) {
  color: initial;
}
[data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .category,
[data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .card-description, [data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .category, [data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .category {
  color: #9A9A9A;
}
[data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .card-title, [data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .card-title {
  color: initial;
}
[data-background-color]:not([data-background-color=gray]) .carousel .carousel-inner {
  box-shadow: none;
}
[data-background-color]:not([data-background-color=gray]) h1, [data-background-color]:not([data-background-color=gray]) h2, [data-background-color]:not([data-background-color=gray]) h3, [data-background-color]:not([data-background-color=gray]) h4, [data-background-color]:not([data-background-color=gray]) h5, [data-background-color]:not([data-background-color=gray]) h6,
[data-background-color]:not([data-background-color=gray]) a:not(.btn):not(.dropdown-item):not(.card-link),
[data-background-color]:not([data-background-color=gray]) .icons-container i, [data-background-color]:not([data-background-color=gray]).card-pricing ul li,
[data-background-color]:not([data-background-color=gray]) .info.info-horizontal .icon i,
[data-background-color]:not([data-background-color=gray]) .card-pricing.card-plain ul li {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).card a:not(.btn):not(.dropdown-item) {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).card a:not(.btn):not(.dropdown-item):hover, [data-background-color]:not([data-background-color=gray]).card a:not(.btn):not(.dropdown-item):focus {
  border-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).footer hr, [data-background-color]:not([data-background-color=gray]).card-pricing .icon i, [data-background-color]:not([data-background-color=gray]).card-pricing ul li {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .card-footer .stats i, [data-background-color]:not([data-background-color=gray]).card-plain .category,
[data-background-color]:not([data-background-color=gray]) .card-plain .category,
[data-background-color]:not([data-background-color=gray]) .card-header:after {
  color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color=gray]).card-pricing ul li i, [data-background-color]:not([data-background-color=gray]).card-pricing ul li b,
[data-background-color]:not([data-background-color=gray]) .card-pricing.card-plain ul li b,
[data-background-color]:not([data-background-color=gray]) .card-category,
[data-background-color]:not([data-background-color=gray]) .author span,
[data-background-color]:not([data-background-color=gray]) .card-pricing.card-plain ul li i {
  color: rgba(255, 255, 255, 0.8) !important;
}
[data-background-color]:not([data-background-color=gray]) .input-group-text,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-text {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) .subscribe-line .form-control {
  background-color: transparent;
  border: 1px solid #E3E3E3;
  color: #2c2c2c;
}
[data-background-color]:not([data-background-color=gray]) .subscribe-line .form-control:last-child {
  border-left: 0 none;
}
[data-background-color]:not([data-background-color=gray]) .subscribe-line .input-group-text,
[data-background-color]:not([data-background-color=gray]) .subscribe-line .form-group.no-border .input-group-text,
[data-background-color]:not([data-background-color=gray]) .subscribe-line .input-group.no-border .input-group-text {
  color: #555555;
  border: 1px solid #E3E3E3;
}

[class*=features-],
[class*=team-],
[class*=projects-],
[class*=pricing-],
[class*=testimonials-],
[class*=contactus-] {
  padding: 80px 0;
}

.page-header .carousel .carousel-indicators {
  bottom: 60px;
}
.page-header .container {
  color: #FFFFFF;
}
.page-header .title {
  color: #FFFFFF;
}
.page-header.header-small {
  height: 65vh;
  min-height: 65vh;
}
.page-header.header-small .container {
  padding-top: 20vh;
}

.header-filter {
  position: relative;
}
.header-filter .container {
  z-index: 2;
  position: relative;
}
.header-filter .info-title,
.header-filter .info.info-horizontal .icon i,
.header-filter .card-pricing.card-plain ul li {
  color: #FFFFFF;
}
.header-filter[filter-color=orange] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(224, 23, 3, 0.6)); /* Standard syntax */
}
.header-filter[filter-color=black] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(0, 0, 0, 0.7)); /* Standard syntax */
}

.clear-filter:before {
  display: none;
}

.iframe-container iframe {
  width: 100%;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.3);
}

.header-1 .wrapper,
.header-2 .wrapper,
.header-3 .wrapper {
  background: #CCCCCC;
}
.header-1 .content-center,
.header-2 .content-center,
.header-3 .content-center {
  max-width: none !important;
}

.header-2 .page-header .card,
.header-1 .page-header .card {
  margin-top: 60px;
}

.header-3 .btn {
  margin: 0;
}
.header-3 h6 {
  margin-bottom: 0;
}

.phone-container img {
  width: 100%;
}

.features-2,
.features-1,
.features-3 {
  text-align: center;
}

.features-4 .card {
  margin-top: 70px;
}

.features-2 .info-title,
.features-2 .title {
  color: #FFFFFF;
}

.features-5 .info {
  max-width: none;
  margin: 0 auto;
  padding: 10px 0 0px;
}
.features-5 .phone-container {
  max-width: 200px;
  margin: 0 auto;
}

.features-6 .phone-container {
  max-width: 260px;
  margin: 60px auto 0;
}
.features-6 .info {
  max-width: none;
  margin: 0 auto;
  padding: 10px 0 0px;
}
.features-6 .info:first-child {
  padding-top: 130px;
}

.features-7,
.features-2,
.features-8 {
  position: relative;
}
.features-7:after,
.features-2:after,
.features-8:after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}
.features-7 .container,
.features-7 .container-fluid,
.features-7 .title,
.features-7 .description,
.features-2 .container,
.features-2 .container-fluid,
.features-2 .title,
.features-2 .description,
.features-8 .container,
.features-8 .container-fluid,
.features-8 .title,
.features-8 .description {
  position: relative;
  z-index: 2;
}

.features-8 .title,
.features-7 .title {
  color: #FFFFFF;
}

.features-8 .title + .description {
  margin-bottom: 70px;
}

.features-7 {
  overflow: hidden;
}
.features-7 .info-title {
  color: #FFFFFF;
}
.features-7 .info-horizontal {
  padding: 15px 0 0;
}
.features-7 .info-horizontal:first-child {
  padding-top: 45px;
}
.features-7 .image-container {
  max-width: 1200px;
  position: relative;
  height: 550px;
  margin-top: 58px;
}
.features-7 .image-container img {
  max-width: 1200px;
  left: 100px;
  top: 0;
  height: 100%;
  position: absolute;
}

.tablet-container {
  margin-top: 40px;
}

[class*=blogs-] {
  padding: 50px 0;
}

.blogs-1 .card {
  margin-bottom: 80px;
}

.blogs-4 .card {
  margin-bottom: 60px;
  text-align: center;
}

.team-2 .card .card-title {
  margin: 10px 0 0;
}
.team-2 .card h6 {
  margin-top: 5px;
}
.team-2 [class*=col-md-]:nth-child(2) {
  margin-top: 45px;
}

.team-3 .card.card-profile .card-image a > img {
  border-radius: 0;
  border-bottom-left-radius: 0.1875rem;
  border-top-left-radius: 0.1875rem;
}
.team-3 .card.card-profile .card-title {
  margin-top: 15px;
}

.team-4 .card {
  text-align: left;
}
.team-4 .card .footer {
  margin-top: 0;
}

.team-5 h5.description {
  margin-bottom: 100px;
}
.team-5 [class*=col-md-] {
  margin-top: 50px;
}
.team-5 [class*=col-md-]:nth-child(2) {
  margin-top: 95px;
}
.team-5 .card.card-profile .card-title + .category {
  margin-bottom: 0.625rem;
}

.projects-1 .card-title {
  margin-top: 10px;
}

.projects-2 h2.title {
  margin-top: 5px;
  margin-bottom: 15px;
}
.projects-2 .card-title {
  margin-bottom: 5px;
}
.projects-2 .category {
  color: #888888;
  margin-top: 5px;
}
.projects-2 .card-description {
  margin-top: 20px;
}
.projects-2 .card {
  text-align: center;
}

.projects-3 h2.title,
.projects-3 h3.title {
  margin-bottom: 80px;
  margin-top: 5px;
}
.projects-3 .card {
  margin-bottom: 30px;
  text-align: center;
}
.projects-3 .category {
  margin-bottom: 5px;
}
.projects-3 .card-title {
  margin-top: 10px;
}

.projects-5 h2.title {
  margin-top: 5px;
  margin-bottom: 15px;
}
.projects-5 .info {
  padding: 0;
}
.projects-5 .info p {
  margin: 0;
}
.projects-5 .card-background {
  margin-bottom: 0;
}
.projects-5 .card-background .card-body {
  padding-top: 140px;
  padding-bottom: 140px;
}
.projects-5 hr {
  margin: 70px auto;
  max-width: 970px;
}

.pricing-1 h2.title {
  margin-bottom: 10px;
}
.pricing-1 .card-separator {
  width: 1px;
  display: block;
  height: 100%;
  background-color: rgba(136, 136, 136, 0.2);
  position: absolute;
  left: 0;
  top: 0;
}

.pricing-2 .nav-pills {
  margin-bottom: 50px;
}

.pricing-5 .nav-pills {
  margin-top: 50px;
  margin-bottom: 50px;
}

.pricing-3 .title,
.pricing-4 .title {
  margin-bottom: 10px;
}

.testimonials-1 .description {
  margin-bottom: 50px;
}

.section-testimonials,
.testimonials-2 {
  background-image: none;
}
.section-testimonials .card-profile .card-title,
.section-testimonials .card-profile .card-description,
.testimonials-2 .card-profile .card-title,
.testimonials-2 .card-profile .card-description {
  text-align: left !important;
}
.section-testimonials .card-image,
.testimonials-2 .card-image {
  margin: 0;
}
.section-testimonials .carousel .carousel-inner,
.testimonials-2 .carousel .carousel-inner {
  box-shadow: none;
}
.section-testimonials .carousel .carousel-control-prev i,
.section-testimonials .carousel .carousel-control-next i,
.testimonials-2 .carousel .carousel-control-prev i,
.testimonials-2 .carousel .carousel-control-next i {
  color: #444;
}
.section-testimonials .testimonials-people,
.testimonials-2 .testimonials-people {
  position: relative;
}
.section-testimonials .testimonials-people img,
.testimonials-2 .testimonials-people img {
  position: absolute;
  border-radius: 50%;
  z-index: 4;
}
.section-testimonials .testimonials-people .left-first-person,
.testimonials-2 .testimonials-people .left-first-person {
  left: 2%;
  top: 2%;
  height: 70px;
  width: 70px;
}
.section-testimonials .testimonials-people .left-second-person,
.testimonials-2 .testimonials-people .left-second-person {
  left: 65%;
  top: 100%;
  height: 70px;
  width: 70px;
}
.section-testimonials .testimonials-people .left-third-person,
.testimonials-2 .testimonials-people .left-third-person {
  left: -25%;
  top: 135%;
  height: 120px;
  width: 120px;
}
.section-testimonials .testimonials-people .left-fourth-person,
.testimonials-2 .testimonials-people .left-fourth-person {
  left: 40%;
  top: 180%;
  height: 40px;
  width: 40px;
}
.section-testimonials .testimonials-people .left-fifth-person,
.testimonials-2 .testimonials-people .left-fifth-person {
  left: 95%;
  top: 220%;
  height: 45px;
  width: 45px;
}
.section-testimonials .testimonials-people .left-sixth-person,
.testimonials-2 .testimonials-people .left-sixth-person {
  left: 40%;
  top: 265%;
  height: 95px;
  width: 95px;
}
.section-testimonials .testimonials-people .right-first-person,
.testimonials-2 .testimonials-people .right-first-person {
  right: 2%;
  top: 0;
  height: 60px;
  width: 60px;
}
.section-testimonials .testimonials-people .right-second-person,
.testimonials-2 .testimonials-people .right-second-person {
  right: 30%;
  top: 60%;
  height: 70px;
  width: 70px;
}
.section-testimonials .testimonials-people .right-third-person,
.testimonials-2 .testimonials-people .right-third-person {
  right: 95%;
  top: 95%;
  height: 50px;
  width: 50px;
}
.section-testimonials .testimonials-people .right-fourth-person,
.testimonials-2 .testimonials-people .right-fourth-person {
  right: 66%;
  top: 145%;
  height: 40px;
  width: 40px;
}
.section-testimonials .testimonials-people .right-fifth-person,
.testimonials-2 .testimonials-people .right-fifth-person {
  right: 90%;
  top: 210%;
  height: 100px;
  width: 100px;
}
.section-testimonials .testimonials-people .right-sixth-person,
.testimonials-2 .testimonials-people .right-sixth-person {
  right: 15%;
  top: 240%;
  height: 70px;
  width: 70px;
}

.contactus-1 .info {
  padding: 0;
  margin: 0;
}
.contactus-1 .info:first-child {
  margin-top: 30px;
}
.contactus-1 .info .info-title {
  margin-top: 20px;
  color: #FFFFFF;
}
.contactus-1 .info .icon {
  margin-top: 19px;
  color: #FFFFFF;
}
.contactus-1 .card-contact {
  margin-top: 30px;
}

.contactus-2 {
  padding: 0;
  position: relative;
}
.contactus-2 .card-contact {
  max-width: 560px;
  margin: 80px 0 80px 150px;
}
.contactus-2 .card-contact .info {
  padding: 0;
  margin: 0;
}
.contactus-2 .map {
  width: 100%;
  height: 100%;
  position: absolute;
}
.contactus-2 .info-horizontal .icon {
  margin-top: 28px;
}
.contactus-2 .info-horizontal .icon > i {
  font-size: 2.2em;
  max-width: 45px;
}

.social-line-big-icons [class*=col-] {
  border-right: 1px solid #E3E3E3;
}
.social-line-big-icons [class*=col-]:last-child {
  border: 0;
}
.social-line-big-icons .btn {
  margin: 0;
  width: 100%;
  padding-top: 30px !important;
  padding-bottom: 30px !important;
  height: auto;
  border: 0;
}
.social-line-big-icons .btn .fab {
  font-size: 25px;
}

.social-line {
  padding: 0.85rem 0;
}

.subscribe-line {
  padding: 30px 0;
}
.subscribe-line .card {
  margin-top: 54px;
}
.subscribe-line .card .card-block {
  min-height: auto;
}
.subscribe-line.subscribe-line-image {
  position: relative;
  background-position: center center;
  background-size: cover;
}
.subscribe-line.subscribe-line-image .description {
  color: rgba(255, 255, 255, 0.8);
}
.subscribe-line.subscribe-line-image .title {
  color: #FFFFFF;
}
.subscribe-line.subscribe-line-image:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.66);
}
.subscribe-line.subscribe-line-image .container {
  z-index: 2;
  position: relative;
}

.social-line-white,
.subscribe-line-white {
  background-color: #FFFFFF;
}

.social-line-black,
.subscribe-line-black {
  background-color: #2c2c2c;
}
.social-line-black [class*=col-],
.subscribe-line-black [class*=col-] {
  border-color: rgba(255, 255, 255, 0.1);
}

[data-background-color] .social-line h1, [data-background-color] .social-line h2, [data-background-color] .social-line h3, [data-background-color] .social-line h4, [data-background-color] .social-line h5, [data-background-color] .social-line h6 {
  color: initial;
}
[data-background-color] .social-line .btn.btn-simple {
  border: 0;
}

@media screen and (max-width: 991px) {
  .navbar-collapse {
    position: fixed;
    display: block !important;
    top: 0;
    height: 100% !important;
    width: 300px;
    right: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    max-height: none !important;
    transform: translate3d(300px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .navbar-collapse:before {
    background: #f96332; /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
    background: linear-gradient(#f96332 0%, #000 80%); /* Standard syntax (must be last) */
    opacity: 0.76;
    filter: alpha(opacity=76);
    display: block;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link {
    margin: 0 1rem;
    margin-top: 0.3125rem;
  }
  .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link:not(.btn) {
    color: #FFFFFF !important;
  }
  .navbar-collapse .dropdown-menu .dropdown-item {
    color: #FFFFFF;
  }
  .menu-on-left .navbar-translate {
    flex-direction: row-reverse;
  }
  .navbar .navbar-nav {
    margin-top: 53px;
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
  }
  .navbar .navbar-nav.navbar-logo {
    top: 0;
    height: 53px;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0 1rem;
    margin-bottom: 15px;
    padding-top: 0;
    height: 125px;
    overflow-y: scroll;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown .dropdown-item {
    padding-left: 2.5rem;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
    border-radius: 0.1875rem;
  }
  .navbar .navbar-translate {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #FFFFFF;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background: #888888;
  }
  .top-bar {
    transform: rotate(0);
  }
  .middle-bar {
    opacity: 1;
  }
  .bottom-bar {
    transform: rotate(0);
  }
  .top-bar,
  .middle-bar,
  .bottom-bar {
    transition: all 0.2s;
  }
  .toggled .top-bar {
    transform: rotate(45deg);
    transform-origin: 0%;
  }
  .toggled .bottom-bar {
    transform: rotate(-45deg);
    transform-origin: 0%;
  }
  .toggled .middle-bar {
    opacity: 0;
  }
  [class*=navbar-expand-] .navbar-collapse {
    width: 300px;
  }
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    left: auto;
    right: 300px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  [class*=navbar-toggleable-] .navbar-collapse {
    width: 300px;
  }
  .button-dropdown {
    display: none;
  }
  .section-nucleo-icons .container .row > [class*=col-]:first-child {
    text-align: center;
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .section-images {
    height: 500px;
    max-height: 500px;
  }
  .section-images .hero-images-container {
    max-width: 500px;
  }
  .section-images .hero-images-container-1 {
    right: 10%;
    top: 68%;
    max-width: 269px;
  }
  .section-images .hero-images-container-2 {
    right: 5%;
    max-width: 135px;
    top: 93%;
  }
  .nav-open .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .wrapper {
    transform: translate3d(-150px, 0, 0);
  }
  .nav-open .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .menu-on-left .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-left .navbar-translate {
    transform: translate3d(300px, 0, 0);
  }
  .nav-open .menu-on-left .wrapper {
    transform: translate3d(150px, 0, 0);
  }
  .nav-open .menu-on-left #bodyClick {
    right: auto;
    left: 300px;
  }
}
@media screen and (min-width: 992px) {
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .navbar-nav .nav-link.btn:not(.btn-sm) {
    margin: 0;
  }
  .navbar-nav .nav-item:not(:last-child) {
    margin-right: 5px;
  }
  .navbar-collapse:not(.has-image) {
    background: transparent !important;
  }
  .card.card-form-horizontal [class*=col-sm-]:not(:last-child),
  .card.card-form-horizontal [class*=col-md-]:not(:last-child) {
    padding-right: 0;
  }
  .burger-menu .navbar-collapse {
    position: fixed;
    display: block !important;
    top: 0;
    height: 100% !important;
    width: 300px;
    right: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    max-height: none !important;
    transform: translate3d(300px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .navbar-collapse:before {
    background: #f96332; /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
    background: linear-gradient(#f96332 0%, #000 80%); /* Standard syntax (must be last) */
    opacity: 0.76;
    filter: alpha(opacity=76);
    display: block;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .burger-menu .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link {
    margin: 0 1rem;
    margin-top: 0.3125rem;
  }
  .burger-menu .navbar-collapse .navbar-nav:not(.navbar-logo) .nav-link:not(.btn) {
    color: #FFFFFF !important;
  }
  .burger-menu .navbar-collapse .dropdown-menu .dropdown-item {
    color: #FFFFFF;
  }
  .burger-menu .menu-on-left .navbar-translate {
    flex-direction: row-reverse;
  }
  .burger-menu .navbar .navbar-nav {
    margin-top: 53px;
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
  }
  .burger-menu .navbar .navbar-nav.navbar-logo {
    top: 0;
    height: 53px;
  }
  .burger-menu .navbar .dropdown.show .dropdown-menu,
  .burger-menu .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0 1rem;
    margin-bottom: 15px;
    padding-top: 0;
    height: 125px;
    overflow-y: scroll;
  }
  .burger-menu .navbar .dropdown.show .dropdown-menu:before,
  .burger-menu .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .burger-menu .navbar .dropdown .dropdown-item {
    padding-left: 2.5rem;
  }
  .burger-menu .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .burger-menu .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .burger-menu .navbar .dropdown-menu .dropdown-item:focus,
  .burger-menu .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
    border-radius: 0.1875rem;
  }
  .burger-menu .navbar .navbar-translate {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #FFFFFF;
  }
  .burger-menu .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .burger-menu .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .burger-menu .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background: #888888;
  }
  .burger-menu .top-bar {
    transform: rotate(0);
  }
  .burger-menu .middle-bar {
    opacity: 1;
  }
  .burger-menu .bottom-bar {
    transform: rotate(0);
  }
  .burger-menu .top-bar,
  .burger-menu .middle-bar,
  .burger-menu .bottom-bar {
    transition: all 0.2s;
  }
  .burger-menu .toggled .top-bar {
    transform: rotate(45deg);
    transform-origin: 0%;
  }
  .burger-menu .toggled .bottom-bar {
    transform: rotate(-45deg);
    transform-origin: 0%;
  }
  .burger-menu .toggled .middle-bar {
    opacity: 0;
  }
  .burger-menu [class*=navbar-expand-] .navbar-collapse {
    width: 300px;
  }
  .burger-menu .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    left: auto;
    right: 300px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .navbar-toggler {
    display: block;
  }
  .burger-menu .navbar-collapse {
    display: block !important;
  }
  .burger-menu .navbar-collapse .navbar-nav {
    position: relative;
    max-height: calc(100vh - 75px);
    min-height: 100%;
    overflow: auto;
    margin-top: 53px;
    height: 100%;
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .burger-menu .navbar-collapse .navbar-nav .nav-item {
    margin: 0;
  }
  .burger-menu .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }
  .burger-menu.menu-on-left .navbar-collapse {
    right: auto;
    left: 0;
    transform: translate3d(-300px, 0, 0);
  }
  .burger-menu.menu-on-left .navbar-translate {
    flex-direction: row-reverse;
  }
  .burger-menu .navbar-toggleable-md .navbar-nav .dropdown-menu {
    position: static;
    float: none;
  }
  .burger-menu .navbar-toggleable-md .navbar-toggler {
    display: inline-block;
  }
  .nav-open .burger-menu.menu-on-left .navbar .navbar-translate {
    transform: translate3d(300px, 0, 0);
  }
  .nav-open .burger-menu .navbar .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .burger-menu.menu-on-left .navbar-collapse,
  .nav-open .burger-menu .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .burger-menu.menu-on-left #bodyClick {
    right: auto;
    left: 300px;
  }
  .burger-menu.menu-on-left .navbar-brand {
    float: right;
    margin-right: 0;
    margin-left: 1rem;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .footer:not(.footer-big) .copyright {
    float: right;
  }
}
@media screen and (min-width: 768px) {
  .image-container.image-right {
    top: 80px;
    margin-left: -100px;
    margin-bottom: 130px;
  }
  .image-container.image-left {
    margin-right: -100px;
  }
}
@media screen and (max-width: 768px) {
  .image-container.image-left {
    margin-bottom: 260px;
  }
  .image-container.image-left p.blockquote {
    margin: 0 auto;
    position: relative;
    right: 0;
  }
  .profile-page .page-header {
    min-height: 580px !important;
  }
  .header-2 .card-form-horizontal .input-group, .header-2 .card-form-horizontal .form-group {
    margin-bottom: 10px;
  }
  .contactus-2 .card-contact {
    max-width: inherit;
    margin: 0;
    margin-top: 15px;
  }
  .section-story-overview .image-container + .category {
    padding-top: 50px;
  }
  .features-7 .image-container img {
    left: 0px;
    top: 0;
    max-width: inherit;
    width: 100%;
    height: auto;
    position: relative;
  }
  .footer.footer-big .social-feed i {
    padding-bottom: 10px;
  }
  .nav-tabs {
    display: inline-block;
    width: 100%;
    padding-left: 100px;
    padding-right: 100px;
    text-align: center;
  }
  .nav-tabs .nav-item > .nav-link {
    margin-bottom: 5px;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 580px) {
  .alert button.close {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .typography-line span {
    margin-left: 0;
  }
  .team-4 .card-profile .card-footer {
    text-align: center;
  }
  .nav-pills.nav-pills-just-icons {
    justify-content: center;
  }
  .nav-pills.nav-pills-just-icons .nav-item .nav-link {
    margin-top: 15px;
    margin-left: auto;
    margin-right: auto;
  }
  .footer .pull-left,
  .footer .footer-brand,
  .footer .pull-right {
    float: unset;
  }
  .media {
    display: block;
  }
  .media .media {
    padding-left: 35px;
  }
  .fileinput {
    margin: 0 auto;
    width: -webkit-fill-available;
    width: -moz-available;
    width: stretch;
  }
  .header-3 .buttons {
    text-align: center !important;
  }
  .blog-post .button-container > .btn:first-child {
    display: block;
  }
  .testimonials-2 .card-testimonial .card-body {
    max-width: 350px;
    min-height: 400px;
    margin: 0 auto;
  }
  .footer .copyright {
    text-align: center;
  }
  .projects-1 .nav-pills {
    display: block;
  }
  .projects-1 .nav-pills .nav-item {
    min-width: 200px;
  }
  .projects-1 .nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
    margin-right: 0;
  }
  .projects-1 .nav-pills .nav-item .nav-link {
    margin: 0 auto;
    margin-bottom: 15px;
  }
  .subscribe-line .card-form-horizontal .btn {
    margin-top: 10px;
  }
  .modal .modal-dialog .modal-header button.close {
    font-size: 18px;
    right: 12px;
    top: 10px;
  }
  .header-3 .btn {
    margin-bottom: 10px;
  }
  .card.card-fashion:not(.card-background):before {
    display: none;
  }
  .profile-page .content-center {
    margin: 10px 0 0;
  }
  .profile-page .content-center .content .social-description {
    width: 105px;
    max-width: 105px;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
}
@media screen and (min-width: 991px) and (max-width: 1200px) {
  .section-images .hero-images-container-1 {
    right: 9%;
    max-width: 370px;
  }
  .section-images .hero-images-container-2 {
    right: 2%;
    max-width: 216px;
  }
}
@media screen and (max-width: 768px) {
  .section-images {
    height: 300px;
    max-height: 300px;
  }
  .section-images .hero-images-container {
    max-width: 380px;
  }
  .section-images .hero-images-container-1 {
    right: 7%;
    top: 87%;
    max-width: 210px;
  }
  .section-images .hero-images-container-2 {
    right: 1%;
    max-width: 133px;
    top: 99%;
  }
  .pricing-5 .title {
    text-align: center;
  }
  .pricing-5 .nav-pills {
    justify-content: center;
  }
  .footer nav {
    display: block;
    float: none;
  }
  #social-buttons > .row .col-md-1:nth-child(2) p,
  #social-buttons > .row .col-md-1:nth-child(3) p,
  #social-buttons > .row .col-md-3 p {
    display: none;
  }
}
@media screen and (max-width: 517px) {
  .alert .alert-icon {
    margin-top: 10px;
  }
}
@media screen and (min-width: 1200px) {
  .section-images .hero-images-container-1 {
    top: 51%;
    right: 21%;
  }
  .section-images .hero-images-container-2 {
    top: 66%;
    right: 14%;
  }
}
@media only screen and (min-height: 950px) {
  .index-page .page-header .category-absolute {
    margin-top: -330px;
  }
}
/*! nouislider - 14.0.2 - 6/28/2019 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
/*

This file was modified by Creative-Tim

*/
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 1px;
}

.noUi-horizontal .noUi-handle {
  width: 15px;
  height: 15px;
  left: -7px;
  top: 0px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 15px;
  height: 15px;
  left: 0px;
  top: -7px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -7px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.125rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #FFFFFF !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #f96332 !important;
  color: #FFFFFF;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #DDDDDD;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #f96332;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #f96332;
  border-radius: 50%;
  border: 1px solid #f96332;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #DDDDDD;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #f96332 !important;
  color: #FFFFFF;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by Creative Tim for React-Select v2.0.0
*/
.react-select {
  margin-bottom: 10px;
}
.react-select .react-select__menu {
  border: 0;
  box-shadow: 0 10px 50px 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.125rem;
  transition: all 0.15s linear;
  font-size: 14px;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  margin-top: 0;
  margin-bottom: 0.125rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
}
.react-select .react-select__menu-list {
  max-height: 198px;
  overflow-y: auto;
  padding-bottom: unset;
  padding-top: unset;
  position: relative;
}
.react-select .react-select__option {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: block;
  outline: none;
  color: #292b2c;
}
.react-select .react-select__option:first-child {
  margin-top: 0;
}
.react-select .react-select__menu .react-select__option, .react-select .react-select__menu .react-select__option:active {
  background-color: transparent;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-selected, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {
  background-color: #DDDDDD;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-focused, .react-select .react-select__menu .react-select__option.react-select__option--is-focused:active {
  background-color: #F5F5F5;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-disabled, .react-select .react-select__menu .react-select__option.react-select__option--is-disabled:active {
  color: #cccccc;
  cursor: default;
}
.react-select .react-select__control {
  border-radius: 30px;
  min-height: 37px;
  height: 37px;
  box-sizing: border-box;
  border-collapse: separate;
  display: table;
  width: 100%;
}
.react-select .react-select__control, .react-select .react-select__control:hover {
  border: 1px solid #E3E3E3;
  box-shadow: none;
  background-color: transparent;
}
.react-select .react-select__control.react-select__control--is-focused .react-select__dropdown-indicator:after {
  transform: rotate(180deg);
  top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused, .react-select .react-select__control.react-select__control--is-focused:hover {
  border: 1px solid #f96332;
  box-shadow: none;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value {
  display: inline-flex;
  border-radius: 30px;
  background-color: transparent;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value + div:not(.react-select__multi-value) {
  display: inline-flex;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value .react-select__multi-value__label {
  font-size: 0.9em;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__single-value {
  top: 48%;
  color: #2c2c2c;
}
.react-select .react-select__control .react-select__placeholder {
  color: #9A9A9A;
  line-height: normal;
  font-size: 0.8571em;
  top: 48%;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
  display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
  width: 60px;
  padding-right: 10px;
  align-items: flex-end;
  vertical-align: middle;
  text-align: right;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  display: inline-block;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:after {
  transition: all 150ms ease 0s;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  content: "";
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:hover:after {
  border-top-color: #666666;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator > * {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator:before {
  content: "×";
  display: inline-block;
  font-size: 18px;
  line-height: 1;
  top: 2px;
  position: relative;
  margin-right: 3px;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator > * {
  display: none;
}
.react-select.react-select-primary .react-select__control.react-select__control--is-focused, .react-select.react-select-primary .react-select__control.react-select__control--is-focused:hover {
  border-color: #f96332;
}
.react-select.react-select-primary .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.react-select-primary .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #f96332;
}
.react-select.react-select-primary .react-select__multi-value {
  border: 1px solid #f96332;
}
.react-select.react-select-primary .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(249, 99, 50, 0.2);
  border-left: 1px solid rgba(249, 99, 50, 0.2);
}
.react-select.react-select-primary .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #f96332;
  background-color: transparent;
}
.react-select.react-select-success .react-select__control.react-select__control--is-focused, .react-select.react-select-success .react-select__control.react-select__control--is-focused:hover {
  border-color: #18ce0f;
}
.react-select.react-select-success .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.react-select-success .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #18ce0f;
}
.react-select.react-select-success .react-select__multi-value {
  border: 1px solid #18ce0f;
}
.react-select.react-select-success .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(24, 206, 15, 0.2);
  border-left: 1px solid rgba(24, 206, 15, 0.2);
}
.react-select.react-select-success .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #18ce0f;
  background-color: transparent;
}
.react-select.react-select-info .react-select__control.react-select__control--is-focused, .react-select.react-select-info .react-select__control.react-select__control--is-focused:hover {
  border-color: #2CA8FF;
}
.react-select.react-select-info .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.react-select-info .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #2CA8FF;
}
.react-select.react-select-info .react-select__multi-value {
  border: 1px solid #2CA8FF;
}
.react-select.react-select-info .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(44, 168, 255, 0.2);
  border-left: 1px solid rgba(44, 168, 255, 0.2);
}
.react-select.react-select-info .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #2CA8FF;
  background-color: transparent;
}
.react-select.react-select-warning .react-select__control.react-select__control--is-focused, .react-select.react-select-warning .react-select__control.react-select__control--is-focused:hover {
  border-color: #FFB236;
}
.react-select.react-select-warning .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.react-select-warning .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #FFB236;
}
.react-select.react-select-warning .react-select__multi-value {
  border: 1px solid #FFB236;
}
.react-select.react-select-warning .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(255, 178, 54, 0.2);
  border-left: 1px solid rgba(255, 178, 54, 0.2);
}
.react-select.react-select-warning .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #FFB236;
  background-color: transparent;
}
.react-select.react-select-danger .react-select__control.react-select__control--is-focused, .react-select.react-select-danger .react-select__control.react-select__control--is-focused:hover {
  border-color: #FF3636;
}
.react-select.react-select-danger .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.react-select-danger .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #FF3636;
}
.react-select.react-select-danger .react-select__multi-value {
  border: 1px solid #FF3636;
}
.react-select.react-select-danger .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(255, 54, 54, 0.2);
  border-left: 1px solid rgba(255, 54, 54, 0.2);
}
.react-select.react-select-danger .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #FF3636;
  background-color: transparent;
}
.react-select.react-select-white .react-select__control.react-select__control--is-focused, .react-select.react-select-white .react-select__control.react-select__control--is-focused:hover {
  border-color: #FFFFFF;
}
.react-select.react-select-white .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.react-select-white .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #FFFFFF;
}
.react-select.react-select-white .react-select__multi-value {
  border: 1px solid #FFFFFF;
}
.react-select.react-select-white .react-select__multi-value .react-select__multi-value__remove {
  color: #FFFFFF;
  border-left: 1px solid #FFFFFF;
}
.react-select.react-select-white .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #FFFFFF;
  background-color: transparent;
}
.react-select .react-select__multi-value {
  border: 1px solid #9A9A9A;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
  position: relative;
  color: rgba(222, 222, 222, 0.8);
  border-left: 1px solid rgba(222, 222, 222, 0.8);
}
.react-select .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #9A9A9A;
  background-color: transparent;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled .react-select__multi-value__remove {
  display: none;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled.react-select__multi-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
}
.react-select.react-select--is-disabled .react-select__control--is-disabled {
  background-color: #f9f9f9;
}
.react-select .react-select__multi-value__remove {
  border-radius: 0;
}

.react-tagsinput {
  display: inline-block;
  padding: 4px 6px;
  max-width: 100%;
  line-height: 22px;
}

.react-tagsinput-tag {
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 3px 8px;
  border-radius: 12px;
  color: #ffffff;
  font-weight: 500;
  font-size: 0.75em;
  text-transform: uppercase;
  display: inline-block;
  line-height: 1.5em;
  padding-left: 0.8em;
}

.react-tagsinput-remove {
  cursor: pointer;
  font-weight: bold;
}

.react-tagsinput-tag a::before {
  font-family: "Nucleo Outline";
  content: "\\ea53";
  padding: 0px 2px;
}

.react-tagsinput-tag a {
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  opacity: 0;
  background-color: transparent;
}

.react-tagsinput-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 5px;
  width: 80px;
}

.react-tagsinput .react-tagsinput-tag {
  transition: all 300ms ease 0s;
}
.react-tagsinput .react-tagsinput-tag:hover {
  padding-right: 22px;
}
.react-tagsinput .react-tagsinput-tag:hover a {
  opacity: 1;
  padding-right: 4px;
}

*:focus {
  outline: none;
}

.navbar .input-group,
.navbar .form-group {
  margin-bottom: 0;
}

.blockquote.blockquote-info {
  border-color: #2CA8FF;
  color: #2CA8FF;
}
.blockquote.blockquote-info small {
  color: #2CA8FF;
}

.carousel-control-next, .carousel-control-prev {
  z-index: 1000;
}

.dropdown-menu a.dropdown-header[tabindex="-1"] {
  color: hsla(0, 0%, 71%, 0.6);
  font-size: 0.7142em;
  text-transform: uppercase;
  font-weight: 700;
}

.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}

.fileinput input[type=file] {
  display: none;
}

.modal.modal-mini .modal-profile i {
  color: #2CA8FF;
  font-size: 21px;
}

.modal .modal-login {
  margin-right: auto;
  margin-left: auto;
}

.popover .arrow:before {
  border-color: transparent !important;
}

.popover-primary .popover {
  background-color: #f96332;
}
.popover-primary .popover .popover-body {
  color: #FFFFFF;
}
.popover-primary .popover.bs-popover-right .arrow:after {
  border-right-color: #f96332;
}
.popover-primary .popover.bs-popover-top .arrow:after {
  border-top-color: #f96332;
}
.popover-primary .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #f96332;
}
.popover-primary .popover.bs-popover-left .arrow:after {
  border-left-color: #f96332;
}
.popover-primary .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-primary .popover .arrow:after {
  border-left-color: #f96332;
}

.popover-info .popover {
  background-color: #2CA8FF;
}
.popover-info .popover .popover-body {
  color: #FFFFFF;
}
.popover-info .popover.bs-popover-right .arrow:after {
  border-right-color: #2CA8FF;
}
.popover-info .popover.bs-popover-top .arrow:after {
  border-top-color: #2CA8FF;
}
.popover-info .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #2CA8FF;
}
.popover-info .popover.bs-popover-left .arrow:after {
  border-left-color: #2CA8FF;
}
.popover-info .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-info .popover .arrow:after {
  border-left-color: #2CA8FF;
}

.popover-warning .popover {
  background-color: #FFB236;
}
.popover-warning .popover .popover-body {
  color: #FFFFFF;
}
.popover-warning .popover.bs-popover-right .arrow:after {
  border-right-color: #FFB236;
}
.popover-warning .popover.bs-popover-top .arrow:after {
  border-top-color: #FFB236;
}
.popover-warning .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #FFB236;
}
.popover-warning .popover.bs-popover-left .arrow:after {
  border-left-color: #FFB236;
}
.popover-warning .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-warning .popover .arrow:after {
  border-left-color: #FFB236;
}

.popover-danger .popover {
  background-color: #FF3636;
}
.popover-danger .popover .popover-body {
  color: #FFFFFF;
}
.popover-danger .popover.bs-popover-right .arrow:after {
  border-right-color: #FF3636;
}
.popover-danger .popover.bs-popover-top .arrow:after {
  border-top-color: #FF3636;
}
.popover-danger .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #FF3636;
}
.popover-danger .popover.bs-popover-left .arrow:after {
  border-left-color: #FF3636;
}
.popover-danger .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-danger .popover .arrow:after {
  border-left-color: #FF3636;
}

.popover-success .popover {
  background-color: #18ce0f;
}
.popover-success .popover .popover-body {
  color: #FFFFFF;
}
.popover-success .popover.bs-popover-right .arrow:after {
  border-right-color: #18ce0f;
}
.popover-success .popover.bs-popover-top .arrow:after {
  border-top-color: #18ce0f;
}
.popover-success .popover.bs-popover-bottom .arrow:after {
  border-bottom-color: #18ce0f;
}
.popover-success .popover.bs-popover-left .arrow:after {
  border-left-color: #18ce0f;
}
.popover-success .popover .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover-success .popover .arrow:after {
  border-left-color: #18ce0f;
}

.bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {
  border-left-color: #FFFFFF;
}

.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {
  border-right-color: #FFFFFF;
}

.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {
  border-top-color: #FFFFFF;
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {
  border-bottom-color: #FFFFFF;
}

.page-header footer {
  position: relative;
}

[filter-color=blue], .clear-filter[filter-color=blue] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(3, 161, 224, 0.6)); /* Standard syntax */
}

[data-background-color=blue] {
  background-color: #2CA8FF;
}

.section-nucleo-icons .icons-container i:nth-child(6) {
  color: #2CA8FF;
}

.page-header.page-header-small {
  min-height: 60vh;
  max-height: 640px;
}
.page-header > .content {
  margin: 80px 0;
}

.signup-page .page-header {
  display: flex;
  align-items: center;
}

.login-page .page-header > .content, .signup-page .page-header > .content {
  width: 100%;
}

.signup-page .card-signup {
  margin-bottom: 0;
}

.login-page .page-header {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 991px) {
  .sidebar-collapse .navbar-collapse:before {
    background: #2CA8FF;
    background: linear-gradient(#2CA8FF, #2c2c2c 80%);
  }
  .navbar-nav .dropdown-menu {
    position: static !important;
  }
}
@media screen and (max-width: 768px) {
  .nav-tabs {
    padding-left: 10px;
    padding-right: 10px;
  }
  .login-page .page-header .content {
    top: 30%;
  }
  .signup-page .page-header {
    flex-direction: column;
  }
  .login-page .page-header {
    flex-direction: column;
    justify-content: space-between;
  }
  .login-page .page-header > .content {
    margin-top: 130px;
  }
}
@media screen and (min-width: 768px) {
  .page-header footer {
    position: absolute;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/now-ui-kit.scss","webpack://./src/assets/scss/now-ui-kit/_variables.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-bootstrap-switch.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-bootstrap-select.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-tagsinput.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_tags.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-fileupload.scss","webpack://./src/assets/scss/now-ui-kit/plugins/_plugin-datetimepicker.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/now-ui-kit/_nucleo-outline.scss","webpack://./src/assets/scss/now-ui-kit/_alerts.scss","webpack://./src/assets/scss/now-ui-kit/_checkboxes-radio.scss","webpack://./src/assets/scss/now-ui-kit/_badges.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_badges.scss","webpack://./src/assets/scss/now-ui-kit/_pagination.scss","webpack://./src/assets/scss/now-ui-kit/_typography.scss","webpack://./src/assets/scss/now-ui-kit/_misc.scss","webpack://./src/assets/scss/now-ui-kit/_buttons.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_buttons.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_transparency.scss","webpack://./src/assets/scss/now-ui-kit/_social-buttons.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_social-buttons.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_inputs.scss","webpack://./src/assets/scss/now-ui-kit/_inputs.scss","webpack://./src/assets/scss/now-ui-kit/_progress.scss","webpack://./src/assets/scss/now-ui-kit/_pills.scss","webpack://./src/assets/scss/now-ui-kit/_pills-extend.scss","webpack://./src/assets/scss/now-ui-kit/_tabs.scss","webpack://./src/assets/scss/now-ui-kit/_navbar.scss","webpack://./src/assets/scss/now-ui-kit/_navbar-extend.scss","webpack://./src/assets/scss/now-ui-kit/_dropdown.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_dropdown.scss","webpack://./src/assets/scss/now-ui-kit/_dropdown-extend.scss","webpack://./src/assets/scss/now-ui-kit/_images.scss","webpack://./src/assets/scss/now-ui-kit/_popups.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_popovers.scss","webpack://./src/assets/scss/now-ui-kit/_tables.scss","webpack://./src/assets/scss/now-ui-kit/_info-areas.scss","webpack://./src/assets/scss/now-ui-kit/_media.scss","webpack://./src/assets/scss/now-ui-kit/_modals.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_modals.scss","webpack://./src/assets/scss/now-ui-kit/_modals-extend.scss","webpack://./src/assets/scss/now-ui-kit/_carousel.scss","webpack://./src/assets/scss/now-ui-kit/_footers.scss","webpack://./src/assets/scss/now-ui-kit/_cards.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-extend.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-background.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-blog.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-contact.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-fashion.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-form-horizontal.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-no-shadow.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-plain.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-pricing.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_cards.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-profile.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-product.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-raised.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-signup.scss","webpack://./src/assets/scss/now-ui-kit/cards/_card-testimonials.scss","webpack://./src/assets/scss/now-ui-kit/_example-pages.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_pages.scss","webpack://./src/assets/scss/now-ui-kit/_sections.scss","webpack://./src/assets/scss/now-ui-kit/_sections-extend.scss","webpack://./src/assets/scss/now-ui-kit/sections/_headers.scss","webpack://./src/assets/scss/now-ui-kit/sections/_features.scss","webpack://./src/assets/scss/now-ui-kit/sections/_blogs.scss","webpack://./src/assets/scss/now-ui-kit/sections/_team.scss","webpack://./src/assets/scss/now-ui-kit/sections/_projects.scss","webpack://./src/assets/scss/now-ui-kit/sections/_pricing.scss","webpack://./src/assets/scss/now-ui-kit/sections/_testimonials.scss","webpack://./src/assets/scss/now-ui-kit/sections/_contactus.scss","webpack://./src/assets/scss/now-ui-kit/sections/_social-subscribe-lines.scss","webpack://./src/assets/scss/now-ui-kit/_responsive.scss","webpack://./src/assets/scss/now-ui-kit/mixins/_navbar.scss","webpack://./src/assets/scss/react/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-select.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-tagsinput.scss","webpack://./src/assets/scss/react/now-ui-kit/_misc.scss","webpack://./src/assets/scss/react/now-ui-kit/_typography.scss","webpack://./src/assets/scss/react/now-ui-kit/_carousel.scss","webpack://./src/assets/scss/react/now-ui-kit/_dropdowns.scss","webpack://./src/assets/scss/react/now-ui-kit/_fileupload.scss","webpack://./src/assets/scss/react/now-ui-kit/_modals.scss","webpack://./src/assets/scss/react/now-ui-kit/_popovers.scss","webpack://./src/assets/scss/react/now-ui-kit/_tooltips.scss","webpack://./src/assets/scss/react/now-ui-kit/_example-pages.scss","webpack://./src/assets/scss/react/now-ui-kit/_sections.scss","webpack://./src/assets/scss/react/now-ui-kit/_responsive.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;EAAA;ACyEA,kCAAA;AAUA,8BAAA;ACnFA;;;;;;EAAA;AA8CA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;EACA,kBAAA;EACA,iCAAA;AFnBF;;AEsBA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AFnBF;;AEqBA;;;EAKE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEQ,0BAAA;AFlBV;;AEqBA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;AFlBF;;AEoBA;;EAEE,WAAA;EACA,mBD7D2B;AD4C7B;;AEmBA;;EAEE,WAAA;EACA,mBDxD2B;ADwC7B;;AEkBA;;EAEE,WAAA;EACA,mBDlE2B;ADmD7B;;AEiBA;;EAEE,mBD5D2B;EC6D3B,WAAA;AFdF;;AEgBA;;EAEE,WAAA;EACA,mBD7D2B;ADgD7B;;AEeA;;EAEE,WAAA;AFZF;;AEcA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;AFXF;;AEcA;EACI,uCAAA;AFXJ;;AEaA;EACI,sBAAA;EACA,kBAAA;AFVJ;;AEYA;EACI,sBAAA;EACA,kBAAA;AFTJ;;AEWA;EACE,8BAAA;EACA,2BAAA;AFRF;;AEUA;EACE,gBAAA;AFPF;;AESA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AFNF;;AEQA;;EAEE,YAAA;AFLF;;AEOA;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;AFJF;;AEMA;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;AFHF;;AEKA;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;AFFF;;AEIA;;;EAGE,0BAAA;AFDF;;AEGA;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;AFAF;;AEEA;EAEE,4BAAA;AFCF;;AECA;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;AFEF;;AEAA;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AFGF;;AEgBA;EACI,4BAAA;AFbJ;;AEgBA;EACI,6BAAA;AFbJ;;AEiBI;EACI,yBAAA;AFdR;;AEkBA;EACI,yBD1MyB;AD2L7B;;AEkBA;EACI,yBDnNyB;ADoM7B;;AEkBA;EACI,yBDjOyB;ADkN7B;;AEkBA;EACI,yBD1OyB;AD2N7B;;AEkBA;EACI,yBDpOyB;ADqN7B;;AEkBA;;;;;EAKI,yBDhRyB;ADiQ7B;;AEkBA;EACI,UAAA;AFfJ;;AEkBA;EACI,UAAA;AFfJ;;AG/RA,yBAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AHkSF;;AGhSA;EACE,kBAAA;EACA,cAAA;AHmSF;;AGjSA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AHoSF;;AGlSA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AHqSF;;AGnSA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAGA,qBAAA;AHsSF;;AGpSA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AHuSF;;AGrSA;;EAAA;AAGA;EACE,QAAA;AHwSF;;AGtSA;EACE,SAAA;AHySF;;AGvSA;EACE,kBAAA;AH0SF;;AGxSA;;EAGE,0BAAA;AH2SF;;AGzSA;EACE,0BAAA;AH4SF;;AG1SA;EAAA;AAEA;EACE,WAAA;AH6SF;;AG3SA;EACI,kBAAA;EACH,yBFvE4B;EEwE5B,2CAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACG,gBAAA;EACA,aAAA;AH8SJ;;AG5SA;EACC,WAAA;AH+SD;;AG7SA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AHgTF;;AG9SA;EACE,YAAA;EACA,UAAA;AHiTF;;AG/SA;;EAAA;AAGC;EACC,0CAAA;EACA,kBAAA;AHkTF;;AGhTA;EACE,kBAAA;AHmTF;;AGjTA;EACC,mBFrE4B;EEsEzB,kBAAA;EAEH,4BAAA;AHoTD;;AGlTA;EAAA;AAEA;EACE,iBAAA;AHqTF;;AGnTA;EACE,iBAAA;AHsTF;;AGpTA;EAEC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;EAGA,iCAAA;EACG,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;AHoTJ;;AGlTA;EAKI,+BAAA;AHqTJ;;AGnTA;EAAA;AAEA;;EAEE,aAAA;AHsTF;;AGpTA;EACE,UAAA;AHuTF;;AGrTA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AHwTF;;AGtTA;EACE,SAAA;AHyTF;;AGvTA;EAAA;AAEA;EACE,mBAAA;AH0TF;;AGxTA;;;EAGE,mBAAA;AH2TF;;AGzTA;;EAAA;AAGA;;EAGE,sBAAA;AH4TF;;AG1TA;EACE,kBAAA;EACA,WAAA;AH6TF;;AG3TA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AH8TF;;AG5TA;EACE,WAAA;EACA,eAAA;AH+TF;;AG7TA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AHgUF;;AG9TA;EACE,gBAAA;AHiUF;;AG/TA;EACE,gBAAA;AHkUF;;AGhUA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AHmUF;;AGjUA;EAEE,+BAAA;AHoUF;;AGlUA;EAEE,8BAAA;AHqUF;;AGnUA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AHsUF;;AGpUA;EACE,YAAA;AHuUF;;AGrUA;EACE,YAAA;AHwUF;;AGtUA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AHyUF;;AGvUA;EAEE,gCAAA;EACA,kBAAA;AH0UF;;AGxUA;EAEE,4BAAA;AH2UF;;AGzUA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AH4UF;;AG1UA;EACE,WAAA;AH6UF;;AG3UA;EACE,WAAA;AH8UF;;AG5UA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AH+UF;;AG7UA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AHgVF;;AG9UA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AHiVF;;AG3UE;EAEU,yBFlSiB;AD+mB7B;AG1UE;EACC,0CAAA;AH4UH;AGzUE;EACC,yBF1S0B;ADqnB7B;AGtUE;EAEU,yBF3QiB;ADklB7B;AGpUE;EACC,wCF7Q0B;ADmlB7B;AGnUE;EACC,yBFnR0B;ADwlB7B;AGhUQ;EAEI,yBFhRiB;ADilB7B;AG9TE;EACC,yCFlR0B;ADklB7B;AG7TE;EACC,yBFxR0B;ADulB7B;AG3TQ;EAEI,yBFnSiB;AD+lB7B;AGzTQ;EACL,wCFrS0B;ADgmB7B;AGxTE;EACC,yBF3S0B;ADqmB7B;AGtTQ;EAEI,yBFvSiB;AD8lB7B;AGpTQ;EACL,yCFzS0B;AD+lB7B;AGnTE;EACC,yBF/S0B;ADomB7B;AGjTQ;EAEI,yBFhTiB;ADkmB7B;AG/SQ;EACL,wCFlT0B;ADmmB7B;AG9SE;EACC,yBFxT0B;ADwmB7B;;AI5qBA;;;;;EAAA;AAOA;;;EAGE,wBAAA;AJ8qBF;;AI5qBA;EACE,gBAAA;EACA,gBAAA;AJ+qBF;AI7qBE;EACE,4BAAA;AJ+qBJ;AI7qBE;EACE,yBAAA;AJ+qBJ;AI5qBE;EACE,oBAAA;EACA,YAAA;AJ8qBJ;;AI3qBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;AJ8qBF;;AI5oBA;EACE,6BAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;AJ+oBF;;AI7oBA;EACE,MAAA;EACA,OAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;AJgpBF;;AI9oBA;;;;EAIE,qBAAA;AJipBF;;AI/oBA;;EAEE,qBAAA;AJkpBF;;AIhpBA;EACE,sBAAA;AJmpBF;;AIjpBA;EACE,YAAA;AJopBF;;AI7oBA;EACE,gBAAA;EACA,UAAA;EACA,YAAA;AJgpBF;;AI9oBA;EACE,WAAA;AJipBF;;AI/oBA;EACE,aAAA;AJkpBF;;AIhpBA;EACE,gBAAA;AJmpBF;;AIjpBA;;EAEE,WAAA;EACA,qBAAA;EACA,cAAA;AJopBF;;AIlpBA;;;EAGE,YAAA;AJqpBF;;AInpBA;;;EAGE,gBAAA;AJspBF;;AIppBA;;EAEE,UAAA;AJupBF;;AIrpBA;;EAEE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AJwpBF;;AItpBA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AJypBF;;AIvpBA;EACE,uBAAA;AJ0pBF;;AIxpBA;EACE,oBAAA;AJ2pBF;;AIzpBA;EACE,WAAA;AJ4pBF;;AI1pBA;;EAEE,mBAAA;AJ6pBF;;AI3pBA;;EAEE,wBAAA;AJ8pBF;;AI5pBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,qBAAA;AJ+pBF;;AI7pBA;EACE,aAAA;AJgqBF;;AI9pBA;EACE,WAAA;EACA,qBAAA;AJiqBF;;AI/pBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AJkqBF;;AIhqBA;EACE,sBAAA;AJmqBF;;AIjqBA;EACE,gBAAA;AJoqBF;;AIlqBA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AJqqBF;;AInqBA;EACE,sBAAA;AJsqBF;;AIpqBA;EACE,WAAA;AJuqBF;;AIrqBA;EACE,eAAA;EAGQ,sBAAA;AJwqBV;;AItqBA;EACE,wBAAA;AJyqBF;;AIvqBA;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EAEQ,gBAAA;AJ0qBV;;AIxqBA;EACE,kBAAA;AJ2qBF;;AIzqBA;EACE,WAAA;AJ4qBF;;AI1qBA;EACE,mBAAA;AJ6qBF;;AI3qBA;EACE,eAAA;EACA,yBAAA;EAGQ,iBAAA;AJ8qBV;;AI5qBA;EACE,kBAAA;EACA,oBAAA;AJ+qBF;;AI7qBA;EACE,aAAA;AJgrBF;;AI9qBA;EACE,qBAAA;AJirBF;;AI/qBA;EACE,mBAAA;AJkrBF;;AIhrBA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EAEQ,+CAAA;EACR,oBAAA;EACA,YAAA;EAGQ,sBAAA;AJmrBV;;AIjrBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AJorBF;;AIlrBA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;AJqrBF;;AInrBA;;EAEE,eAAA;AJsrBF;;AIprBA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;AJurBF;;AIrrBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;AJwrBF;;AItrBA;EACE,kBAAA;AJyrBF;;AIvrBA;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,+BAAA;EAIQ,wBAAA;AJ0rBV;;AIxrBA;;EAEE,aAAA;AJ2rBF;;AIzrBA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;AJ4rBF;;AI1rBA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AJ6rBF;;AI3rBA;EACE,YAAA;EACA,SAAA;EACA,8CAAA;EACA,gBAAA;AJ8rBF;;AI5rBA;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;AJ+rBF;;AI7rBA;EACE,WAAA;EACA,UAAA;AJgsBF;;AI9rBA;EACE,WAAA;EACA,UAAA;AJisBF;;AI/rBA;;;;EAIE,cAAA;AJksBF;;AIhsBA;;;EAGE,gBAAA;AJmsBF;;AIjsBA;EACE,WAAA;EAGQ,sBAAA;AJosBV;;AIlsBA;EACE,UAAA;AJqsBF;;AInsBA;EACE,WAAA;EACA,WAAA;EAGQ,sBAAA;AJssBV;;AIpsBA;EACE,WAAA;AJusBF;;AIrsBA;EACE,kBAAA;AJwsBF;;AItsBA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;AJysBF;;;AK5lCA;;;EAAA;AAKA;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;AL+lCJ;AK7lCI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AL+lCR;AK7lCQ;EACI,YAAA;EACA,gBAAA;AL+lCZ;AK3lCI;EACI,WAAA;EACA,UAAA;AL6lCR;AK1lCI;EAEI,WAAA;AL2lCR;AKxlCI;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AL0lCR;AKxlCQ;EACI,mBAAA;AL0lCZ;AKxlCY;EACI,UAAA;EACA,kBAAA;AL0lChB;AKtlCQ;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;ALwlCZ;AKplCY;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;ALslChB;AMlpCI;EAZK,yBL+CoB;EK9CpB,cLQoB;EKPpB,YAAA;ANiqCT;AMhqCS;EACI,cLKgB;AD6pC7B;AMhqCK;EACI,cLwCoB;AD0nC7B;AM1pCI;EAfK,yBLyDoB;EKxDpB,cLQoB;EKPpB,YAAA;AN4qCT;AM3qCS;EACI,cLKgB;ADwqC7B;AM3qCK;EACI,cLkDoB;AD2nC7B;AMlqCI;EAlBK,yBLoDoB;EKnDpB,cLQoB;EKPpB,YAAA;ANurCT;AMtrCS;EACI,cLKgB;ADmrC7B;AMtrCK;EACI,cL6CoB;AD2oC7B;AM1qCI;EArBK,yBL8DoB;EK7DpB,cLQoB;EKPpB,YAAA;ANksCT;AMjsCS;EACI,cLKgB;AD8rC7B;AMjsCK;EACI,cLuDoB;AD4oC7B;AMlrCI;EAxBK,yBLmEoB;EKlEpB,cLQoB;EKPpB,YAAA;AN6sCT;AM5sCS;EACI,cLKgB;ADysC7B;AM5sCK;EACI,cL4DoB;ADkpC7B;;AOttCA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;APytCF;;AOvtCA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;EAEA,cAAA;APytCF;;AOvtCA;EACE,qBAAA;EACA,kBAAA;AP0tCF;;AOxtCA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AP2tCF;;AOztCA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AP4tCF;AO1tCE;EACI,kBAAA;EACA,gBAAA;AP4tCN;;AOztCA;EACE,gBAAA;AP4tCF;;AO1tCA;EACE,sBAAA;AP6tCF;;AO3tCA;;EAEE,aAAA;AP8tCF;;AO5tCA;EACE,eAAA;AP+tCF;;AO7tCA;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;APguCF;;AO9tCA;EACE,sBAAA;APiuCF;;AO/tCA;EACE,cAAA;APkuCF;;AOhuCA;EACE,kBAAA;EACA,UAAA;APmuCF;;AOjuCA;EACE,UAAA;APouCF;;AOluCA;;EAEE,0BAAA;APquCF;;AOnuCA;;;;EAIE,0BAAA;APsuCF;;AOpuCA;;EAEE,0BAAA;APuuCF;;AOruCA;EACE,cN3B2B;ADmwC7B;;AOtuCA;EACE,qBN9B2B;ADuwC7B;;AOvuCA;EACE,cN5B2B;ADswC7B;;AOxuCA;EACE,qBN/B2B;AD0wC7B;;AOzuCA;EACE,cNjD2B;AD6xC7B;;AO1uCA;EACE,qBNpD2B;ADiyC7B;;AO3uCA;EACE,cAAA;AP8uCF;;AO5uCA;EACI,cAAA;EACA,gBAAA;EACA,UAAA;AP+uCJ;;AQh2CA;;;;;;;;;;;;;EAaE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;ARm2CF;;AQh2CA;EACE,gBAAA;ARm2CF;;AQj2CA;EACE,6BAAA;ARo2CF;;AQl2CA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;ARq2CF;AQn2CE;EACI,UAAA;EACA,QAAA;ARq2CN;;AQl2CA;EACE;IACE,WAAA;ERq2CF;AACF;AQn2CA;EACE;IACE,WAAA;ERq2CF;AACF;AQn2CA;EACE;IACE,WAAA;ERq2CF;AACF;AQn2CA;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cPtDyB;EOuDzB,0BAAA;EACA,qCAAA;EACA,oCAAA;ARq2CJ;;AQl2CA;EACI,aAAA;ARq2CJ;;AQl2CA;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cP3EyB;EO4EzB,uBAAA;EACA,qCAAA;EACA,oCAAA;ARq2CJ;;AQn2CA;EACE,UAAA;EACA,UAAA;ARs2CF;;AQp2CA;EACE,UAAA;EACA,UAAA;ARu2CF;;AQr2CA;EACE,SAAA;ARw2CF;;AQt2CA;EACE,UAAA;EACA,eAAA;EACA,6BAAA;ARy2CF;AQv2CE;EAEE,yBAAA;ARw2CJ;;AQr2CA;;EAEI,cPjEyB;ADy6C7B;;AQt2CA;EACE,6BAAA;ARy2CF;;AQv2CA;EACE,gBAAA;AR02CF;;AQx2CA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AR22CF;;AQz2CA;EACE,WAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;AR42CF;;AQz2CA;EACE,oBAAA;AR42CF;AQ12CE;EAGE,2BAAA;EACA,wCAAA;AR02CJ;;AQt2CA;EACE,0BAAA;ARy2CF;;AQv2CA;EACE,4BAAA;AR02CF;;AQx2CA;EACE,0BAAA;AR22CF;;AQz2CA;EACE,4BAAA;AR42CF;;AQ12CA;EACE,qBAAA;AR62CF;;AQ32CA;EACE,uBAAA;AR82CF;;AQ52CA;EACE,uBAAA;AR+2CF;;AQ72CA;EACE,2BAAA;ARg3CF;;AQ92CA;EACE,gCAAA;ARi3CF;;AQ/2CA;EACE,kBAAA;EACA,kBAAA;EACA,cPvI2B;ADy/C7B;;AQh3CA;EACE,uCAAA;ARm3CF;;AQj3CA;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;ARo3CF;;AQl3CA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;ARq3CF;;AQn3CA;EACE,WAAA;EACA,SAAA;EACA,kBAAA;ARs3CF;;AQp3CA;EACE,kBAAA;ARu3CF;;AQr3CA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;ARw3CF;;AQt3CA;EACE,YAAA;ARy3CF;;AQv3CA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AR03CF;;AQx3CA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,cPxL2B;ADmjD7B;;AQz3CA;EACE,yBAAA;AR43CF;;AQ13CA;EACE,qBAAA;AR63CF;;AQ33CA;EACE,kBAAA;EACA,cPlM2B;EOmM3B,mBAAA;EACA,iBAAA;AR83CF;;AQ53CA;EACE,eAAA;AR+3CF;;AQ73CA;EACE,gBAAA;ARg4CF;;AQv3CA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AR03CF;;AQx3CA;;;EAGE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;ECrQE,6BAAA;ATqoDJ;;AQ73CA;EACE,gBAAA;EACA,eAAA;ARg4CF;;AQ93CA;EACE,cPpP2B;ADqnD7B;;AQ/3CA;EACE,WAAA;EACA,qBAAA;EACA,qCAAA;EACA,4BAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ARk4CF;;AQh4CA;EACE,yBP7P2B;EO8P3B,cPpS2B;EOqS3B,+CAAA;ARm4CF;;AQj4CA;EACE,4BAAA;ARo4CF;;AQl4CA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;ARq4CF;;AQn4CA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;ARs4CF;;AQp4CA;EACE,gBAAA;ARu4CF;;AQr4CA;EACE,yBPvR2B;EOwR3B,cAAA;ARw4CF;;AQt4CA;EACE,cAAA;ARy4CF;;AQv4CA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AR04CF;;AQx4CA;;;EAGE,6BAAA;AR24CF;;AQz4CA;EACE,YAAA;EACA,iBAAA;AR44CF;;AQz4CA;EACE,eAAA;AR44CF;;AQz4CA;;;;;;EAME,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AR44CF;;AQx4CI;;;;;;;;;;;;EAYI,cP/WqB;AD0vD7B;AQt4CI;EACI,+BP/VqB;ADuuD7B;AQr4CI;;EAEI,+BAAA;ARu4CR;AQp4CI;EACI,oCAAA;ARs4CR;AQn4CI;;EAEI,yBPnYqB;ADwwD7B;AQl4CI;;;;;EAKI,oCP9WqB;ADkvD7B;AQj4CI;;EAEI,0CPnXqB;ADsvD7B;;AQ93CA;EACI,yBPhXyB;ADivD7B;AQ/3CI;;;EAKI,yBAAA;AR+3CR;;AQ33CA;EACI,yBPlXyB;ADgvD7B;AQ53CI;;;EAKI,cPzXqB;ADqvD7B;;AQx3CA;EACI,yBPnYyB;AD8vD7B;AQz3CI;;;EAKI,cP1YqB;ADmwD7B;;AQr3CA;EACI,yBPhYyB;ADwvD7B;AQt3CI;;;EAKI,cPvYqB;AD6vD7B;;AQl3CA;EACI,yBPjZyB;ADswD7B;AQn3CI;;;EAKI,cPxZqB;AD2wD7B;;AU10DA;;;;;;kCAAA;AAQA;EACE,6BAAA;EACA,4CAAA;EACA,qPAAA;EAIA,mBAAA;EACA,kBAAA;AVy0DF;AUt0DA;;0BAAA;AAIA;EACE,qBAAA;EACA,kDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;AVu0DF;;AUp0DA;;0BAAA;AAIA;;oCAAA;AAIA;EACE,qBAAA;EACA,oBAAA;EACA,sBAAA;AVq0DF;;AUl0DA;EACE,kBAAA;AVq0DF;;AUl0DA;;0BAAA;AAIA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;AVo0DF;;AUj0DA;EACE,kBAAA;AVo0DF;;AUj0DA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AVo0DF;;AUj0DA;EACE,kBAAA;EACA,kBAAA;AVo0DF;;AUj0DA;;0BAAA;AAIA;EAGE,0CAAA;AVm0DF;AU5yDA;EACE;IAKE,uBAAA;EV+zDF;EU5zDA;IAKE,yBAAA;EV8zDF;AACF;AU3zDA;;0BAAA;AAIA;;0BAAA;AAIA;EACI,gBAAA;AV2zDJ;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACE,gBAAA;AV2zDF;;AUxzDA;EACI,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;AV2zDJ;;AUxzDA;EACI,eAAA;AV2zDJ;;AUxzDA;EACI,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AV2zDJ;;AWp2EA;EACI,SAAA;EACA,gBAAA;EACA,cVMyB;EULzB,mBAAA;EACA,sBAAA;AXu2EJ;AWr2EI;EACE,cVCuB;EUAvB,YAAA;AXu2EN;AWp2EI;EACI,wCV0CqB;AD4zE7B;AWn2EI;EACI,wCVqDqB;ADgzE7B;AWl2EI;EACI,yCV4CqB;ADwzE7B;AWj2EI;EACI,yCVmCqB;ADg0E7B;AWh2EI;EACI,wCVqBqB;AD60E7B;AW/1EI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AXi2ER;AW91EI;EACI,yBAAA;EACA,eAAA;AXg2ER;AW71EI;;EAEI,eAAA;AX+1ER;AW51EI;EACI,cVzCqB;EU0CrB,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;AX81ER;;AYv5EA;EACC,mBAAA;EACA,eAAA;AZ05ED;;AYv5EA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAKA,6BAAA;AZ05EF;;AYx5EA;EACI,kBAAA;AZ25EJ;;AYx5EA;;EAEE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,6BAAA;EACA,yBAAA;EAKA,+BAAA;AZ25EF;;AYx5EC;EACC,6BAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,cXP2B;EWQ3B,SAAA;EACA,yBAAA;AZ25EF;;AYx5EA;;EAEI,cXhCyB;EWiCzB,YAAA;EACA,mBAAA;AZ25EJ;;AYx5EA;;EAEE,UAAA;EACA,kBAAA;EACA,kBAAA;AZ25EF;;AYz5EA;EACE,UAAA;AZ45EF;;AYz5EA;;EAEI,mBAAA;AZ45EJ;;AYz5EA;;EAEI,oBAAA;AZ45EJ;;AYz5EA;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EAKA,+BAAA;AZ45EF;;AYz5EA;;EAEI,UAAA;AZ45EJ;;AY15EA;EACI,UAAA;EACA,WAAA;EACA,yBXjEyB;EWkEzB,qBXlEyB;EWmEzB,SAAA;EACA,UAAA;EACA,UAAA;AZ65EJ;;AY15EA;EACI,UAAA;AZ65EJ;;AY15EA;EACE,cX/F2B;AD4/E7B;;AY15EA;;EAEE,cXpG2B;ADigF7B;;AazhFA,iCAAA;AACA;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBZsJ2B;EYrJ3B,iBAAA;EACA,6BZkCyB;EYjCzB,iBZqH4B;EYpH5B,kBAAA;EACA,cAAA;EACA,uBZsH4B;ADs6EhC;Aa1hFI;EAEE,qBAAA;Ab2hFN;;AavhFA;EACI,qBAAA;Ab0hFJ;AazhFI;EACG,gBAAA;Ab2hFP;;Ac/iFI;EAGE,qBbuCuB;EatCvB,yBbsCuB;EarCvB,cbGuB;AD6iF7B;;AcrjFI;EAGE,qBb2CuB;Ea1CvB,yBb0CuB;EazCvB,cbGuB;ADmjF7B;;Ac3jFI;EAGE,qBbqDuB;EapDvB,yBboDuB;EanDvB,cbGuB;ADyjF7B;;AcjkFI;EAGE,qBbgDuB;Ea/CvB,yBb+CuB;Ea9CvB,cbGuB;AD+jF7B;;AcvkFI;EAGE,qBb0DuB;EazDvB,yBbyDuB;EaxDvB,cbGuB;ADqkF7B;;Ac7kFI;EAGE,qBb+DuB;Ea9DvB,yBb8DuB;Ea7DvB,cbGuB;AD2kF7B;;Aa1iFA;EAEI,yBAAA;Ab4iFJ;AcvlFI;EAGE,qBbKuB;EaJvB,yBbIuB;EaHvB,cbGuB;ADolF7B;;Ae5lFI;EACI,SAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cdMqB;EcLrB,eAAA;EACA,ed8IuB;Ec7IvB,yBAAA;EACA,uBAAA;Af+lFR;Ae7lFQ;EAEI,cdFiB;EcGjB,0CdIiB;EcHjB,YAAA;Af8lFZ;Ae1lFI;;EAEI,kBAAA;Af4lFR;AezlFI;EACI,QAAA;Af2lFR;AexlFI;EACI,OAAA;Af0lFR;AevlFI;EACI,cdnBqB;EcoBrB,+CAAA;AfylFR;AevlFQ;EAGI,yBdHiB;EcIjB,qBdJiB;EcKjB,cdvCiB;AD8nF7B;AenlFI;EACI,YAAA;EACA,0CAAA;EACA,cd9CqB;ADmoF7B;Ae/kFY;EAGI,yBdPa;EcQb,qBdRa;ADulF7B;AexkFY;EAGI,yBdvBa;EcwBb,qBdxBa;ADgmF7B;AejkFY;EAGI,yBdvCa;EcwCb,qBdxCa;ADymF7B;Ae1jFY;EAGI,yBdnCa;EcoCb,qBdpCa;AD8lF7B;AenjFY;EAGI,yBdzCa;Ec0Cb,qBd1Ca;AD6lF7B;Ae7iFQ;EACI,cd3GiB;AD0pF7B;Ae7iFY;EAEI,0CdlFa;EcmFb,cdhHa;AD8pF7B;AeziFY;EAGI,yBdvHa;EcwHb,qBdxHa;EcyHb,cdpFa;AD6nF7B;;AeliFA;EACI,aAAA;EACA,mBAAA;AfqiFJ;;AgBlrFA;;;;;EAKI,8DfDyB;ADsrF7B;;AgBnrFA;EACI,gBf2J4B;AD2hFhC;;AgBnrFA;EACI,cAAA;AhBsrFJ;;AgBnrFA;EACI,cfgCyB;ADspF7B;AgBrrFI;EAEI,cf6BqB;ADypF7B;;AgBnrFA;EACI,gBf2H2B;Ee1H3B,iBAAA;EACA,mBAAA;AhBsrFJ;AgBprFI;EACI,gBfyIwB;EexIxB,yBAAA;EACA,YAAA;AhBsrFR;;AgBnrFA;EACI,gBfiH2B;EehH3B,mBAAA;AhBsrFJ;;AgBprFA;EACI,kBf8G2B;Ee7G3B,mBAAA;EACA,kBAAA;AhBurFJ;;AgBrrFA;EACI,gBf0G2B;EezG3B,mBAAA;EACA,gBAAA;EACA,mBf0E2B;AD8mF/B;AgBtrFI;EAEI,gBAAA;AhBurFR;;AgBprFA;EACI,gBfgG2B;Ee/F3B,kBAAA;EACA,mBAAA;AhBurFJ;AgBrrFI;EACI,gBAAA;AhBurFR;;AgBprFA;EACI,gBfwF2B;EevF3B,gBfqG4B;EepG5B,yBAAA;AhBurFJ;;AgBrrFA;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;AhBwrFJ;;AgBrrFA;EACI,gBf2F4B;Ee1F5B,iBAAA;AhBwrFJ;AgBrrFI;EACI,yBAAA;AhBurFR;AgBrrFQ;EACI,cf/DiB;EegEjB,qBAAA;AhBurFZ;AgBprFI;EACI,iBAAA;AhBsrFR;;AgBlrFA;;;EAGI,cftEyB;EeuEzB,gBfmE4B;ADknFhC;;AgBnrFA;EACI,0BAAA;EACA,gBfkE4B;EejE5B,cf5EyB;ADkwF7B;;AgBprFA;EACE,yBAAA;AhBurFF;;AgBrrFA;EACE,yBAAA;AhBwrFF;;AgBtrFA;EACE,yBAAA;AhByrFF;;AgBvrFA;EACE,yBAAA;AhB0rFF;;AgBxrFA;EACE,yBAAA;AhB2rFF;;AgBzrFA;EACE,WfvG2B;ADmyF7B;;AgBzrFA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBfmC2B;EelC3B,gBAAA;AhB4rFJ;AgB1rFI;EACI,cfrFqB;EesFrB,mBf0BuB;EezBvB,yBAAA;AhB4rFR;AgBzrFI;EACI,qBfvFqB;EewFrB,cfxFqB;ADmxF7B;AgBzrFQ;EACI,cf3FiB;ADsxF7B;AgBvrFI;EACI,qBf5EqB;Ee6ErB,cf7EqB;ADswF7B;AgBvrFQ;EACI,cfhFiB;ADywF7B;AgBrrFI;EACI,sCfzHqB;Ee0HrB,cfhJqB;ADu0F7B;AgBrrFQ;EACI,+Bf7HiB;ADozF7B;;AiBp1FA;EACI,chBkByB;EgBjBzB,ehB2J2B;EgB1J3B,8DhBCyB;EgBAzB,kBAAA;EACA,kCAAA;EACA,mCAAA;AjBu1FJ;;AiBp1FA;EACI,kBAAA;EACA,mBhBDyB;ADw1F7B;;AiBr1FA,eAAA;AACA;;;;;;ERKI,6BAAA;AT61FJ;;AiBx1FA;;ERLI,6BAAA;ATs2FJ;;AiB51FA;;ERFI,mCAAA;ATu2FJ;;AiBh2FA;;ERHI,gEAAA;EAGA,yBAAA;ATw2FJ;;AiBn2FA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBhBlCyB;ADw4F7B;AiBp2FI;EACI,eAAA;AjBs2FR;AiBn2FI;EACI,WAAA;AjBq2FR;;AiBj2FA;EACI,WAAA;EACA,WAAA;EACA,yBhBfyB;EgBgBzB,iBAAA;AjBo2FJ;AiBl2FI;EACI,yBhBfqB;ADm3F7B;;AiBh2FA;EACI,YAAA;EACA,cAAA;AjBm2FJ;;AiBh2FA;EACE,WAAA;AjBm2FF;;AiBj2FA;EACE,YAAA;AjBo2FF;;AiBj2FA;EACE,yBAAA;AjBo2FF;;AkBp7FA;;EAEI,iBjBMyB;EiBLzB,gBjBgK4B;EiB/J5B,mBjBwJ2B;EiBvJ3B,mBjBqKyB;EiBpKzB,gBAAA;EACA,YAAA;EACA,wBjBuH4B;EiBtH5B,kBAAA;EACA,eAAA;ECRA,yBlB0CyB;EkByFrB,clB3HqB;ADy7F7B;AmB77FI;;;;;;;;;;;;EAWI,yBlB4BqB;EkB3BrB,clBRqB;EkBSrB,gBAAA;AnBg8FR;AmB77FI;;EACI,2CAAA;AnBg8FR;AmBz7FQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yBlBQiB;EkBPjB,qBlBOiB;ADu8F7B;AmB32FI;;EACI,clB7FqB;EkB8FrB,qBlB9FqB;AD48F7B;AmB52FQ;;;;;;;;;;;;EAWI,6BlB9GiB;EkB+GjB,clB3GiB;EkB4GjB,qBlB5GiB;EkB6GjB,gBAAA;AnB+2FZ;AmB32FI;;EACI,clBnHqB;ADi+F7B;AmB52FQ;;;;;;;;;;;;EAWI,6BlBnIiB;EkBoIjB,clBhIiB;EkBiIjB,qBAAA;EACA,gBAAA;AnB+2FZ;AkBhhGI;;;EEXF,UFauB;EEVvB,0BAAA;EFWM,qBAAA;AlBohGR;AkBlhGI;;;;ETjBM,gBSoBD;EACA,qBAAA;AlBshGT;AkBnhGI;;EAEI,gBjB+GwB;EiB9GxB,mBjB8GwB;EiB7GxB,ejB6GwB;EiB5GxB,UAAA;EACA,oBjB4GwB;EiB3GxB,gBAAA;EACA,kBAAA;EACA,mBAAA;AlBqhGR;AkBnhGQ;;EACI,UAAA;AlBshGZ;AkBnhGQ;;EACI,gBjBoGoB;EiBnGpB,mBjBmGoB;EiBlGpB,ejBkGoB;ADo7FhC;AkBphGY;;;;EAEI,oBjB6FgB;AD27FhC;AkBphGQ;;EACI,cjB2FoB;EiB1FpB,iBjB0FoB;EiBzFpB,ajByFoB;AD87FhC;AkBrhGY;;;;EAEI,mBjBoFgB;ADq8FhC;AkBrhGQ;;;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;AlBwhGZ;AkBnhGI;;EACI,kBAAA;EACA,QAAA;AlBshGR;;AkBhhGA;ECjFI,yBlB8CyB;EkBqFrB,clB3HqB;AD8lG7B;AmBlmGI;EAWI,yBlBgCqB;EkB/BrB,clBRqB;EkBSrB,gBAAA;AnB0lGR;AmBvlGI;EACI,2CAAA;AnBylGR;AmBllGQ;EAMI,yBlBYiB;EkBXjB,qBlBWiB;ADokG7B;AmB5+FI;EACI,clBzFqB;EkB0FrB,qBlB1FqB;ADwkG7B;AmB5+FQ;EAWI,6BlB9GiB;EkB+GjB,clBvGiB;EkBwGjB,qBlBxGiB;EkByGjB,gBAAA;AnBo+FZ;AmBh+FI;EACI,clB/GqB;ADilG7B;AmBh+FQ;EAWI,6BlBnIiB;EkBoIjB,clB5HiB;EkB6HjB,qBAAA;EACA,gBAAA;AnBw9FZ;;AkBnjGA;EClFI,yBlBmDyB;EkBgFrB,clB3HqB;ADkoG7B;AmBtoGI;EAWI,yBlBqCqB;EkBpCrB,clBRqB;EkBSrB,gBAAA;AnB8nGR;AmB3nGI;EACI,2CAAA;AnB6nGR;AmBtnGQ;EAMI,yBlBiBiB;EkBhBjB,qBlBgBiB;ADmmG7B;AmBhhGI;EACI,clBpFqB;EkBqFrB,qBlBrFqB;ADumG7B;AmBhhGQ;EAWI,6BlB9GiB;EkB+GjB,clBlGiB;EkBmGjB,qBlBnGiB;EkBoGjB,gBAAA;AnBwgGZ;AmBpgGI;EACI,clB1GqB;ADgnG7B;AmBpgGQ;EAWI,6BlBnIiB;EkBoIjB,clBvHiB;EkBwHjB,qBAAA;EACA,gBAAA;AnB4/FZ;;AkBtlGA;ECnFI,yBlBwDyB;EkB2ErB,clB3HqB;ADsqG7B;AmB1qGI;EAWI,yBlB0CqB;EkBzCrB,clBRqB;EkBSrB,gBAAA;AnBkqGR;AmB/pGI;EACI,2CAAA;AnBiqGR;AmB1pGQ;EAMI,yBlBsBiB;EkBrBjB,qBlBqBiB;ADkoG7B;AmBpjGI;EACI,clB/EqB;EkBgFrB,qBlBhFqB;ADsoG7B;AmBpjGQ;EAWI,6BlB9GiB;EkB+GjB,clB7FiB;EkB8FjB,qBlB9FiB;EkB+FjB,gBAAA;AnB4iGZ;AmBxiGI;EACI,clBrGqB;AD+oG7B;AmBxiGQ;EAWI,6BlBnIiB;EkBoIjB,clBlHiB;EkBmHjB,qBAAA;EACA,gBAAA;AnBgiGZ;;AkBznGA;ECpFI,yBlB6DyB;EkBsErB,clB3HqB;AD0sG7B;AmB9sGI;EAWI,yBlB+CqB;EkB9CrB,clBRqB;EkBSrB,gBAAA;AnBssGR;AmBnsGI;EACI,2CAAA;AnBqsGR;AmB9rGQ;EAMI,yBlB2BiB;EkB1BjB,qBlB0BiB;ADiqG7B;AmBxlGI;EACI,clB1EqB;EkB2ErB,qBlB3EqB;ADqqG7B;AmBxlGQ;EAWI,6BlB9GiB;EkB+GjB,clBxFiB;EkByFjB,qBlBzFiB;EkB0FjB,gBAAA;AnBglGZ;AmB5kGI;EACI,clBhGqB;AD8qG7B;AmB5kGQ;EAWI,6BlBnIiB;EkBoIjB,clB7GiB;EkB8GjB,qBAAA;EACA,gBAAA;AnBokGZ;;AkB5pGA;ECrFI,yBlBkEyB;EkBiErB,clB3HqB;AD8uG7B;AmBlvGI;EAWI,yBlBoDqB;EkBnDrB,clBRqB;EkBSrB,gBAAA;AnB0uGR;AmBvuGI;EACI,2CAAA;AnByuGR;AmBluGQ;EAMI,yBlBgCiB;EkB/BjB,qBlB+BiB;ADgsG7B;AmB5nGI;EACI,clBrEqB;EkBsErB,qBlBtEqB;ADosG7B;AmB5nGQ;EAWI,6BlB9GiB;EkB+GjB,clBnFiB;EkBoFjB,qBlBpFiB;EkBqFjB,gBAAA;AnBonGZ;AmBhnGI;EACI,clB3FqB;AD6sG7B;AmBhnGQ;EAWI,6BlBnIiB;EkBoIjB,clBxGiB;EkByGjB,qBAAA;EACA,gBAAA;AnBwmGZ;;AkB/rGA;ECtFI,yBlBQyB;EkBiCrB,clBKqB;AD4uG7B;AmBtxGI;EAWI,yBlBPqB;EkBQrB,clBRqB;EkBSrB,gBAAA;AnB8wGR;AmB3wGI;EACI,2CAAA;AnB6wGR;AmBtwGQ;EAMI,yBlB1BiB;EkB2BjB,qBlB3BiB;AD8xG7B;AmB1vGQ;EACI,clBqBiB;ADuuG7B;AmB1vGY;EAGI,yBAAA;AnB0vGhB;AmBtvGQ;EACI,clBTiB;ADiwG7B;AmBtvGY;EAGI,yBAAA;AnBsvGhB;AmBlvGQ;EACI,clBTiB;AD6vG7B;AmBlvGY;EAGI,yBAAA;AnBkvGhB;AmB9uGQ;EACI,clBdiB;AD8vG7B;AmB9uGY;EAGI,yBAAA;AnB8uGhB;AmB1uGQ;EACI,clBlCiB;AD8wG7B;AmB1uGY;EAGI,yBAAA;AnB0uGhB;AmBtuGQ;EACI,clBrDiB;AD6xG7B;AmBtuGY;EAGI,yBAAA;AnBsuGhB;AmBluGQ;EAWI,yBlB3GiB;EkB4GjB,clBrEiB;EkBsEjB,gBAAA;AnB0tGZ;AmBvtGQ;EAEI,yBAAA;AnBwtGZ;AmBttGY;EACI,gBAAA;AnBwtGhB;AmB/sGI;EACI,clB/HqB;EkBgIrB,qBlBhIqB;ADi1G7B;AmB/sGQ;EAWI,6BlB9GiB;EkB+GjB,clB9IiB;EkB+IjB,qBlB/IiB;EkBgJjB,gBAAA;AnBusGZ;AmBnsGI;EACI,clBrJqB;AD01G7B;AmBnsGQ;EAWI,6BlBnIiB;EkBoIjB,clBnKiB;EkBoKjB,qBAAA;EACA,gBAAA;AnB2rGZ;;AkBhxGA;EC2FE,clBrI2B;EkBsI3B,qBlBtI2B;AD+zG7B;AmBvrGE;EAWI,6BlB1JuB;EkB2JvB,clBnJuB;EkBoJvB,qBlBpJuB;EkBqJvB,gBAAA;AnB+qGN;;AkB1xGA;EC0FE,clBhI2B;EkBiI3B,qBlBjI2B;ADq0G7B;AmBlsGE;EAWI,6BlB1JuB;EkB2JvB,clB9IuB;EkB+IvB,qBlB/IuB;EkBgJvB,gBAAA;AnB0rGN;;AkBpyGA;ECyFE,clB3H2B;EkB4H3B,qBlB5H2B;AD20G7B;AmB7sGE;EAWI,6BlB1JuB;EkB2JvB,clBzIuB;EkB0IvB,qBlB1IuB;EkB2IvB,gBAAA;AnBqsGN;;AkB9yGA;ECwFE,clBtH2B;EkBuH3B,qBlBvH2B;ADi1G7B;AmBxtGE;EAWI,6BlB1JuB;EkB2JvB,clBpIuB;EkBqIvB,qBlBrIuB;EkBsIvB,gBAAA;AnBgtGN;;AkBxzGA;ECuFE,clBjH2B;EkBkH3B,qBlBlH2B;ADu1G7B;AmBnuGE;EAWI,6BlB1JuB;EkB2JvB,clB/HuB;EkBgIvB,qBlBhIuB;EkBiIvB,gBAAA;AnB2tGN;;AkBl0GA;ECsFE,clBzI2B;EkB0I3B,qBlB1I2B;AD03G7B;AmB9uGE;EAWI,6BlB1JuB;EkB2JvB,clBvJuB;EkBwJvB,qBlBxJuB;EkByJvB,gBAAA;AnBsuGN;;AkB30GA;EACI,iBjB3FyB;EiB4FzB,8BAAA;EACA,kBAAA;AlB80GJ;AkB50GI;EACI,kBAAA;AlB80GR;;AkB30GA;EACI,iBjBkB4B;EiBjB5B,kBAAA;EACA,6BjBpEyB;ADk5G7B;;AkBr0GQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,6BjBnFiB;AD86G7B;;AkBt1GA;EC2EG,clB9C4B;EkB+C5B,sBlB7E6B;EkB8E7B,kBAAA;AnB+wGH;AmB7wGG;EACC,kBAAA;AnB+wGJ;;AkB51GA;ECwEG,elB/C4B;EkBgD5B,wBlB9E6B;EkB+E7B,iBAAA;AnBwxGH;AmBtxGG;EACC,iBAAA;AnBwxGJ;;AkBj2GA;EACI,SjBnIyB;EiBoIzB,sBAAA;EACA,6BjBlGyB;ADs8G7B;;AkBj2GA;EACI,gBAAA;AlBo2GJ;;AkBl2GA;EACI,WAAA;AlBq2GJ;;AkBn2GA;EACI,gBAAA;AlBs2GJ;;AkBp2GA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AlBu2GJ;;AqBhgHE;ECAE,yBrBoPwB;EqBnPxB,WAAA;AtBogHJ;AsBlgHI;EAWI,yBrBuO2B;EqBtO3B,WAAA;AtB0/GR;AsBv/GI;EACI,crBiOoB;EqBhOpB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrB8NoB;AD2xG5B;AsBv/GQ;EAWI,crBkNuB;EqBjNvB,qBrBiNuB;EqBhNvB,6BrBEiB;AD6+G7B;AsB3+GI;EACI,crB0MoB;EqBzMpB,yBrBnCqB;ADghH7B;AsB1+GQ;EAWI,crB4LuB;EqB3LvB,yBrBlDiB;ADohH7B;AqBzhHE;ECHE,yBrBiP+B;EqBhP/B,WAAA;AtB+hHJ;AsB7hHI;EAWI,yBrBoO2B;EqBnO3B,WAAA;AtBqhHR;AsBlhHI;EACI,crB8N2B;EqB7N3B,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrB2N2B;ADyzGnC;AsBlhHQ;EAWI,crB+MuB;EqB9MvB,qBrB8MuB;EqB7MvB,6BrBEiB;ADwgH7B;AsBtgHI;EACI,crBuM2B;EqBtM3B,yBrBnCqB;AD2iH7B;AsBrgHQ;EAWI,crByLuB;EqBxLvB,yBrBlDiB;AD+iH7B;AqBjjHE;ECNE,yBrB6PyB;EqB5PzB,WAAA;AtB0jHJ;AsBxjHI;EAWI,yBrBgP2B;EqB/O3B,WAAA;AtBgjHR;AsB7iHI;EACI,crB0OqB;EqBzOrB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrBuOqB;ADw0G7B;AsB7iHQ;EAWI,crB2NuB;EqB1NvB,qBrB0NuB;EqBzNvB,6BrBEiB;ADmiH7B;AsBjiHI;EACI,crBmNqB;EqBlNrB,yBrBnCqB;ADskH7B;AsBhiHQ;EAWI,crBqMuB;EqBpMvB,yBrBlDiB;AD0kH7B;AqBzkHE;ECTE,yBrBuPsB;EqBtPtB,WAAA;AtBqlHJ;AsBnlHI;EAWI,yBrB0O2B;EqBzO3B,WAAA;AtB2kHR;AsBxkHI;EACI,crBoOkB;EqBnOlB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrBiOkB;ADy2G1B;AsBxkHQ;EAWI,crBqNuB;EqBpNvB,qBrBoNuB;EqBnNvB,6BrBEiB;AD8jH7B;AsB5jHI;EACI,crB6MkB;EqB5MlB,yBrBnCqB;ADimH7B;AsB3jHQ;EAWI,crB+LuB;EqB9LvB,yBrBlDiB;ADqmH7B;AqBjmHE;ECZE,yBrB0PwB;EqBzPxB,WAAA;AtBgnHJ;AsB9mHI;EAWI,yBrB6O2B;EqB5O3B,WAAA;AtBsmHR;AsBnmHI;EACI,crBuOoB;EqBtOpB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrBoOoB;ADi4G5B;AsBnmHQ;EAWI,crBwNuB;EqBvNvB,qBrBuNuB;EqBtNvB,6BrBEiB;ADylH7B;AsBvlHI;EACI,crBgNoB;EqB/MpB,yBrBnCqB;AD4nH7B;AsBtlHQ;EAWI,crBkMuB;EqBjMvB,yBrBlDiB;ADgoH7B;AqBznHE;ECfE,yBrBgQ2B;EqB/P3B,WAAA;AtB2oHJ;AsBzoHI;EAWI,yBrBmP2B;EqBlP3B,WAAA;AtBioHR;AsB9nHI;EACI,crB6OuB;EqB5OvB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrB0OuB;ADs5G/B;AsB9nHQ;EAWI,crB8NuB;EqB7NvB,qBrB6NuB;EqB5NvB,6BrBEiB;ADonH7B;AsBlnHI;EACI,crBsNuB;EqBrNvB,yBrBnCqB;ADupH7B;AsBjnHQ;EAWI,crBwMuB;EqBvMvB,yBrBlDiB;AD2pH7B;AqBjpHE;EClBE,yBrBmQwB;EqBlQxB,WAAA;AtBsqHJ;AsBpqHI;EAWI,yBrBsP2B;EqBrP3B,WAAA;AtB4pHR;AsBzpHI;EACI,crBgPoB;EqB/OpB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrB6OoB;AD86G5B;AsBzpHQ;EAWI,crBiOuB;EqBhOvB,qBrBgOuB;EqB/NvB,6BrBEiB;AD+oH7B;AsB7oHI;EACI,crByNoB;EqBxNpB,yBrBnCqB;ADkrH7B;AsB5oHQ;EAWI,crB2MuB;EqB1MvB,yBrBlDiB;ADsrH7B;AqBzqHE;ECrBE,yBrBsQuB;EqBrQvB,WAAA;AtBisHJ;AsB/rHI;EAWI,yBrByP2B;EqBxP3B,WAAA;AtBurHR;AsBprHI;EACI,crBmPmB;EqBlPnB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrBgPmB;ADs8G3B;AsBprHQ;EAWI,crBoOuB;EqBnOvB,qBrBmOuB;EqBlOvB,6BrBEiB;AD0qH7B;AsBxqHI;EACI,crB4NmB;EqB3NnB,yBrBnCqB;AD6sH7B;AsBvqHQ;EAWI,crB8MuB;EqB7MvB,yBrBlDiB;ADitH7B;AqBjsHE;ECxBE,yBrByQ4B;EqBxQ5B,WAAA;AtB4tHJ;AsB1tHI;EAWI,yBrB4P2B;EqB3P3B,WAAA;AtBktHR;AsB/sHI;EACI,crBsPwB;EqBrPxB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrBmPwB;AD89GhC;AsB/sHQ;EAWI,crBuOuB;EqBtOvB,qBrBsOuB;EqBrOvB,6BrBEiB;ADqsH7B;AsBnsHI;EACI,crB+NwB;EqB9NxB,yBrBnCqB;ADwuH7B;AsBlsHQ;EAWI,crBiNuB;EqBhNvB,yBrBlDiB;AD4uH7B;AqBztHE;EC3BE,yBrB4QwB;EqB3QxB,WAAA;AtBuvHJ;AsBrvHI;EAWI,yBrB+P2B;EqB9P3B,WAAA;AtB6uHR;AsB1uHI;EACI,crByPoB;EqBxPpB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrBsPoB;ADs/G5B;AsB1uHQ;EAWI,crB0OuB;EqBzOvB,qBrByOuB;EqBxOvB,6BrBEiB;ADguH7B;AsB9tHI;EACI,crBkOoB;EqBjOpB,yBrBnCqB;ADmwH7B;AsB7tHQ;EAWI,crBoNuB;EqBnNvB,yBrBlDiB;ADuwH7B;AqBjvHE;EC9BE,yBrB+QsB;EqB9QtB,WAAA;AtBkxHJ;AsBhxHI;EAWI,yBrBkQ2B;EqBjQ3B,WAAA;AtBwwHR;AsBrwHI;EACI,crB4PkB;EqB3PlB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrByPkB;AD8gH1B;AsBrwHQ;EAWI,crB6OuB;EqB5OvB,qBrB4OuB;EqB3OvB,6BrBEiB;AD2vH7B;AsBzvHI;EACI,crBqOkB;EqBpOlB,yBrBnCqB;AD8xH7B;AsBxvHQ;EAWI,crBuNuB;EqBtNvB,yBrBlDiB;ADkyH7B;AqBzwHE;ECjCE,yBrBkRuB;EqBjRvB,WAAA;AtB6yHJ;AsB3yHI;EAWI,yBrBqQ2B;EqBpQ3B,WAAA;AtBmyHR;AsBhyHI;EACI,crB+PmB;EqB9PnB,gBAAA;EACA,6BrBkBqB;EqBjBrB,qBrB4PmB;ADsiH3B;AsBhyHQ;EAWI,crBgPuB;EqB/OvB,qBrB+OuB;EqB9OvB,6BrBEiB;ADsxH7B;AsBpxHI;EACI,crBwOmB;EqBvOnB,yBrBnCqB;ADyzH7B;AsBnxHQ;EAWI,crB0NuB;EqBzNvB,yBrBlDiB;AD6zH7B;;AuBl0HG;EACI,ctBsCsB;EmBzC3B,YIHgD;EJMhD,yBAAA;ApBu0HF;;AuBp0HG;EACI,ctBkCsB;EmBzC3B,YIHgD;EJMhD,yBAAA;ApB60HF;;AuBt0HG;EACI,ctB8BsB;EmBzC3B,YIHgD;EJMhD,yBAAA;ApBm1HF;;AuBx0HG;EACI,ctB0BsB;EmBzC3B,YIHgD;EJMhD,yBAAA;ApBy1HF;;AwB71HA;EACI,6BvBsCyB;EuBrCzB,yBAAA;EACA,mBvBiI2B;EuBhI3B,cvBayB;EuBZzB,YAAA;EACA,mBAAA;EACA,mBvBmJ2B;EQlJ3B,oGAAA;EARM,gBeSN;AxBq2HJ;AwBn2HI;EACI,qBvBQqB;AD61H7B;AwBl2HI;EACI,yBAAA;EfhBE,gBeiBF;EACA,qBAAA;EACA,cvBFqB;ADu2H7B;AwBn2HQ;EAEI,yBAAA;EACA,iBAAA;EACA,6BvBciB;ADs1H7B;AwBh2HI;Ef7BM,gBeiCF;AxBg2HR;AwB71HI;EACI,qBAAA;AxB+1HR;AwBz1HQ;EAEI,sBAAA;AxB01HZ;AwBt1HI;EACI,qBAAA;EACA,cvBeqB;EuBdrB,0CAAA;AxBw1HR;AwBt1HQ;EACI,yBvB/CiB;ADu4H7B;AwBp1HI;EACI,sBvBkEwB;EuBjExB,evB8FuB;EuB7FvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AxBs1HR;AwBn1HI;EACI,kCAAA;EACA,gCAAA;AxBq1HR;;AwB30HI;;EACI,6BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cvBrCqB;EuBsCrB,eAAA;AxB+0HR;AwB30HQ;;EACI,eAAA;EACA,SAAA;AxB80HZ;;AwBx0HI;EACI,gBAAA;EACA,cvBrCqB;ADg3H7B;;AuBj5HQ;;EACI,yBAAA;AvBq5HZ;AuBl5HQ;;EACI,kBAAA;AvBq5HZ;AuBn5HY;;EACI,yBAAA;AvBs5HhB;;AuB/4HQ;;EACI,kBAAA;AvBm5HZ;AuBj5HY;;EACI,yBAAA;AvBo5HhB;AuBh5HQ;;EACI,yBAAA;AvBm5HZ;AuBj5HY;;EACI,4BAAA;AvBo5HhB;;AuBz4HQ;;EACI,kBAAA;AvB64HZ;AuB34HY;;EACI,yBAAA;AvB84HhB;AuB14HQ;;EACI,yBAAA;AvB64HZ;;AuBv4HQ;;EACI,4BAAA;AvB24HZ;AuBz4HY;;EACI,yBAAA;AvB44HhB;AuBx4HQ;;EACI,yBAAA;AvB24HZ;AuBz4HY;;;EAEI,4BAAA;AvB44HhB;;AwB/3HI;;;;EAEI,0CvB1FqB;EuB2FrB,mBAAA;AxBo4HR;AwBn4HQ;;;;;;;;;;EAGI,mBAAA;EACA,0CvB/FiB;AD2+H7B;AwBt4HY;;EACI,0CvBtGa;AD++H7B;AwBp4HM;;EACI,0CvB7GmB;EuB8GnB,YAAA;EACA,mCAAA;AxBu4HV;AwBj4HY;;EACI,0CvBrHa;ADy/H7B;;AwB73HI;EACI,cvBpFqB;ADo9H7B;;AwB53HI;EACI,cvBxGqB;ADu+H7B;;AwB33HA;EACI,yBvBvJyB;EuBwJzB,yBAAA;EACA,mBvB9B2B;EuB+B3B,cvB3HyB;EQhCzB,oGAAA;AT8hIJ;AwB/3HI;EACE,yBvB/JuB;EuBgKvB,qBvB3HuB;AD4/H7B;AwB93HI;EAEI,yBvBtKqB;ADqiI7B;AwB73HI;EACI,cvB/GqB;AD8+H7B;AwB73HI;EACI,cvBjIqB;ADggI7B;AwB53HI;EDxLA,uBAAA;EC2LI,kBAAA;AxB63HR;AwB13HI;EACI,WAAA;AxB43HR;;AwBx3HA;;EAEI,mBAAA;EACA,kBAAA;AxB23HJ;;AwBx3HI;EACI,yBvBrLqB;ADgjI7B;;AwBr3HE;;EACE,eAAA;AxBy3HJ;AwBv3HI;;EACE,8BAAA;AxB03HN;AwBv3HE;;EACE,+BAAA;EACA,yBAAA;AxB03HJ;AwBt3HI;;EACE,8BAAA;AxBy3HN;AwBv3HI;;EACE,+BAAA;AxB03HN;AwBv3HM;;EACE,wBAAA;AxB03HR;;AwBp3HA;;;;EAII,oBAAA;AxBu3HJ;;AwBr3HA;;;;EAII,mBAAA;AxBw3HJ;;AwBt3HA;EACI,yBvBnOyB;EuBoOzB,cvB9MyB;EuB+MzB,mBAAA;AxBy3HJ;;AwBt3HA;EACI,iBvBxPyB;EuByPzB,oBAAA;AxBy3HJ;;AwBv3HA;EACI,qBvB5OyB;ADsmI7B;;AwBv3HA;EACI,cAAA;AxB03HJ;;AwBx3HA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;AxB23HJ;AwBz3HI;EAEI,iBAAA;EACA,gBAAA;EACA,kBAAA;AxB03HR;;AwBn3HI;;;EAEI,mBAAA;AxBu3HR;;AwBn3HA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AxBs3HJ;;AwBn3HA;EACI,eAAA;AxBs3HJ;;AwBl3HA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AxBq3HF;;AyB7qIA;EACI,kBAAA;AzBgrIJ;AyB9qII;EAEI,gBxBkHuB;AD6jI/B;AyB7qII;EACI,cxBmCqB;EwBlCrB,mBxBkJuB;EwBjJvB,yBAAA;AzB+qIR;AyB3qII;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCxBSqB;EwBRrB,gBAAA;AzB6qIR;AyB3qIQ;EACI,gBAAA;EACA,yBxBoBiB;ADypI7B;AyB1qIQ;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,cxBaiB;EwBZjB,mBxB4HmB;ADgjI/B;AyBvqIQ;EACI,oCAAA;AzByqIZ;AyBtqIQ;EACI,mBxB/BiB;ADusI7B;AyBrqIQ;;EAEI,cxBrCiB;AD4sI7B;AyBlqIQ;EACI,kCxBHiB;ADuqI7B;AyBjqIQ;EACI,mBxBTiB;AD4qI7B;AyBhqIQ;;EAEI,cxBdiB;ADgrI7B;AyB7pIQ;EACI,mCxBRiB;ADuqI7B;AyB5pIQ;EACI,mBxBdiB;AD4qI7B;AyB3pIQ;;EAEI,cxBnBiB;ADgrI7B;AyBxpIQ;EACI,kCxB5BiB;ADsrI7B;AyBvpIQ;EACI,mBxBlCiB;AD2rI7B;AyBtpIQ;;EAEI,cxBvCiB;AD+rI7B;AyBnpIQ;EACI,mCxBjCiB;ADsrI7B;AyBlpIQ;EACI,mBxBvCiB;AD2rI7B;AyBjpIQ;;EAEI,cxB5CiB;AD+rI7B;AyB9oIQ;EACI,kCxB3CiB;AD2rI7B;AyB7oIQ;EACI,mBxBjDiB;ADgsI7B;AyB5oIQ;;EAEI,cxBtDiB;ADosI7B;;A0BrwIM;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;A1BwwIR;A0BtwIQ;EACE,iBAAA;A1BwwIV;A0BlwIQ;EACI,kBAAA;A1BowIZ;A0B/vIQ;EACE,kBAAA;EACA,0CzBFmB;EyBGnB,gBAAA;EACA,gBzBqIsB;EyBpItB,kBAAA;EACA,WzBjBmB;ADkxI7B;A0B9vIY;EACI,0CzBVa;AD0wI7B;A0B5vIgB;EAGI,yBzBnBS;EyBoBT,czBlCS;EyBmCT,+CAAA;A1B4vIpB;A0BxvIY;EAGI,YAAA;A1BwvIhB;A0BpvIQ;EACI,cAAA;EACA,iBAAA;EACA,eAAA;A1BsvIZ;A0BhvIY;EACI,0CzB3Ba;EyB4Bb,czBzDa;AD2yI7B;A0B/uIoB;EAGI,yBzB/DK;EyBgEL,czB1BK;ADywI7B;A0BruIgB;EAGI,yBzBvCS;AD4wI7B;A0B5tIgB;EAGI,yBzBzCS;ADqwI7B;A0BntIgB;EAGI,yBzB1DS;AD6wI7B;A0B1sIgB;EAGI,yBzB5DS;ADswI7B;A0BjsIgB;EAGI,yBzBnES;ADowI7B;;A0B3rIA;EACI,wBAAA;A1B8rIJ;;A0B3rIA;EACI,kBAAA;A1B8rIJ;A0B5rII;EACI,oBAAA;A1B8rIR;;A2Bl1IE;EACI,mBAAA;A3Bq1IN;A2Bl1IE;EACE,mB1BgI2B;ADotI/B;A2B/0IM;EACE,6BAAA;A3Bi1IR;A2B90IM;EACE,eAAA;A3Bg1IR;;A4B91IA;EACI,SAAA;EACA,oBAAA;A5Bi2IJ;A4B/1II;EACI,+CAAA;A5Bi2IR;A4B91II;EACI,kC3BoHwB;E2BnHxB,iC3BmHwB;AD6uIhC;A4B51IQ;EACI,c3B2BiB;E2B1BjB,SAAA;EACA,iBAAA;EACA,6B3BqBiB;E2BpBjB,6BAAA;EACA,mBAAA;EACA,e3BsImB;E2BrInB,kBAAA;EACA,gB3B8IiB;ADgtI7B;A4B51IY;EACI,6B3Baa;ADi1I7B;A4B31IY;EACI,sB3BjBa;E2BkBb,mBAAA;EACA,c3BxBa;ADq3I7B;A4B11IY;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A5B41IhB;A4Bx1IQ;EAEI,+BAAA;A5By1IZ;A4Bn1IY;EACI,c3B5Ca;ADi4I7B;A4Bn1IgB;EACI,0C3BlBS;E2BmBT,c3BhDS;ADq4I7B;A4B50IgB;EACI,yB3BpBS;ADk2I7B;A4Br0IgB;EACI,yB3BpBS;AD21I7B;A4B9zIgB;EACI,yB3BpBS;ADo1I7B;A4BvzIgB;EACI,yB3BnCS;AD41I7B;A4BhzIgB;EACI,yB3BvDS;ADy2I7B;;A6B95IA;EACI,qB5B2M6B;E4B1M7B,wB5B0M6B;E4BzM7B,gBAAA;EACA,mBAAA;EACA,gDAAA;A7Bi6IJ;A6B/5II;EACI,sBAAA;A7Bi6IR;A6B/5IQ;EACI,c5BDiB;ADk6I7B;A6B75II;EACI,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;A7B+5IR;A6B35IQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;A7B65IZ;A6B15IQ;EACI,kBAAA;A7B45IZ;A6B15IY;EACI,kBAAA;A7B45IhB;A6Bz5IY;EACI,iBAAA;A7B25IhB;A6Bv5IQ;EACI,yBAAA;EACA,mB5B4GmB;E4B3GnB,sBAAA;EACA,qB5BuHiB;ADkyI7B;A6Bv5IY;;EAEI,gBAAA;A7By5IhB;A6Bt5IY;;EAEI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;A7Bw5IhB;A6Br5IY;EACI,QAAA;EACA,eAAA;A7Bu5IhB;A6Bn5IgB;EACI,WAAA;EACA,YAAA;A7Bq5IpB;A6Bj5IY;EACI,YAAA;EACA,c5BrEa;ADw9I7B;A6B/4IQ;;;;EAII,0C5BhDiB;E4BiDjB,wB5BuCoB;AD02IhC;A6B74II;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;A7B+4IR;A6B54II;EACI,yBAAA;EACA,mB5BqDuB;E4BpDvB,mB5BLuB;E4BMvB,sB5BNuB;E4BOvB,qB5B8DqB;ADg1I7B;A6B34II;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;A7B64IR;A6B34IQ;EACI,kBAAA;EACA,OAAA;EACA,eAAA;A7B64IZ;A6B14IQ;EACE,WAAA;EACA,6BAAA;A7B44IV;A6Bx4IY;EACI,WAAA;A7B04IhB;A6Bp4IQ;EACI,WAAA;A7Bs4IZ;A6Bl4II;EACI,wCAAA;EACA,gBAAA;EACA,c5BpIqB;E4BqIrB,4BAAA;A7Bo4IR;A6Bh4IQ;EACI,c5BxGiB;AD0+I7B;A6Bh4IY;EACI,YAAA;EACA,c5B5Ga;AD8+I7B;A6B93IQ;EACI,mB5BjHiB;ADi/I7B;A6B73IQ;;;;EAII,0C5B1IiB;ADygJ7B;A6B53IQ;EACI,yBAAA;A7B83IZ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A6Bz3IA;EACI,oCAAA;A7B43IJ;;A8BjkJE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;A9BokJJ;A8BjkJE;EACC,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;A9BmkJH;A8BhkJE;EACE,sBAAA;A9BkkJJ;A8BhkJI;EACE,MAAA;A9BkkJN;A8B/jJI;EACE,gBAAA;EACA,QAAA;A9BikJN;;A+BxlJA;EACI,SAAA;EACA,gDAAA;EACA,uB9B2H4B;EQ3G5B,4BAAA;EsBdA,e9BwJ2B;ADu8I/B;A+B5lJQ;EACI,UAAA;EACA,WAAA;A/B8lJZ;A+B1lJI;EtB4CG,8CAAA;EsB1CC,kBAAA;EACA,cAAA;EXdN,UWeuB;EXZvB,wBAAA;EWaM,oBAAA;A/BimJR;A+B9lJI;EXnBF,UWqBuB;EXlBvB,0BAAA;EWmBM,mBAAA;EtBiCD,4CAAA;ATokJP;A+BjmJI;EAEE,mB9B6HyB;E8B5HzB,mBAAA;EACA,sBAAA;EACA,eAAA;EtBfF,4BAAA;EsBiBE,aAAA;A/BsmJN;A+BpmJM;EAEE,0C9BdqB;ADmnJ7B;A+BlmJM;EAEE,+B9BCqB;ADkmJ7B;A+BjmJQ;EAEE,6BAAA;A/BkmJV;A+B7lJI;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,c9BtDqB;E8BuDrB,0BAAA;EACA,qCAAA;EACA,oCAAA;A/B+lJR;A+B5lJI;EACI,0C9B5CqB;AD0oJ7B;A+B3lJI;EACI,+B9B7BqB;E8B8BrB,mB9B+EuB;E8B9EvB,yBAAA;EACA,gB9BuFwB;ADsgJhC;A+B1lJI;EChFA,yBDiF6B;A/B4lJjC;AgC3qJI;EACI,cD8EyB;A/B+lJjC;AgC1qJI;EACI,+B/BwBqB;ADopJ7B;AgCzqJI;EACI,c/BFqB;AD6qJ7B;AgCzqJQ;EAEI,0C/BuBiB;ADmpJ7B;AgCtqJI;EACI,0C/BkBqB;ADspJ7B;A+BxmJI;ECpFA,yBDqF6B;A/B0mJjC;AgC7rJI;EACI,cDkFyB;A/B6mJjC;AgC5rJI;EACI,+B/BwBqB;ADsqJ7B;AgC3rJI;EACI,c/BFqB;AD+rJ7B;AgC3rJQ;EAEI,0C/BuBiB;ADqqJ7B;AgCxrJI;EACI,0C/BkBqB;ADwqJ7B;A+BtnJI;ECxFA,yBDyF6B;A/BwnJjC;AgC/sJI;EACI,cDsFyB;A/B2nJjC;AgC9sJI;EACI,+B/BwBqB;ADwrJ7B;AgC7sJI;EACI,c/BFqB;ADitJ7B;AgC7sJQ;EAEI,0C/BuBiB;ADurJ7B;AgC1sJI;EACI,0C/BkBqB;AD0rJ7B;A+BpoJI;EC5FA,yBD6F6B;A/BsoJjC;AgCjuJI;EACI,cD0FyB;A/ByoJjC;AgChuJI;EACI,+B/BwBqB;AD0sJ7B;AgC/tJI;EACI,c/BFqB;ADmuJ7B;AgC/tJQ;EAEI,0C/BuBiB;ADysJ7B;AgC5tJI;EACI,0C/BkBqB;AD4sJ7B;A+BlpJI;EChGA,yBDiG6B;A/BopJjC;AgCnvJI;EACI,cD8FyB;A/BupJjC;AgClvJI;EACI,+B/BwBqB;AD4tJ7B;AgCjvJI;EACI,c/BFqB;ADqvJ7B;AgCjvJQ;EAEI,0C/BuBiB;AD2tJ7B;AgC9uJI;EACI,0C/BkBqB;AD8tJ7B;;A+BhqJA;EACI,qB9BF2B;E8BG3B,eAAA;A/BmqJJ;A+BjqJI;EACI,mB9BPuB;E8BQvB,sB9BRuB;E8BSvB,cAAA;A/BmqJR;A+BjqJQ;EACI,aAAA;A/BmqJZ;;AiCjxJE;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;AjCoxJJ;AiCjxJE;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AjCmxJJ;AiC/wJI;EAEE,cAAA;AjCgxJN;AiC3wJI;EACE,aAAA;AjC6wJN;AiC1wJI;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,chC7BuB;EgC8BvB,uBAAA;EACA,qCAAA;EACA,oCAAA;AjC4wJN;AiCxwJM;EACE,WAAA;EACA,UAAA;AjC0wJR;AiCrwJE;EAEE,mBhCqG2B;EgCpG3B,mBAAA;EACA,sBAAA;EACA,eAAA;ExBvCA,4BAAA;ATkzJJ;AiCxwJI;EAEE,0ChCrCuB;AD8yJ7B;AiCtwJI;EAEE,+BhCtBuB;AD6xJ7B;AiCrwJM;EAEE,6BAAA;AjCswJR;AiChwJE;ExBpBK,8CAAA;EwBuBH,kBAAA;EACA,cAAA;Eb/EF,UagFmB;Eb7EnB,wBAAA;Ea8EE,oBAAA;AjCswJJ;AiCnwJE;EbpFA,UauFmB;EbpFnB,0BAAA;EaqFE,mBAAA;ExBjCG,4CAAA;AT0yJP;AiCnwJE;EAEE,kBAAA;EbhGF,UaiGmB;Eb9FnB,wBAAA;EXoDK,6CAAA;EwB4CH,cAAA;EACA,oBAAA;EACA,uBAAA;AjCywJJ;AiCtwJE;EAEE,mBAAA;Eb1GF,Ua2GmB;EbxGnB,0BAAA;EXoDK,6CAAA;ATi0JP;;AkC33JA;EACI,eAAA;EACA,kBAAA;AlC83JJ;;AkC53JA;EACI,gDjC6KuB;ADktJ3B;;AmCp4JA;EACI,elC4J2B;EkC3J3B,gDAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AnCu4JJ;AmCr4JI;EAII,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;AnCo4JR;AmCj4JI;EACI,+BlC4BqB;EkC3BrB,elC0IuB;EkCzIvB,0BAAA;EACA,gBlC+IwB;EkC9IxB,SAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AnCm4JR;AmCh4JI;EACI,aAAA;AnCk4JR;AmC/3JI;EACI,4BlCvBqB;EkCwBrB,SAAA;AnCi4JR;AmC93JI;ECpCA,yBnC+CyB;ADs3J7B;AoCn6JI;EACI,cnCMqB;AD+5J7B;AoCj6JI;EACI,2BnCuCqB;AD43J7B;AoCh6JI;EACI,yBnCmCqB;AD+3J7B;AoC/5JI;EACI,4BnC+BqB;ADk4J7B;AoC95JI;EACI,0BnC2BqB;ADq4J7B;AoC75JI;EACI,cnCfqB;EmCgBrB,YAAA;ApC+5JR;AmCh5JI;ECxCA,yBnCyDyB;ADk4J7B;AoCz7JI;EACI,cnCMqB;ADq7J7B;AoCv7JI;EACI,2BnCiDqB;ADw4J7B;AoCt7JI;EACI,yBnC6CqB;AD24J7B;AoCr7JI;EACI,4BnCyCqB;AD84J7B;AoCp7JI;EACI,0BnCqCqB;ADi5J7B;AoCn7JI;EACI,cnCfqB;EmCgBrB,YAAA;ApCq7JR;AmCl6JI;EC5CA,yBnC8DyB;ADm5J7B;AoC/8JI;EACI,cnCMqB;AD28J7B;AoC78JI;EACI,2BnCsDqB;ADy5J7B;AoC58JI;EACI,yBnCkDqB;AD45J7B;AoC38JI;EACI,4BnC8CqB;AD+5J7B;AoC18JI;EACI,0BnC0CqB;ADk6J7B;AoCz8JI;EACI,cnCfqB;EmCgBrB,YAAA;ApC28JR;AmCp7JI;EChDA,yBnCmEyB;ADo6J7B;AoCr+JI;EACI,cnCMqB;ADi+J7B;AoCn+JI;EACI,2BnC2DqB;AD06J7B;AoCl+JI;EACI,yBnCuDqB;AD66J7B;AoCj+JI;EACI,4BnCmDqB;ADg7J7B;AoCh+JI;EACI,0BnC+CqB;ADm7J7B;AoC/9JI;EACI,cnCfqB;EmCgBrB,YAAA;ApCi+JR;AmCt8JI;ECpDA,yBnCoDyB;ADy8J7B;AoC3/JI;EACI,cnCMqB;ADu/J7B;AoCz/JI;EACI,2BnC4CqB;AD+8J7B;AoCx/JI;EACI,yBnCwCqB;ADk9J7B;AoCv/JI;EACI,4BnCoCqB;ADq9J7B;AoCt/JI;EACI,0BnCgCqB;ADw9J7B;AoCr/JI;EACI,cnCfqB;EmCgBrB,YAAA;ApCu/JR;;AmCr9JI;EACI,2BlCnDqB;AD2gK7B;AmCr9JI;EACI,yBlCvDqB;AD8gK7B;AmCp9JI;EACI,4BlC3DqB;ADihK7B;AmCn9JI;EACI,0BlC/DqB;ADohK7B;;AmCj9JA;EACI,sBAAA;EACA,gBAAA;EACA,yBlCtEyB;EkCuEzB,elC4E2B;EkC3E3B,cAAA;EACA,+CAAA;AnCo9JJ;;AqCtiKG;EACI,wBAAA;EACA,gBpCmJwB;EoClJxB,gBpC8JyB;EoC7JzB,SAAA;ArCyiKP;AqCtiKG;EACI,SAAA;ArCwiKP;AqCriKG;;EAEI,SAAA;EACA,UAAA;EACA,WAAA;ArCuiKP;AqCriKO;;EACI,kBAAA;ArCwiKX;AqCpiKY;;;EAEI,UAAA;EACA,UAAA;ArCuiKhB;AqCniKG;;;;;;EAMI,iBAAA;EACA,sBAAA;ArCqiKP;AqCliKG;EACI,gBAAA;ArCoiKP;AqCliKG;EACI,eAAA;EACA,gBpCqHyB;EoCpHzB,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;ArCoiKP;AqCliKG;EACK,gBpCiHwB;EoChHxB,gBpCiGuB;EoChGvB,iBAAA;EACA,iBAAA;ArCoiKR;AqCjiKG;EACC,WAAA;ArCmiKJ;AqChiKI;EACI,kBAAA;ArCkiKR;;AqC7hKI;EACI,gBpCkFuB;EoCjFvB,yBAAA;ArCgiKR;AqC9hKI;EACI,gBpCgFuB;ADg9J/B;AqC9hKQ;EACI,cAAA;EACA,kBAAA;ArCgiKZ;AqC7hKI;EACI,gBpCkFwB;EoCjFxB,gBAAA;ArC+hKR;AqC9hKQ;EACI,cpC5DiB;EoC6DjB,iBAAA;EACA,gBpC4EoB;ADo9JhC;AqC7hKI;EACG,gBpCwEyB;EoCvEzB,gBpC0DwB;ADq+J/B;AqC7hKI;EACI,gBAAA;ArC+hKR;AqC7hKI;EACI,iBAAA;EACA,gBAAA;ArC+hKR;AqC7hKQ;EACI,iBAAA;ArC+hKZ;AqC3hKI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ArC6hKR;AqC3hKQ;EACI,WAAA;ArC6hKZ;;AqCxhKA;EACI,mBAAA;ArC2hKJ;;AsCjpKA;EACI,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AtCopKJ;AsCjpKQ;EACI,sBAAA;AtCmpKZ;AsC/oKY;E7BsDJ,qCAAA;ATgmKR;AsClpKoB;EACI,qDAAA;AtCopKxB;AsChpKoB;EACI,sDAAA;AtCkpKxB;AsC9oKoB;EACI,qDAAA;AtCgpKxB;AsC5oKoB;EACI,sDAAA;AtC8oKxB;AsC1oKoB;EACI,qDAAA;AtC4oKxB;AsCxoKgB;EACI,crCgBS;AD0nK7B;AsCvoKgB;EACI,crCiBS;ADwnK7B;AsCtoKgB;EACI,crCkBS;ADsnK7B;AsCroKgB;EACI,crCNS;AD6oK7B;AsCpoKgB;EACI,crCLS;AD2oK7B;AsChoKI;EACI,crCrBqB;EqCsBrB,2CAAA;AtCkoKR;AsChoKQ;EACI,cAAA;AtCkoKZ;AsC/nKQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;EACA,mBrC4EmB;EqC3EnB,yBrCtEiB;EqCuEjB,kBAAA;AtCioKZ;AsC/nKY;EACI,gBAAA;AtCioKhB;AsC5nKI;EACI,mBAAA;EACA,eAAA;EACA,crCzEqB;ADusK7B;AsC5nKI;EACI,crCnDqB;EqCoDrB,eAAA;EACA,gBAAA;AtC8nKR;;AsC1nKA;EACI,2BAAA;AtC6nKJ;AsC3nKI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AtC6nKR;AsC3nKQ;EACI,cAAA;AtC6nKZ;AsC1nKQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AtC4nKZ;AsC1nKY;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AtC4nKhB;AsCxnKI;EACI,gBAAA;AtC0nKR;;AsCpnKI;EACI,crCvFqB;AD8sK7B;AsCrnKQ;EACI,oDAAA;AtCunKZ;AsCpnKI;EACI,crCpFqB;AD0sK7B;AsCpnKQ;EACI,qDAAA;AtCsnKZ;AsCnnKI;EACI,crChGqB;ADqtK7B;AsCnnKQ;EACI,oDAAA;AtCqnKZ;AsClnKI;EACI,crC7FqB;ADitK7B;AsClnKQ;EACI,qDAAA;AtConKZ;AsCjnKI;EACI,crC/FqB;ADktK7B;AsCjnKQ;EACI,oDAAA;AtCmnKZ;AsC/mKI;EACI,crCjKqB;ADkxK7B;;AuC3xKI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AvC8xKR;AuC5xKQ;EACI,WAAA;EACA,kBAAA;AvC8xKZ;AuC1xKI;EACI,mBAAA;AvC4xKR;AuCzxKI;EACI,8DtCdqB;ADyyK7B;AuCzxKI;EACI,mBAAA;AvC2xKR;AuCzxKQ;EACI,kBAAA;AvC2xKZ;AuCvxKQ;;EAEI,gBAAA;AvCyxKZ;AuCrxKQ;EACI,mBAAA;AvCuxKZ;AuCnxKQ;EACI,cAAA;EACA,YAAA;EACA,WAAA;AvCqxKZ;AuClxKI;EACI,ctCFqB;EsCGrB,kBAAA;EACA,mBAAA;AvCoxKR;;AuCjxKA;;EAEI,aAAA;AvCoxKJ;;AwCr0KA;EAEE,wBvCyH8B;EuCxH9B,YAAA;EACA,gDAAA;AxCu0KF;AwCp0KE;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AxCs0KJ;AwCp0KI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AxCs0KR;AwCp0KI;EACI,eAAA;EACA,gBAAA;AxCs0KR;AwCj0KE;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AxCm0KJ;AwCh0KE;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA,EACA,gBAAA;EACA,8BAAA;AxCk0KJ;AwCh0KI;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AxCk0KN;AwCj0KM;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AxCm0KR;AwC9zKE;EACE,cAAA;AxCg0KJ;;AwC7zKA;EACE,8BAAA;AxCg0KF;;AwC1zKQ;EACI,kBAAA;AxC6zKZ;AwC1zKQ;EACI,gBAAA;EACA,cAAA;AxC4zKZ;AwCzzKQ;EACI,WAAA;EACA,YAAA;EACA,yBvC1EiB;EuC2EjB,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AxC2zKZ;AwCzzKY;EACI,cvC3Ca;EuC4Cb,eAAA;AxC2zKhB;AwCvzKgB;EACI,cvCvFS;ADg5K7B;AwCrzKY;EACI,yBvCtDa;AD62K7B;AwCpzKY;EACI,yBvCtCa;AD41K7B;AwCnzKY;EACI,yBvC/Ca;ADo2K7B;AwClzKY;EACI,yBvC7Da;ADi3K7B;AwCjzKY;EACI,yBvC5Da;AD+2K7B;AwC9yKY;EACI,yBAAA;AxCgzKhB;AwC9yKgB;EACI,YAAA;AxCgzKpB;AyC96KI;EACI,yBxCQqB;EwCPrB,cxCgBqB;ADg6K7B;AyC76KI;EACI,cxCYqB;ADm6K7B;AyCr7KI;EACI,yBxC8CqB;EwC7CrB,cxCOqB;ADg7K7B;AyCp7KI;EACI,cxCGqB;ADm7K7B;AyC57KI;EACI,yBxCkEqB;EwCjErB,cxCOqB;ADu7K7B;AyC37KI;EACI,cxCGqB;AD07K7B;AyCn8KI;EACI,yBxC6DqB;EwC5DrB,cxCOqB;AD87K7B;AyCl8KI;EACI,cxCGqB;ADi8K7B;AyC18KI;EACI,yBxCmDqB;EwClDrB,cxCOqB;ADq8K7B;AyCz8KI;EACI,cxCGqB;ADw8K7B;AyCj9KI;EACI,yBxCwDqB;EwCvDrB,cxCOqB;AD48K7B;AyCh9KI;EACI,cxCGqB;AD+8K7B;AwC5zKI;EAGI,4BAAA;AxC8zKR;AwC3zKI;EACI,cvChGqB;EuCiGrB,iBAAA;AxC6zKR;AwC3zKQ;EAEI,UAAA;AxC4zKZ;;A0Cp+KE;EACI,gBAAA;A1Cu+KN;A0Cp+KU;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;A1Cs+Kd;;A2C7+KA;;;EAGI,cAAA;A3Cg/KJ;;A2C5+KI;EACI,gD1CyKmB;E0CxKnB,wB1CqHwB;AD03KhC;A2C5+KI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;A3C8+KR;;A4C9/KA;EACI,mBAAA;EACA,kBAAA;A5CigLJ;A4C//KI;EACI,yBAAA;A5CigLR;A4C9/KI;EACI,yB3CCqB;AD+/K7B;A4C7/KI;EACI,qBAAA;EACA,WAAA;A5C+/KR;A4C5/KI;EACI,gBAAA;A5C8/KR;A4C3/KI;EACI,eAAA;A5C6/KR;A4C1/KI;EACI,eAAA;A5C4/KR;A4C1/KQ;EACI,eAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;A5C4/KZ;A4Cz/KQ;EACI,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;A5C2/KZ;A4Cv/KI;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;A5Cy/KR;A4Cp/KI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;A5Cs/KR;A4Cp/KQ;EACI,gBAAA;A5Cs/KZ;A4Cn/KQ;EACI,gBAAA;A5Cq/KZ;A4Cn/KY;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;A5Cq/KhB;A4Cn/KgB;EACI,YAAA;EACA,cAAA;A5Cq/KpB;A4Ch/KQ;EACI,qBAAA;A5Ck/KZ;A4Ch/KY;EACI,cAAA;EACA,oBAAA;EACA,mB3C0Ee;E2CzEf,yBAAA;EACA,qBAAA;A5Ck/KhB;A4Ch/KgB;EACI,qBAAA;A5Ck/KpB;A4C3+KQ;;EAEI,SAAA;A5C6+KZ;A4Cz+KI;EACI,qBAAA;EACA,WAAA;A5C2+KR;A4Cx+KI;EACI,mB3CkDuB;E2CjDvB,gBAAA;A5C0+KR;A4Cv+KI;EACI,cAAA;EACA,WAAA;EACA,YAAA;A5Cy+KR;;A6C1lLA;EACE,SAAA;EACA,wB5C6H8B;E4C5H9B,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,+CAAA;A7C6lLF;A6C3lLE;EACE,6B5C+ByB;E4C9BzB,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;A7C6lLJ;A6C1lLE;EACE,UAAA;EACA,gBAAA;EACA,6B5CqByB;E4CpBzB,SAAA;A7C4lLJ;A6CzlLE;EACI,yB5CuBuB;ADokL7B;A6CxlLE;EACI,yB5CuCuB;ADmjL7B;A6CvlLE;EACI,yB5C8BuB;AD2jL7B;A6CtlLE;EACI,yB5CqBuB;ADmkL7B;A6CrlLE;EACI,yBAAA;A7CulLN;;A8C/nLE;EACI,mCAAA;A9CkoLN;A8C/nLE;EACI,uCAAA;EACA,wCAAA;A9CioLN;A8C9nLE;EACI,qBAAA;A9CgoLN;A8C7nLE;EACI,qBAAA;EACA,oCAAA;EACA,W7CFuB;ADioL7B;A8C7nLM;EAEI,kBAAA;A9C8nLV;A8CznLM;EACI,kBAAA;EACA,kBAAA;A9C2nLV;A8CznLU;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,yB7Cde;ADyoL7B;A8CxnLU;EACI,cAAA;EACA,W7C1Be;ADopL7B;A8CrnLkB;ErCfd,gEAAA;EAGA,yBAAA;ATuoLJ;A8CtnLc;EACI,YAAA;EACA,kBAAA;EACA,c7CNW;E6COX,QAAA;ErCpCd,6BAAA;ATiqLJ;A8CtnLE;EACI,kBAAA;A9CwnLN;A8CpnLM;EACI,qBAAA;A9CsnLV;A8ClnLU;EACI,YAAA;EACA,iBAAA;A9ConLd;A8CjnLU;EACI,kBAAA;A9CmnLd;A8C7mLM;EACI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;A9C+mLV;A8C3mLM;EACI,cAAA;A9C6mLV;A8CzmLE;EACI,gBAAA;EACA,mBAAA;A9C2mLN;A8CvmLM;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;A9CymLV;A8CvmLM;EACI,c7CvFmB;ADgsL7B;A8CpmLE;EACI,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A9CsmLN;;A+C7tLA;EACI,kCAAA;EACA,sBAAA;EACA,kBAAA;A/CguLJ;A+C9tLI;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;A/CguLR;A+C7tLI;EACI,gBAAA;A/C+tLR;A+C9tLQ;EACI,gBAAA;A/CguLZ;A+C5tLI;EACI,c9CdqB;AD4uL7B;A+C1tLQ;EACI,c9CnBiB;E8CoBjB,gBAAA;A/C4tLZ;A+CxtLI;;;EAGI,+B9CLqB;AD+tL7B;A+CvtLI;EACI,c9C/BqB;E8CgCrB,iBAAA;A/CytLR;A+CttLI;EACI,gBAAA;A/CwtLR;A+CrtLI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,qCAAA;EACA,sB9CqEwB;ADkpLhC;;AgDhxLQ;EACI,gBAAA;AhDmxLZ;AgD/wLI;EACI,gBAAA;AhDixLR;;AiDvxLQ;EACI,mBAAA;AjD0xLZ;;AkD7xLA;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AlDgyLJ;AkD9xLI;EACI,UAAA;EACA,WAAA;AlDgyLR;AkD7xLI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,gCAAA;EACA,kBAAA;EACA,UAAA;AlD+xLR;AkD5xLI;EACI,aAAA;AlD8xLR;AkD1xLQ;EACI,gBAAA;AlD4xLZ;AkDzxLQ;EACI,yBAAA;AlD2xLZ;AkDzxLY;EAEI,gCAAA;AlD0xLhB;AkDrxLI;;EAEI,cAAA;AlDuxLR;AkDpxLI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AlDsxLR;AkDnxLI;EACI,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AlDqxLR;AkDlxLI;EACI,WAAA;EACA,wBAAA;EACA,UAAA;EACA,iBAAA;AlDoxLR;;AmD/1LI;EACI,kBAAA;EACA,mBAAA;AnDk2LR;AmDh2LI;EACI,mBAAA;EACA,iBAAA;AnDk2LR;AmDh2LQ;EACI,gBAAA;AnDk2LZ;AmD/1LI;EACI,SAAA;AnDi2LR;AmD/1LI;;EAEI,SAAA;AnDi2LR;;AoDn3LA;EACI,gBAAA;EACA,gBAAA;EACA,SAAA;ApDs3LJ;AoDp3LI;EACI,gBAAA;ApDs3LR;;AqD53LA;EACI,uBAAA;EACA,gBAAA;ArD+3LJ;AqD73LI;;EAEI,iBAAA;EACA,kBAAA;ArD+3LR;AqD53LI;EACI,WAAA;EACA,OAAA;ArD83LR;;AsDz4LA;EACI,kBAAA;AtD44LJ;AsD14LI;EACI,gBAAA;AtD44LR;AsDz4LI;EACI,mBAAA;AtD24LR;AsDz4LQ;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,crD6BiB;EqD5BjB,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;EACA,yBrDXiB;EqDYjB,kBAAA;AtD24LZ;AsDx4LQ;ECxBJ,qCAAA;EACA,ctD8CyB;ADq3L7B;AsDz4LQ;EC3BJ,qCAAA;EACA,ctDwDyB;AD+2L7B;AsD14LQ;EACI,crDqBiB;EqDpBjB,qDAAA;AtD44LZ;AsD14LQ;EClCJ,qCAAA;EACA,ctD6DyB;ADk3L7B;AsD34LQ;ECrCJ,qCAAA;EACA,ctDkEyB;ADi3L7B;AsD14LQ;EACI,eAAA;AtD44LZ;AsD14LY;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AtD44LhB;AsDv4LI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AtDy4LR;AsDv4LQ;EACI,crDjBiB;EqDkBjB,kBAAA;EACA,eAAA;EACA,iDAAA;AtDy4LZ;AsDv4LY;EACI,SAAA;AtDy4LhB;AsDv4LY;EACI,crDnDa;AD47L7B;AsDv4LY;EACI,QAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AtDy4LhB;AsDl4LY;EACI,crD1Ea;EqD2Eb,sCAAA;AtDo4LhB;AsDl4LgB;EACI,crD9ES;ADk9L7B;AsDh4LQ;EACI,yBAAA;AtDk4LZ;AsDh4LQ;EACI,oBAAA;EACA,uBAAA;AtDk4LZ;AsD/3LI;EACI,qCAAA;AtDi4LR;;AwDt+LA;EACI,gBAAA;EACA,kBAAA;AxDy+LJ;AwDv+LI;EACI,aAAA;AxDy+LR;AwDr+LQ;EACI,gBAAA;AxDu+LZ;AwDr+LY;EACI,eAAA;AxDu+LhB;AwDh+LI;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;AxDk+LR;AwDh+LQ;EACI,6BAAA;AxDk+LZ;AwD/9LQ;EACI,gBAAA;AxDi+LZ;AwD59LQ;EACI,aAAA;AxD89LZ;AwD19LQ;EACI,mBAAA;AxD49LZ;;AyDpgMA;EACI,gBAAA;AzDugMJ;AyDrgMI;EACI,eAAA;AzDugMR;AyDpgMI;EACI,SAAA;AzDsgMR;AyDngMI;EACI,gBAAA;EACA,sBxDkHwB;ADm5LhC;AyDlgMI;EACI,eAAA;AzDogMR;AyDlgMY;EACI,gBAAA;EACA,aAAA;AzDogMhB;AyDjgMQ;EACI,eAAA;AzDmgMZ;AyDjgMY;EACI,kBAAA;EACA,SAAA;AzDmgMhB;AyD9/LI;;;EAGI,kBAAA;AzDggMR;AyD9/LI;EACI,gBAAA;AzDggMR;AyD9/LI;EACI,aAAA;AzDggMR;AyD7/LI;EACI,eAAA;EACA,cxDLqB;ADogM7B;AyD7/LI;EACI,6BAAA;EACA,eAAA;EACA,cxDVqB;ADygM7B;AyD5/LI;EACI,cxDUqB;ADo/L7B;AyD3/LI;EACI,aAAA;AzD6/LR;;A0D3jMA;EACE,gDAAA;A1D8jMF;A0D5jME;EACE,gBAAA;A1D8jMJ;;A2DlkMA;EACI,gBAAA;EACA,cAAA;A3DqkMJ;A2DnkMI;EACE,cAAA;EACA,eAAA;A3DqkMN;A2DlkMI;EACE,gBAAA;EACA,mBAAA;A3DokMN;A2DjkMI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;A3DmkMN;A2DhkMI;EACI,gBAAA;EACA,mBAAA;EACA,gBAAA;A3DkkMR;A2D/jMI;;EAEI,gBAAA;A3DikMR;A2D/jMQ;;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;A3DkkMZ;A2D9jMI;EACI,gBAAA;EACA,mBAAA;A3DgkMR;A2D7jMI;EACI,gBAAA;EACA,kBAAA;A3D+jMR;A2D7jMQ;;EAEI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,+CAAA;A3D+jMZ;;A4DhnMI;EACI,iBAAA;A5DmnMR;A4DhnMI;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;A5DknMR;A4DhnMI;EACI,aAAA;EACA,qBAAA;A5DknMR;A4D/mMQ;EACI,gBAAA;A5DinMZ;A4D7mMQ;EACI,eAAA;A5D+mMZ;A4D5mMQ;EACI,c3DqBiB;ADylM7B;A4D3mMQ;EACI,c3D2BiB;ADklM7B;A4D1mMQ;EACI,c3DiCiB;AD2kM7B;A4DzmMQ;EACI,c3DwBiB;ADmlM7B;A4DxmMQ;EACI,c3DUiB;ADgmM7B;A4DtmMC;EACI,gBAAA;A5DwmML;;A6DrpMI;;EACI,aAAA;A7DypMR;A6DtpMY;;EACI,QAAA;A7DypMhB;;A6DjpMI;;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;A7DqpMR;;A6D5oMQ;EACI,kBAAA;EACA,mBAAA;A7D+oMZ;A6D5oMQ;EACI,cAAA;A7D8oMZ;A6D3oMQ;EACI,WAAA;EACA,wB5DoFoB;E4DnFpB,4BAAA;EACA,+CAAA;A7D6oMZ;A6D3oMY;EpDLZ,sBAAA;ATupMA;A6D3oMQ;EACI,gBAAA;A7D6oMZ;A6D1oMQ;EACI,gBAAA;A7D4oMZ;;A6DtoMI;EACI,cAAA;A7DyoMR;;A6DpoMI;EACI,kBAAA;EACA,UAAA;A7DuoMR;A6DpoMI;EACI,eAAA;EACA,gBAAA;A7DsoMR;A6DpoMQ;EACI,WAAA;EACA,OAAA;A7DsoMZ;A6DloMI;EACI,cAAA;A7DooMR;A6DhoMQ;EACI,mBAAA;A7DkoMZ;A6D/nMQ;EACE,iBAAA;EACA,kBAAA;A7DioMV;A6D9nMQ;EACE,kBAAA;A7DgoMV;A6D7nMQ;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;A7D+nMZ;A6D7nMY;EACI,kBAAA;EACA,mBAAA;A7D+nMhB;A6D3nMQ;;EAEI,gBAAA;A7D6nMZ;A6D1nMQ;EACI,kBAAA;A7D4nMZ;A6DznMQ;EACI,mB5D7EiB;ADwsM7B;A6DtnMQ;EACI,YAAA;EACA,cAAA;A7DwnMZ;;A6DnnMA;EACI,sBAAA;A7DsnMJ;A6DpnMG;EACK,mBAAA;A7DsnMR;A6DpnMQ;EACE,wB5DjBsB;E4DkBtB,YAAA;A7DsnMV;A6DnnMI;EACI,iBAAA;A7DqnMR;A6DnnMI;EACE,mBAAA;EACA,gB5DS0B;AD4mMhC;A6DlnMI;EACI,UAAA;EACA,iBAAA;EACA,eAAA;A7DonMR;A6DjnMI;EACI,gBAAA;EACA,mBAAA;A7DmnMR;A6DlnMQ;EACI,eAAA;A7DonMZ;A6D9mMQ;EACI,mBAAA;A7DgnMZ;A6D7mMI;EACE,iBAAA;A7D+mMN;A6D7mMI;EACI,mBAAA;A7D+mMR;;A6DzmMI;EACI,aAAA;EACA,kBAAA;A7D4mMR;A6D1mMQ;EACI,iBAAA;A7D4mMZ;A6D1mMQ;EACI,gBAAA;A7D4mMZ;A6D1mMQ;EACI,c5D3LiB;ADuyM7B;A6DvmMQ;EACI,gBAAA;A7DymMZ;A6DtmMQ;EACI,mBAAA;A7DwmMZ;A6DnmMQ;EACI,mBAAA;A7DqmMZ;A6DlmMQ;EACI,mBAAA;A7DomMZ;A6DjmMQ;;;EAGI,eAAA;A7DmmMZ;A6DhmMQ;EACI,cAAA;A7DkmMZ;A6D/lMQ;EACI,gBAAA;A7DimMZ;;A6D1lMI;;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;A7D8lMR;;A6DxlMI;EACI,cAAA;A7D2lMR;A6DzlMI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gDAAA;A7D2lMR;A6DxlMI;EACI,kBAAA;EACA,gBAAA;A7D0lMR;A6DvlMI;EACI,kBAAA;A7DylMR;A6DtlMI;EACI,gBAAA;EACA,sBAAA;A7DwlMR;A6DrlMI;EACI,gBAAA;A7DulMR;A6DplMI;EACI,iBAAA;A7DslMR;A6DplMI;EACI,gBAAA;EACA,cAAA;A7DslMR;A6DplMQ;EACI,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7DslMZ;A6DplMY;EACI,kBAAA;A7DslMhB;A6DhlMQ;EACI,mBAAA;A7DklMZ;A6D9kMI;EACI,gBAAA;EACA,oBAAA;A7DglMR;;A6D1kMI;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;A7D4kMR;A6DzkMI;EACI,oCAAA;A7D2kMR;A6DtkMQ;ECzUJ,qCD0UiC,EC1UZ,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,qFAAA,EAAA,oBAAA;A9Dk5MJ;A6DtkMI;EACI,YAAA;A7DwkMR;A6DrkMI;;EAEI,kBAAA;EACA,UAAA;A7DukMR;A6DpkMI;EACI,8BAAA;A7DskMR;A6DnkMI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;A7DqkMR;A6DjkMI;;;EAGI,c5DrWqB;ADw6M7B;;A6D7jMI;EACI,kBAAA;EACA,iBAAA;A7DgkMR;A6D7jMI;EACI,mBAAA;A7D+jMR;A6D5jMI;EACI,eAAA;EACA,oBAAA;EACA,iBAAA;A7D8jMR;A6D5jMQ;EACI,cAAA;A7D8jMZ;A6D3jMQ;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;A7D6jMZ;A6DzjMI;EACI,qBAAA;A7D2jMR;A6DxjMQ;EACI,WAAA;A7D0jMZ;A6DxjMQ;EACI,gBAAA;A7D0jMZ;;A6DnjMI;EACE,cAAA;EACA,kBAAA;A7DsjMN;A6DnjMI;EACI,sB5DnSwB;E4DoSxB,sB5DhUuB;E4DiUvB,gBAAA;A7DqjMR;A6DnjMQ;EACI,gBAAA;A7DqjMZ;A6DljMQ;EACI,WAAA;EACA,cAAA;EACA,mBAAA;A7DojMZ;A6DljMY;EACI,WAAA;A7DojMhB;A6DhjMQ;EACI,mBAAA;A7DkjMZ;AuBn+MG;EACI,cA+G+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApBu+MF;AuBp+MG;EACI,cA2G+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApB4+MF;AuBr+MG;EACI,cAuG+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApBi/MF;AuBt+MG;EACI,cAmG+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApBs/MF;AuBr4MI;EACI,sCtBzFqB;EsB0FrB,ctB/GqB;ADs/M7B;AuBr4MQ;EACI,qBtBlHiB;EsBmHjB,6BtBpFiB;EsBqFjB,ctBpHiB;AD2/M7B;AuBj4MQ;;EACI,ctB3HiB;AD+/M7B;AuB/3MQ;EACI,6BtBlGiB;ADm+M7B;AuB73MI;EACI,6BtBvGqB;EsBwGrB,sCtBlHqB;EsBmHrB,ctBxIqB;ADugN7B;AuB33MQ;EACI,6BtB9GiB;EsB+GjB,qBtB9IiB;EsB+IjB,ctB/IiB;AD4gN7B;AuBv3MQ;;EACI,0CtB1HiB;EsB2HjB,ctBvJiB;ADihN7B;AuBx3MY;;;;EAGI,0CtB/Ha;EsBgIb,ctB7Ja;ADwhN7B;AuBv3MQ;;EACI,0CtBtIiB;ADggN7B;AuBx3MY;;;;EAGI,0CtB1Ia;EsB2Ib,ctBxKa;ADmiN7B;AuBr3MgB;;EACI,0CtBlJS;EsBmJT,ctBhLS;ADwiN7B;AuBn3MQ;;EACI,0CtB1JiB;EsB2JjB,YAAA;EACA,ctBxLiB;AD8iN7B;AuBl3MY;;EACI,0CtBhKa;EsBiKb,ctB9La;ADmjN7B;A6DjoMY;;;EAGI,+B5D/Za;ADkiN7B;A6D9nMI;EACI,eAAA;EACA,yBAAA;EACA,qBAAA;A7DgoMR;A6D9nMQ;EAEI,gCAAA;A7D+nMZ;;A6DznMI;EACI,oBAAA;EACA,iBAAA;A7D4nMR;A6D1nMI;EACI,gBAAA;A7D4nMR;A6D1nMI;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;A7D4nMR;A6D1nMI;EACI,gBAAA;A7D4nMR;A6D1nMI;EACI,oBAAA;EACA,gBAAA;A7D4nMR;A6D3nMQ;EACI,mBAAA;A7D6nMZ;;A6DtnMI;EACI,iBAAA;EACA,mBAAA;A7DynMR;A6DvnMQ;EACI,aAAA;EACA,gBAAA;A7DynMZ;A6DvnMQ;EACI,gBAAA;A7DynMZ;A6DvnMQ;EACI,aAAA;EACA,gBAAA;A7DynMZ;A6DvnMY;EACI,e5D/Ve;ADw9M/B;A6DvnMY;EACI,gBAAA;A7DynMhB;A6DpnMQ;EACI,mBAAA;A7DsnMZ;A6DjnMQ;EACI,c5D/diB;ADklN7B;;A6D5mMQ;EACI,cAAA;EACA,kBAAA;A7D+mMZ;A6D7mMQ;EACI,c5D7gBiB;AD4nN7B;A6D5mMI;EACI,yBAAA;A7D8mMR;A6D5mMI;EACI,iBAAA;A7D8mMR;A6D3mMQ;EACI,mBAAA;A7D6mMZ;A6D3mMQ;EACI,gBAAA;A7D6mMZ;A6DzmMI;;EAEI,iBAAA;A7D2mMR;A6D1mMQ;;EACI,mBAAA;A7D6mMZ;;A6DxmMA;EACE,aAAA;EACA,mBAAA;A7D2mMF;;A+D/pNA;EACI,eAAA;EACA,kBAAA;EACA,mB9DOyB;AD2pN7B;A+DhqNI;EACI,gB9DkHuB;ADgjN/B;;A+D/pNA;EACI,iBAAA;A/DkqNJ;;A+D/pNA;EACI,aAAA;A/DkqNJ;;A+DhqNA;EACI,iBAAA;A/DmqNJ;;A+DhqNA;EACE,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,c9Dd2B;E8De3B,kBAAA;EACA,gBAAA;A/DmqNF;A+DjqNE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;A/DmqNJ;A+DhqNE;EACI,gBAAA;EACA,iBAAA;A/DkqNN;A+D/pNE;EACI,oCAAA;A/DiqNN;A+D9pNE;EACE,UAAA;EACA,iBAAA;EACA,oBAAA;A/DgqNJ;A+D7pNI;EACI,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;A/D+pNR;A+D5pNI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAGA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;A/D8pNN;A+D1pNI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;A/D4pNR;A+D1pNI;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;A/D4pNR;A+DzpNI;;EAEE,+B9DxDuB;ADmtN7B;A+DxpNI;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;A/DypNR;;A+DppNI;EAEI,aAAA;A/DspNR;A+DnpNI;ED7GA,iCC8G6B,ED9GR,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,+EAAA,EAAA,oBAAA;A9DmwNJ;;A+DrpNA;EACI,eAAA;A/DwpNJ;A+DtpNI;EACI,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,sBAAA;EACA,gD9DuDmB;E8DtDnB,sBAAA;A/DwpNR;A+DtpNQ;EACI,iBAAA;A/DwpNZ;A+DrpNQ;EACI,UAAA;A/DupNZ;A+DrpNY;EACI,iBAAA;A/DupNhB;A+DnpNQ;EACI,UAAA;A/DqpNZ;A+DlpNQ;EACI,iBAAA;EACA,mBAAA;A/DopNZ;A+DhpNI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;A/DkpNR;;A+D7oNK;EACG,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;A/DgpNR;A+D7oNK;EACG,aAAA;EACA,kBAAA;A/D+oNR;A+D5oNK;EACG,mBAAA;A/D8oNR;A+D3oNK;EACG,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;A/D6oNR;A+D1oNK;EACG,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;A/D4oNR;A+DzoNK;EACG,OAAA;EACA,QAAA;A/D2oNR;A+DxoNK;EACI,QAAA;EACA,SAAA;A/D0oNT;A+DvoNK;EACI,QAAA;A/DyoNT;A+DtoNK;EACI,QAAA;EACA,SAAA;A/DwoNT;A+DroNK;EACI,QAAA;EACA,QAAA;A/DuoNT;A+DpoNK;EACI,QAAA;EACA,SAAA;EACD,eAAA;EACA,cAAA;EACA,YAAA;A/DsoNR;A+DnoNK;EACI,QAAA;EACA,SAAA;A/DqoNT;A+DloNK;EACI,QAAA;EACA,SAAA;A/DooNT;A+DjoNK;EACG,QAAA;EACA,SAAA;A/DmoNR;A+DhoNK;EACI,QAAA;EACA,SAAA;A/DkoNT;A+D/nNK;EACI,QAAA;EACA,SAAA;A/DioNT;A+D9nNK;EACI,QAAA;EACA,SAAA;A/DgoNT;A+D7nNK;EACI,OAAA;EACA,SAAA;A/D+nNT;A+D5nNK;EACI,QAAA;EACA,SAAA;A/D8nNT;A+D3nNK;EACG,OAAA;EACA,SAAA;A/D6nNR;;A+DznNA;EACI,iBAAA;EACA,aAAA;A/D4nNJ;A+D1nNI;;;EAGI,iBAAA;A/D4nNR;A+DznNI;EACI,gBAAA;A/D2nNR;A+DxnNI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A/D0nNR;A+DtnNI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A/DwnNR;;A+DnnNA;EACI,yB9DlSyB;ADw5N7B;;A+DpnNA;EACI,yB9D9RyB;ADq5N7B;;A+DpnNA;EACI,c9D3SyB;ADk6N7B;A+DrnNI;;;;;EAKI,c9DlTqB;ADy6N7B;A+DpnNI;EACI,yB9DtTqB;AD46N7B;A+DnnNI;EACI,c9DxRqB;AD64N7B;A+DlnNI;;EAEE,c9D/TuB;ADm7N7B;A+DjnNI;;;EAGE,+B9D/SuB;ADk6N7B;A+DhnNI;;EAEI,+B9DpTqB;ADs6N7B;A+D/mNI;EACI,sC9DjTqB;ADk6N7B;A+D7mNI;;;;EAII,sC9DzTqB;ADw6N7B;A+D5mNI;;;EAGI,c9D5VqB;AD08N7B;A+D3mNI;;EAEI,c9DjWqB;AD88N7B;A+D1mNI;;EAEI,yB9DtWqB;E8DuWrB,qB9DvWqB;ADm9N7B;AuBx9NG;EACI,cA+G+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApB49NF;AuBz9NG;EACI,cA2G+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApBi+NF;AuB19NG;EACI,cAuG+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApBs+NF;AuB39NG;EACI,cAmG+B;EHlHpC,UGkHyD;EH/GzD,0BAAA;ApB2+NF;AuB13NI;EACI,sCtBzFqB;EsB0FrB,ctB/GqB;AD2+N7B;AuB13NQ;EACI,qBtBlHiB;EsBmHjB,6BtBpFiB;EsBqFjB,ctBpHiB;ADg/N7B;AuBt3NQ;;EACI,ctB3HiB;ADo/N7B;AuBp3NQ;EACI,6BtBlGiB;ADw9N7B;AuBl3NI;EACI,6BtBvGqB;EsBwGrB,sCtBlHqB;EsBmHrB,ctBxIqB;AD4/N7B;AuBh3NQ;EACI,6BtB9GiB;EsB+GjB,qBtB9IiB;EsB+IjB,ctB/IiB;ADigO7B;AuB52NQ;;EACI,0CtB1HiB;EsB2HjB,ctBvJiB;ADsgO7B;AuB72NY;;;;EAGI,0CtB/Ha;EsBgIb,ctB7Ja;AD6gO7B;AuB52NQ;;EACI,0CtBtIiB;ADq/N7B;AuB72NY;;;;EAGI,0CtB1Ia;EsB2Ib,ctBxKa;ADwhO7B;AuB12NgB;;EACI,0CtBlJS;EsBmJT,ctBhLS;AD6hO7B;AuBx2NQ;;EACI,0CtB1JiB;EsB2JjB,YAAA;EACA,ctBxLiB;ADmiO7B;AuBv2NY;;EACI,0CtBhKa;EsBiKb,ctB9La;ADwiO7B;A+D1rNI;EACI,6B9DhVqB;E8DiVrB,sC9D3VqB;E8D4VrB,c9DjXqB;AD6iO7B;A+D1rNQ;EAWI,6B9D/ViB;E8DgWjB,qB9D/XiB;E8DgYjB,c9DhYiB;ADkjO7B;A+D1qNgB;EACI,c9DzYS;ADqjO7B;A+DtqNI;EACI,c9DhZqB;ADwjO7B;;AgElkOA;EACI,gBAAA;EACA,aAAA;EACA,WAAA;AhEqkOJ;;AgElkOA;EACI,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;AhEqkOJ;AgEnkOI;;EAEI,c/DJqB;ADykO7B;AgElkOI;EACI,yB/DRqB;AD4kO7B;AgElkOQ;EAEI,yB/DZiB;AD+kO7B;AgE/jOI;;;EAGI,c/DnBqB;ADolO7B;AgE/jOI;;EAEI,+B/DDqB;ADkkO7B;AgE9jOQ;EACI,c/DlBiB;ADklO7B;AgE9jOQ;;;EAGI,c/DlBiB;ADklO7B;AgE5jOI;EACI,c/DrCqB;ADmmO7B;AgE3jOQ;;EAEI,c/D1CiB;ADumO7B;AgE3jOQ;EACI,+BAAA;AhE6jOZ;AgEzjOI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,oCAAA;AhE2jOR;AgExjOI;EACI,UAAA;EACA,kBAAA;AhE0jOR;;AgErjOI;EACI,uBAAA;EACA,cAAA;EACA,kBAAA;AhEwjOR;AgErjOI;EACI,gBAAA;EACA,iBAAA;AhEujOR;AgEpjOI;EACI,mBAAA;AhEsjOR;AgEpjOI;EACI,gBAAA;AhEsjOR;;AgEhjOA;EACI,eAAA;AhEmjOJ;AgEhjOQ;EACI,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;AhEkjOZ;;AgE5iOA;EACI,yBAAA;AhE+iOJ;;AgE1iOI;EACI,0C/D1FqB;ADuoO7B;AgEziOQ;EAEI,cAAA;AhE0iOZ;AgEtiOI;;EAII,c/D/GqB;ADqpO7B;AgEniOI;EAEI,cAAA;AhEoiOR;AgEjiOI;EACI,gBAAA;AhEmiOR;AgEhiOI;;;;;EAMI,c/D/IqB;ADgrO7B;AgE9hOI;EACI,c/DnJqB;ADmrO7B;AgE9hOQ;EAEI,qB/DvJiB;ADsrO7B;AgE3hOI;EAGI,sC/DjIqB;AD4pO7B;AgExhOI;;;EAII,+B/DhJqB;ADyqO7B;AgEthOI;;;;;EAMI,0CAAA;AhEuhOR;AgEphOI;;;EAGI,+B/D9JqB;ADorO7B;AgElhOQ;EACI,6B/D1JiB;E+D2JjB,yBAAA;EACA,c/DlLiB;ADssO7B;AgElhOY;EACI,mBAAA;AhEohOhB;AgEhhOQ;;;EAGI,c/DrKiB;E+DsKjB,yBAAA;AhEkhOZ;;AgE7gOA;;;;;;EAMI,eAAA;AhEghOJ;;AiE1uOI;EACI,YAAA;AjE6uOR;AiE1uOI;EACI,cAAA;AjE4uOR;AiEzuOI;EACI,cAAA;AjE2uOR;AiExuOI;EACI,YAAA;EACA,gBAAA;AjE0uOR;AiExuOQ;EACI,iBAAA;AjE0uOZ;;AiEruOA;EACI,kBAAA;AjEwuOJ;AiEtuOI;EACI,UAAA;EACA,kBAAA;AjEwuOR;AiEruOI;;;EAGE,chExBuB;AD+vO7B;AiEpuOI;EHpCA,iCGqC6B,EHrCR,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,+EAAA,EAAA,oBAAA;A9D2wOJ;AiExuOI;EHvCA,iCGwC6B,EHxCR,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,4EAAA,EAAA,oBAAA;A9DkxOJ;;AiE1uOI;EACI,aAAA;AjE6uOR;;AiEzuOA;EACI,WAAA;EACA,gDAAA;AjE4uOJ;;AiEtuOI;;;EACI,mBAAA;AjE2uOR;AiEzuOI;;;EACI,0BAAA;AjE6uOR;;AiEtuOQ;;EACI,gBAAA;AjE0uOZ;;AiEpuOI;EACI,SAAA;AjEuuOR;AiEruOI;EACI,gBAAA;AjEuuOR;;AkEtzOI;EACI,WAAA;AlEyzOR;;AkErzOA;;;EAGI,kBAAA;AlEwzOJ;;AkEpzOI;EACI,gBAAA;AlEuzOR;;AkElzOI;;EAEI,cjEXqB;ADg0O7B;;AkEhzOI;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AlEmzOR;AkEjzOI;EACI,gBAAA;EACA,cAAA;AlEmzOR;;AkE9yOI;EACI,gBAAA;EACA,mBAAA;AlEizOR;AkE/yOI;EACI,eAAA;EACA,cAAA;EACA,mBAAA;AlEizOR;AkE/yOI;EACI,kBAAA;AlEizOR;;AkE7yOA;;;EAGI,kBAAA;AlEgzOJ;AkE9yOI;;;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,oCAAA;AlEkzOR;AkE/yOI;;;;;;;;;;;;EAII,kBAAA;EACA,UAAA;AlEyzOR;;AkEnzOI;;EACI,cAAA;AlEuzOR;;AkElzOI;EACI,mBAAA;AlEqzOR;;AkEjzOA;EACI,gBAAA;AlEozOJ;AkElzOI;EACI,cAAA;AlEozOR;AkElzOI;EACI,iBAAA;AlEozOR;AkElzOQ;EACI,iBAAA;AlEozOZ;AkEhzOI;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AlEkzOR;AkEhzOQ;EACI,iBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;AlEkzOZ;;AkE7yOA;EACI,gBAAA;AlEgzOJ;;AmE16OA;EACI,eAAA;AnE66OJ;;AmEx6OI;EACI,mBAAA;AnE26OR;;AmEt6OI;EACI,mBAAA;EACA,kBAAA;AnEy6OR;;AoEr7OQ;EACI,gBAAA;ApEw7OZ;AoEt7OQ;EACI,eAAA;ApEw7OZ;AoEp7OI;EACI,gBAAA;ApEs7OR;;AoEh7OQ;EACI,gBAAA;EACA,oCnE4GoB;EmE3GpB,iCnE2GoB;ADw0OhC;AoEh7OQ;EACI,gBAAA;ApEk7OZ;;AoE36OI;EACI,gBAAA;ApE86OR;AoE56OQ;EACI,aAAA;ApE86OZ;;AoEx6OI;EACI,oBAAA;ApE26OR;AoEx6OI;EACI,gBAAA;ApE06OR;AoEx6OQ;EACI,gBAAA;ApE06OZ;AoEr6OQ;EACI,uBAAA;ApEu6OZ;;AqE79OI;EACI,gBAAA;ArEg+OR;;AqE39OI;EACI,eAAA;EACA,mBAAA;ArE89OR;AqE59OI;EACI,kBAAA;ArE89OR;AqE59OI;EACI,cpE6BqB;EoE5BrB,eAAA;ArE89OR;AqE59OI;EACI,gBAAA;ArE89OR;AqE59OI;EACI,kBAAA;ArE89OR;;AqEz9OI;;EAEI,mBAAA;EACA,eAAA;ArE49OR;AqEz9OI;EACI,mBAAA;EACA,kBAAA;ArE29OR;AqEz9OI;EACI,kBAAA;ArE29OR;AqEz9OI;EACI,gBAAA;ArE29OR;;AqEp9OI;EACI,eAAA;EACA,mBAAA;ArEu9OR;AqEp9OI;EACI,UAAA;ArEs9OR;AqEp9OQ;EACI,SAAA;ArEs9OZ;AqEl9OI;EACI,gBAAA;ArEo9OR;AqEl9OS;EACG,kBAAA;EACA,qBAAA;ArEo9OZ;AqEj9OI;EACI,iBAAA;EACA,gBAAA;ArEm9OR;;AsEzhPI;EACI,mBAAA;AtE4hPR;AsEzhPI;EACI,UAAA;EACA,cAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AtE2hPR;;AsEnhPI;EACI,mBAAA;AtEshPR;;AsEhhPI;EACI,gBAAA;EACA,mBAAA;AtEmhPR;;AsE7gPI;;EACI,mBAAA;AtEihPR;;AuEpjPI;EACI,mBAAA;AvEujPR;;AuEnjPA;;EAEQ,sBAAA;AvEsjPR;AuEnjPY;;;;EAEI,2BAAA;AvEujPhB;AuEpjPQ;;EACI,SAAA;AvEujPZ;AuEpjPY;;EACI,gBAAA;AvEujPhB;AuEljPgB;;;;EACI,WtEZS;ADmkP7B;AuEnjPQ;;EACI,kBAAA;AvEsjPZ;AuEpjPY;;EACI,kBAAA;EACA,kBAAA;EACA,UAAA;AvEujPhB;AuErjPY;;EACI,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AvEwjPhB;AuEtjPY;;EACI,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AvEyjPhB;AuEvjPY;;EACI,UAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;AvE0jPhB;AuExjPY;;EACI,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AvE2jPhB;AuEzjPY;;EACI,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AvE4jPhB;AuE1jPY;;EACI,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AvE6jPhB;AuE3jPY;;EACI,SAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;AvE8jPhB;AuE5jPY;;EACI,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AvE+jPhB;AuE7jPY;;EACI,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AvEgkPhB;AuE9jPY;;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AvEikPhB;AuE/jPY;;EACI,UAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;AvEkkPhB;AuEhkPY;;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AvEmkPhB;;AwE/qPI;EACI,UAAA;EACA,SAAA;AxEkrPR;AwEhrPQ;EACI,gBAAA;AxEkrPZ;AwE/qPQ;EACI,gBAAA;EACA,cvEDiB;ADkrP7B;AwE9qPQ;EACI,gBAAA;EACA,cvENiB;ADsrP7B;AwE5qPI;EACI,gBAAA;AxE8qPR;;AwEzqPA;EACI,UAAA;EACA,kBAAA;AxE4qPJ;AwE1qPI;EACI,gBAAA;EACA,yBAAA;AxE4qPR;AwE1qPQ;EACI,UAAA;EACA,SAAA;AxE4qPZ;AwEzqPI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AxE2qPR;AwExqPI;EACI,gBAAA;AxE0qPR;AwExqPQ;EACI,gBAAA;EACA,eAAA;AxE0qPZ;;AyE3tPI;EACI,+BAAA;AzE8tPR;AyE5tPQ;EACI,SAAA;AzE8tPZ;AyE1tPI;EACI,SAAA;EACA,WAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;EACA,SAAA;AzE4tPR;AyE1tPQ;EACI,eAAA;AzE4tPZ;;AyEvtPA;EACI,kBAAA;AzE0tPJ;;AyEvtPA;EACI,eAAA;AzE0tPJ;AyExtPI;EACI,gBAAA;AzE0tPR;AyExtPQ;EACI,gBAAA;AzE0tPZ;AyEvtPI;EACI,kBAAA;EAEA,kCAAA;EACA,sBAAA;AzEwtPR;AyEttPQ;EACI,+BxEZiB;ADouP7B;AyErtPQ;EACI,cxEtCiB;AD6vP7B;AyErtPQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,qCAAA;AzEutPZ;AyEptPQ;EACI,UAAA;EACA,kBAAA;AzEstPZ;;AyEjtPA;;EAEI,yBxE7DyB;ADixP7B;;AyEltPA;;EAEI,yBxExDyB;AD6wP7B;AyEntPI;;EACI,sCAAA;AzEstPR;;AyEhtPQ;EACI,cAAA;AzEmtPZ;AyEhtPQ;EACI,SAAA;AzEktPZ;;A0E3yPA;EC4KE;IACE,eAAA;IACA,yBAAA;IACA,MAAA;IACA,uBAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IAEA,2BAAA;IlExII,mCAAA;IA/BJ,0DAAA;ETmzPF;E2EvoPE;IACE,mB1EhJuB,E0EgJK,+CAAA,EAIzB,0BAAA,EAIA,2BAAA,EAIA,0BAAA;IACH,iDAAA,EAGG,mCAAA;IvD7MP,auD8MqB;IvD3MrB,yBAAA;IuD6MI,cAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;E3E6nPJ;E2EznPI;IACE,cAAA;IACA,qBAAA;E3E2nPN;E2EznPM;IACE,yBAAA;E3E2nPR;E2EtnPE;IACE,c1E/NuB;EDu1P3B;E2Eh2PA;IACE,2BAAA;E3Ek2PF;E2E91PE;IACE,gBAAA;IACA,kBAAA;IACA,8BAAA;IACA,gBAAA;IACA,cAAA;E3Eg2PJ;E2E91PI;IACE,MAAA;IACA,YAAA;E3Eg2PN;E2E51PE;;IAEE,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,mBAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;E3E81PJ;E2E51PI;;IACE,aAAA;E3E+1PN;E2E11PI;IACE,oBAAA;E3E41PN;E2Ez1PI;IACE,aAAA;E3E21PN;E2Ex1PI;IACE,cAAA;E3E01PN;E2Et1PE;;IAEE,c1E5CuB;I0E6CvB,wB1EwE0B;EDgxP9B;E2Er1PE;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IAEA,yCAAA;IAEA,mBAAA;IlEfE,iCAAA;IA/BJ,0DAAA;ET+4PF;E2E51PE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mB1EjEuB;ED+5P3B;E2E51PI;IACE,eAAA;E3E81PN;E2E31PI;IACE,WAAA;IACA,6BAAA;E3E61PN;E2Ez1PE;IACE,mB1E7CuB;EDw4P3B;E2E3zPA;IACE,oBAAA;E3E6zPF;E2E3zPA;IACE,UAAA;E3E6zPF;E2E3zPA;IACE,oBAAA;E3E6zPF;E2E1zPA;;;IAGE,oBAAA;E3E4zPF;E2ExzPE;IACE,wBAAA;IACA,oBAAA;E3E0zPJ;E2ExzPE;IACE,yBAAA;IACA,oBAAA;E3E0zPJ;E2ExzPE;IACE,UAAA;E3E0zPJ;E2E9tPA;IACE,YAAA;E3EguPF;E2E7tPA;IlEhOE,0DAAA;ETo8PF;E2EhuPA;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;IlE/OA,0DAAA;ETs9PF;E0Et+PE;IACI,iBAAA;E1Ew+PN;E0Er+PE;IACI,YAAA;E1Eu+PN;E0Ep+PE;IACI,aAAA;E1Es+PN;E0En+PE;IACI,kBAAA;E1Eq+PN;E0Ej+PM;IACI,iBAAA;E1Em+PV;E0E/9PE;IACI,gBAAA;E1Ei+PN;E0E99PE;IACI,aAAA;IACA,iBAAA;E1Eg+PN;E0E99PM;IACI,gBAAA;E1Eg+PV;E0E79PM;IACI,UAAA;IACA,QAAA;IACA,gBAAA;E1E+9PV;E0E59PM;IACI,SAAA;IACA,gBAAA;IACA,QAAA;E1E89PV;E0Ez9PM;IjEDA,iCAAA;ETi+PN;E0E59PM;IjELA,oCAAA;ETw+PN;E0E/9PM;IjETA,oCAAA;ET++PN;E0Ej+PU;IjEdJ,iCAAA;ETs/PN;E0Ep+PU;IjElBJ,mCAAA;ET6/PN;E0Ev+PU;IjEtBJ,mCAAA;ETogQN;E0E1+PU;IACI,WAAA;IACA,WAAA;E1E4+Pd;AACF;A0Ev+PA;EAGY;IACI,UAAA;IACA,kBAAA;E1Eu+Pd;E0Ep+PU;IACI,SAAA;E1Es+Pd;E0El+PM;IACI,iBAAA;E1Eo+PV;E0Eh+PE;IACE,kCAAA;E1Ek+PJ;E0E99PM;;IAEI,gBAAA;E1Eg+PV;E2Ej6PA;IACE,eAAA;IACA,yBAAA;IACA,MAAA;IACA,uBAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IAEA,2BAAA;IlExII,mCAAA;IA/BJ,0DAAA;ETmlQF;E2Ev6PE;IACE,mB1EhJuB,E0EgJK,+CAAA,EAIzB,0BAAA,EAIA,2BAAA,EAIA,0BAAA;IACH,iDAAA,EAGG,mCAAA;IvD7MP,auD8MqB;IvD3MrB,yBAAA;IuD6MI,cAAA;IACA,WAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;E3E65PJ;E2Ez5PI;IACE,cAAA;IACA,qBAAA;E3E25PN;E2Ez5PM;IACE,yBAAA;E3E25PR;E2Et5PE;IACE,c1E/NuB;EDunQ3B;E2EhoQA;IACE,2BAAA;E3EkoQF;E2E9nQE;IACE,gBAAA;IACA,kBAAA;IACA,8BAAA;IACA,gBAAA;IACA,cAAA;E3EgoQJ;E2E9nQI;IACE,MAAA;IACA,YAAA;E3EgoQN;E2E5nQE;;IAEE,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,mBAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;E3E8nQJ;E2E5nQI;;IACE,aAAA;E3E+nQN;E2E1nQI;IACE,oBAAA;E3E4nQN;E2EznQI;IACE,aAAA;E3E2nQN;E2ExnQI;IACE,cAAA;E3E0nQN;E2EtnQE;;IAEE,c1E5CuB;I0E6CvB,wB1EwE0B;EDgjQ9B;E2ErnQE;IACE,WAAA;IACA,kBAAA;IACA,aAAA;IAEA,yCAAA;IAEA,mBAAA;IlEfE,iCAAA;IA/BJ,0DAAA;ET+qQF;E2E5nQE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mB1EjEuB;ED+rQ3B;E2E5nQI;IACE,eAAA;E3E8nQN;E2E3nQI;IACE,WAAA;IACA,6BAAA;E3E6nQN;E2EznQE;IACE,mB1E7CuB;EDwqQ3B;E2E3lQA;IACE,oBAAA;E3E6lQF;E2E3lQA;IACE,UAAA;E3E6lQF;E2E3lQA;IACE,oBAAA;E3E6lQF;E2E1lQA;;;IAGE,oBAAA;E3E4lQF;E2ExlQE;IACE,wBAAA;IACA,oBAAA;E3E0lQJ;E2ExlQE;IACE,yBAAA;IACA,oBAAA;E3E0lQJ;E2ExlQE;IACE,UAAA;E3E0lQJ;E2E9/PA;IACE,YAAA;E3EggQF;E2E7/PA;IlEhOE,0DAAA;ETouQF;E2EhgQA;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;IlE/OA,0DAAA;ETsvQF;E0ErpQM;IACE,cAAA;E1EupQR;E0EppQM;IACI,yBAAA;E1EspQV;E0EppQU;IACI,kBAAA;IACA,8BAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;IAIA,aAAA;IAKA,sBAAA;E1EspQd;E0EppQc;IACI,SAAA;E1EspQlB;E0EjpQM;IACE,gBAAA;IACA,WAAA;E1EmpQR;E0E/oQQ;IACI,WAAA;IACA,OAAA;IjE1GN,oCAAA;ETgwQN;E0ElpQQ;IACE,2BAAA;E1EopQV;E0E/oQU;IACI,gBAAA;IACA,WAAA;E1EipQd;E0E9oQU;IACI,qBAAA;E1EgpQd;E0E3oQU;IjE/HJ,mCAAA;ETixQN;E0E9oQU;IjEnIJ,oCAAA;ETwxQN;E0EjpQU;;IjEvIJ,iCAAA;ETgyQN;E0EppQU;IACI,WAAA;IACA,WAAA;E1EspQd;E0ElpQM;IACI,YAAA;IACA,eAAA;IACA,iBAAA;E1EopQV;E0E9oQE;IACI,kBAAA;E1EgpQN;E0E5oQM;IACI,YAAA;E1E8oQV;AACF;A0E1oQA;EAEQ;IACI,SAAA;IACA,mBAAA;IACA,oBAAA;E1E2oQV;E0ExoQM;IACI,oBAAA;E1E0oQV;AACF;A0EtoQA;EAEQ;IACI,oBAAA;E1EuoQV;E0EroQU;IACI,cAAA;IACA,kBAAA;IACA,QAAA;E1EuoQd;E0EjoQI;IACI,4BAAA;E1EmoQR;E0E9nQM;IACI,mBAAA;E1EgoQV;E0E5nQE;IACI,kBAAA;IACA,SAAA;IACA,gBAAA;E1E8nQN;E0E3nQE;IACI,iBAAA;E1E6nQN;E0E1nQE;IACI,SAAA;IACA,MAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;E1E4nQN;E0EznQE;IACI,oBAAA;E1E2nQN;E0ExnQE;IACI,qBAAA;IACA,WAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;E1E0nQN;E0ExnQM;IACI,kBAAA;E1E0nQV;E0EtnQE;IACI,cAAA;IACA,mBAAA;E1EwnQN;AACF;A0ErnQA;EAEQ;IACI,kBAAA;IACA,UAAA;IACA,QAAA;IACA,2BAAA;E1EsnQV;AACF;A0EhnQA;EACI;IACI,cAAA;IACA,eAAA;E1EknQN;E0E/mQE;IACI,cAAA;E1EinQN;E0E7mQI;IACE,kBAAA;E1E+mQN;E0E3mQE;IACE,uBAAA;E1E6mQJ;E0E3mQI;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;E1E6mQN;E0ExmQI;;;IAGE,YAAA;E1E0mQN;E0EtmQE;IACE,cAAA;E1EwmQJ;E0EtmQI;IACE,kBAAA;E1EwmQN;E0EpmQE;IACE,cAAA;IACA,6BAAA;IAAA,qBAAA;IAAA,cAAA;E1EsmQJ;E0ElmQI;IACE,6BAAA;E1EomQN;E0E/lQI;IACE,cAAA;E1EimQN;E0E5lQI;IACE,gBAAA;IACA,iBAAA;IACA,cAAA;E1E8lQN;E0EzlQM;IACI,kBAAA;E1E2lQV;E0EtlQM;IACI,cAAA;E1EwlQV;E0EtlQU;IACE,gBAAA;E1EwlQZ;E0ErlQU;IACE,eAAA;E1EulQZ;E0EplQU;IACI,cAAA;IACA,mBAAA;E1EslQd;E0E/kQE;IACI,gBAAA;E1EilQN;E0E9kQE;IACI,eAAA;IACA,WAAA;IACA,SAAA;E1EglQN;E0E7kQE;IACI,mBAAA;E1E+kQN;E0E5kQE;IACI,aAAA;E1E8kQN;E0E1kQM;IACI,gBAAA;E1E4kQV;E0E1kQU;IACI,YAAA;IACA,gBAAA;E1E4kQd;E0ErkQU;IACI,eAAA;E1EukQd;E0ErkQc;IACI,eAAA;E1EukQlB;E0EhkQM;IACI,UAAA;E1EkkQV;AACF;A0E9jQA;EAEQ;IACI,SAAA;IACA,gBAAA;E1E+jQV;E0E5jQM;IACI,SAAA;IACA,gBAAA;E1E8jQV;AACF;A0E1jQA;EACI;IACI,aAAA;IACA,iBAAA;E1E4jQN;E0E1jQM;IACI,gBAAA;E1E4jQV;E0EzjQM;IACI,SAAA;IACA,QAAA;IACA,gBAAA;E1E2jQV;E0ExjQM;IACI,SAAA;IACA,gBAAA;IACA,QAAA;E1E0jQV;E0ErjQI;IACE,kBAAA;E1EujQN;E0EpjQI;IACE,uBAAA;E1EsjQN;E0EljQE;IACI,cAAA;IACA,WAAA;E1EojQN;E0EhjQM;;;IAGI,aAAA;E1EkjQV;AACF;A0E9iQA;EACI;IACI,gBAAA;E1EgjQN;AACF;A0E7iQA;EAEQ;IACI,QAAA;IACA,UAAA;E1E8iQV;E0E3iQM;IACI,QAAA;IACA,UAAA;E1E6iQV;AACF;A0EziQA;EACE;IACE,kBAAA;E1E2iQF;AACF;A4EjkRA,qCAAA;AACA;;;EAAA;AAIA;;;;CAAA;AAKA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;A5EmkRF;;A4EjkRA;EACE,kBAAA;EACA,cAAA;A5EokRF;;A4ElkRA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;A5EqkRF;;A4EnkRA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;A5EskRF;;A4EpkRA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;A5EukRF;;A4ErkRA;EACE,YAAA;EACA,WAAA;A5EwkRF;;A4EtkRA;EACE,WAAA;EACA,UAAA;A5EykRF;;A4EvkRA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;A5E0kRF;;A4ExkRA;;EAAA;AAGA;EACE,QAAA;A5E2kRF;;A4EzkRA;EACE,SAAA;A5E4kRF;;A4E1kRA;EAEE,2BAAA;EACA,kBAAA;A5E6kRF;;A4E3kRA;EACE,YAAA;EACA,WAAA;A5E8kRF;;A4E5kRA;;EAGE,0BAAA;A5E+kRF;;A4E7kRA;EACE,0BAAA;A5EglRF;;A4E9kRA;EAAA;AAEA;EACE,WAAA;A5EilRF;;A4E/kRA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;A5EklRF;;A4EhlRA;EACE,WAAA;A5EmlRF;;A4EjlRA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;A5EolRF;;A4EllRA;EACE,WAAA;EACA,UAAA;A5EqlRF;;A4EnlRA;;EAAA;AAGA;EACE,0CAAA;EACA,kBAAA;A5EslRF;;A4EplRA;EACE,kBAAA;A5EulRF;;A4EllRA;EAAA;AAEA;EACE,iBAAA;A5EqlRF;;A4EnlRA;EACE,iBAAA;A5EslRF;;A4EplRA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;A5EulRF;;A4ErlRA;EACE,yEAAA;A5EwlRF;;A4EtlRA;EAAA;AAEA;EACE,mBAAA;A5EylRF;;A4EvlRA;;;EAGE,mBAAA;A5E0lRF;;A4ExlRA;;EAAA;AAGA;;EAGE,sBAAA;A5E2lRF;;A4EzlRA;EACE,kBAAA;EACA,WAAA;A5E4lRF;;A4E1lRA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;A5E6lRF;;A4E3lRA;EACE,WAAA;EACA,eAAA;A5E8lRF;;A4E5lRA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;A5E+lRF;;A4E7lRA;EACE,gBAAA;A5EgmRF;;A4E9lRA;EACE,gBAAA;A5EimRF;;A4E/lRA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;A5EkmRF;;A4EhmRA;EAEE,+BAAA;A5EmmRF;;A4EjmRA;EAEE,8BAAA;A5EomRF;;A4ElmRA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;A5EqmRF;;A4EnmRA;EACE,YAAA;A5EsmRF;;A4EpmRA;EACE,YAAA;A5EumRF;;A4ErmRA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;A5EwmRF;;A4EtmRA;EAEE,6BAAA;EACA,kBAAA;A5EymRF;;A4EvmRA;EAEE,4BAAA;A5E0mRF;;A4ExmRA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;A5E2mRF;;A4EzmRA;EACE,WAAA;A5E4mRF;;A4E1mRA;EACE,WAAA;A5E6mRF;;A4E3mRA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A5E8mRF;;A4E5mRA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;A5E+mRF;;A4E7mRA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;A5EgnRF;;A6Ej4RA;;CAAA;AAGA;EACE,kBAAA;A7Eo4RF;A6En4RE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A7Eq4RJ;A6El4RI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;A7Eo4RN;;A6Eh4RA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EAEA,4BAAA;EACA,gBAAA;A7Em4RF;A6Ej4RE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A7Em4RJ;A6Ej4RE;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A7Em4RJ;;A6E/3RA;EACE,cAAA;EACA,SAAA;A7Ek4RF;;A6Eh4RA;EACE,gBAAA;EACA,gBAAA;A7Em4RF;;A6Eh4RA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;A7Em4RF;;A6Eh4RA;EACE,WAAA;EACA,SAAA;EACA,gCAAA;A7Em4RF;;A6Ej4RA;;EAEE,kBAAA;EACA,YAAA;A7Eo4RF;;A6El4RA;EACE,eAAA;A7Eq4RF;;A6En4RA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A7Es4RF;A6Er4RE;EAGE,oCAAA;EACA,c5E9FyB;ADm+R7B;;A6Eh4RI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;A7Em4RN;A6Ej4RI;;EAEE,c5EjGuB;ADo+R7B;;A6E93RA;;;;;EAKE,mBAAA;EACA,eAAA;A7Ei4RF;;A6E/3RA;EACE,kBAAA;A7Ek4RF;;A6Eh4RA;EACE,yBAAA;A7Em4RF;;A6Ej4RA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A7Eo4RF;;A6Ej4RA;EACE,cAAA;A7Eo4RF;;A6El4RA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A7Eq4RF;;A6En4RA;EACE,eAAA;EACA,mBAAA;A7Es4RF;;A6Ep4RA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A7Eu4RF;;A6Er4RA;;EAEE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;A7Ew4RF;;A6Ep4RE;;;;;EAKE,c5ElIyB;ADygS7B;;A6En4RA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A7Es4RF;;A6En4RA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A7Es4RF;;A6Ep4RA;EACE,eAAA;A7Eu4RF;;A6Er4RA;EACE,mBAAA;A7Ew4RF;;A6Er4RA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A7Ew4RF;;A6Et4RA;EACE,sBAAA;A7Ey4RF;;A6Et4RA;EACE,WAAA;EACA,YAAA;A7Ey4RF;;A6Et4RA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;A7Ey4RF;;A6Ev4RA;;EAEE,gBAAA;A7E04RF;;A6Ev4RA;EACE,qBAAA;A7E04RF;;A6Et4RE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;A7Ey4RJ;A6Ev4RE;EACE,QAAA;EACA,6BAAA;A7Ey4RJ;;A6Er4RA;EACE,aAAA;A7Ew4RF;;A6Er4RA;EACE,WAAA;A7Ew4RF;A6Ev4RE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;A7Ey4RJ;;A6Ep4RI;EACE,c5ExNuB;E4EyNvB,kBAAA;EACA,yBAAA;A7Eu4RN;;A6El4RA;EACE,YAAA;EACA,kBAAA;A7Eq4RF;;A6En4RA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,c5EjQ2B;E4EsQ3B,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A7Eq4RF;;A6En4RA;EACE,gBAAA;EACA,cAAA;A7Es4RF;;A6Ep4RA;EACE,kBAAA;EACA,iBAAA;A7Eu4RF;;A6Ep4RA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;A7Eu4RF;;A6Ep4RA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;A7Eu4RF;;A6Er4RA;;EAEE,oBAAA;A7Ew4RF;A6Ev4RE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A7E24RJ;A6Ez4RI;;;;EACE,oCAAA;EACA,c5EhUuB;AD8sS7B;;A8ExtSA;;;;;;CAAA;AASA;;CAAA;AAIA;EACE,mBAAA;A9EwtSF;A8EvtSE;EACE,SAAA;EACA,4CAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;A9EytSJ;A8EvtSE;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;A9EytSJ;A8EvtSE;EACE,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EAKA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;A9EytSJ;A8ExtSI;EACE,aAAA;A9E0tSN;A8ErtSM;EACE,6BAAA;A9EutSR;A8EntSU;EACE,yB7E1CiB;AD+vS7B;A8EhtSQ;EACE,yB7EzDmB;AD2wS7B;A8E9sSQ;EACE,cAAA;EACA,eAAA;A9EgtSV;A8E3sSE;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;A9E6sSJ;A8E5sSI;EACE,yBAAA;EACA,gBAAA;EACA,6BAAA;A9E8sSN;A8E1sSQ;EACE,yBAAA;EACA,SAAA;A9E4sSV;A8EzsSM;EACE,yBAAA;EACA,gBAAA;A9E2sSR;A8EvsSM;EACE,oBAAA;EACA,mBAAA;EACA,6BAAA;A9EysSR;A8ExsSQ;EACE,oBAAA;A9E0sSV;A8ExsSQ;EACE,gBAAA;A9E0sSV;A8EvsSM;EACE,QAAA;EACA,c7EtGqB;AD+yS7B;A8EtsSI;EACE,c7ErGuB;E6EsGvB,mBAAA;EACA,mBAAA;EACA,QAAA;A9EwsSN;A8EtsSI;;EAEE,mBAAA;A9EwsSN;A8EtsSI;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;A9EwsSN;A8EvsSM;EACE,aAAA;A9EysSR;A8EvsSM;EACE,UAAA;EACA,qBAAA;A9EysSR;A8EtsSQ;EACE,6BAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;A9EwsSV;A8EtsSQ;EACE,yB7E/EmB;ADuxS7B;A8EtsSQ;EACE,aAAA;A9EwsSV;A8EpsSQ;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;A9EssSV;A8EpsSQ;EACE,aAAA;A9EssSV;A8E9rSQ;EACE,qB7E1ImB;AD00S7B;A8E5rSQ;;EAEE,c7EhJmB;AD80S7B;A8E1rSI;EACE,yBAAA;A9E4rSN;A8E3rSM;EACE,6B7EnHqB;E6EoHrB,6CAAA;A9E6rSR;A8E5rSQ;EACE,c7E1JmB;E6E2JnB,6BAAA;A9E8rSV;A8EtrSQ;EACE,qB7E/JmB;ADu1S7B;A8EprSQ;;EAEE,c7ErKmB;AD21S7B;A8ElrSI;EACE,yBAAA;A9EorSN;A8EnrSM;EACE,6B7E3IqB;E6E4IrB,6CAAA;A9EqrSR;A8EprSQ;EACE,c7E/KmB;E6EgLnB,6BAAA;A9EsrSV;A8E9qSQ;EACE,qB7EpLmB;ADo2S7B;A8E5qSQ;;EAEE,c7E1LmB;ADw2S7B;A8E1qSI;EACE,yBAAA;A9E4qSN;A8E3qSM;EACE,8B7EtKqB;E6EuKrB,8CAAA;A9E6qSR;A8E5qSQ;EACE,c7EpMmB;E6EqMnB,6BAAA;A9E8qSV;A8EtqSQ;EACE,qB7EzMmB;ADi3S7B;A8EpqSQ;;EAEE,c7E/MmB;ADq3S7B;A8ElqSI;EACE,yBAAA;A9EoqSN;A8EnqSM;EACE,8B7E9LqB;E6E+LrB,8CAAA;A9EqqSR;A8EpqSQ;EACE,c7EzNmB;E6E0NnB,6BAAA;A9EsqSV;A8E9pSQ;EACE,qB7E9NmB;AD83S7B;A8E5pSQ;;EAEE,c7EpOmB;ADk4S7B;A8E1pSI;EACE,yBAAA;A9E4pSN;A8E3pSM;EACE,6B7EvNqB;E6EwNrB,6CAAA;A9E6pSR;A8E5pSQ;EACE,c7E9OmB;E6E+OnB,6BAAA;A9E8pSV;A8ErpSQ;EACE,qB7EnTmB;AD08S7B;A8EnpSQ;;EAEE,c7EzTmB;AD88S7B;A8EjpSI;EACE,yBAAA;A9EmpSN;A8ElpSM;EACE,c7EhUqB;E6EiUrB,8BAAA;A9EopSR;A8EnpSQ;EACE,c7EnUmB;E6EoUnB,6BAAA;A9EqpSV;A8E/oSE;EACE,yBAAA;A9EipSJ;A8EhpSI;EACE,kBAAA;EACA,+BAAA;EACA,+CAAA;A9EkpSN;A8EjpSM;EACE,c7EnUqB;E6EoUrB,6BAAA;A9EmpSR;A8E7oSM;EACE,aAAA;A9E+oSR;A8E7oSM;EACE,yBAAA;EACA,yBAAA;A9E+oSR;A8E5oSI;EACE,yBAAA;A9E8oSN;A8E3oSE;EACE,gBAAA;A9E6oSJ;;A+E1/SA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;A/E6/SF;;A+E1/SA;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;A/E6/SF;;A+E1/SA;EACE,eAAA;EACA,iBAAA;A/E6/SF;;A+E1/SA;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;A/E6/SF;;A+E3/SA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;A/E8/SF;;A+E3/SA;EACE,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;A/E8/SF;;A+E1/SE;EAKE,6BAAA;A/E6/SJ;A+E3/SI;EACE,mBAAA;A/E6/SN;A+E3/SM;EACE,UAAA;EACA,kBAAA;A/E6/SR;;AgFnkTA;EACE,aAAA;AhFskTF;;AgFnkTE;;EAEE,gBAAA;AhFskTJ;;AiF3kTI;EACI,qBhFwDqB;EgFvDrB,chFuDqB;ADuhT7B;AiF5kTQ;EACI,chFoDiB;AD0hT7B;;AkFplTA;EACE,aAAA;AlFulTF;;AmFxlTA;EACE,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AnF2lTF;;AmFxlTA;EACE,mBAAA;EACA,qBAAA;AnF2lTF;;AoFpmTA;EACE,aAAA;ApFumTF;;AqFxmTA;EACE,cpFyD2B;EoFxD3B,eAAA;ArF2mTF;;AqFzmTA;EACE,kBAAA;EACA,iBAAA;ArF4mTF;;AsFjnTE;EACE,oCAAA;AtFonTJ;;AsF/mTE;ElDNE,yBnC+CyB;AD0kT7B;AoCvnTI;EACI,cnCMqB;ADmnT7B;AoCrnTI;EACI,2BnCuCqB;ADglT7B;AoCpnTI;EACI,yBnCmCqB;ADmlT7B;AoCnnTI;EACI,4BnC+BqB;ADslT7B;AoClnTI;EACI,0BnC2BqB;ADylT7B;AoCjnTI;EACI,cnCfqB;EmCgBrB,YAAA;ApCmnTR;AsFpoTI;EACE,0BrFsCuB;ADgmT7B;;AsFhoTE;ElDfE,yBnCyDyB;AD0lT7B;AoCjpTI;EACI,cnCMqB;AD6oT7B;AoC/oTI;EACI,2BnCiDqB;ADgmT7B;AoC9oTI;EACI,yBnC6CqB;ADmmT7B;AoC7oTI;EACI,4BnCyCqB;ADsmT7B;AoC5oTI;EACI,0BnCqCqB;ADymT7B;AoC3oTI;EACI,cnCfqB;EmCgBrB,YAAA;ApC6oTR;AsFrpTI;EACE,0BrFuCuB;ADgnT7B;;AsFjpTE;ElDxBE,yBnC8DyB;AD+mT7B;AoC3qTI;EACI,cnCMqB;ADuqT7B;AoCzqTI;EACI,2BnCsDqB;ADqnT7B;AoCxqTI;EACI,yBnCkDqB;ADwnT7B;AoCvqTI;EACI,4BnC8CqB;AD2nT7B;AoCtqTI;EACI,0BnC0CqB;AD8nT7B;AoCrqTI;EACI,cnCfqB;EmCgBrB,YAAA;ApCuqTR;AsFtqTI;EACE,0BrFmCuB;ADqoT7B;;AsFlqTE;ElDjCE,yBnCmEyB;ADooT7B;AoCrsTI;EACI,cnCMqB;ADisT7B;AoCnsTI;EACI,2BnC2DqB;AD0oT7B;AoClsTI;EACI,yBnCuDqB;AD6oT7B;AoCjsTI;EACI,4BnCmDqB;ADgpT7B;AoChsTI;EACI,0BnC+CqB;ADmpT7B;AoC/rTI;EACI,cnCfqB;EmCgBrB,YAAA;ApCisTR;AsFvrTI;EACE,0BrF+BuB;AD0pT7B;;AsFnrTE;ElD1CE,yBnCoDyB;AD6qT7B;AoC/tTI;EACI,cnCMqB;AD2tT7B;AoC7tTI;EACI,2BnC4CqB;ADmrT7B;AoC5tTI;EACI,yBnCwCqB;ADsrT7B;AoC3tTI;EACI,4BnCoCqB;ADyrT7B;AoC1tTI;EACI,0BnCgCqB;AD4rT7B;AoCztTI;EACI,cnCfqB;EmCgBrB,YAAA;ApC2tTR;AsFxsTI;EACE,0BrFOuB;ADmsT7B;;AuFxvTA;EACE,0BtFU2B;ADivT7B;;AuFzvTA;EACE,2BtFO2B;ADqvT7B;;AuF1vTA;EACE,yBtFI2B;ADyvT7B;;AuF3vTA;EACE,4BtFC2B;AD6vT7B;;AwFxwTA;EACE,kBAAA;AxF2wTF;;AyF5wTA;E3BCI,iCAAA,EAAA,+CAAA,EACA,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,gFAAA,EAAA,oBAAA;A9D+wTJ;;AyFjxTA;EACI,yBxFsDyB;AD8tT7B;;AyFlxTA;EACE,cxFmD2B;ADkuT7B;;AyFlxTE;EACE,gBAAA;EACA,iBAAA;AzFqxTJ;AyFnxTE;EACE,cAAA;AzFqxTJ;;AyFlxTA;EACE,aAAA;EACA,mBAAA;AzFqxTF;;AyFnxTA;EACE,WAAA;AzFsxTF;;AyFpxTA;EACE,gBAAA;AzFuxTF;;AyFrxTA;EACE,aAAA;EACA,mBAAA;AzFwxTF;;A0FtzTA;EACE;IACE,mBzFwDyB;IyFvDzB,iDAAA;E1FyzTF;E0FvzTA;IACE,2BAAA;E1FyzTF;AACF;A0FtzTA;EACE;IACE,kBAAA;IACA,mBAAA;E1FwzTF;E0FtzTA;IACE,QAAA;E1FwzTF;E0FtzTA;IACE,sBAAA;E1FwzTF;E0FtzTA;IACE,sBAAA;IACA,8BAAA;E1FwzTF;E0FvzTE;IACE,iBAAA;E1FyzTJ;AACF;A0FtzTA;EACE;IACE,kBAAA;E1FwzTF;AACF","sourcesContent":["/*!\n\n =========================================================\n * Now UI Kit Pro - v1.3.0\n =========================================================\n\n * Product Page: https://www.creative-tim.com/product/now-ui-kit-pro\n * Copyright 2023 Creative Tim (http://www.creative-tim.com)\n\n * Designed by www.invisionapp.com Coded by www.creative-tim.com\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n@import 'now-ui-kit/variables';\n@import 'now-ui-kit/mixins';\n\n// Plugins CSS\n@import 'now-ui-kit/plugins/plugin-bootstrap-switch';\n@import 'now-ui-kit/plugins/plugin-nouislider';\n@import 'now-ui-kit/plugins/plugin-bootstrap-select';\n@import 'now-ui-kit/plugins/plugin-tagsinput';\n@import 'now-ui-kit/plugins/plugin-fileupload';\n@import 'now-ui-kit/plugins/plugin-datetimepicker';\n\n// Core CSS\n@import 'now-ui-kit/nucleo-outline';\n\n@import 'now-ui-kit/alerts';\n@import 'now-ui-kit/checkboxes-radio';\n@import 'now-ui-kit/badges';\n@import 'now-ui-kit/pagination';\n@import 'now-ui-kit/typography';\n@import 'now-ui-kit/misc';\n\n@import 'now-ui-kit/buttons';\n@import 'now-ui-kit/social-buttons';\n@import 'now-ui-kit/inputs';\n@import 'now-ui-kit/progress';\n@import 'now-ui-kit/pills';\n@import 'now-ui-kit/pills-extend';\n\n// components\n@import 'now-ui-kit/tabs';\n@import 'now-ui-kit/navbar';\n@import 'now-ui-kit/navbar-extend';\n@import 'now-ui-kit/dropdown';\n@import 'now-ui-kit/dropdown-extend';\n@import 'now-ui-kit/images';\n@import 'now-ui-kit/popups';\n@import 'now-ui-kit/tables';\n@import 'now-ui-kit/info-areas';\n@import 'now-ui-kit/media';\n@import 'now-ui-kit/modals';\n@import 'now-ui-kit/modals-extend';\n@import 'now-ui-kit/carousel';\n@import 'now-ui-kit/footers';\n\n// cards\n@import 'now-ui-kit/cards';\n@import 'now-ui-kit/cards/card-extend';\n@import 'now-ui-kit/cards/card-background';\n@import 'now-ui-kit/cards/card-blog';\n@import 'now-ui-kit/cards/card-contact';\n@import 'now-ui-kit/cards/card-fashion';\n@import 'now-ui-kit/cards/card-form-horizontal';\n@import 'now-ui-kit/cards/card-no-shadow';\n@import 'now-ui-kit/cards/card-plain';\n@import 'now-ui-kit/cards/card-pricing';\n@import 'now-ui-kit/cards/card-profile';\n@import 'now-ui-kit/cards/card-product';\n@import 'now-ui-kit/cards/card-raised';\n@import 'now-ui-kit/cards/card-signup';\n@import 'now-ui-kit/cards/card-testimonials';\n\n\n// example pages and sections\n@import 'now-ui-kit/example-pages';\n@import 'now-ui-kit/sections';\n@import 'now-ui-kit/sections-extend';\n\n@import 'now-ui-kit/responsive';\n\n// react\n@import 'react/react-differences';\n","//== Buttons\n//\n//## For each of Bootstrap's buttons, define text, background and border color.\n\n$sans-serif-family:          'Montserrat', 'Helvetica Neue',  Arial, sans-serif !default;\n\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n\n$white-color:                #FFFFFF !default;\n$white-bg:                   #FFFFFF !default;\n$orange-bg:                  #e95e38 !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n$light-black:                #444    !default;\n\n$black-bg:                   rgba(30,30,30,.97) !default;\n\n$black-color:                #2c2c2c !default;\n$black-hr:                   #444444 !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$dark-gray:                  #9A9A9A !default;\n\n$opacity-gray-3:             rgba(222,222,222, .3) !default;\n$opacity-gray-5:             rgba(222,222,222, .5) !default;\n$opacity-gray-8:             rgba(222,222,222, .8) !default;\n\n\n$opacity-5:                  rgba(255,255,255, .5) !default;\n$opacity-8:                  rgba(255,255,255, .8) !default;\n\n$datepicker-color-days:             rgba(255,255,255, .8)  !default;\n$datepicker-color-old-new-days:     rgba(255,255,255, .4)  !default;\n\n\n$opacity-1:                  rgba(255,255,255, .1) !default;\n$opacity-2:                  rgba(255,255,255, .2) !default;\n\n$transparent-bg:             transparent !default;\n$dark-background:            #555555 !default;\n\n$default-color:              #888888 !default;\n$default-states-color:       lighten($default-color, 6%) !default;\n$default-color-opacity:      rgba(182, 182, 182, .6) !default;\n\n$primary-color:              #f96332 !default;\n$primary-states-color:       lighten($primary-color, 6%) !default;\n$primary-color-opacity:      rgba(249, 99, 50, .3) !default;\n$primary-color-alert:        rgba(249, 99, 50, .8) !default;\n\n$success-color:              #18ce0f !default;\n$success-states-color:       lighten($success-color, 6%) !default;\n$success-color-opacity:      rgba(24, 206, 15, .3) !default;\n$success-color-alert:        rgba(24, 206, 15, .8) !default;\n\n$info-color:                 #2CA8FF !default;\n$info-states-color:          lighten($info-color, 6%) !default;\n$info-color-opacity:         rgba(44, 168, 255, .3) !default;\n$info-color-alert:           rgba(44, 168, 255, .8) !default;\n\n$warning-color:              #FFB236 !default;\n$warning-states-color:       lighten($warning-color, 6%) !default;\n$warning-color-opacity:      rgba(255, 178, 54, .3) !default;\n$warning-color-alert:        rgba(255, 178, 54, .8) !default;\n\n$danger-color:               #FF3636 !default;\n$danger-states-color:        lighten($danger-color, 6%) !default;\n$danger-color-opacity:       rgba(255, 54, 54, .3) !default;\n$danger-color-alert:         rgba(255, 54, 54, .8) !default;\n\n/*     brand Colors              */\n$brand-primary:              $primary-color !default;\n$brand-info:                 $info-color !default;\n$brand-success:              $success-color !default;\n$brand-warning:              $warning-color !default;\n$brand-danger:               $danger-color !default;\n$brand-inverse:              $black-color !default;\n\n$link-disabled-color:        #666666 !default;\n\n/*      light colors         */\n$light-blue:                 rgba($primary-color, .2);\n$light-azure:                rgba($info-color, .2);\n$light-green:                rgba($success-color, .2);\n$light-orange:               rgba($warning-color, .2);\n$light-red:                  rgba($danger-color, .2);\n\n//== Components\n//\n\n$padding-input-vertical:        11px !default;\n$padding-input-horizontal:      19px !default;\n\n$padding-btn-vertical:         11px !default;\n$padding-btn-horizontal:       22px !default;\n\n$padding-base-vertical:        .5rem !default;\n$padding-base-horizontal:      .7rem !default;\n\n$padding-round-horizontal:     23px !default;\n\n$padding-simple-vertical:      10px !default;\n$padding-simple-horizontal:    17px !default;\n\n$padding-large-vertical:       15px !default;\n$padding-large-horizontal:     48px !default;\n\n$padding-small-vertical:        5px !default;\n$padding-small-horizontal:     15px !default;\n\n// $padding-xs-vertical:           1px !default;\n// $padding-xs-horizontal:         5px !default;\n\n$padding-label-vertical:        2px !default;\n$padding-label-horizontal:     12px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n$margin-base-horizontal:       15px !default;\n\n$margin-bottom:                 10px        !default;\n$border:                        1px solid   !default;\n$border-radius-extra-small:     0.125rem    !default;\n$border-radius-small:           0.1875rem   !default;\n$border-radius-large:           0.25rem     !default;\n$border-radius-extreme:         0.875rem    !default;\n\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\n\n$btn-round-radius:             30px         !default;\n\n$height-base:                  55px         !default;\n\n$btn-icon-size:                 3.5rem       !default;\n$btn-icon-size-regular:         2.375rem      !default;\n$btn-icon-font-size-regular:    0.9375rem     !default;\n$btn-icon-font-size-small:      0.6875rem      !default;\n$btn-icon-size-small:           1.875rem     !default;\n$btn-icon-font-size-lg:         1.325rem     !default;\n$btn-icon-size-lg:              3.6rem         !default;\n\n$font-size-h1:                 3.5em        !default; // ~ 49px\n$font-size-h2:                 2.5em        !default; // ~ 35px\n$font-size-h3:                 1.825em      !default; // ~ 28px\n$font-size-h4:                 1.5em        !default; // ~ 24px\n$font-size-h5:                 1.3em        !default; // ~ 22px\n$font-size-h6:                 .9em         !default; // ~ 12px\n\n$font-paragraph:               1.2em          !default;\n$font-size-navbar:             1em          !default;\n$font-size-mini:               0.7142em     !default;\n$font-size-small:              0.8571em     !default;\n$font-size-base:               14px         !default;\n$font-size-large:              1em          !default;\n$font-size-large-navbar:       20px         !default;\n$font-size-blockquote:         1.1em        !default; // ~ 15px\n\n$font-weight-light:             300         !default;\n$font-weight-normal:            400         !default;\n$font-weight-semi:              600         !default;\n$font-weight-bold:              700         !default;\n\n$line-height-general:        1.5            !default;\n$line-height-nav-link:       1.625rem       !default;\n$btn-icon-line-height:       2.4em          !default;\n$line-height:                1.35em         !default;\n$line-height-lg:             54px           !default;\n\n\n$border-radius-top:        10px 10px 0 0     !default;\n$border-radius-bottom:     0 0 10px 10px     !default;\n\n$dropdown-shadow:          1px 2px 3px rgba(0, 0, 0, 0.125);\n$box-shadow-raised:        0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n\n$general-transition-time:  300ms             !default;\n\n$slow-transition-time:           370ms       !default;\n$dropdown-coordinates:      29px -50px       !default;\n\n$fast-transition-time:           150ms       !default;\n$select-coordinates:         50% -40px       !default;\n\n$transition-linear:         linear           !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n\n\n//$navbar-padding-a:               9px 13px;\n$navbar-margin-a:                15px 0px;\n\n$padding-social-a:               10px 5px;\n\n$navbar-margin-a-btn:            15px 0px;\n$navbar-margin-a-btn-round:      16px 0px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-base:            0.625rem;\n//$navbar-margin-brand:             5px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n$navbar-margin-btn:              15px  3px;\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n$white-navbar:                  rgba(#FFFFFF, .96);\n$primary-navbar:                rgba(#34ACDC, .98);\n$info-navbar:                   rgba(#5BCAFF, .98);\n$success-navbar:                rgba(#4CD964, .98);\n$warning-navbar:                rgba(#FF9500, .98);\n$danger-navbar:                 rgba(#FF4C40, .98);\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n//Nucleo Icons\n\n$nc-font-path:        '~assets/fonts' !default;\n$nc-font-size-base:   14px !default;\n$nc-css-prefix:       now-ui !default;\n$nc-background-color:     #eee !default;\n$nc-li-width:         calc(30em / 14) !default;\n$nc-padding-width:    calc(1em / 3) !default;\n\n// Social icons color\n$social-twitter:                   #55acee !default;\n$social-twitter-state-color:       lighten(#55acee, 6%) !default;\n\n$social-facebook: \t\t\t       #3b5998 !default;\n$social-facebook-state-color:      lighten(#3b5998, 6%) !default;\n\n$social-google: \t\t\t       #dd4b39 !default;\n$social-google-state-color:        lighten(#dd4b39, 6%) !default;\n\n$social-linkedin: \t\t\t       #0077B5 !default;\n$social-linkedin-state-color:      lighten(#0077B5, 6%) !default;\n\n$social-pinterest: \t\t\t       #cc2127 !default;\n$social-pinterest-state-color:     lighten(#cc2127, 6%) !default;\n\n$social-dribbble: \t\t           #ea4c89 !default;\n$social-dribbble-state-color:      lighten(#ea4c89, 6%) !default;\n\n$social-github: \t\t      \t   #333333 !default;\n$social-github-state-color:        lighten(#333333, 6%) !default;\n\n$social-youtube: \t\t    \t   #e52d27 !default;\n$social-youtube-state-color:       lighten(#e52d27, 6%) !default;\n\n$social-instagram: \t\t           #125688 !default;\n$social-instagram-state-color:     lighten(#125688, 6%) !default;\n\n$social-reddit: \t\t  \t       #ff4500 !default;\n$social-reddit-state-color:        lighten(#ff4500, 6%) !default;\n\n$social-tumblr: \t\t\t       #35465c !default;\n$social-tumblr-state-color:        lighten(#35465c, 6%) !default;\n\n$social-behance: \t\t\t       #1769ff !default;\n$social-behance-state-color:       lighten(#1769ff, 6%) !default;\n","/* ========================================================================\n * bootstrap-switch - v3.3.2\n * http://www.bootstrap-switch.org\n * ========================================================================\n * Copyright 2012-2013 Mattia Larentis\n * http://www.apache.org/licenses/LICENSE-2.0\n */\n\n\n\n\n\n\n\n\n\n\n\n\n\n //* IMPORTANT! Creative Tim Notice: this file has major changes to fit the NOW UI Kit's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  margin-bottom: 10px;\n  line-height: 8px;\n  width: 59px !important;\n  height: 22px;\n  outline: none;\n  z-index: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  margin-right: 20px;\n  background: rgba($black-color, .2);\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 22px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block !important;\n  height: 100%;\n  color: #fff;\n  padding: 6px 12px;\n  font-size: 11px;\n  text-indent: -5px;\n  line-height: 15px;\n  -webkit-transition: 0.25s ease-out;\n          transition: 0.25s ease-out;\n\n}\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  line-height: 11px;\n  width: 50% !important;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-brown,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-brown {\n  color: #fff;\n  background: $brand-primary;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-blue,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-blue {\n  color: #fff;\n  background: $brand-info;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-green,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-green {\n  color: #fff;\n  background: $brand-success;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-orange,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-orange {\n  background: $brand-warning;\n  color: #fff;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-red,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-red {\n  color: #fff;\n  background: $brand-danger;\n}\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-default,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n  color: #fff;\n}\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px !important;\n  margin: 0px -11px;\n  border-radius: 20px;\n  position: absolute;\n  float: left;\n  top: 0;\n  left: 50%;\n  padding: 0;\n  box-shadow: 0 1px 11px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label{\n    background-color: rgba(23, 23, 23, .4);\n}\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label{\n    width: 27px !important;\n    margin-left: -16px;\n}\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label{\n    width: 27px !important;\n    margin-left: -11px;\n}\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n.bootstrap-switch input[type='radio'],\n.bootstrap-switch input[type='checkbox'] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n.bootstrap-switch input[type='radio'].form-control,\n.bootstrap-switch input[type='checkbox'].form-control {\n  height: auto;\n}\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n  padding: 6px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n  cursor: default !important;\n}\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n.bootstrap-switch.bootstrap-switch-focused {\n  // border-color: #66afe9;\n  // outline: 0;\n  // -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  // box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n// .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label,\n// .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-off .bootstrap-switch-label {\n//   border-bottom-right-radius: 3px;\n//   border-top-right-radius: 3px;\n// }\n// .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-label,\n// .bootstrap-switch.bootstrap-switch-inverse.bootstrap-switch-on .bootstrap-switch-label {\n//   border-bottom-left-radius: 3px;\n//   border-top-left-radius: 3px;\n// }\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container{\n    margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container{\n    margin-left: -39px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-label{\n    &:before{\n        background-color: #FFFFFF;\n    }\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-red ~ .bootstrap-switch-default{\n    background-color: $brand-danger;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-orange ~ .bootstrap-switch-default{\n    background-color: $brand-warning;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-green ~ .bootstrap-switch-default{\n    background-color: $brand-success;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-brown ~ .bootstrap-switch-default{\n    background-color: $brand-primary;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-blue ~ .bootstrap-switch-default{\n    background-color: $brand-info;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-red,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-brown,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-blue,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-orange,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-green{\n    background-color: $light-gray;\n}\n\n.bootstrap-switch-off .bootstrap-switch-handle-on{\n    opacity: 0;\n}\n\n.bootstrap-switch-on .bootstrap-switch-handle-off{\n    opacity: 0;\n}\n","/*! nouislider - 13.1.4 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  transform-origin: 0 0;\n}\n/* Offset direction\n */\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  position: absolute;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 1px;\n}\n.noUi-horizontal .noUi-handle {\n    border-radius: 50%;\n\tbackground-color: $white-color;\n\tbox-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\n\theight:15px;\n\twidth:15px;\n\tcursor:pointer;\n    margin-top: -7px;\n    outline: none;\n}\n.noUi-vertical {\n\twidth: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -15px;\n  left: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n .noUi-target {\n \tbackground-color: rgba(182, 182, 182, .3);\n \tborder-radius: 3px;\n }\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n\tbackground: $default-color;\n    border-radius: 3px;\n-webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n\t// border: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #FFF;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #EBEBEB,\n\t\t\t\t0 3px 6px -3px #BBB;\n\t-webkit-transition: $general-transition-time $transition-ease;\n    -moz-transition: $general-transition-time $transition-ease;\n    -ms-transition: $general-transition-time $transition-ease;\n    -o-transform: $general-transition-time $transition-ease;\n    transition: $general-transition-time $transition-ease;\n}\n.noUi-active {\n\t-webkit-transform: scale3d(1.5,1.5,1);\n    -moz-transform: scale3d(1.5,1.5,1);\n    -ms-transform: scale3d(1.5,1.5,1);\n    -o-transform: scale3d(1.5,1.5,1);\n    transform: scale3d(1.5,1.5,1);\n}\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  display: none;\n}\n.noUi-handle:after {\n  left: 17px;\n}\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%, 0);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.slider {\n\n\t&.slider-neutral{\n\t\t& .noUi-connect,\n        &.noUi-connect{\n            background-color: $white-color;\n        }\n\n\t\t&.noUi-target{\n\t\t\tbackground-color: rgba(255,255,255, .3);\n\t\t}\n\n\t\t& .noUi-handle{\n\t\t\tbackground-color: $white-color;\n\t\t}\n\t}\n\n\t&.slider-primary{\n\t\t& .noUi-connect,\n        &.noUi-connect{\n            background-color: $primary-color;\n        }\n\n\t\t&.noUi-target{\n\t\t\tbackground-color: $primary-color-opacity;\n\t\t}\n\n\t\t& .noUi-handle{\n\t\t\tbackground-color: $brand-primary;\n\t\t}\n\t}\n\n    &.slider-info{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $brand-info;\n        }\n\n\t\t&.noUi-target{\n\t\t\tbackground-color: $info-color-opacity;\n\t\t}\n\n\t\t& .noUi-handle{\n\t\t\tbackground-color: $brand-info;\n\t\t}\n    }\n    &.slider-success{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $brand-success;\n        }\n\n        &.noUi-target{\n\t\t\tbackground-color: $success-color-opacity;\n\t\t}\n\n\t\t& .noUi-handle{\n\t\t\tbackground-color: $brand-success;\n\t\t}\n    }\n    &.slider-warning{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $brand-warning;\n        }\n\n        &.noUi-target{\n\t\t\tbackground-color: $warning-color-opacity;\n\t\t}\n\n\t\t& .noUi-handle{\n\t\t\tbackground-color: $brand-warning;\n\t\t}\n    }\n    &.slider-danger{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $brand-danger;\n        }\n\n        &.noUi-target{\n\t\t\tbackground-color: $danger-color-opacity;\n\t\t}\n\n\t\t& .noUi-handle{\n\t\t\tbackground-color: $brand-danger;\n\t\t}\n    }\n\n}\n","/*!\n * Bootstrap-select v1.13.1 (https://developer.snapappointments.com/bootstrap-select)\n *\n * Copyright 2012-2018 SnapAppointments, LLC\n * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)\n */\n\nselect.bs-select-hidden,\n.bootstrap-select > select.bs-select-hidden,\nselect.selectpicker {\n  display: none !important;\n}\n.bootstrap-select {\n  width: 220px \\0;\n  /*IE9 and below*/\n\n  & > .dropdown-menu {\n    overflow: visible !important;\n  }\n  .dropdown-item.active, .dropdown-item:active{\n    background-color: inherit;\n  }\n\n  &.dropup .dropdown-menu:not(.inner) {\n    top: auto !important;\n    bottom: 100%;\n  }\n}\n.bootstrap-select > .dropdown-toggle {\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  text-align: right;\n  white-space: nowrap;\n  margin: 0;\n}\n// .bootstrap-select > .dropdown-toggle.bs-placeholder,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder:active {\n//   color: #999;\n// }\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:hover,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:focus,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-primary:active,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-secondary:active,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-success:active,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-danger:active,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-info:active,\n// .bootstrap-select > .dropdown-toggle.bs-placeholder.btn-dark:active {\n//   color: rgba(255, 255, 255, 0.5);\n// }\n.bootstrap-select > select {\n  position: absolute !important;\n  bottom: 0;\n  left: 50%;\n  display: block !important;\n  width: 0.5px !important;\n  height: 100% !important;\n  padding: 0 !important;\n  opacity: 0 !important;\n  border: none;\n}\n.bootstrap-select > select.mobile-device {\n  top: 0;\n  left: 0;\n  display: block !important;\n  width: 100% !important;\n  z-index: 2;\n}\n.has-error .bootstrap-select .dropdown-toggle,\n.error .bootstrap-select .dropdown-toggle,\n.bootstrap-select.is-invalid .dropdown-toggle,\n.was-validated .bootstrap-select .selectpicker:invalid + .dropdown-toggle {\n  border-color: #b94a48;\n}\n.bootstrap-select.is-valid .dropdown-toggle,\n.was-validated .bootstrap-select .selectpicker:valid + .dropdown-toggle {\n  border-color: #28a745;\n}\n.bootstrap-select.fit-width {\n  width: auto !important;\n}\n.bootstrap-select:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(.input-group-btn) {\n  width: 220px;\n}\n// .bootstrap-select .dropdown-toggle:focus {\n//   outline: thin dotted #333333 !important;\n//   outline: 5px auto -webkit-focus-ring-color !important;\n//   outline-offset: -2px;\n// }\n.bootstrap-select.form-control {\n  margin-bottom: 0;\n  padding: 0;\n  border: none;\n}\n:not(.input-group) > .bootstrap-select.form-control:not([class*=\"col-\"]) {\n  width: 100%;\n}\n.bootstrap-select.form-control.input-group-btn {\n  z-index: auto;\n}\n.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.bootstrap-select:not(.input-group-btn),\n.bootstrap-select[class*=\"col-\"] {\n  float: none;\n  display: inline-block;\n  margin-left: 0;\n}\n.bootstrap-select.dropdown-menu-right,\n.bootstrap-select[class*=\"col-\"].dropdown-menu-right,\n.row .bootstrap-select[class*=\"col-\"].dropdown-menu-right {\n  float: right;\n}\n.form-inline .bootstrap-select,\n.form-horizontal .bootstrap-select,\n.form-group .bootstrap-select {\n  margin-bottom: 0;\n}\n.form-group-lg .bootstrap-select.form-control,\n.form-group-sm .bootstrap-select.form-control {\n  padding: 0;\n}\n.form-group-lg .bootstrap-select.form-control .dropdown-toggle,\n.form-group-sm .bootstrap-select.form-control .dropdown-toggle {\n  height: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n.bootstrap-select.form-control-sm .dropdown-toggle,\n.bootstrap-select.form-control-lg .dropdown-toggle {\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n.bootstrap-select.form-control-sm .dropdown-toggle {\n  padding: 0.25rem 0.5rem;\n}\n.bootstrap-select.form-control-lg .dropdown-toggle {\n  padding: 0.5rem 1rem;\n}\n.form-inline .bootstrap-select .form-control {\n  width: 100%;\n}\n.bootstrap-select.disabled,\n.bootstrap-select > .disabled {\n  cursor: not-allowed;\n}\n.bootstrap-select.disabled:focus,\n.bootstrap-select > .disabled:focus {\n  outline: none !important;\n}\n.bootstrap-select.bs-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 0 !important;\n  padding: 0 !important;\n}\n.bootstrap-select.bs-container .dropdown-menu {\n  z-index: 1060;\n}\n.bootstrap-select .dropdown-toggle:before {\n  content: '';\n  display: inline-block;\n}\n.bootstrap-select .dropdown-toggle .filter-option {\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding-top: inherit;\n  padding-right: inherit;\n  padding-bottom: inherit;\n  padding-left: inherit;\n  height: 100%;\n  width: 100%;\n  text-align: left;\n  outline: none;\n}\n.bootstrap-select .dropdown-toggle .filter-option-inner {\n  padding-right: inherit;\n}\n.bootstrap-select .dropdown-toggle .filter-option-inner-inner {\n  overflow: hidden;\n}\n.bootstrap-select .dropdown-toggle .caret {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  margin-top: -2px;\n  vertical-align: middle;\n}\n.input-group .bootstrap-select.form-control .dropdown-toggle {\n  border-radius: inherit;\n}\n.bootstrap-select[class*=\"col-\"] .dropdown-toggle {\n  width: 100%;\n}\n.bootstrap-select .dropdown-menu {\n  min-width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bootstrap-select .dropdown-menu > .inner:focus {\n  outline: none !important;\n}\n.bootstrap-select .dropdown-menu.inner {\n  position: static;\n  float: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  border-radius: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bootstrap-select .dropdown-menu li {\n  position: relative;\n}\n.bootstrap-select .dropdown-menu li.active small {\n  color: #fff;\n}\n.bootstrap-select .dropdown-menu li.disabled a {\n  cursor: not-allowed;\n}\n.bootstrap-select .dropdown-menu li a {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.bootstrap-select .dropdown-menu li a.opt {\n  position: relative;\n  padding-left: 2.25em;\n}\n.bootstrap-select .dropdown-menu li a span.check-mark {\n  display: none;\n}\n.bootstrap-select .dropdown-menu li a span.text {\n  display: inline-block;\n}\n.bootstrap-select .dropdown-menu li small {\n  padding-left: 0.5em;\n}\n.bootstrap-select .dropdown-menu .notify {\n  position: absolute;\n  bottom: 5px;\n  width: 96%;\n  margin: 0 2%;\n  min-height: 26px;\n  padding: 3px 5px;\n  background: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  pointer-events: none;\n  opacity: 0.9;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bootstrap-select .no-results {\n  padding: 3px;\n  background: #f5f5f5;\n  margin: 0 5px;\n  white-space: nowrap;\n}\n.bootstrap-select.fit-width .dropdown-toggle .filter-option {\n  position: static;\n  display: inline;\n  padding: 0;\n}\n.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner,\n.bootstrap-select.fit-width .dropdown-toggle .filter-option-inner-inner {\n  display: inline;\n}\n.bootstrap-select.fit-width .dropdown-toggle .caret {\n  position: static;\n  top: auto;\n  margin-top: -1px;\n}\n.bootstrap-select.show-tick .dropdown-menu .selected span.check-mark {\n  position: absolute;\n  display: inline-block;\n  right: 15px;\n  top: 14px;\n}\n.bootstrap-select.show-tick .dropdown-menu li a span.text {\n  margin-right: 34px;\n}\n.bootstrap-select .bs-ok-default:after {\n  content: '';\n  display: block;\n  width: 0.5em;\n  height: 1em;\n  border-style: solid;\n  border-width: 0 0.26em 0.26em 0;\n  -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n       -o-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {\n  z-index: 1061;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:before {\n  content: '';\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid rgba(204, 204, 204, 0.2);\n  position: absolute;\n  bottom: -4px;\n  left: 9px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle .filter-option:after {\n  content: '';\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  position: absolute;\n  bottom: -4px;\n  left: 10px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:before {\n  bottom: auto;\n  top: -4px;\n  border-top: 7px solid rgba(204, 204, 204, 0.2);\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle .filter-option:after {\n  bottom: auto;\n  top: -4px;\n  border-top: 6px solid white;\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:before {\n  right: 12px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle .filter-option:after {\n  right: 13px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:before,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:before,\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle .filter-option:after,\n.bootstrap-select.show-menu-arrow.show > .dropdown-toggle .filter-option:after {\n  display: block;\n}\n.bs-searchbox,\n.bs-actionsbox,\n.bs-donebutton {\n  padding: 4px 8px;\n}\n.bs-actionsbox {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-actionsbox .btn-group button {\n  width: 50%;\n}\n.bs-donebutton {\n  float: left;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-donebutton .btn-group button {\n  width: 100%;\n}\n.bs-searchbox + .bs-actionsbox {\n  padding: 0 8px 4px;\n}\n.bs-searchbox .form-control {\n  margin-bottom: 0;\n  width: 100%;\n  float: none;\n}\n/*# sourceMappingURL=bootstrap-select.css.map */\n","/*\n * bootstrap-tagsinput v0.8.0\n *\n */\n\n.bootstrap-tagsinput {\n    display: inline-block;\n    padding: 4px 6px;\n    max-width: 100%;\n    line-height: 22px;\n    background-color: transparent !important;\n\n    input{\n        border: none;\n        box-shadow: none;\n        outline: none;\n        background-color: transparent;\n        margin: 0;\n        width: 74px;\n        max-width: inherit;\n\n        &:focus{\n            border: none;\n            box-shadow: none;\n        }\n    }\n\n    &.form-control input::-moz-placeholder{\n        color: #777;\n        opacity: 1;\n    }\n\n    &.form-control input:-ms-input-placeholder,\n    &.form-control input::-webkit-input-placeholder{\n        color: #777;\n    }\n\n    .tag{\n        cursor: pointer;\n        margin: 5px 3px 5px 0;\n        position: relative;\n        padding: 3px 8px;\n        border-radius: 12px;\n        color: #FFFFFF;\n        font-weight: 500;\n        font-size: 0.75em;\n        text-transform: uppercase;\n        display: inline-block;\n        line-height: 1.5em;\n        padding-left: 0.8em;\n\n        &:hover{\n            padding-right: 22px;\n\n            [data-role=\"remove\"]{\n                opacity: 1;\n                padding-right: 4px;\n            }\n        }\n\n        [data-role=\"remove\"]{\n            cursor: pointer;\n            position: absolute;\n            top: 3px;\n            right: 0px;\n            opacity: 0;\n            background-color: transparent;\n        }\n\n        [data-role=\"remove\"]{\n            &:after{\n                font-family: 'Nucleo Outline';\n                content: \"\\ea53\";\n                padding: 0px 2px;\n            }\n        }\n    }\n\n    @include create-colored-tags();\n\n}\n","@mixin tag-color ($color){\n         background-color: $color;\n         color: $white-color;\n         border:none;\n         .tagsinput-remove-link{\n             color: $white-color;\n         }\n     .tagsinput-add{\n         color: $color;\n     }\n}\n\n@mixin create-colored-tags(){\n    &.badge-primary .badge{\n        @include tag-color($brand-primary);\n    }\n    &.badge-info .badge{\n        @include tag-color($brand-info);\n    }\n    &.badge-success .badge{\n        @include tag-color($brand-success);\n    }\n    &.badge-warning .badge{\n        @include tag-color($brand-warning);\n    }\n    &.badge-danger .badge{ \n        @include tag-color($brand-danger);\n    }\n}\n",".btn-file {\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.btn-file > input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 23px;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  direction: ltr;\n}\n.fileinput {\n  display: inline-block;\n  margin-bottom: 9px;\n}\n.fileinput .form-control {\n  display: inline-block;\n  padding-top: 7px;\n  padding-bottom: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  cursor: text;\n}\n.fileinput .thumbnail {\n  display: inline-block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: middle;\n  max-width: 360px;\n\n  &.img-circle{\n      border-radius: 50%;\n      max-width: 100px;\n  }\n}\n.fileinput .thumbnail > img {\n  max-height: 100%;\n}\n.fileinput .btn {\n  vertical-align: middle;\n}\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n.fileinput-inline .fileinput-controls {\n  display: inline;\n}\n.fileinput-filename {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.form-control .fileinput-filename {\n  vertical-align: bottom;\n}\n.fileinput.input-group {\n  display: table;\n}\n.fileinput.input-group > * {\n  position: relative;\n  z-index: 2;\n}\n.fileinput.input-group > .btn-file {\n  z-index: 1;\n}\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n  border-radius: 0 4px 4px 0;\n}\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n  border-radius: 0 3px 3px 0;\n}\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n  border-radius: 0 6px 6px 0;\n}\n.form-group.has-warning .fileinput .fileinput-preview {\n  color: $brand-warning;\n}\n.form-group.has-warning .fileinput .thumbnail {\n  border-color: $brand-warning;\n}\n.form-group.has-error .fileinput .fileinput-preview {\n  color: $brand-danger;\n}\n.form-group.has-error .fileinput .thumbnail {\n  border-color: $brand-danger;\n}\n.form-group.has-success .fileinput .fileinput-preview {\n  color: $brand-success;\n}\n.form-group.has-success .fileinput .thumbnail {\n  border-color: $brand-success;\n}\n.input-group-text:not(:first-child) {\n  border-left: 0;\n}\n.thumbnail{\n    border: 0 none;\n    border-radius: 0;\n    padding: 0;\n}\n",".sr-only,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\n.bootstrap-datetimepicker-widget .picker-switch::after,\n.bootstrap-datetimepicker-widget table th.prev::after,\n.bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.bootstrap-datetimepicker-widget {\n  list-style: none;\n}\n.bootstrap-datetimepicker-widget a .btn:hover {\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu {\n  padding: 8px 6px;\n  width: 254px;\n  max-width: 254px;\n\n  .now-ui-icons{\n      opacity: 1;\n      top: 2px;\n  }\n}\n@media (min-width: 768px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 992px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 1200px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: -5px;\n    left: 10px;\n    right: auto;\n    color: $white-color;\n    border-bottom: .4em solid;\n    border-right: .4em solid transparent;\n    border-left: .4em solid transparent;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top:before{\n    display: none;\n}\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top:after{\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: auto;\n    bottom: -6px;\n    right: auto;\n    left: 10px;\n    color: $white-color;\n    border-top: .4em solid;\n    border-right: .4em solid transparent;\n    border-left: .4em solid transparent;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n  left: auto;\n  right: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n  left: auto;\n  right: 7px;\n}\n.bootstrap-datetimepicker-widget .list-unstyled {\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget a[data-action] {\n  padding: 0;\n  border-width: 0;\n  background-color: transparent;\n\n  &,\n  &:active {\n    color: #66615B !important;\n  }\n}\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\n    color: $primary-color;\n}\n.bootstrap-datetimepicker-widget a[data-action]:hover {\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget a[data-action]:active {\n  box-shadow: none;\n}\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  font-weight: 300;\n  font-size: 1.5em;\n  margin: 3px;\n  border-radius: 50%;\n}\n.bootstrap-datetimepicker-widget button[data-action] {\n  width: 38px;\n  border-color: transparent;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  height: 38px;\n  padding: 0;\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\n}\n\n.bootstrap-datetimepicker-widget .btn{\n  margin: 0 !important;\n\n  &:not([data-action=\"togglePeriod\"]):hover,\n  &:not([data-action=\"togglePeriod\"]):active,\n  &:not([data-action=\"togglePeriod\"]):focus {\n    box-shadow: none !important;\n    background-color: transparent !important;\n  }\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n  content: \"Increment Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n  content: \"Increment Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n  content: \"Decrement Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n  content: \"Decrement Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n  content: \"Show Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n  content: \"Show Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n  content: \"Toggle AM/PM\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n  content: \"Clear the picker\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n  content: \"Set the date to today\";\n}\n.bootstrap-datetimepicker-widget .picker-switch {\n  text-align: center;\n  border-radius: 3px;\n  color: $primary-color;\n}\n.bootstrap-datetimepicker-widget .picker-switch::after {\n  content: \"Toggle Date and Time Screens\";\n}\n.bootstrap-datetimepicker-widget .picker-switch td {\n  padding: 0;\n  margin: 0;\n  height: auto;\n  width: auto;\n  line-height: inherit;\n}\n.bootstrap-datetimepicker-widget .picker-switch td span {\n  line-height: 2.5;\n  height: 2.5em;\n  width: 100%;\n  border-radius: 3px;\n  margin: 2px 0px !important;\n}\n.bootstrap-datetimepicker-widget table {\n  width: 100%;\n  margin: 0;\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table th {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n  font-weight: 300;\n}\n.bootstrap-datetimepicker-widget table th.picker-switch {\n  width: 145px;\n}\n.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {\n  border-radius: 4px;\n  height: 27px;\n  width: 27px;\n  line-height: 28px;\n  font-size: 12px;\n  border-radius: 50%;\n  text-align: center;\n  color: $primary-color;\n}\n.bootstrap-datetimepicker-widget table th.prev::after {\n  content: \"Previous Month\";\n}\n.bootstrap-datetimepicker-widget table th.next::after {\n  content: \"Next Month\";\n}\n.bootstrap-datetimepicker-widget table th.dow {\n  text-align: center;\n  color: $primary-color;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\n  background: #eee;\n}\n// .bootstrap-datetimepicker-widget table td > div {\n//   border-radius: 4px;\n//   height: 54px;\n//   line-height: 54px;\n//   width: 54px;\n//   text-align: center;\n// }\n.bootstrap-datetimepicker-widget table td.cw > div {\n  font-size: .8em;\n  height: 20px;\n  line-height: 20px;\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td.day > div,\n.bootstrap-datetimepicker-widget table td.minute > div,\n.bootstrap-datetimepicker-widget table td.hour > div {\n  height: 30px;\n  line-height: 2.2;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  margin: 0 auto;\n  z-index: -1;\n  position: relative;\n  font-weight: 300;\n  font-size: 14px;\n  border: none;\n  cursor: pointer;\n  @include transition($general-transition-time, $transition-ease);\n}\n.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {\n  background: #eee;\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {\n  color: $default-color;\n}\n.bootstrap-datetimepicker-widget table td.today > div:before {\n  content: '';\n  display: inline-block;\n  border: 0 0 7px 7px solid transparent;\n  border-bottom-color: #68B3C8;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {\n  background-color: $primary-color;\n  color: $white-color;\n  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);\n}\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\n  border-bottom-color: #FFFFFF;\n}\n.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table td span {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  margin: 0 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table td span:hover {\n  background: #eee;\n}\n.bootstrap-datetimepicker-widget table td span.active {\n  background-color: $primary-color;\n  color: #FFFFFF;\n}\n.bootstrap-datetimepicker-widget table td span.old {\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget .timepicker-picker span,\n.bootstrap-datetimepicker-widget .timepicker-hours span,\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\n  border-radius: 50% !important;\n}\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n  height: 27px;\n  line-height: 27px;\n}\n\n.input-group.date .input-group-text {\n  cursor: pointer;\n}\n\n.table-condensed > tbody > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > thead > tr > th {\n  padding: 1px;\n  text-align: center;\n  z-index: 1;\n  cursor: pointer;\n}\n\ninput.datetimepicker[data-color] + .bootstrap-datetimepicker-widget{\n    .picker-switch,\n    table th.prev span,\n    table th.next span,\n    table td.day > div,\n    a[data-action=\"togglePicker\"],\n    a[data-action=\"togglePicker\"]:hover,\n    span,\n    .timepicker-hours span,\n    .timepicker-minutes span,\n    .separator,\n    table td.minute > div,\n    table td.hour > div{\n        color: $white-color;\n    }\n\n\n\n    table th.dow{\n        color: $opacity-8;\n    }\n\n    table td.old > div,\n    table td.new > div{\n        color: rgba(255,255,255, .4);\n    }\n\n    button[data-action]{\n        background-color: $white-color !important;\n    }\n\n    table td.active > div,\n    table td.active:hover > div{\n        background-color: $white-color;\n    }\n\n    table td:not(.active).day:hover > div,\n    table td.hour:hover > div,\n    table td.minute:hover > div,\n    table td.second:hover > div,\n    table td span:hover{\n        background: $opacity-2;\n    }\n\n    table thead tr:first-child th:hover span,\n    table thead tr:first-child th.picker-switch:hover{\n        background-color: $opacity-2;\n    }\n}\n\n\ninput.datetimepicker[data-color=\"orange\"] + .bootstrap-datetimepicker-widget{\n    background-color: $primary-color;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $primary-color !important;\n    }\n}\n\ninput.datetimepicker[data-color=\"blue\"] + .bootstrap-datetimepicker-widget{\n    background-color: $info-color;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $info-color;\n    }\n}\n\ninput.datetimepicker[data-color=\"green\"] + .bootstrap-datetimepicker-widget{\n    background-color: $success-color;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $success-color;\n    }\n}\n\ninput.datetimepicker[data-color=\"red\"] + .bootstrap-datetimepicker-widget{\n    background-color: $danger-color;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $danger-color;\n    }\n}\n\ninput.datetimepicker[data-color=\"yellow\"] + .bootstrap-datetimepicker-widget{\n    background-color: $warning-color;\n\n    table td.active > div,\n    table td.active:hover > div,\n    button[data-action],\n    &.dropdown-menu.top:after,\n    &.dropdown-menu.bottom:before{\n        color: $warning-color;\n    }\n}\n","@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\n          box-shadow: $shadow;\n}\n\n@mixin transition-input-focus-color() {\n    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n}\n\n\n@mixin transition($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n@mixin transition-on-prop($prop ,$time, $type){\n    -webkit-transition: $prop $time $type;\n    -moz-transition: $prop $time $type;\n    -o-transition: $prop $time $type;\n    -ms-transition: all $time $type;\n    transition: $prop $time $type;\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@mixin transform-scale($value){\n-webkit-transform: scale($value);\n-moz-transform: scale($value);\n-o-transform: scale($value);\n-ms-transform: scale($value);\ntransform: scale($value);\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y-dropdown($value) {\n    -webkit-transform:  translate3d(0,$value,0) !important;\n       -moz-transform: translate3d(0,$value,0) !important;\n       -o-transform: translate3d(0,$value,0) !important;\n       -ms-transform: translate3d(0,$value,0) !important;\n       transform: translate3d(0,$value,0) !important;\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0,$value,0);\n        -moz-transform: translate3d(0,$value,0);\n        -o-transform: translate3d(0,$value,0);\n        -ms-transform: translate3d(0,$value,0);\n        transform: translate3d(0,$value,0);\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n\n\n@mixin nc-rotate($degrees, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: rotate($degrees);\n  -moz-transform: rotate($degrees);\n  -ms-transform: rotate($degrees);\n  -o-transform: rotate($degrees);\n  transform: rotate($degrees);\n}\n\n@mixin nc-flip($horiz, $vert, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: scale($horiz, $vert);\n  -moz-transform: scale($horiz, $vert);\n  -ms-transform: scale($horiz, $vert);\n  -o-transform: scale($horiz, $vert);\n  transform: scale($horiz, $vert);\n}\n","/* --------------------------------\n\nNucleo Outline Web Font - nucleoapp.com/\nLicense - nucleoapp.com/license/\nCreated using IcoMoon - icomoon.io\n\n-------------------------------- */\n\n@font-face {\n  font-family: 'Nucleo Outline';\n  src: url('~assets/fonts/nucleo-outline.eot');\n  src: url('~assets/fonts/nucleo-outline.eot') format('embedded-opentype'),\n  url('~assets/fonts/nucleo-outline.woff2') format('woff2'),\n  url('~assets/fonts/nucleo-outline.woff') format('woff'),\n  url('~assets/fonts/nucleo-outline.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/*------------------------\n\tbase class definition\n-------------------------*/\n\n.now-ui-icons {\n  display: inline-block;\n  font: normal normal normal 14px/1 'Nucleo Outline';\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/*------------------------\n  change icon size\n-------------------------*/\n\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n\n.now-ui-icons.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n\n.now-ui-icons.circle {\n  border-radius: 50%;\n}\n\n/*------------------------\n  list icons\n-------------------------*/\n\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n\n.nc-icon-ul > li {\n  position: relative;\n}\n\n.nc-icon-ul > li > .now-ui-icons {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n.nc-icon-ul > li > .now-ui-icons.circle {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n\n/*------------------------\n  spinning icons\n-------------------------*/\n\n.now-ui-icons.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n\n/*------------------------\n\tfont icons\n-------------------------*/\n\n.now-ui-icons.ui-1_check:before{\n    content: \"\\ea22\";\n}\n\n.now-ui-icons.ui-1_email-85:before {\n  content: \"\\ea2a\";\n}\n\n.now-ui-icons.arrows-1_cloud-download-93:before {\n  content: \"\\ea21\";\n}\n\n.now-ui-icons.arrows-1_cloud-upload-94:before {\n  content: \"\\ea24\";\n}\n\n.now-ui-icons.arrows-1_minimal-down:before {\n  content: \"\\ea39\";\n}\n\n.now-ui-icons.arrows-1_minimal-left:before {\n  content: \"\\ea3a\";\n}\n\n.now-ui-icons.arrows-1_minimal-right:before {\n  content: \"\\ea3b\";\n}\n\n.now-ui-icons.arrows-1_minimal-up:before {\n  content: \"\\ea3c\";\n}\n\n.now-ui-icons.arrows-1_refresh-69:before {\n  content: \"\\ea44\";\n}\n\n.now-ui-icons.arrows-1_share-66:before {\n  content: \"\\ea4c\";\n}\n\n.now-ui-icons.business_badge:before {\n  content: \"\\ea09\";\n}\n\n.now-ui-icons.business_bank:before {\n  content: \"\\ea0a\";\n}\n\n.now-ui-icons.business_briefcase-24:before {\n  content: \"\\ea13\";\n}\n\n.now-ui-icons.business_bulb-63:before {\n  content: \"\\ea15\";\n}\n\n.now-ui-icons.business_chart-bar-32:before {\n  content: \"\\ea1e\";\n}\n\n.now-ui-icons.business_chart-pie-36:before {\n  content: \"\\ea1f\";\n}\n\n.now-ui-icons.business_globe:before {\n  content: \"\\ea2f\";\n}\n\n.now-ui-icons.business_money-coins:before {\n  content: \"\\ea40\";\n}\n\n.now-ui-icons.clothes_tie-bow:before {\n  content: \"\\ea5b\";\n}\n\n.now-ui-icons.design_vector:before {\n  content: \"\\ea61\";\n}\n\n.now-ui-icons.design_app:before {\n  content: \"\\ea08\";\n}\n\n.now-ui-icons.design_bullet-list-67:before {\n  content: \"\\ea14\";\n}\n\n.now-ui-icons.design_image:before {\n  content: \"\\ea33\";\n}\n\n.now-ui-icons.design_palette:before {\n  content: \"\\ea41\";\n}\n\n.now-ui-icons.design_scissors:before {\n  content: \"\\ea4a\";\n}\n\n.now-ui-icons.design-2_html5:before {\n  content: \"\\ea32\";\n}\n\n.now-ui-icons.design-2_ruler-pencil:before {\n  content: \"\\ea48\";\n}\n\n.now-ui-icons.emoticons_satisfied:before {\n  content: \"\\ea49\";\n}\n\n.now-ui-icons.files_box:before {\n  content: \"\\ea12\";\n}\n\n.now-ui-icons.files_paper:before {\n  content: \"\\ea43\";\n}\n\n.now-ui-icons.files_single-copy-04:before {\n  content: \"\\ea52\";\n}\n\n.now-ui-icons.health_ambulance:before {\n  content: \"\\ea07\";\n}\n\n.now-ui-icons.loader_gear:before {\n  content: \"\\ea4e\";\n}\n\n.now-ui-icons.loader_refresh:before {\n  content: \"\\ea44\";\n}\n\n.now-ui-icons.location_bookmark:before {\n  content: \"\\ea10\";\n}\n\n.now-ui-icons.location_compass-05:before {\n  content: \"\\ea25\";\n}\n\n.now-ui-icons.location_map-big:before {\n  content: \"\\ea3d\";\n}\n\n.now-ui-icons.location_pin:before {\n  content: \"\\ea47\";\n}\n\n.now-ui-icons.location_world:before {\n  content: \"\\ea63\";\n}\n\n.now-ui-icons.media-1_album:before {\n  content: \"\\ea02\";\n}\n\n.now-ui-icons.media-1_button-pause:before {\n  content: \"\\ea16\";\n}\n\n.now-ui-icons.media-1_button-play:before {\n  content: \"\\ea18\";\n}\n\n.now-ui-icons.media-1_button-power:before {\n  content: \"\\ea19\";\n}\n\n.now-ui-icons.media-1_camera-compact:before {\n  content: \"\\ea1c\";\n}\n\n.now-ui-icons.media-2_note-03:before {\n  content: \"\\ea3f\";\n}\n\n.now-ui-icons.media-2_sound-wave:before {\n  content: \"\\ea57\";\n}\n\n.now-ui-icons.objects_diamond:before {\n  content: \"\\ea29\";\n}\n\n.now-ui-icons.objects_globe:before {\n  content: \"\\ea2f\";\n}\n\n.now-ui-icons.objects_key-25:before {\n  content: \"\\ea38\";\n}\n\n.now-ui-icons.objects_planet:before {\n  content: \"\\ea46\";\n}\n\n.now-ui-icons.objects_spaceship:before {\n  content: \"\\ea55\";\n}\n\n.now-ui-icons.objects_support-17:before {\n  content: \"\\ea56\";\n}\n\n.now-ui-icons.objects_umbrella-13:before {\n  content: \"\\ea5f\";\n}\n\n.now-ui-icons.education_agenda-bookmark:before {\n  content: \"\\ea01\";\n}\n\n.now-ui-icons.education_atom:before {\n  content: \"\\ea0c\";\n}\n\n.now-ui-icons.education_glasses:before {\n  content: \"\\ea2d\";\n}\n\n.now-ui-icons.education_hat:before {\n  content: \"\\ea30\";\n}\n\n.now-ui-icons.education_paper:before {\n  content: \"\\ea42\";\n}\n\n.now-ui-icons.shopping_bag-16:before {\n  content: \"\\ea0d\";\n}\n\n.now-ui-icons.shopping_basket:before {\n  content: \"\\ea0b\";\n}\n\n.now-ui-icons.shopping_box:before {\n  content: \"\\ea11\";\n}\n\n.now-ui-icons.shopping_cart-simple:before {\n  content: \"\\ea1d\";\n}\n\n.now-ui-icons.shopping_credit-card:before {\n  content: \"\\ea28\";\n}\n\n.now-ui-icons.shopping_delivery-fast:before {\n  content: \"\\ea27\";\n}\n\n.now-ui-icons.shopping_shop:before {\n  content: \"\\ea50\";\n}\n\n.now-ui-icons.shopping_tag-content:before {\n  content: \"\\ea59\";\n}\n\n.now-ui-icons.sport_trophy:before {\n  content: \"\\ea5d\";\n}\n\n.now-ui-icons.sport_user-run:before {\n  content: \"\\ea60\";\n}\n\n.now-ui-icons.tech_controller-modern:before {\n  content: \"\\ea26\";\n}\n\n.now-ui-icons.tech_headphones:before {\n  content: \"\\ea31\";\n}\n\n.now-ui-icons.tech_laptop:before {\n  content: \"\\ea36\";\n}\n\n.now-ui-icons.tech_mobile:before {\n  content: \"\\ea3e\";\n}\n\n.now-ui-icons.tech_tablet:before {\n  content: \"\\ea58\";\n}\n\n.now-ui-icons.tech_tv:before {\n  content: \"\\ea5e\";\n}\n\n.now-ui-icons.tech_watch-time:before {\n  content: \"\\ea62\";\n}\n\n.now-ui-icons.text_align-center:before {\n  content: \"\\ea05\";\n}\n\n.now-ui-icons.text_align-left:before {\n  content: \"\\ea06\";\n}\n\n.now-ui-icons.text_bold:before {\n  content: \"\\ea0e\";\n}\n\n.now-ui-icons.text_caps-small:before {\n  content: \"\\ea1b\";\n}\n\n.now-ui-icons.gestures_tap-01:before {\n  content: \"\\ea5a\";\n}\n\n.now-ui-icons.transportation_air-baloon:before {\n  content: \"\\ea03\";\n}\n\n.now-ui-icons.transportation_bus-front-12:before {\n  content: \"\\ea17\";\n}\n\n.now-ui-icons.travel_info:before {\n  content: \"\\ea04\";\n}\n\n.now-ui-icons.travel_istanbul:before {\n  content: \"\\ea34\";\n}\n\n.now-ui-icons.ui-1_bell-53:before {\n  content: \"\\ea0f\";\n}\n\n.now-ui-icons.ui-1_calendar-60:before {\n  content: \"\\ea1a\";\n}\n\n.now-ui-icons.ui-1_lock-circle-open:before {\n  content: \"\\ea35\";\n}\n\n.now-ui-icons.ui-1_send:before {\n  content: \"\\ea4d\";\n}\n\n.now-ui-icons.ui-1_settings-gear-63:before {\n  content: \"\\ea4e\";\n}\n\n.now-ui-icons.ui-1_simple-add:before {\n  content: \"\\ea4f\";\n}\n\n.now-ui-icons.ui-1_simple-delete:before {\n  content: \"\\ea54\";\n}\n\n.now-ui-icons.ui-1_simple-remove:before {\n  content: \"\\ea53\";\n}\n\n.now-ui-icons.ui-1_zoom-bold:before {\n  content: \"\\ea64\";\n}\n\n.now-ui-icons.ui-2_chat-round:before {\n  content: \"\\ea20\";\n}\n\n.now-ui-icons.ui-2_favourite-28:before {\n  content: \"\\ea2b\";\n}\n\n.now-ui-icons.ui-2_like:before {\n  content: \"\\ea37\";\n}\n\n.now-ui-icons.ui-2_settings-90:before {\n  content: \"\\ea4b\";\n}\n\n.now-ui-icons.ui-2_time-alarm:before {\n  content: \"\\ea5c\";\n}\n\n.now-ui-icons.users_circle-08:before {\n  content: \"\\ea23\";\n}\n\n.now-ui-icons.users_single-02:before {\n  content: \"\\ea51\";\n}\n\n.all-icons .font-icon-detail {\n    text-align: center;\n    padding: 45px 0px 30px;\n    border: 1px solid #e5e5e5;\n    border-radius: 0.1875rem;\n    margin: 15px 0;\n    min-height: 168px;\n}\n\n.all-icons [class*=\"now-ui-icons\"] {\n    font-size: 32px;\n}\n\n.all-icons .font-icon-detail p {\n    margin: 25px auto 0;\n    width: 100%;\n    text-align: center;\n    display: block;\n    color: #B8B8B8;\n    padding:0 10px;\n    font-size: 0.7142em;\n}\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\n.alert{\n    border: 0;\n    border-radius: 0;\n    color: $white-color;\n    padding-top: .9rem;\n    padding-bottom: .9rem;\n\n    .alert-link{\n      color: $white-color;\n      opacity: .8;\n    }\n\n    &.alert-success{\n        background-color: $success-color-alert;\n    }\n\n    &.alert-danger{\n        background-color: $danger-color-alert;\n    }\n\n    &.alert-warning{\n        background-color: $warning-color-alert;\n    }\n\n    &.alert-info{\n        background-color: $info-color-alert;\n    }\n\n    &.alert-primary{\n        background-color: $primary-color-alert;\n    }\n\n    .alert-icon{\n        display: block;\n        float: left;\n        margin-right: 15px;\n        margin-top: -1px;\n    }\n\n    strong{\n        text-transform: uppercase;\n        font-size: 12px;\n    }\n\n    i.fa,\n    i.now-ui-icons{\n        font-size: 20px;\n    }\n\n    .close{\n        color: $white-color;\n        opacity: .9;\n        text-shadow: none;\n        line-height: 0;\n        outline: 0;\n        display: inline-block;\n        cursor: pointer;\n\n    }\n}\n",".form-check{\n margin-top: .65rem;\n padding-left: 0;\n}\n\n.form-check .form-check-label{\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  padding-left: 35px;\n  line-height: 26px;\n  margin-bottom: 0;\n  -webkit-transition: color 0.3s linear;\n  -moz-transition: color 0.3s linear;\n  -o-transition: color 0.3s linear;\n  -ms-transition: color 0.3s linear;\n  transition: color 0.3s linear;\n}\n.radio .form-check-sign{\n    padding-left: 28px;\n}\n\n.form-check .form-check-sign::before,\n.form-check .form-check-sign::after{\n  content: \" \";\n  display: inline-block;\n  position: absolute;\n  width: 26px;\n  height: 26px;\n  left: 0;\n  cursor: pointer;\n  border-radius: 3px;\n  top: 0;\n  background-color: transparent;\n  border: 1px solid $light-gray;\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n\n .form-check .form-check-sign::after{\n  font-family: 'Nucleo Outline';\n  content: \"\\ea22\";\n  top: 0px;\n  text-align: center;\n  font-size: 14px;\n  opacity: 0;\n  color: $dark-background;\n  border: 0;\n  background-color: inherit;\n}\n\n.form-check.disabled .form-check-label,\n.form-check.disabled .form-check-label {\n    color: $dark-gray;\n    opacity: .5;\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.radio input[type=\"radio\"]{\n  opacity: 0;\n  position: absolute;\n  visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n  opacity: 1;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none;\n}\n\n.form-check-radio .form-check-sign::before,\n.form-check-radio .form-check-sign::after{\n  content: \" \";\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 1px solid $light-gray;\n  display: inline-block;\n  position: absolute;\n  left: 3px;\n  top: 3px;\n  padding: 1px;\n  -webkit-transition: opacity 0.3s linear;\n  -moz-transition: opacity 0.3s linear;\n  -o-transition: opacity 0.3s linear;\n  -ms-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n}\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    width: 4px;\n    height: 4px;\n    background-color: $dark-background;\n    border-color: $dark-background;\n    top: 11px;\n    left: 11px;\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\n  color: $dark-gray;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n  color: $dark-gray;\n}\n","/*           badges             */\n.badge{\n    border-radius: 8px;\n    padding: 4px 8px;\n    text-transform: uppercase;\n    font-size: $font-size-mini;\n    line-height: 12px;\n    background-color: $transparent-bg;\n    border: $border;\n    margin-bottom: 5px;\n    color: $white-color;\n    border-radius: $border-radius-extreme;\n\n    &:hover,\n    &:focus{\n      text-decoration: none;\n    }\n\n}\n.badge-icon{\n    padding: 0.4em 0.55em;\n    i{\n       font-size: 0.8em;\n    }\n}\n.badge-default{\n    @include badge-color($default-color);\n}\n.badge-primary{\n    @include badge-color($primary-color);\n}\n.badge-info{\n    @include badge-color($info-color);\n}\n.badge-success{\n    @include badge-color($success-color);\n}\n.badge-warning{\n    @include badge-color($warning-color);\n}\n.badge-danger{\n    @include badge-color($danger-color);\n}\n.badge-neutral{\n    @include badge-color($white-color);\n    color: inherit !important;\n}\n","@mixin badge-color($color) {\n\n    &,\n    &[href]:focus,\n    &[href]:hover{\n      border-color: $color;\n      background-color: $color;\n      color: $white-color;\n    }\n}\n",".pagination{\n\n    .page-item .page-link{\n        border: 0;\n        border-radius: 30px !important;\n        transition: all .3s;\n        padding: 0px 11px;\n        margin: 0 3px;\n        min-width: 30px;\n        text-align: center;\n        box-shadow: none;\n        height: 30px;\n        line-height: 30px;\n        color: $black-color;\n        cursor: pointer;\n        font-size: $font-size-base;\n        text-transform: uppercase;\n        background: transparent;\n\n        &:hover,\n        &:focus{\n            color: $black-color;\n            background-color: $opacity-gray-3;\n            border: none;\n        }\n    }\n\n    .arrow-margin-left,\n    .arrow-margin-right{\n        position: absolute;\n    }\n\n    .arrow-margin-right{\n        right: 0;\n    }\n\n    .arrow-margin-left{\n        left: 0;\n    }\n\n    .page-item.active > .page-link{\n        color: $light-gray;\n        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n\n        &,\n        &:focus,\n        &:hover{\n            background-color: $default-color;\n            border-color: $default-color;\n            color: $white-color;\n        }\n    }\n\n    .page-item.disabled > .page-link{\n        opacity: .5;\n        background-color: rgba(255,255,255, .2);\n        color: $white-color;\n    }\n\n    // Colors\n    &.pagination-info{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-info;\n                border-color: $brand-info;\n            }\n        }\n    }\n\n    &.pagination-success{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-success;\n                border-color: $brand-success;\n            }\n        }\n    }\n\n    &.pagination-primary{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-primary;\n                border-color: $brand-primary;\n            }\n        }\n    }\n\n    &.pagination-warning{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-warning;\n                border-color: $brand-warning;\n            }\n        }\n    }\n\n    &.pagination-danger{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-danger;\n                border-color: $brand-danger;\n            }\n        }\n    }\n\n    &.pagination-neutral{\n        .page-item > .page-link{\n            color: $white-color;\n\n            &:focus,\n            &:hover{\n                background-color: $opacity-2;\n                color: $white-color;\n            }\n        }\n\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $white-bg;\n                border-color: $white-bg;\n                color: $brand-primary;\n            }\n        }\n    }\n\n}\n\n.pagination-container{\n    display: flex;\n    align-items: center;\n}\n","button,\ninput,\noptgroup,\nselect,\ntextarea{\n    font-family: $sans-serif-family;\n}\nh1,h2,h3,h4,h5,h6{\n    font-weight: $font-weight-normal;\n}\n\nsmall{\n    font-size: 60%;\n}\n\na{\n    color: $primary-color;\n    &:hover,\n    &:focus{\n        color: $primary-color;\n    }\n}\nh1, .h1 {\n    font-size: $font-size-h1;\n    line-height: 1.15;\n    margin-bottom: $margin-base-vertical * 2;\n\n    small{\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        opacity: .8;\n    }\n}\nh2, .h2{\n    font-size: $font-size-h2;\n    margin-bottom: $margin-base-vertical * 2;\n}\nh3, .h3{\n    font-size: $font-size-h3;\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.4em;\n}\nh4, .h4{\n    font-size: $font-size-h4;\n    line-height: 1.45em;\n    margin-top: $margin-base-vertical * 2;\n    margin-bottom: $margin-base-vertical;\n\n    & + .category,\n    &.title + .category{\n        margin-top: -5px;\n    }\n}\nh5, .h5 {\n    font-size: $font-size-h5;\n    line-height: 1.4em;\n    margin-bottom: 15px;\n\n    &.category{\n        font-weight: 400;\n    }\n}\nh6, .h6{\n    font-size: $font-size-h6;\n    font-weight: $font-weight-bold;\n    text-transform: uppercase;\n}\np{\n    line-height: 1.61em;\n    font-weight: 300;\n    font-size: 1.2em;\n}\n\n.title{\n    font-weight: $font-weight-bold;\n    padding-top: 30px;\n\n\n    &.title-up{\n        text-transform: uppercase;\n\n        a{\n            color: $black-color;\n            text-decoration: none;\n        }\n    }\n    & + .category{\n        margin-top: -25px;\n    }\n}\n\n.description,\n.card-description,\n.footer-big p{\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n}\n.category{\n    text-transform: capitalize;\n    font-weight: $font-weight-bold;\n    color: $dark-gray;\n}\n.text-primary {\n  color: $brand-primary !important;\n}\n.text-info {\n  color: $brand-info !important;\n}\n.text-success {\n  color: $brand-success !important;\n}\n.text-warning {\n  color: $brand-warning !important;\n}\n.text-danger {\n  color: $brand-danger !important;\n}\n.text-black{\n  color: $light-black;\n}\n\n.blockquote{\n    border-left: none;\n    border: 1px solid $default-color;\n    padding: 20px;\n    font-size: $font-size-blockquote;\n    line-height: 1.8;\n\n    small{\n        color: $default-color;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n    }\n\n    &.blockquote-primary{\n        border-color: $primary-color;\n        color: $primary-color;\n\n        small{\n            color: $primary-color;\n        }\n    }\n\n    &.blockquote-danger{\n        border-color: $danger-color;\n        color: $danger-color;\n\n        small{\n            color: $danger-color;\n        }\n    }\n\n    &.blockquote-white{\n        border-color: $opacity-8;\n        color: $white-color;\n\n        small{\n            color: $opacity-8;\n        }\n    }\n}\n","body{\n    color: $black-color;\n    font-size: $font-size-base;\n    font-family: $sans-serif-family;\n    overflow-x: hidden;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n}\n\n.main{\n    position: relative;\n    background: $white-color;\n}\n/* Animations */\n.nav-pills .nav-link,\n.nav-item .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.tag,\n.tag [data-role=\"remove\"]{\n    @include transition($general-transition-time, $transition-ease);\n}\n\n//transition for dropdown caret\n.card a,\n.bootstrap-switch-label:before{\n    @include transition($fast-transition-time, $transition-ease);\n}\n\n.dropdown-toggle:after,\n[data-toggle=\"collapse\"][data-parent=\"#accordion\"] i{\n  @include transition-on-prop(transform, $fast-transition-time, $transition-ease);\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\n[data-toggle=\"collapse\"][data-parent=\"#accordion\"][aria-expanded=\"true\"] i{\n    @include rotate-180();\n}\n\n.button-bar{\n    display: block;\n    position: relative;\n    width: 22px;\n    height: 1px;\n    border-radius: 1px;\n    background: $white-bg;\n\n    & + .button-bar{\n        margin-top: 7px;\n    }\n\n    &:nth-child(2){\n        width: 17px;\n    }\n}\n\n.separator-line{\n    height: 2px;\n    width: 44px;\n    background-color: $default-color;\n    margin: 20px auto;\n\n    &.separator-primary{\n        background-color: $primary-color;\n    }\n}\n\n.section-space{\n    height: 62px;\n    display: block;\n}\n\n.pull-left{\n  float: left;\n}\n.pull-right{\n  float: right;\n}\n\n.title-up{\n  text-transform: uppercase;\n}\n",".btn,\n.navbar .navbar-nav > a.btn{\n    border-width: $border-thick;\n    font-weight: $font-weight-normal;\n    font-size: $font-size-small;\n    line-height: $line-height;\n    margin: 10px 1px;\n    border: none;\n    border-radius: $border-radius-small;\n    padding: $padding-btn-vertical $padding-btn-horizontal;\n    cursor: pointer;\n\n    @include btn-styles($default-color, $default-states-color);\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    &.btn-icon {\n        // see above for color variations\n        height: $btn-icon-size-regular;\n        min-width: $btn-icon-size-regular;\n        width: $btn-icon-size-regular;\n        padding: 0;\n        font-size: $btn-icon-font-size-regular;\n        overflow: hidden;\n        position: relative;\n        line-height: normal;\n\n        &[class*=\"btn-outline-\"]{\n            padding: 0;\n        }\n\n        &.btn-sm{\n            height: $btn-icon-size-small;\n            min-width: $btn-icon-size-small;\n            width: $btn-icon-size-small;\n\n            i.fab,\n            i.now-ui-icons{\n                font-size: $btn-icon-font-size-small;\n            }\n        }\n\n        &.btn-lg{\n            height: $btn-icon-size-lg;\n            min-width: $btn-icon-size-lg;\n            width: $btn-icon-size-lg;\n\n            i.now-ui-icons,\n            i.fab{\n                font-size: $btn-icon-font-size-lg;\n            }\n        }\n\n        &:not(.btn-footer) i.now-ui-icons,\n        &:not(.btn-footer) i.fab{\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-12px, -12px);\n            line-height: 1.5626rem;\n            width: 23px;\n        }\n\n    }\n\n    &:not(.btn-icon) .now-ui-icons{\n        position: relative;\n        top: 1px;\n    }\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary { @include btn-styles($primary-color, $primary-states-color); }\n.btn-success { @include btn-styles($success-color, $success-states-color); }\n.btn-info    { @include btn-styles($info-color, $info-states-color); }\n.btn-warning { @include btn-styles($warning-color, $warning-states-color); }\n.btn-danger  { @include btn-styles($danger-color, $danger-states-color); }\n.btn-neutral { @include btn-styles($white-color, $white-color); }\n\n.btn-outline-primary { @include outline-buttons($primary-color, $primary-states-color); }\n.btn-outline-success { @include outline-buttons($success-color, $success-states-color); }\n.btn-outline-info    { @include outline-buttons($info-color, $info-states-color); }\n.btn-outline-warning { @include outline-buttons($warning-color, $warning-states-color); }\n.btn-outline-danger  { @include outline-buttons($danger-color, $danger-states-color); }\n.btn-outline-default { @include outline-buttons($default-color, $default-states-color); }\n\n.btn-round{\n    border-width: $border-thin;\n    border-radius: $btn-round-radius !important;\n    padding: $padding-btn-vertical  $padding-round-horizontal;\n\n    &[class*=\"btn-outline-\"]{\n        padding: $padding-btn-vertical - 1  $padding-round-horizontal - 1;\n    }\n}\n[class*=\"btn-outline-\"]{\n    border: $border;\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\n    background-color: $transparent-bg;\n}\n\n[class*=\"btn-outline-\"],\n.btn-link{\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $transparent-bg;\n        }\n    }\n}\n\n.btn-lg{\n   @include btn-size($padding-large-vertical, $padding-large-horizontal, $font-size-large, $border-radius-large);\n}\n.btn-sm{\n    @include btn-size($padding-small-vertical, $padding-small-horizontal, $font-size-base, $border-radius-small);\n}\n\n.btn-link{\n    border: $none;\n    padding: $padding-base-vertical $padding-base-horizontal;\n    background-color: $transparent-bg;\n}\n\n.btn-wd {\n    min-width: 140px;\n}\n.btn-group.select{\n    width: 100%;\n}\n.btn-group.select .btn{\n    text-align: left;\n}\n.btn-group.select .caret{\n    position: absolute;\n    top: 50%;\n    margin-top: -1px;\n    right: 8px;\n}\n\n// .btn-facebook {\n//   &,\n//   &:hover,\n//   &focus,\n//   &:active,\n//   &:active:focus {\n//     color: $social-facebook !important;\n//   }\n// }\n//\n// .btn-twitter {\n//\n//   &,\n//   &:hover,\n//   &focus,\n//   &:active,\n//   &:active:focus {\n//     color: $social-twitter !important;\n//   }\n// }\n//\n// .btn-google {\n//   &,\n//   &:hover,\n//   &focus,\n//   &:active,\n//   &:active:focus {\n//     color: $social-google !important;\n//   }\n// }\n//\n// .btn-github {\n//   &,\n//   &:hover,\n//   &focus,\n//   &:active,\n//   &:active:focus {\n//     color: $social-github !important;\n//   }\n// }\n//\n// .btn-linkedin {\n//   &,\n//   &:hover,\n//   &focus,\n//   &:active,\n//   &:active:focus {\n//     color: $social-linkedin !important;\n//   }\n// }\n","// Mixin for generating new styles\n@mixin btn-styles($btn-color, $btn-states-color) {\n    background-color: $btn-color;\n\n\n\n    &:hover,\n    &:focus,\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:active:hover,\n    &.active:hover,\n    .show > &.dropdown-toggle,\n    .show > &.dropdown-toggle:focus,\n    .show > &.dropdown-toggle:hover {\n        background-color: $btn-states-color;\n        color: $white-color;\n        box-shadow: none;\n    }\n\n    &:hover{\n        box-shadow:  0 3px 8px 0 rgba(0,0,0, 0.17);\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $btn-color;\n            border-color: $btn-color;\n        }\n    }\n\n    // btn-neutral style\n    @if $btn-color == $white-color{\n        color: $primary-color;\n\n\n        &.btn-danger{\n            color: $danger-color;\n\n            &:hover,\n            &:focus,\n            &:active{\n                color: $danger-states-color !important;\n            }\n        }\n\n        &.btn-primary{\n            color: $primary-color;\n\n            &:hover,\n            &:focus,\n            &:active{\n                color: $primary-states-color !important;\n            }\n        }\n\n        &.btn-info{\n            color: $info-color;\n\n            &:hover,\n            &:focus,\n            &:active{\n                color: $info-states-color !important;\n            }\n        }\n\n        &.btn-warning{\n            color: $warning-color;\n\n            &:hover,\n            &:focus,\n            &:active{\n                color: $warning-states-color !important;\n            }\n        }\n\n        &.btn-success{\n            color: $success-color;\n\n            &:hover,\n            &:focus,\n            &:active{\n                color: $success-states-color !important;\n            }\n        }\n\n        &.btn-default{\n            color: $default-color;\n\n            &:hover,\n            &:focus,\n            &:active{\n                color: $default-states-color !important;\n            }\n        }\n\n        &:hover,\n        &:focus,\n        &:not(:disabled):not(.disabled):active,\n        &:not(:disabled):not(.disabled).active,\n        &:not(:disabled):not(.disabled):active:focus,\n        &:not(:disabled):not(.disabled).active:focus,\n        &:active:hover,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover {\n            background-color: $white-color;\n            color: $primary-states-color;\n            box-shadow: none;\n        }\n\n        &:hover,\n        &:focus{\n            color: $primary-states-color !important;\n\n            &:not(.nav-link){\n                box-shadow: none;\n            }\n\n        }\n\n    } @else {\n        color: $white-color;\n    }\n\n    &.btn-simple{\n        color: $btn-color;\n        border-color: $btn-color;\n\n        &:hover,\n        &:focus,\n        &:not(:disabled):not(.disabled):active,\n        &:not(:disabled):not(.disabled).active,\n        &:not(:disabled):not(.disabled):active:focus,\n        &:not(:disabled):not(.disabled).active:focus,\n        &:active:hover,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover{\n            background-color: $transparent-bg;\n            color: $btn-states-color;\n            border-color: $btn-states-color;\n            box-shadow: none;\n        }\n    }\n\n    &.btn-link{\n        color: $btn-color;\n\n        &:hover,\n        &:focus,\n        &:not(:disabled):not(.disabled):active,\n        &:not(:disabled):not(.disabled).active,\n        &:not(:disabled):not(.disabled):active:focus,\n        &:not(:disabled):not(.disabled).active:focus,\n        &:active:hover,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover{\n            background-color: $transparent-bg;\n            color: $btn-states-color;\n            text-decoration: none;\n            box-shadow: none;\n        }\n    }\n}\n\n@mixin outline-buttons($btn-color, $btn-states-color) {\n  color: $btn-color;\n  border-color: $btn-color;\n\n  &:hover,\n  &:focus,\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active:focus,\n  &:not(:disabled):not(.disabled).active:focus,\n  &:active:hover,\n  &.active:hover,\n  .show > &.dropdown-toggle,\n  .show > &.dropdown-toggle:focus,\n  .show > &.dropdown-toggle:hover {\n      background-color: $transparent-bg;\n      color: $btn-states-color;\n      border-color: $btn-states-color;\n      box-shadow: none;\n  }\n}\n\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &[class*=\"btn-outline-\"] {\n    padding: $padding-vertical - 1 $padding-horizontal - 1;\n   }\n\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n",".btn{\n  // social buttons\n  &.btn-facebook {\n    @include social-buttons-color($social-facebook, $social-facebook-state-color);\n  }\n  &.btn-twitter {\n    @include social-buttons-color($social-twitter, $social-twitter-state-color);\n  }\n  &.btn-pinterest {\n    @include social-buttons-color($social-pinterest, $social-pinterest-state-color);\n  }\n  &.btn-google {\n    @include social-buttons-color($social-google, $social-google-state-color);\n  }\n  &.btn-linkedin {\n    @include social-buttons-color($social-linkedin, $social-linkedin-state-color);\n  }\n  &.btn-dribbble {\n    @include social-buttons-color($social-dribbble, $social-dribbble-state-color);\n  }\n  &.btn-github {\n    @include social-buttons-color($social-github, $social-github-state-color);\n  }\n  &.btn-youtube {\n    @include social-buttons-color($social-youtube, $social-youtube-state-color);\n  }\n  &.btn-instagram {\n    @include social-buttons-color($social-instagram, $social-instagram-state-color);\n  }\n  &.btn-reddit {\n    @include social-buttons-color($social-reddit, $social-reddit-state-color);\n  }\n  &.btn-tumblr {\n    @include social-buttons-color($social-tumblr, $social-tumblr-state-color);\n  }\n  &.btn-behance {\n    @include social-buttons-color($social-behance, $social-behance-state-color);\n  }\n}\n","// for social buttons\n@mixin social-buttons-color ($color, $state-color){\n    background-color: $color;\n    color: #fff;\n\n    &:hover,\n    &:focus,\n    &:not(:disabled):not(.disabled):active,\n    &:not(:disabled):not(.disabled).active,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:active:hover,\n    &.active:hover,\n    .show > &.dropdown-toggle,\n    .show > &.dropdown-toggle:focus,\n    .show > &.dropdown-toggle:hover{\n        background-color: $state-color;\n        color: #fff;\n    }\n\n    &.btn-simple{\n        color: $color;\n        box-shadow: none;\n        background-color: $transparent-bg;\n        border-color: $color;\n\n        &:hover,\n        &:focus,\n        &:not(:disabled):not(.disabled):active,\n        &:not(:disabled):not(.disabled).active,\n        &:not(:disabled):not(.disabled):active:focus,\n        &:not(:disabled):not(.disabled).active:focus,\n        &:active:hover,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover{\n            color: $state-color;\n            border-color: $state-color;\n            background-color: $transparent-bg;\n        }\n    }\n\n    &.btn-neutral{\n        color: $color;\n        background-color: $white-color;\n\n\n        &:hover,\n        &:focus,\n        &:not(:disabled):not(.disabled):active,\n        &:not(:disabled):not(.disabled).active,\n        &:not(:disabled):not(.disabled):active:focus,\n        &:not(:disabled):not(.disabled).active:focus,\n        &:active:hover,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover{\n            color: $state-color;\n            background-color: $white-color;\n        }\n    }\n}\n","@mixin input-size($padding-vertical, $padding-horizontal){\n    padding: $padding-vertical $padding-horizontal;\n}\n\n@mixin form-control-placeholder($color, $opacity){\n   .form-control::-moz-placeholder{\n       color: $color;\n       @include opacity($opacity);\n   }\n   .form-control:-moz-placeholder{\n       color: $color;\n       @include opacity($opacity);\n   }\n   .form-control::-webkit-input-placeholder{\n       color: $color;\n       @include opacity($opacity);\n   }\n   .form-control:-ms-input-placeholder{\n       color: $color;\n       @include opacity($opacity);\n   }\n}\n\n@mixin light-form(){\n    border-radius: 0;\n    border:0;\n    padding: 0;\n    background-color: transparent;\n\n}\n\n\n@mixin input-lg-padding($padding-vertical, $padding-horizontal) {\n    .form-group.no-border.input-lg,\n    .input-group.no-border.input-lg{\n        .input-group-text{\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n        }\n\n        .form-control{\n            padding: $padding-vertical $padding-horizontal;\n\n            & + .input-group-text{\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n            }\n        }\n    }\n\n    .form-group.input-lg,\n    .input-group.input-lg{\n        .form-control{\n            padding: $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .input-group-text{\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\n            }\n        }\n\n        .input-group-text{\n            padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\n\n            & + .form-control{\n                padding: $padding-vertical  $padding-horizontal - 1 $padding-vertical $padding-horizontal - 3;\n            }\n        }\n    }\n}\n\n\n\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\n    .form-group.no-border,\n    .input-group.no-border{\n        .form-control{\n            padding: $padding-vertical $padding-horizontal;\n\n            & + .input-group-text{\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n            }\n        }\n\n        .input-group-text{\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n        }\n    }\n\n    .form-group,\n    .input-group{\n        .form-control{\n            padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .input-group-text{\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\n            }\n        }\n\n        .input-group-text{\n            padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal - 1;\n\n            & + .form-control,\n            & ~ .form-control{\n                padding:$padding-vertical - 1 $padding-horizontal $padding-vertical $padding-horizontal - 3;\n            }\n        }\n    }\n}\n\n\n//color1 = $opacity-5\n//color2 = $opacity-8\n//color3 = $white-color\n//color4 = $transparent-bg\n//color5 = $opacity-1\n//color6 = $opacity-2\n\n\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\n    @include form-control-placeholder(darken($color2, 8%), 1);\n\n    .form-control{\n        border-color: $color1;\n        color: $color2;\n\n        &:focus{\n            border-color: $color3;\n            background-color: $color4;\n            color: $color3;\n        }\n    }\n\n    .has-success,\n    .has-danger{\n        &:after{\n            color: $color3;\n        }\n    }\n\n    .has-danger{\n        .form-control{\n            background-color: $color4;\n        }\n    }\n\n    .input-group-text{\n        background-color: $color4;\n        border-color: $color1;\n        color: $color2;\n    }\n\n    .input-group-focus{\n        .input-group-text{\n            background-color: $color4;\n            border-color: $color3;\n            color: $color3;\n        }\n    }\n\n    .form-group.no-border,\n    .input-group.no-border{\n        .form-control{\n            background-color: $color5;\n            color: $color2;\n\n            &:focus,\n            &:active,\n            &:active{\n                background-color: $color6;\n                color: $color3;\n            }\n        }\n\n        .form-control + .input-group-text{\n            background-color: $color5;\n\n            &:focus,\n            &:active,\n            &:active{\n                background-color: $color6;\n                color: $color3;\n            }\n        }\n\n        .form-control{\n            &:focus{\n                & + .input-group-text{\n                    background-color: $color6;\n                    color: $color3;\n                }\n            }\n        }\n\n        .input-group-text{\n            background-color: $color5;\n            border: none;\n            color: $color2;\n        }\n\n        &.input-group-focus{\n            .input-group-text{\n                background-color: $color6;\n                color: $color3;\n            }\n        }\n    }\n}\n","@include form-control-placeholder($default-color, .8);\n\n.form-control {\n    background-color: $transparent-bg;\n    border: 1px solid $light-gray;\n    border-radius: $btn-round-radius;\n    color: $black-color;\n    height: auto;\n    line-height: normal;\n    font-size: $font-size-small;\n    @include transition-input-focus-color();\n    @include box-shadow(none);\n\n    .has-success &{\n        border-color: $light-gray;\n    }\n\n    &:focus{\n        border: 1px solid $primary-color;\n        @include box-shadow(none);\n        outline: 0 !important;\n        color: $black-color;\n\n        & + .input-group-text,\n        & ~ .input-group-text{\n            border: 1px solid $primary-color;\n            border-left: none;\n            background-color: $transparent-bg;\n        }\n    }\n\n    .has-success &,\n    .has-error &,\n    .has-success &:focus,\n    .has-error &:focus{\n        @include box-shadow(none);\n    }\n\n    .has-success &:focus{\n        border-color: lighten($success-color, 5%);\n    }\n\n\n    .has-danger &,\n    .has-success &{\n        &.form-control-success,\n        &.form-control-danger{\n            background-image: none;\n        }\n    }\n\n    .has-danger &{\n        border-color: lighten($danger-color, 30%);\n        color: $danger-color;\n        background-color: rgba(222,222,222, .1);\n\n        &:focus{\n            background-color: $white-color;\n        }\n    }\n\n    & + .form-control-feedback{\n        border-radius: $border-radius-large;\n        font-size: $font-size-base;\n        margin-top: -7px;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        vertical-align: middle;\n    }\n\n    .open &{\n        border-radius: $border-radius-large $border-radius-large 0 0;\n        border-bottom-color: transparent;\n    }\n\n    // & + .input-group-text{\n    //     background-color: $white-bg;\n    // }\n}\n\n.has-success,\n.has-danger{\n    &:after{\n        font-family: 'Nucleo Outline';\n        content: \"\\ea22\";\n        display: inline-block;\n        position: absolute;\n        right: 20px;\n        top: 12px;\n        color: $success-color;\n        font-size: 11px;\n    }\n\n    &.input-lg{\n        &:after{\n            font-size: 13px;\n            top: 13px;\n        }\n    }\n}\n\n.has-danger{\n    &:after{\n        content: \"\\ea53\";\n        color: $danger-color;\n    }\n}\n\n@include input-lg-padding($padding-large-vertical, $padding-input-horizontal);\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\n\n.form-group.no-border,\n.input-group.no-border{\n    .form-control,\n    .form-control + .input-group-text{\n        background-color: $opacity-gray-3;\n        border: medium none;\n        &:focus,\n        &:active,\n        &:active{\n            border: medium none;\n            background-color: $opacity-gray-5;\n        }\n    }\n\n    .form-control{\n        &:focus{\n            & + .input-group-text{\n                background-color: $opacity-gray-5;\n            }\n        }\n    }\n    .input-group-prepend{\n      .input-group-text{\n          background-color: $opacity-gray-3;\n          border: none;\n          border-left: transparent !important;\n      }\n    }\n\n    &.input-group-focus{\n        &.no-border{\n            .input-group-text{\n                background-color: $opacity-gray-5;\n            }\n        }\n    }\n}\n\n.has-error{\n    .form-control-feedback, .control-label{\n        color: $danger-color;\n    }\n}\n.has-success{\n    .form-control-feedback, .control-label{\n        color: $success-color;\n    }\n}\n\n.input-group-text {\n    background-color: $white-bg;\n    border: 1px solid $light-gray;\n    border-radius: $btn-round-radius;\n    color: $dark-background;\n\n    @include transition-input-focus-color();\n\n    .input-group-focus &{\n      background-color: $white-bg;\n      border-color: $primary-color;\n    }\n\n    .has-success &,\n    .has-danger &{\n        background-color: $white-color;\n    }\n    .has-danger .form-control:focus + &{\n        color: $danger-color;\n    }\n    .has-success .form-control:focus + &{\n        color: $success-color;\n    }\n\n    & + .form-control,\n    & ~ .form-control{\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\n        padding-left: 18px;\n    }\n\n    i{\n        width: 17px;\n    }\n}\n\n.input-group,\n.form-group{\n    margin-bottom: 10px;\n    position: relative;\n}\n.input-group[disabled]{\n    .input-group-text{\n        background-color: $light-gray;\n    }\n}\n\n.input-group,\n.form-group{\n  .input-group-prepend{\n    margin-right: 0;\n\n    .input-group-text {\n      border-left: 1px solid #E3E3E3;\n    }\n  }\n  .input-group-append .input-group-text {\n    border-right: 1px solid #E3E3E3;\n    padding: 10px 18px 10px 0;\n  }\n\n  &.input-group-focus {\n    .input-group-prepend .input-group-text {\n      border-left: 1px solid #f96332;\n    }\n    .input-group-append .input-group-text {\n      border-right: 1px solid #f96332;\n    }\n    &.no-border{\n      .input-group-prepend .input-group-text{\n        border-left: transparent;\n      }\n    }\n  }\n}\n\n.input-group .form-control:first-child,\n.input-group-text:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-text:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $light-gray;\n    color: $default-color;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-btn-vertical  $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\ntextarea.form-control{\n    max-width: 100%;\n    max-height: 80px;\n    padding: 10px 10px 0 0;\n    resize: none;\n    border: none;\n    border-bottom: 1px solid $light-gray;\n    border-radius: 0;\n    line-height: 2;\n\n    &:focus,\n    &:active{\n        border-left: none;\n        border-top: none;\n        border-right: none;\n    }\n}\n\n.has-success,\n.has-danger{\n\n    &.form-group .form-control,\n    &.form-group.no-border .form-control{\n        padding-right: $padding-input-horizontal + 21;\n    }\n}\n\n.form.form-newsletter .form-group{\n    float: left;\n    width: 78%;\n    margin-right: 2%;\n    margin-top: 9px;\n}\n\n.input-group .input-group-btn{\n    padding: 0 12px;\n}\n\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\n.progress-container{\n    position: relative;\n\n    & + .progress-container,\n    & ~ .progress-container{\n        margin-top: $margin-base-vertical;\n    }\n    .progress-badge{\n        color: $default-color;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n\n    }\n\n    .progress {\n        height: 1px;\n        border-radius: 0;\n        box-shadow: none;\n        background: $opacity-gray-8;\n        margin-top: 14px;\n\n        .progress-bar {\n            box-shadow: none;\n            background-color: $default-color;\n        }\n\n        .progress-value{\n            position: absolute;\n            top: 2px;\n            right: 0;\n            color: $default-color;\n            font-size: $font-size-small;\n        }\n    }\n\n    &.progress-neutral{\n        .progress{\n            background: rgba(255, 255, 255, .3);\n        }\n\n        .progress-bar{\n            background: $white-bg;\n        }\n\n        .progress-value,\n        .progress-badge{\n            color: $white-color;\n        }\n    }\n\n    &.progress-primary{\n        .progress{\n            background: $primary-color-opacity;\n        }\n\n        .progress-bar{\n            background: $brand-primary;\n        }\n\n        .progress-value,\n        .progress-badge{\n            color: $brand-primary;\n        }\n    }\n\n    &.progress-info{\n        .progress{\n            background: $info-color-opacity;\n        }\n\n        .progress-bar{\n            background: $brand-info;\n        }\n\n        .progress-value,\n        .progress-badge{\n            color: $brand-info;\n        }\n    }\n\n    &.progress-success{\n        .progress{\n            background: $success-color-opacity;\n        }\n\n        .progress-bar{\n            background: $brand-success;\n        }\n\n        .progress-value,\n        .progress-badge{\n            color: $brand-success;\n        }\n    }\n\n    &.progress-warning{\n        .progress{\n            background: $warning-color-opacity;\n        }\n\n        .progress-bar{\n            background: $brand-warning;\n        }\n\n        .progress-value,\n        .progress-badge{\n            color: $brand-warning;\n        }\n    }\n\n    &.progress-danger{\n        .progress{\n            background: $danger-color-opacity;\n        }\n\n        .progress-bar{\n            background: $brand-danger;\n        }\n\n        .progress-value,\n        .progress-badge{\n            color: $brand-danger;\n        }\n    }\n}\n",".nav-pills{\n\n    &.nav-pills-just-icons{\n      .nav-item .nav-link{\n        text-align: center;\n        border-radius: 50%;\n        height: 80px;\n        width: 80px;\n        padding: 0;\n        max-width: 80px;\n        min-width: auto;\n        margin-bottom: 4px;\n\n        i{\n          line-height: 80px;\n        }\n      }\n    }\n\n    &:not(.flex-column) .nav-item {\n        &:not(:last-child) .nav-link{\n            margin-right: 19px;\n        }\n    }\n\n    .nav-item {\n        .nav-link{\n          padding: $padding-btn-vertical - 1 $padding-round-horizontal;\n          background-color: $opacity-gray-3;\n          min-width: 100px;\n          font-weight: $font-weight-normal;\n          text-align: center;\n          color: $light-black;\n\n\n            &:hover{\n                background-color: $opacity-gray-3;\n            }\n\n            &.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $dark-gray;\n                    color: $white-color;\n                    box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);\n                }\n            }\n\n            &.disabled,\n            &:disabled,\n            &[disabled]{\n                opacity: .5;\n            }\n        }\n\n        i{\n            display: block;\n            line-height: 60px;\n            font-size: 24px;\n        }\n    }\n\n    &.nav-pills-neutral{\n        .nav-item {\n            .nav-link{\n                background-color: $opacity-2;\n                color: $white-color;\n\n                &.active{\n                    &,\n                    &:focus,\n                    &:hover{\n                        background-color: $white-color;\n                        color: $primary-color;\n                    }\n                }\n            }\n        }\n    }\n\n    &.nav-pills-primary{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $brand-primary;\n                }\n            }\n        }\n    }\n\n    &.nav-pills-info{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $brand-info;\n                }\n            }\n        }\n    }\n\n    &.nav-pills-success{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $brand-success;\n                }\n            }\n        }\n    }\n\n    &.nav-pills-warning{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $brand-warning;\n                }\n            }\n        }\n    }\n\n    &.nav-pills-danger{\n        .nav-item {\n            .nav-link.active{\n                &,\n                &:focus,\n                &:hover{\n                    background-color: $brand-danger;\n                }\n            }\n        }\n    }\n}\n.tab-space{\n    padding: 20px 0 50px 0px;\n}\n\n.nav-align-center{\n    text-align: center;\n\n    .nav-pills{\n        display: inline-flex;\n    }\n}\n",".nav-pills{\n  &.flex-column li > a{\n      margin-bottom: 15px;\n  }\n\n  &:not(.nav-pills-icons):not(.nav-pills-just-icons) .nav-item .nav-link{\n    border-radius: $btn-round-radius;\n  }\n\n  &.nav-pills-icons{\n    .nav-item {\n      .nav-link{\n        background-color: transparent;\n      }\n\n      i{\n        font-size: 20px;\n      }\n    }\n  }\n}\n","// This file has been autogenerated by grunt task lessToSass. Any changes will be overwritten.\n\n.nav-tabs {\n    border: 0;\n    padding: $padding-large-vertical $padding-base-horizontal;\n\n    &:not(.nav-tabs-neutral) > .nav-item > .nav-link.active{\n        box-shadow: 0px 5px 35px 0px rgba(0, 0, 0, 0.3);\n    }\n\n    .card &{\n        border-top-right-radius: $border-radius-small;\n        border-top-left-radius: $border-radius-small;\n    }\n\n    > .nav-item{\n        > .nav-link{\n            color: $default-color;\n            margin: 0;\n            margin-right: 5px;\n            background-color: $transparent-bg;\n            border: 1px solid $transparent-bg;\n            border-radius: 30px;\n            font-size: $font-size-base;\n            padding: $padding-btn-vertical $padding-round-horizontal;\n            line-height: $line-height-general;\n\n            &:hover {\n                background-color: $transparent-bg;\n            }\n\n            &.active{\n                background-color: $light-black;\n                border-radius: 30px;\n                color: $white-color;\n            }\n\n            i.now-ui-icons{\n                font-size: 14px;\n                position: relative;\n                top: 1px;\n                margin-right: 3px;\n            }\n        }\n\n        &.disabled > .nav-link,\n        &.disabled > .nav-link:hover {\n            color: rgba(255,255,255,0.5);\n        }\n    }\n\n    &.nav-tabs-neutral{\n        > .nav-item{\n            > .nav-link{\n                color: $white-color;\n\n                &.active{\n                    background-color: $opacity-2;\n                    color: $white-color;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-primary{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    background-color: $primary-color;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-info{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    background-color: $info-color;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-danger{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    background-color: $danger-color;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-warning{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    background-color: $warning-color;\n                }\n            }\n        }\n    }\n\n    &.nav-tabs-success{\n        > .nav-item{\n            > .nav-link{\n                &.active{\n                    background-color: $success-color;\n                }\n            }\n        }\n    }\n\n}\n",".navbar{\n    padding-top: $navbar-padding-base;\n    padding-bottom: $navbar-padding-base;\n    min-height: 53px;\n    margin-bottom: 20px;\n    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);\n\n    a{\n        vertical-align: middle;\n\n        &:not(.btn):not(.dropdown-item){\n            color: $white-color;\n        }\n    }\n\n    p{\n        display: inline-block;\n        margin: 0;\n        line-height: 21px;\n        font-weight: inherit;\n        font-size: inherit;\n    }\n\n    .navbar-nav{\n        &.navbar-logo{\n            position: absolute;\n            left: 0;\n            right: 0;\n            margin: 0 auto;\n            width: 49px;\n            top: -4px;\n        }\n\n        .nav-link.btn{\n            padding: $padding-btn-vertical $padding-btn-horizontal;\n\n            &.btn-lg{\n                padding: $padding-large-vertical $padding-large-horizontal;\n            }\n\n            &.btn-sm{\n                padding: $padding-small-vertical $padding-small-horizontal;\n            }\n        }\n\n        .nav-link:not(.btn){\n            text-transform: uppercase;\n            font-size: $font-size-mini;\n            padding: $padding-base-vertical $padding-base-horizontal;\n            line-height: $line-height-nav-link;\n\n            i.fab + p,\n            i.now-ui-icons + p{\n                margin-left: 3px;\n            }\n\n            i.fab,\n            i.now-ui-icons{\n                font-size: 18px;\n                position: relative;\n                top: 3px;\n                text-align: center;\n                width: 21px;\n            }\n\n            i.now-ui-icons{\n                top: 4px;\n                font-size: 16px;\n            }\n\n            &.profile-photo{\n                .profile-photo-small{\n                    width: 27px;\n                    height: 27px;\n                }\n            }\n\n            &.disabled{\n                opacity: .5;\n                color: $white-color;\n            }\n        }\n\n        .nav-item.active .nav-link:not(.btn),\n        .nav-item .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):active{\n            background-color: $opacity-2;\n            border-radius: $border-radius-small;\n        }\n    }\n\n    .logo-container{\n        width: 27px;\n        height: 27px;\n        overflow: hidden;\n        margin: 0 auto;\n        border-radius: 50%;\n        border: 1px solid transparent;\n    }\n\n    .navbar-brand{\n        text-transform: uppercase;\n        font-size: $font-size-small;\n        padding-top: $padding-base-vertical;\n        padding-bottom: $padding-base-vertical;\n        line-height: $line-height-nav-link;\n    }\n\n    .navbar-toggler{\n        width: 37px;\n        height: 27px;\n        outline: 0;\n        cursor: pointer;\n\n        &.navbar-toggler-left{\n            position: relative;\n            left: 0;\n            padding-left: 0;\n        }\n\n        .navbar-toggler-bar.middle-bar{\n          width: 17px;\n          transition: width .2s linear;\n        }\n\n        &:hover{\n            & .navbar-toggler-bar.middle-bar{\n                width: 22px;\n            }\n        }\n    }\n\n    .button-dropdown{\n        .navbar-toggler-bar:nth-child(2){\n            width: 17px;\n        }\n    }\n\n    &.navbar-transparent{\n        background-color: $transparent-bg !important;\n        box-shadow: none;\n        color: $white-color;\n        padding-top: 20px !important;\n    }\n\n    &.bg-white:not(.navbar-transparent){\n        a:not(.dropdown-item):not(.btn){\n            color: $default-color;\n\n            &.disabled{\n                opacity: .5;\n                color: $default-color;\n            }\n        }\n\n        .button-bar{\n            background: $default-color;\n        }\n\n        .nav-item.active .nav-link:not(.btn),\n        .nav-item .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):active{\n            background-color: $opacity-gray-3;\n        }\n\n        .logo-container{\n            border: 1px solid $default-color;\n        }\n    }\n}\n\n.bg-default{\n    background-color: $default-color !important;\n}\n\n.bg-primary{\n    background-color: $primary-color !important;\n}\n\n.bg-info{\n    background-color: $info-color !important;\n}\n\n.bg-success{\n    background-color: $success-color !important;\n}\n\n.bg-danger{\n    background-color: $danger-color !important;\n}\n\n.bg-warning{\n    background-color: $warning-color !important;\n}\n\n.bg-white{\n    background-color: $white-color !important;\n}\n",".navbar{\n  p{\n    line-height: 1.8em;\n    font-size: 1em;\n    font-weight: 400;\n  }\n\n  &.navbar-absolute{\n\t  position: absolute;\n\t  width: 100%;\n\t  padding-top: 10px;\n\t  z-index: 1029;\n  }\n\n  .navbar-toggler{\n    vertical-align: middle;\n\n    &.navbar-toggler-left{\n      top:0;\n    }\n\n    &.navbar-toggler-right{\n      padding-right: 0;\n      top: 8px;\n    }\n  }\n}\n",".dropdown-menu{\n    border: 0;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n    border-radius: $border-radius-extra-small;\n    @include transition($fast-transition-time, $transition-linear);\n    font-size: $font-size-base;\n\n    &.dropdown-menu-right{\n        &:before{\n            left:auto;\n            right: 10px;\n        }\n    }\n\n    .dropdown &{\n        @include transform-translate-y-dropdown(-25px);\n        visibility: hidden;\n        display: block;\n        @include opacity(0);\n        top: 100% !important;\n    }\n\n    .dropdown.show &,\n    &.open{\n        @include opacity(1);\n        visibility: visible;\n        @include transform-translate-y-dropdown(0px);\n    }\n\n    .dropdown-item,\n    .bootstrap-select &.inner li a{\n      font-size: $font-size-small;\n      padding-top: .6rem;\n      padding-bottom: .6rem;\n      margin-top: 5px;\n      @include transition($fast-transition-time, $transition-linear);\n      outline: none;\n\n      &:hover,\n      &:focus{\n        background-color: $opacity-gray-3;\n      }\n\n      &.disabled,\n      &:disabled{\n        color: $default-color-opacity;\n\n        &:hover,\n        &:focus{\n          background-color: transparent;\n        }\n      }\n    }\n\n    &:before{\n        display: inline-block;\n        position: absolute;\n        width: 0;\n        height: 0;\n        vertical-align: middle;\n        content: \"\";\n        top: -5px;\n        left: 10px;\n        right: auto;\n        color: $white-color;\n        border-bottom: .4em solid;\n        border-right: .4em solid transparent;\n        border-left: .4em solid transparent;\n    }\n\n    .dropdown-divider{\n        background-color: $opacity-gray-5;\n    }\n\n    .dropdown-header:not([href]):not([tabindex]){\n        color: $default-color-opacity;\n        font-size: $font-size-mini;\n        text-transform: uppercase;\n        font-weight: $font-weight-bold;\n    }\n\n    &.dropdown-primary{\n        @include dropdown-colors(darken($primary-color, 3%),$opacity-8,$white-color, $opacity-2);\n    }\n\n    &.dropdown-info{\n        @include dropdown-colors(darken($info-color, 3%),$opacity-8,$white-color, $opacity-2);\n    }\n\n    &.dropdown-danger{\n        @include dropdown-colors(darken($danger-color, 3%),$opacity-8,$white-color, $opacity-2);\n    }\n\n    &.dropdown-success{\n        @include dropdown-colors(darken($success-color, 3%),$opacity-8,$white-color, $opacity-2);\n    }\n\n    &.dropdown-warning{\n        @include dropdown-colors(darken($warning-color, 3%),$opacity-8,$white-color, $opacity-2);\n    }\n}\n.button-dropdown{\n    padding-right: $padding-base-horizontal;\n    cursor: pointer;\n\n    & .dropdown-toggle{\n        padding-top: $padding-base-vertical;\n        padding-bottom: $padding-base-vertical;\n        display: block;\n\n        &:after{\n            display: none;\n        }\n    }\n}\n","@mixin dropdown-colors($brand-color, $dropdown-header-color, $dropdown-color, $background-color ) {\n    background-color: $brand-color;\n\n    &:before{\n        color: $brand-color;\n    }\n\n    .dropdown-header:not([href]):not([tabindex]){\n        color: $dropdown-header-color;\n    }\n\n    .dropdown-item{\n        color: $dropdown-color;\n\n        &:hover,\n        &:focus{\n            background-color: $background-color;\n        }\n    }\n\n    .dropdown-divider{\n        background-color: $background-color;\n    }\n}\n",".dropdown-menu{\n  i{\n    margin-right: 5px;\n    position: relative;\n    top: 1px;\n  }\n\n  .now-ui-icons{\n    margin-right: 10px;\n    position: relative;\n    top: 4px;\n    font-size: 18px;\n    margin-top: -5px;\n    opacity: .5;\n  }\n\n  .dropdown-item{\n    &.active,\n    &:active{\n      color: inherit;\n    }\n  }\n\n  .dropup &{\n    &:before{\n      display: none;\n    }\n\n    &:after{\n      display: inline-block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      vertical-align: middle;\n      content: \"\";\n      top: auto;\n      bottom: -5px;\n      right: auto;\n      left: 10px;\n      color: $white-color;\n      border-top: .4em solid;\n      border-right: .4em solid transparent;\n      border-left: .4em solid transparent;\n    }\n\n    &.dropdown-menu-right{\n      &:after{\n        right: 10px;\n        left: auto;\n      }\n    }\n  }\n\n  .dropdown-item,\n  .bootstrap-select &.inner li a{\n    font-size: $font-size-small;\n    padding-top: .6rem;\n    padding-bottom: .6rem;\n    margin-top: 5px;\n    @include transition($fast-transition-time, $transition-linear);\n\n    &:hover,\n    &:focus{\n      background-color: $opacity-gray-3;\n    }\n\n    &.disabled,\n    &:disabled{\n      color: $default-color-opacity;\n\n      &:hover,\n      &:focus{\n        background-color: transparent;\n      }\n    }\n  }\n\n  // Dropdown\n  .dropdown &:not(.inner),\n  &.bootstrap-datetimepicker-widget {\n    @include transform-translate-y-dropdown(-25px);\n    visibility: hidden;\n    display: block;\n    @include opacity(0);\n    top: 100% !important;\n  }\n\n  .dropdown.show &:not(.inner),\n  &.bootstrap-datetimepicker-widget.bottom.open,\n  &.bootstrap-datetimepicker-widget.top.open {\n    @include opacity(1);\n    visibility: visible;\n    @include transform-translate-y-dropdown(0px);\n  }\n\n\n  // Dropup\n  .dropup &:not(.inner),\n  &.bootstrap-datetimepicker-widget.top {\n    visibility: hidden;\n    @include opacity(0);\n    @include transform-translate-y-dropdown(25px);\n    display: block;\n    top: auto !important;\n    bottom: 100% !important;\n  }\n\n  .dropup.show &:not(.inner),\n  &.bootstrap-datetimepicker-widget.top.open {\n    visibility: visible;\n    @include opacity(1);\n    @include transform-translate-y-dropdown(-1px);\n  }\n}\n","img{\n    max-width: 100%;\n    border-radius: 1px;\n}\n.img-raised{\n    box-shadow: $box-shadow-raised;\n}\n",".popover{\n    font-size: $font-size-base;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n    border: none;\n    line-height: 1.7;\n    max-width: 240px;\n\n    &.bs-popover-top .arrow:before,\n    &.bs-popover-left .arrow:before,\n    &.bs-popover-right .arrow:before,\n    &.bs-popover-bottom .arrow:before,{\n        border-top-color: transparent;\n        border-left-color: transparent;\n        border-right-color: transparent;\n        border-bottom-color: transparent;\n    }\n\n    .popover-header{\n        color: $default-color-opacity;\n        font-size: $font-size-base;\n        text-transform: capitalize;\n        font-weight: $font-weight-semi;\n        margin: 0;\n        margin-top: 5px;\n        border: none;\n        background-color: transparent;\n    }\n\n    &:before{\n        display: none;\n    }\n\n    &.bs-tether-element-attached-top:after{\n        border-bottom-color:$white-color;\n        top: -9px;\n    }\n\n    &.popover-primary{\n        @include popover-color($primary-color, $white-color);\n    }\n\n    &.popover-info{\n        @include popover-color($info-color, $white-color);\n    }\n\n    &.popover-warning{\n        @include popover-color($warning-color, $white-color);\n    }\n\n    &.popover-danger{\n        @include popover-color($danger-color, $white-color);\n    }\n\n    &.popover-success{\n        @include popover-color($success-color, $white-color);\n    }\n}\n\n\n.tooltip{\n    &.bs-tooltip-right .arrow:before{\n        border-right-color:$white-color;\n    }\n\n    &.bs-tooltip-top .arrow:before{\n        border-top-color:$white-color;\n    }\n\n    &.bs-tooltip-bottom .arrow:before{\n        border-bottom-color:$white-color;\n    }\n\n    &.bs-tooltip-left .arrow:before{\n        border-left-color:$white-color;\n    }\n}\n\n.tooltip-inner{\n    padding: $padding-base-vertical $padding-base-horizontal;\n    min-width: 130px;\n    background-color: $white-color;\n    font-size: $font-size-base;\n    color: inherit;\n    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n}\n","@mixin popover-color($color, $text-color) {\n    background-color: $color;\n\n    .popover-body{\n        color: $text-color;\n    }\n\n\n    &.bs-popover-right .arrow:after{\n        border-right-color:$color;\n    }\n\n    &.bs-popover-top .arrow:after{\n        border-top-color:$color;\n    }\n\n    &.bs-popover-bottom .arrow:after{\n        border-bottom-color:$color;\n    }\n\n    &.bs-popover-left .arrow:after{\n        border-left-color:$color;\n    }\n\n    .popover-header{\n        color: $text-color;\n        opacity: .6;\n    }\n}\n",".table{\n   > thead > tr > th{\n       border-bottom-width: 1px;\n       font-size: $font-size-h5;\n       font-weight: $font-weight-light;\n       border: 0;\n   }\n\n   .btn{\n       margin: 0;\n   }\n\n   .form-check,\n   .form-check.form-check-radio{\n       margin: 0;\n       padding: 0;\n       width: 15px;\n\n       .icons{\n           position: relative;\n       }\n\n        label.form-check-label .form-check-sign{\n            &:after,\n            &:before{\n                top: -17px;\n                left: -3px;\n            }\n        }\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       padding: 12px 7px;\n       vertical-align: middle;\n   }\n\n   .th-description{\n       max-width: 150px;\n   }\n   .td-price{\n       font-size: 26px;\n       font-weight: $font-weight-light;\n       margin-top: 5px;\n       position: relative;\n       top: 4px;\n       text-align: right;\n   }\n   .td-total{\n        font-weight: $font-weight-bold;\n        font-size: $font-size-h5;\n        padding-top: 20px;\n        text-align: right;\n    }\n\n   .td-actions .btn{\n    margin: 0px;\n    }\n\n    > tbody > tr{\n        position: relative;\n    }\n}\n\n.table-shopping{\n    > thead > tr > th{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n    }\n    > tbody > tr > td{\n        font-size: $font-paragraph;\n\n        b{\n            display: block;\n            margin-bottom: 5px;\n        }\n    }\n    .td-name{\n        font-weight: $font-weight-normal;\n        font-size: 1.5em;\n        small{\n            color: $dark-gray;\n            font-size: 0.75em;\n            font-weight: $font-weight-light;\n        }\n    }\n    .td-number{\n       font-weight: $font-weight-light;\n       font-size: $font-size-h4;\n   }\n    .td-name{\n        min-width: 200px;\n    }\n    .td-number{\n        text-align: right;\n        min-width: 145px;\n\n        small{\n            margin-right: 3px;\n        }\n    }\n\n    .img-container{\n        width: 120px;\n        max-height: 160px;\n        overflow: hidden;\n        display: block;\n\n        img{\n            width: 100%;\n        }\n    }\n}\n\n#tables .table-responsive{\n    margin-bottom: 30px;\n}\n",".info{\n    max-width: 360px;\n    margin: 0 auto;\n    padding: 70px 0 30px;\n    text-align: center;\n\n    &.info-hover{\n        .info-title{\n            transition: color .4s;\n        }\n\n        &:hover{\n            .icon{\n                @include transform-translate-y(-.5rem);\n\n                &.icon-primary{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.35);\n                    }\n                }\n                &.icon-info{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.35);\n                    }\n                }\n                &.icon-success{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.35);\n                    }\n                }\n                &.icon-warning{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.35);\n                    }\n                }\n                &.icon-danger{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.35);\n                    }\n                }\n\n                &.icon-info + .info-title{\n                    color: $info-color;\n                }\n\n                &.icon-warning + .info-title{\n                    color: $warning-color;\n                }\n\n                &.icon-danger + .info-title{\n                    color: $danger-color;\n                }\n\n                &.icon-primary + .info-title{\n                    color: $primary-color;\n                }\n\n                &.icon-success + .info-title{\n                    color: $success-color;\n                }\n            }\n        }\n    }\n\n    .icon{\n        color: $default-color;\n        transition: transform .4s, box-shadow .4s;\n\n        > i{\n            font-size: 3em;\n        }\n\n        &.icon-circle{\n            max-width: 80px;\n            width: 80px;\n            height: 80px;\n            margin: 0 auto;\n            border-radius: 50%;\n            box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);\n            font-size: $font-size-mini;\n            background-color: $white-color;\n            position: relative;\n\n            i{\n                line-height: 2.7;\n            }\n        }\n    }\n\n    .info-title{\n        margin: $margin-base-vertical + 10 0 $margin-base-vertical;\n        padding: 0 15px;\n        color: $black-color;\n    }\n    p{\n        color: $default-color;\n        padding: 0 15px;\n        font-size: 1.1em;\n    }\n}\n\n.info-horizontal{\n    text-align: left !important;\n\n    .icon{\n        float: left;\n        margin-top: 23px;\n        margin-right: 10px;\n\n        >i{\n            font-size: 2em;\n        }\n\n        &.icon-circle{\n            width: 65px;\n            height: 65px;\n            max-width: 65px;\n            margin-top: 8px;\n\n            i{\n                display: table;\n                margin: 0 auto;\n                line-height: 3.5;\n                font-size: 1.9em;\n            }\n        }\n    }\n    .description{\n        overflow: hidden;\n    }\n\n}\n\n.icon{\n    &.icon-primary{\n        color: $brand-primary;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px $primary-color-opacity;\n        }\n    }\n    &.icon-info{\n        color: $brand-info;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px $info-color-opacity;\n        }\n    }\n    &.icon-success{\n        color: $brand-success;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px $success-color-opacity;\n        }\n    }\n    &.icon-warning{\n        color: $brand-warning;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px $warning-color-opacity;\n        }\n    }\n    &.icon-danger{\n        color: $brand-danger;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px $danger-color-opacity;\n        }\n    }\n\n    &.icon-white{\n        color: $white-color;\n    }\n}\n",".media{\n    .avatar{\n        margin: 0 auto;\n        width: 64px;\n        height: 64px;\n        margin-right: 15px;\n\n        img{\n            width: 100%;\n            border-radius: 50%;\n        }\n    }\n\n    textarea{\n        margin-bottom: 20px;\n    }\n\n    .media-heading small{\n        font-family: $sans-serif-family;\n    }\n    .media-body{\n        padding-right: 10px;\n\n        .media .media-body{\n            padding-right: 0px;\n        }\n    }\n    &.media-post{\n        .form-group,\n        .input-group{\n            margin-top: 25px;\n        }\n    }\n    .media-footer{\n        .btn{\n            margin-bottom: 20px;\n\n        }\n\n        &:after{\n            display: table;\n            content: \" \";\n            clear: both;\n        }\n    }\n    p{\n        color: $default-color;\n        font-size: $font-paragraph * .92;\n        line-height: 1.61em;\n    }\n}\n.media-left,\n.media>.pull-left{\n    padding: 10px;\n}\n","//\n// Modals\n// Now Ui Kit Design element Dialogs\n// --------------------------------------------------\n.modal-content {\n\n  border-radius: $border-radius-small;\n  border: none;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);\n  // Modal header\n  // Top section of the modal w/ title and dismiss\n  .modal-header {\n    border-bottom: none;\n    padding-top:    24px;\n    padding-right:  24px;\n    padding-bottom: 0;\n    padding-left:   24px;\n\n    & button{\n        position: absolute;\n        right: 27px;\n        top: 30px;\n        outline: 0;\n    }\n    .title{\n        margin-top: 5px;\n        margin-bottom: 0;\n    }\n  }\n  // Modal body\n  // Where all modal content resides (sibling of .modal-header and .modal-footer)\n  .modal-body {\n    padding-top:    24px;\n    padding-right:  24px;\n    padding-bottom: 16px;\n    padding-left:   24px;\n    line-height: 1.9;\n  }\n  // Footer (for actions)\n  .modal-footer {\n    border-top: none;\n    padding-right: 24px;\n    padding-bottom: 16px;\n    padding-left: 24px;\n    -webkit-justify-content: space-between; /* Safari 6.1+ */\n    justify-content: space-between;\n\n    button {\n      margin: 0;\n      padding-left: 16px;\n      padding-right: 16px;\n      width: auto;\n      &.pull-left {\n        padding-left: 5px;\n        padding-right: 5px;\n        position: relative;\n        left: -5px;\n      }\n    }\n\n  }\n  .modal-body + .modal-footer {\n    padding-top: 0;\n  }\n}\n.modal-backdrop {\n  background: rgba(0,0,0,0.3);\n}\n\n.modal{\n\n    &.modal-mini{\n        p{\n            text-align: center;\n        }\n\n        .modal-dialog{\n            max-width: 255px;\n            margin: 0 auto;\n        }\n\n        .modal-profile{\n            width: 70px;\n            height: 70px;\n            background-color: $white-color;\n            border-radius: 50%;\n            text-align: center;\n            line-height: 5.7;\n            box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.3);\n\n            i{\n                color: $primary-color;\n                font-size: 21px;\n            }\n\n            &[class*=\"modal-profile-\"]{\n                i{\n                    color: $white-color;\n                }\n            }\n\n            &.modal-profile-primary{\n                background-color: $primary-color;\n            }\n\n            &.modal-profile-danger{\n                background-color: $danger-color;\n            }\n\n            &.modal-profile-warning{\n                background-color: $warning-color;\n            }\n\n            &.modal-profile-success{\n                background-color: $success-color;\n            }\n\n            &.modal-profile-info{\n                background-color: $info-color;\n            }\n        }\n\n        .modal-footer{\n            button{\n                text-transform: uppercase;\n\n                &:first-child{\n                    opacity: .5;\n                }\n            }\n        }\n    }\n\n    &.modal-default{\n        @include modal-colors($white-color, $black-color);\n    }\n\n    &.modal-primary{\n        @include modal-colors($primary-color, $white-color);\n    }\n\n    &.modal-danger{\n        @include modal-colors($danger-color, $white-color);\n    }\n\n    &.modal-warning{\n        @include modal-colors($warning-color, $white-color);\n    }\n\n    &.modal-success{\n        @include modal-colors($success-color, $white-color);\n    }\n\n    &.modal-info{\n        @include modal-colors($info-color, $white-color);\n    }\n\n    &.show.modal-mini .modal-dialog{\n        -webkit-transform: translate(0,30%);\n        -o-transform: translate(0,30%);\n        transform: translate(0,30%);\n    }\n\n    .modal-header .close{\n        color: $danger-color;\n        text-shadow: none;\n\n        &:hover,\n        &:focus{\n            opacity: 1;\n        }\n    }\n}\n","@mixin modal-colors($bg-color, $color) {\n    .modal-content{\n        background-color: $bg-color;\n        color: $color;\n    }\n\n    .modal-header .close{\n        color: $color;\n    }\n\n\n}\n",".modal{\n  .modal-login{\n      max-width: 320px;\n\n      .card-login{\n          .logo-container{\n              width: 65px;\n              margin-bottom: 38px;\n              margin-top: 27px;\n          }\n      }\n  }\n}\n","// display flex was causing errors\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active{\n    display: block;\n}\n\n.carousel{\n    .carousel-inner{\n        box-shadow: $box-shadow-raised;\n        border-radius: $border-radius-small;\n    }\n\n    .card {\n        max-width: 650px;\n        margin: 60px auto;\n        display: block;\n    }\n}\n",".footer{\n    padding: 1.125rem 0;\n    text-align: center;\n\n    &.footer-default{\n        background-color: #f2f2f2;\n    }\n\n    &.footer-white{\n        background-color: $white-color;\n    }\n\n    nav{\n        display: inline-block;\n        float: left;\n    }\n\n    .content{\n        text-align: left;\n    }\n\n    .nav-link{\n        display: inline;\n    }\n\n    &.footer-big{\n        padding: 30px 0;\n\n        .social-feed i{\n            font-size: 20px;\n            float: left;\n            padding-right: 10px;\n            padding-bottom: 30px;\n        }\n\n        .gallery-feed img{\n            width: 20%;\n            margin-right: 5%;\n            margin-bottom: 5%;\n            float: left;\n        }\n    }\n\n    .footer-brand{\n        float: left;\n        font-size: 0.875rem;\n        line-height: 44px;\n    }\n\n\n\n    ul{\n        margin-bottom: 0;\n        padding: 0;\n        list-style: none;\n\n        &:not(.links-vertical){\n            line-height: 3.1;\n        }\n\n        &.links-vertical{\n            line-height: 1.6;\n\n            li{\n                display: block;\n                margin-left: -5px;\n                margin-right: -5px;\n                margin-bottom: 0px;\n\n                a{\n                    padding: 5px;\n                    display: block;\n                }\n            }\n        }\n\n        li{\n            display: inline-block;\n\n            a{\n                color: inherit;\n                padding: 13px $padding-base-vertical;\n                font-size: $font-size-small;\n                text-transform: uppercase;\n                text-decoration: none;\n\n                &:hover{\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n\n    .social-buttons{\n        a,\n        .btn{\n            margin: 0;\n        }\n    }\n\n    .pull-center{\n        display: inline-block;\n        float: none;\n    }\n\n    .copyright{\n        font-size: $font-size-small;\n        line-height: 3.5;\n    }\n\n    &:after{\n        display: table;\n        clear: both;\n        content: \" \";\n    }\n}\n",".card{\n  border: 0;\n  border-radius: $border-radius-small;\n  display: inline-block;\n  position: relative;\n  width: 100%;\n  margin-bottom: 30px;\n  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n\n  .card-header{\n    background-color: $transparent-bg;\n    border-bottom: 0;\n    background-color: transparent;\n    border-radius: 0;\n    padding: 0;\n  }\n\n  .card-footer{\n    padding: 0;\n    margin-top: 15px;\n    background-color: $transparent-bg;\n    border:0;\n  }\n\n  &[data-background-color=\"orange\"]{\n      background-color: $primary-color;\n  }\n\n  &[data-background-color=\"red\"]{\n      background-color: $danger-color;\n  }\n\n  &[data-background-color=\"yellow\"]{\n      background-color: $warning-color;\n  }\n\n  &[data-background-color=\"blue\"]{\n      background-color: $info-color;\n  }\n\n  &[data-background-color=\"green\"]{\n      background-color: darken($success-color, 5%);\n  }\n}\n",".card{\n  .rounded{\n      border-radius: $border-radius-small !important;\n  }\n\n  &:not(.card-plain) .rounded{\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n  }\n\n  a[data-toggle='collapse']{\n      text-decoration: none;\n  }\n\n  & a:not(.btn):not(.nav-link):not([data-toggle='collapse']):not(.footer-link){\n      text-decoration: none;\n      border-bottom: 2px solid transparent;\n      color: $light-black;\n\n      &:hover,\n      &:focus{\n          border-color: #444;\n      }\n  }\n\n  .card-header{\n      .card-collapse &{\n          padding: .75rem 0;\n          position: relative;\n\n          &:after{\n              content: \"\";\n              position: absolute;\n              bottom: 0 ;\n              width: 100%;\n              height: 1px;\n              background-color: $light-gray;\n          }\n\n          a[data-toggle=\"collapse\"]{\n              display: block;\n              color: $light-black;\n\n\n              &[aria-expanded=\"true\"],\n              &.expanded{\n                  i{\n                      @include rotate-180();\n                  }\n              }\n\n              i{\n                  float: right;\n                  position: relative;\n                  color: $primary-color;\n                  top: 1px;\n                  @include transition($general-transition-time, $transition-ease);\n              }\n          }\n      }\n  }\n\n  .card-image{\n      position: relative;\n  }\n\n  .card-footer{\n      div{\n          display: inline-block;\n      }\n\n      .stats{\n          &.stats-right{\n              float: right;\n              line-height: 30px;\n          }\n\n          span:first-child{\n              margin-right: 30px;\n          }\n      }\n  }\n\n  &:not(.card-product) .card-footer .stats{\n      .now-ui-icons{\n          position: relative;\n          top: 3px;\n          font-size: 18px;\n          margin-right: 5px;\n\n      }\n\n      i{\n          color: lighten($default-color, 10%);\n      }\n  }\n\n  .card-title{\n      margin-top: 15px;\n      line-height: 1.25em;\n  }\n\n  .author{\n      .avatar{\n          width: 30px;\n          height: 30px;\n          overflow: hidden;\n          border-radius: 50%;\n          margin-right: 5px;\n      }\n      span{\n          color: $dark-gray;\n      }\n  }\n\n\n  .info{\n      padding: 40px 0 40px;\n      text-align: center;\n      position: relative;\n      z-index: 2;\n\n  }\n}\n","\n.card-background{\n    background-position: center center;\n    background-size: cover;\n    text-align: center;\n\n    .card-body{\n        position: relative;\n        z-index: 2;\n        min-height: 370px;\n        max-width: 530px;\n        margin: 0 auto;\n        padding-top: 60px;\n        padding-bottom: 60px;;\n    }\n\n    &.card-background-product .card-body{\n        max-width: 400px;\n        .card-title{\n            margin-top: 30px;\n        }\n    }\n\n    .stats{\n        color: $white-color;\n    }\n\n    .card-footer{\n        .stats-link > a{\n            color: $white-color;\n            line-height: 1.9;\n        }\n    }\n\n    .category,\n    .card-description,\n    small{\n        color: $opacity-8;\n    }\n\n    .card-title{\n        color: $white-color;\n        margin-top: 130px;\n    }\n\n    &:not(.card-pricing) .btn{\n        margin-bottom: 0;\n    }\n\n    &:after{\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n        background-color: rgba(0,0,0,.63);\n        border-radius: $border-radius-large;\n    }\n}\n",".card-blog{\n    .row{\n        .category{\n            margin-bottom: 0;\n        }\n    }\n\n    .card-image + .category{\n        margin-top: 20px;\n    }\n}\n",".card-contact{\n    .header{\n        .title{\n            margin: 10px 0 10px;\n        }\n    }\n}\n",".card-fashion{\n    min-height: 500px;\n    border-radius: 0;\n    box-shadow: none;\n    margin:0;\n    display: block;\n\n    .card-container &{\n        width: 50%;\n        float: left;\n    }\n\n    &:not(.card-background) .card-title{\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        -webkit-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n        text-align: center;\n        width: 85%;\n    }\n\n    h4{\n        margin-top: 0;\n    }\n\n    &.card-background{\n        &::after{\n            border-radius: 0;\n        }\n\n        a{\n            color: $white-color !important;\n\n            &:hover,\n            &:focus{\n                border-color: $white-color !important;\n            }\n        }\n    }\n\n    &:not(.card-background) .stats span,\n    .stats-link{\n        color: initial;\n    }\n\n    .card-body{\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        padding: 2rem 2rem 1.4rem;\n        color: #fff;\n        min-height: auto;\n    }\n\n    &:not(.card-background):before{\n        left: 100%;\n        top: 50%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        z-index: 2;\n        position: absolute;\n        pointer-events: none;\n        border-color: rgba(255,255,255,0);\n        border-left-color: #ffffff;\n        border-width: 10px;\n        margin-top: -10px;\n    }\n\n    &.arrow-left:not(.card-background):before{\n        right: 100%;\n        border-right-color: #fff;\n        left: auto;\n        border-left: none;\n    }\n\n}\n",".card-form-horizontal{\n    .card-body{\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n    .form-group{\n        padding-bottom: 0px;\n        margin: 3px 0 0 0;\n\n        .form-control{\n            margin-bottom: 0;\n        }\n    }\n    .btn{\n        margin: 0;\n    }\n    .input-group,\n    .form-group{\n        margin: 0;\n    }\n}\n",".card-no-shadow{\n    box-shadow: none;\n    border-radius: 0;\n    margin: 0;\n\n    &:after{\n        border-radius: 0;\n    }\n}\n",".card-plain{\n    background: transparent;\n    box-shadow: none;\n\n    .card-body,\n    .card-header{\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n\n    .card-header:after{\n        width: 100%;\n        left: 0;\n    }\n}\n","\n.card-pricing{\n    text-align: center;\n\n    .card-title{\n        margin-top: 30px;\n    }\n\n    .icon{\n        padding: 10px 0 0px;\n\n        i{\n            font-size: 30px;\n            line-height: 2.7;\n            max-width: 80px;\n            color: $default-color;\n            width: 80px;\n            height: 80px;\n            margin: 0 auto;\n            border-radius: 50%;\n            box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);\n            background-color: $white-color;\n            position: relative;\n        }\n\n        &.icon-primary i{\n            @include icon-color($primary-color);\n        }\n        &.icon-info i{\n            @include icon-color($info-color);\n        }\n        &.icon-success i{\n            color: $success-color;\n            box-shadow:  0px 9px 30px -6px rgba(22, 199, 13, 0.85);\n        }\n        &.icon-warning i{\n            @include icon-color($warning-color);\n        }\n        &.icon-danger i{\n            @include icon-color($danger-color);\n        }\n    }\n    h1{\n        small{\n            font-size: 18px;\n\n            &:first-child{\n                position: relative;\n                top: -17px;\n                font-size: 26px;\n            }\n        }\n    }\n\n    ul{\n        list-style: none;\n        padding: 0;\n        max-width: 240px;\n        margin: 10px auto;\n\n        li{\n            color: $default-color;\n            text-align: center;\n            padding: 12px 0;\n            border-bottom: 1px solid rgba($default-color,.3);\n\n            &:last-child{\n                border: 0;\n            }\n            b{\n                color: $black-color;\n            }\n            i{\n                top: 3px;\n                right: 3px;\n                position: relative;\n                font-size: 20px;\n            }\n        }\n    }\n\n    &.card-background{\n        ul{\n            li{\n                color: $white-color;\n                border-color: rgba($white-color,.3);\n\n                b{\n                    color: $white-color;\n                }\n            }\n        }\n        [class*=\"text-\"]{\n            color: $white-color !important;\n        }\n        .card-body{\n            padding-top: 1.25rem;\n            padding-bottom: 1.25rem;\n        }\n    }\n    &.card-background:after{\n        background-color: rgba(0, 0, 0, 0.65);\n    }\n}\n","@mixin icon-color($color) {\n    box-shadow:  0px 9px 30px -6px $color;\n    color: $color;\n}\n","%card-profile{\n    margin-top: 60px;\n    text-align: center;\n\n    .card-body .card-title{\n        margin-top: 0;\n    }\n\n     [class*=col-]{\n        .card-description{\n            margin-bottom: 0;\n\n            & + .card-footer{\n                margin-top: 8px;\n            }\n        }\n\n\n     }\n\n    .card-avatar{\n        max-width: 130px;\n        max-height: 130px;\n        margin: -60px auto 0;\n\n        img{\n            border-radius: 50% !important;\n        }\n\n        & + .card-body{\n            margin-top: 15px;\n        }\n    }\n\n    &.card-plain{\n        .card-avatar{\n            margin-top: 0;\n        }\n    }\n    .card-body{\n        .card-avatar{\n            margin: 0 auto 30px;\n        }\n    }\n}\n\n.card-profile{\n\t@extend %card-profile;\n}\n","\n.card-product{\n    margin-top: 30px;\n\n    .price-container{\n        margin-top: 9px;\n    }\n\n    .btn{\n        margin: 0;\n    }\n\n    .image{\n        overflow: hidden;\n        border-radius: $border-radius-large;\n    }\n\n    .card-footer{\n        margin-top: 5px;\n        .price{\n            h4{\n                margin-bottom: 0;\n                margin-top: 0;\n            }\n        }\n        .stats{\n            margin-top: 5px;\n\n            .btn{\n                position: relative;\n                top: -3px;\n            }\n        }\n    }\n\n    .card-title,\n    .category,\n    .card-description{\n        text-align: center;\n    }\n    .category{\n        margin-bottom: 0;\n    }\n    .category ~ .card-title{\n        margin-top: 0;\n    }\n\n    .price{\n        font-size: 16px;\n        color: $default-color;\n    }\n    .price-old{\n        text-decoration: line-through;\n        font-size: 16px;\n        color: $default-color;\n    }\n\n    .price-new{\n        color: $danger-color;\n    }\n\n    &:not(.card-plain) .card-image{\n        padding: 15px;\n    }\n}\n",".card-raised {\n  box-shadow: 0px 20px 50px 0px rgba(0, 0, 0, 0.3);\n\n  &.card-plain{\n    box-shadow: none;\n  }\n}\n",".card-signup{\n    max-width: 350px;\n    margin: 0 auto;\n\n    .card-header{\n      margin:0 20px;\n      padding: 30px 0;\n    }\n\n    .card-title{\n      margin-top: 15px;\n      margin-bottom: 15px;\n    }\n\n    .card-footer {\n      margin-bottom: 10px;\n      margin-top: 24px;\n      padding: 24px 0;\n    }\n\n    .card-body{\n        padding-top: 0px;\n        padding-bottom: 0px;\n        min-height: auto;\n    }\n\n    .form-check,\n    .form-check.form-check-radio{\n        margin-top: 20px;\n\n        label{\n            margin-left: 11px;\n            color: initial;\n            padding-left: 40px;\n        }\n    }\n\n    .card-description{\n        margin-top: 15px;\n        margin-bottom: 20px;\n    }\n\n    .social-line{\n        margin-top: 20px;\n        text-align: center;\n\n        .btn.btn-icon ,\n        .btn.btn-icon .btn-icon{\n            margin-left: 5px;\n            margin-right: 5px;\n            margin-top: 0;\n            margin-bottom: 0;\n            box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);\n        }\n    }\n}\n","\n.card-testimonial{\n\t@extend %card-profile;\n    .card-body{\n        padding-top: 25px;\n    }\n\n    .card-avatar{\n        max-width: 100px;\n        max-height: 100px;\n        margin-top: -50px;\n    }\n    .card-footer{\n        margin-top: 0;\n        margin-bottom: 2.5rem;\n    }\n    .card-description{\n        & + .card-title{\n            margin-top: 30px;\n        }\n    }\n    .icon{\n        i{\n            font-size: 32px;\n        }\n\n        &.icon-primary i{\n            color: $primary-color;\n        }\n\n        &.icon-info i{\n            color: $info-color;\n        }\n\n        &.icon-danger i{\n            color: $danger-color;\n        }\n\n        &.icon-warning i{\n            color: $warning-color;\n        }\n\n        &.icon-success i{\n            color: $success-color;\n        }\n    }\n\n\t& .card-description + .card-title{\n\t    margin-top: 20px;\n\t}\n}\n","// style for the landing page\n.index-page,\n.presentation-page{\n    .page-header{\n        height: 125vh;\n\n        .container{\n            > .content-center{\n                top: 37%;\n            }\n        }\n    }\n}\n\n.index-page,\n.presentation-page{\n    .category-absolute{\n        position: absolute;\n        top: 100vh;\n        margin-top: -60px;\n        padding: 0 15px;\n        width: 100%;\n        text-align: center;\n        color: rgba(255,255,255,.5);\n    }\n}\n\n.presentation-page{\n    .section-sections{\n        // padding-bottom: 0;\n        // margin-bottom: -120px;\n\n        .section-description{\n            text-align: center;\n            margin-bottom: 60px;\n        }\n\n        .col-md-3{\n            padding: 7.5px;\n        }\n\n        img{\n            width: 100%;\n            border-radius: $border-radius-small;\n            transition: all .2s $transition-ease;\n            box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n\n            &:hover{\n                @include transform-scale(1.02);\n            }\n        }\n    }\n\n    .section-pricing{\n        .card-pricing{\n            margin-top: 45px;\n        }\n\n        .card-margin{\n            margin-top: 90px;\n        }\n    }\n}\n\n.blog-posts{\n    .projects-4{\n        padding-top: 0;\n    }\n}\n\n.ecommerce-page{\n    .container{\n        position: relative;\n        z-index: 2;\n    }\n\n    .card-header{\n        padding-left: 0;\n        padding-right: 0;\n\n        &:after{\n            width: 100%;\n            left: 0;\n        }\n    }\n\n    .slider-refine{\n        margin: 15px 0;\n    }\n\n    .card-refine{\n        & > .card-title{\n            margin-bottom: 30px;\n        }\n\n        [role=\"tabpanel\"]{\n          max-height: 273px;\n          overflow-y: scroll;\n        }\n\n        h6{\n          margin-top: .5rem;\n        }\n\n        .card-body{\n            padding-left: 25px;\n            padding-right: 25px;\n            padding-bottom: 0;\n\n            &.panel-refine{\n                padding-left: 15px;\n                padding-right: 15px;\n            }\n        }\n\n        .price-right,\n        .price-left{\n            font-weight: 500;\n        }\n\n        .btn{\n            margin: -5px -12px;\n        }\n\n        .checkbox input[type=checkbox]:checked + .checkbox-material .check{\n            background: $primary-color;\n        }\n    }\n\n    .card-product{\n        .card-image{\n            width: 200px;\n            margin: 0 auto;\n        }\n    }\n}\n\n.product-page{\n    background-color: #eee;\n\n   .carousel{\n        margin: -90px 0px 0;\n\n        img {\n          border-radius: $border-radius-small;\n          height: auto;\n        }\n    }\n    .section{\n        padding-top: 30px;\n    }\n    .main-price{\n      margin: 10px 0 25px;\n      font-weight: $font-weight-light;\n    }\n\n    .blockquote{\n        width: 90%;\n        margin-top: -10px;\n        margin-left: 5%;\n    }\n\n    .pick-size{\n        margin-top: 15px;\n        margin-bottom: 15px;\n        .form-group{\n            margin-top: 5px;\n        }\n    }\n\n    .related-products{\n\n        .title{\n            margin-bottom: 80px;\n        }\n    }\n    .features{\n      padding-top: 30px;\n    }\n    .accordeon .card{\n        margin-bottom: 15px;\n    }\n}\n\n.landing-page{\n\n    .page-header{\n        height: 100vh;\n        position: relative;\n\n        .share{\n            margin-top: 150px;\n        }\n        h1{\n            font-weight: 600;\n        }\n        .title{\n            color: $white-color;\n        }\n    }\n\n    .section-team{\n        .team .team-player img{\n            max-width: 100px;\n        }\n\n        .team-player{\n            margin-bottom: 15px;\n        }\n    }\n\n    .section-contact-us{\n        .title{\n            margin-bottom: 15px;\n        }\n\n        .description{\n            margin-bottom: 30px;\n        }\n\n        .input-group,\n        .send-button,\n        .textarea-container{\n            padding: 0 40px;\n        }\n\n        .textarea-container{\n            margin: 40px 0;\n        }\n\n        a.btn{\n            margin-top: 35px;\n        }\n    }\n}\n\n.profile-page,\n.blog-post{\n    .button-container{\n        text-align: center;\n        margin-top: -112px;\n        position: relative;\n        z-index: 100;\n    }\n}\n\n// style for the profile page\n.profile-page{\n    .profile-container{\n        color: #FFFFFF;\n    }\n    .photo-container{\n        width: 100px;\n        height: 100px;\n        border-radius: 50%;\n        overflow: hidden;\n        margin: 0 auto;\n        box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n    }\n\n    .title{\n        text-align: center;\n        margin-top: 30px;\n    }\n\n    .category{\n        text-align: center;\n    }\n\n    h5.description{\n        max-width: 700px;\n        margin: 20px auto 75px;\n    }\n\n    .nav-align-center{\n        margin-top: 30px;\n    }\n\n    .info-horizontal{\n        padding: 15px 0 0;\n    }\n    .content{\n        max-width: 450px;\n        margin: 0 auto;\n\n        .social-description{\n            display: inline-block;\n            max-width: 150px;\n            width: 145px;\n            text-align: center;\n            margin: 15px 0 0px;\n\n            h2{\n                margin-bottom: 5px;\n            }\n        }\n    }\n\n    .collections{\n        img{\n            margin-bottom: 30px;\n        }\n    }\n\n    .gallery{\n        margin-top: 45px;\n        padding-bottom: 50px;\n    }\n}\n\n.section-full-page{\n\n    &:after,\n    &:before{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 2;\n    }\n\n    &:before{\n        background-color: rgba(0,0,0,.5);\n    }\n\n    &[filter-color=\"purple\"],\n    &[filter-color=\"primary\"]{\n        &:after{\n            @include linear-gradient(rgba($light-gray,.26), rgba($primary-color,.95));\n\n        }\n\n    }\n\n    &[data-image]:after{\n        opacity: .5;\n    }\n\n    > .content,\n    > .footer{\n        position: relative;\n        z-index: 4;\n    }\n\n    > .content{\n        min-height: calc(100vh - 80px);\n    }\n\n    .full-page-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n\n    }\n\n    .footer nav > ul a:not(.btn),\n    .footer,\n    .footer .copyright a{\n        color: $white-color;\n    }\n\n}\n\n.signup-page{\n    .section{\n        padding-top: 180px;\n        padding-bottom: 0;\n    }\n\n    .input-group, .form-group{\n        margin-bottom: 20px;\n    }\n\n    .card-signup{\n        max-width: 100%;\n        margin-bottom: 130px;\n        padding: 15px 0px;\n\n        &:not([data-background-color]) .card-title{\n            color: initial;\n        }\n\n        .checkbox label{\n            margin-left: 14px;\n            padding-left: 39px;\n            color: initial;\n        }\n    }\n\n    .info-horizontal{\n        padding: 0px 0px 20px;\n    }\n    .social{\n        .btn{\n            margin: 5px;\n        }\n        h4{\n            margin-top: 20px;\n        }\n    }\n}\n\n.login-page{\n\n    .page-header{\n      display: block;\n      align-items: unset;\n    }\n\n    .card-login{\n        border-radius: $border-radius-large;\n        padding-bottom: $padding-base-horizontal;\n        max-width: 320px;\n\n        .btn-wd{\n            min-width: 180px;\n        }\n\n        .logo-container{\n            width: 65px;\n            margin: 0 auto;\n            margin-bottom: 55px;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        .input-group:last-child{\n            margin-bottom: 40px;\n        }\n\n        &.card-plain{\n            @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\n\n            .input-group-text,\n            .form-group.no-border .input-group-text,\n            .input-group.no-border .input-group-text{\n                color: $opacity-8;\n            }\n        }\n    }\n\n    .link{\n        font-size: 10px;\n        color: $white-color !important;\n        text-decoration: none;\n\n        &:hover,\n        &:focus{\n            border-color: $white-color !important;\n        }\n    }\n}\n\n.contact-page{\n    .contact-content{\n        padding-bottom: 40px;\n        padding-top: 40px;\n    }\n    .container{\n        max-width: 970px;\n    }\n    .big-map{\n        height: 55vh;\n        width: 100%;\n        display: block;\n        position: relative;\n    }\n    .message{\n        margin-top: 20px;\n    }\n    .info{\n        padding-bottom: 10px;\n        padding-top: 0px;\n        .title{\n            margin: 25px 0 10px;\n        }\n    }\n}\n\n\n.blog-post{\n    .section-blog-info{\n        padding-top: 30px;\n        padding-bottom: 0px;\n\n        .btn{\n            margin-top: 0;\n            margin-bottom: 0;\n        }\n        .blog-tags{\n            padding-top: 8px;\n        }\n        .card-profile{\n            margin-top: 0;\n            text-align: left;\n\n            .description{\n                font-size: $font-size-base;\n            }\n            .btn{\n                margin-top: 25px;\n            }\n        }\n    }\n    .section-comments{\n        .title{\n            margin-bottom: 30px;\n        }\n    }\n\n    .media{\n        p{\n            color: $default-color;\n        }\n    }\n}\n\n.about-us{\n    .page-header{\n        .container{\n            color: #FFFFFF;\n            text-align: center;\n        }\n        .title{\n            color: $white-color;\n        }\n    }\n    .about-description{\n        padding: 70px 0px 0px 0px;\n    }\n    .about-services{\n        padding-top: 10px;\n    }\n    .about-office{\n        .description{\n            margin-bottom: 70px;\n        }\n        img{\n            margin: 20px 0px;\n        }\n    }\n\n    .about-contact,\n    .about-office{\n        padding: 80px 0px;\n        .description{\n            margin-bottom: 70px;\n        }\n    }\n}\n\n.sections-page .page-header{\n  display: flex;\n  align-items: center;\n}\n","@mixin linear-gradient($color1, $color2){\n    background: $color1; /* For browsers that do not support gradients */\n    background: -webkit-linear-gradient(90deg, $color1 , $color2); /* For Safari 5.1 to 6.0 */\n    background: -o-linear-gradient(90deg, $color1, $color2); /* For Opera 11.1 to 12.0 */\n    background: -moz-linear-gradient(90deg, $color1, $color2); /* For Firefox 3.6 to 15 */\n    background: linear-gradient(0deg, $color1 , $color2); /* Standard syntax */\n}\n",".section{\n    padding: 70px 0;\n    position: relative;\n    background: $white-color;\n\n    .row + .category{\n        margin-top: $margin-base-vertical;\n    }\n}\n.section-navbars{\n    padding-bottom: 0;\n}\n\n.section-full-screen{\n    height: 100vh;\n}\n.section-signup{\n    padding-top: 20vh;\n}\n\n.page-header{\n  min-height: 100vh;\n  max-height: 999px;\n  padding: 0;\n  color: $white-color;\n  position: relative;\n  overflow: hidden;\n\n  & > .content{\n    margin-top: 12%;\n    text-align: center;\n    margin-bottom: 50px;\n  }\n\n  &.page-header-small{\n      min-height: 60vh;\n      max-height: 440px;\n  }\n\n  &:before{\n      background-color: rgba(0,0,0,.3);\n  }\n\n  > .container{\n    z-index: 2;\n    padding-top: 12vh;\n    padding-bottom: 40px;\n  }\n\n    .page-header-image{\n        position: absolute;\n        background-size: cover;\n        background-position: center center;\n        width: 100%;\n        height: 100%;\n        z-index: -1;\n    }\n\n    .content-center{\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 2;\n      -ms-transform: translate(-50%, -50%);\n      -webkit-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n      text-align: center;\n      color: #FFFFFF;\n      padding: 0 15px;\n      width: 100%;\n      max-width: 880px;\n\n    }\n\n    footer{\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n    .container{\n        height: 100%;\n        z-index: 1;\n        text-align: center;\n        position: relative;\n    }\n\n    .category,\n    .description{\n      color: $opacity-8;\n    }\n\n    &:after,\n    &:before{\n        position: absolute;\n        z-index: 0;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n    }\n}\n\n.clear-filter{\n    &:after,\n    &:before{\n        display: none;\n    }\n\n    &[filter-color=\"orange\"]{\n        @include linear-gradient(rgba($black-color,.20), rgba(224, 23, 3, 0.6));\n    }\n}\n\n.section-story-overview{\n    padding: 50px 0;\n\n    .image-container{\n        height: 335px;\n        position: relative;\n        background-position: center center;\n        background-size: cover;\n        box-shadow: $box-shadow-raised;\n        border-radius: .25rem;\n\n        & + .category{\n            padding-top: 15px;\n        }\n\n        &.image-right{\n            z-index: 2;\n\n            + h3.title{\n                margin-top: 120px;\n            }\n        }\n\n        &.image-left{\n            z-index: 1;\n        }\n\n        &:nth-child(2){\n            margin-top: 420px;\n            margin-left: -105px;\n        }\n    }\n\n    p.blockquote{\n        width: 220px;\n        min-height: 180px;\n        text-align: left;\n        position: absolute;\n        top: 376px;\n        right: 155px;\n        z-index: 0;\n    }\n}\n\n.section-nucleo-icons{\n     .nucleo-container img{\n        width: auto;\n        left: 0;\n        top: 0;\n        height: 100%;\n        position: absolute;\n    }\n\n     .nucleo-container{\n        height: 335px;\n        position: relative;\n    }\n\n     h5{\n        margin-bottom: 35px;\n    }\n\n     .icons-container{\n        position: relative;\n        max-width: 450px;\n        height: 300px;\n        max-height: 300px;\n        margin: 0 auto;\n\n    }\n     .icons-container i{\n        font-size: 34px;\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n\n     .icons-container i:nth-child(1){\n        top: 5%;\n        left: 7%;\n    }\n\n     .icons-container i:nth-child(2){\n         top: 28%;\n         left: 24%;\n    }\n\n     .icons-container i:nth-child(3){\n         top: 40%;\n    }\n\n     .icons-container i:nth-child(4){\n         top: 18%;\n         left: 62%;\n    }\n\n     .icons-container i:nth-child(5){\n         top: 74%;\n         left: 3%;\n    }\n\n     .icons-container i:nth-child(6){\n         top: 36%;\n         left: 44%;\n        font-size: 65px;\n        color: #f96332;\n        padding: 1px;\n    }\n\n     .icons-container i:nth-child(7){\n         top: 59%;\n         left: 26%;\n    }\n\n     .icons-container i:nth-child(8){\n         top: 60%;\n         left: 69%;\n    }\n\n     .icons-container i:nth-child(9){\n        top: 72%;\n        left: 47%;\n    }\n\n     .icons-container i:nth-child(10){\n         top: 88%;\n         left: 27%;\n    }\n\n     .icons-container i:nth-child(11){\n         top: 31%;\n         left: 80%;\n    }\n\n     .icons-container i:nth-child(12){\n         top: 88%;\n         left: 68%;\n    }\n\n     .icons-container i:nth-child(13){\n         top: 5%;\n         left: 81%;\n    }\n\n     .icons-container i:nth-child(14){\n         top: 58%;\n         left: 90%;\n    }\n\n     .icons-container i:nth-child(15){\n        top: 6%;\n        left: 40%;\n    }\n}\n\n.section-images{\n    max-height: 670px;\n    height: 670px;\n\n    .hero-images-container,\n    .hero-images-container-1,\n    .hero-images-container-2{\n        margin-top: -38vh;\n    }\n\n    .hero-images-container{\n        max-width: 670px;\n    }\n\n    .hero-images-container-1{\n        max-width: 390px;\n        position: absolute;\n        top: 55%;\n        right: 18%;\n\n    }\n\n    .hero-images-container-2{\n        max-width: 225px;\n        position: absolute;\n        top: 68%;\n        right: 12%;\n    }\n}\n\n\n[data-background-color=\"orange\"]{\n    background-color: $orange-bg;\n}\n[data-background-color=\"black\"]{\n    background-color: $black-color;\n}\n\n[data-background-color]:not([data-background-color=\"gray\"]){\n    color: $white-color;\n\n    .title,\n    .social-description h2,\n    p,\n    p.blockquote,\n    p.blockquote small{\n        color: $white-color;\n    }\n\n    .separator{\n        background-color: $white-color;\n    }\n\n    .navbar.bg-white p{\n        color: $default-color;\n    }\n\n    h1,h2,h3,h4,h5,h6,a:not(.btn):not(.dropdown-item),\n    .icons-container{\n      color: $white-color;\n    }\n\n    .input-group-text,\n    .form-group.no-border .input-group-text,\n    .input-group.no-border .input-group-text{\n      color: $opacity-8;\n    }\n\n    .description,\n    .social-description p{\n        color: $opacity-8;\n    }\n\n    p.blockquote{\n        border-color: $opacity-2;\n    }\n\n    //radio and checkboxes\n    .checkbox label::before,\n    .checkbox label::after,\n    .radio label::before,\n    .radio label::after{\n        border-color: $opacity-2;\n    }\n\n    .checkbox label::after,\n    .checkbox label,\n    .radio label{\n        color: $white-color;\n    }\n\n    .checkbox input[type=\"checkbox\"]:disabled + label,\n    .radio input[type=\"radio\"]:disabled + label  {\n        color: $white-color;\n    }\n\n    .radio input[type=\"radio\"]:not(:disabled):hover + label::after,\n    .radio input[type=\"radio\"]:checked + label::after {\n        background-color: $white-color;\n        border-color: $white-color;\n    }\n\n    //inputs\n    @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\n\n    //buttons\n    .btn[class*=\"btn-outline-\"] {\n        background-color: $transparent-bg;\n        border-color: $opacity-5;\n        color: $white-color;\n\n        &:hover,\n        &:focus,\n        &:not(:disabled):not(.disabled):active,\n        &:not(:disabled):not(.disabled).active,\n        &:not(:disabled):not(.disabled):active:focus,\n        &:not(:disabled):not(.disabled).active:focus,\n        &:active:hover,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover {\n            background-color: $transparent-bg;\n            border-color: $white-color;\n            color: $white-color;\n        }\n    }\n\n    //tabs\n    .nav-tabs{\n        > .nav-item{\n            >.nav-link{\n                i.now-ui-icons{\n                    color: $white-color;\n                }\n            }\n        }\n    }\n\n    &.section-nucleo-icons .icons-container i:nth-child(6){\n        color: $white-color;\n    }\n}\n",".parallax-s{\n    overflow: hidden;\n    height: 500px;\n    width: 100%;\n}\n\n.section-image{\n    background-size: cover;\n    background-position: center center;\n    position: relative;\n    width: 100%;\n\n    .title,\n    .card-plain .card-title{\n        color: $white-color;\n    }\n\n    .nav-pills .nav-link{\n        background-color: $white-color;\n\n        &:hover,\n        &:focus{\n            background-color: $white-color;\n        }\n    }\n\n    .info-title,\n    .info.info-horizontal .icon i,\n    .card-pricing.card-plain ul li{\n        color: $white-color;\n    }\n    .description,\n    .info .icon:not(.icon-circle){\n        color: $opacity-8;\n    }\n    .card:not(.card-plain){\n        .info-title{\n            color: $black-color;\n        }\n        .info p,\n        .info .icon,\n        .description{\n            color: $dark-gray;\n        }\n    }\n\n    .footer{\n        color: $white-color;\n    }\n    .card-plain{\n        [class*=\"text-\"],\n        ul li b{\n            color: $white-color;\n        }\n        .category{\n            color: rgba($white-color,.5);\n        }\n    }\n\n    &:after{\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n        background-color: rgba(0,0,0,.7);\n    }\n\n    .container{\n        z-index: 2;\n        position: relative;\n    }\n}\n\n.page-header{\n    .signup-page &{\n        max-height: fit-content;\n        display: block;\n        align-items: unset;\n    }\n\n    &.page-header-mini{\n        min-height: 40vh;\n        max-height: 340px;\n    }\n\n    .title{\n        margin-bottom: 15px;\n    }\n    .title + h4{\n        margin-top: 10px;\n    }\n\n\n}\n\n.section-story-overview{\n    padding: 50px 0;\n\n    .image-container{\n        img{\n            width: 100%;\n            left: 0;\n            top: 0;\n            height: auto;\n            position: absolute;\n        }\n    }\n}\n\n\n[data-background-color=\"gray\"]{\n    background-color: lighten($default-color, 40%);\n}\n\n[data-background-color]:not([data-background-color=\"gray\"]){\n\n    .separator-line{\n        background-color: $opacity-5;\n    }\n\n    .footer{\n        &.footer-white .footer-brand,\n        &.footer-white ul li > a.nav-link:not(.btn-icon){\n            color: initial;\n        }\n    }\n\n    .card:not(.card-plain) .category,\n    .card:not(.card-plain) .card-description,\n    & .card:not(.card-plain) .category,\n    & .card:not(.card-plain) .category{\n        color: $dark-gray;\n    }\n\n    .card:not(.card-plain) .card-title,\n    & .card:not(.card-plain) .card-title{\n        color: initial;\n    }\n\n    .carousel .carousel-inner{\n        box-shadow: none;\n    }\n\n    h1,h2,h3,h4,h5,h6,\n    a:not(.btn):not(.dropdown-item):not(.card-link),\n    .icons-container i,\n    &.card-pricing ul li,\n    .info.info-horizontal .icon i,\n    .card-pricing.card-plain ul li{\n        color: $white-color;\n    }\n\n    &.card a:not(.btn):not(.dropdown-item){\n        color: $white-color;\n\n        &:hover,\n        &:focus{\n            border-color: $white-color;\n        }\n    }\n\n    &.footer hr,\n    &.card-pricing .icon i,\n    &.card-pricing ul li{\n        border-color: $opacity-2;\n    }\n\n    .card-footer .stats i,\n    &.card-plain .category,\n    .card-plain .category,\n    .card-header:after{\n        color: $opacity-5;\n    }\n\n    &.card-pricing ul li i,\n    &.card-pricing ul li b,\n    .card-pricing.card-plain ul li b,\n    .card-category,\n    .author span,\n    .card-pricing.card-plain ul li i{\n        color: $opacity-8 !important;\n    }\n\n    .input-group-text,\n    .form-group.no-border .input-group-text,\n    .input-group.no-border .input-group-text{\n        color: $opacity-8;\n    }\n\n    .subscribe-line{\n        .form-control{\n            background-color: $transparent-bg;\n            border: 1px solid $light-gray;\n            color: $black-color;\n\n            &:last-child{\n                border-left: 0 none;\n            }\n        }\n\n        .input-group-text,\n        .form-group.no-border .input-group-text,\n        .input-group.no-border .input-group-text{\n            color: $dark-background;\n            border: 1px solid $light-gray;\n        }\n    }\n}\n\n[class*=\"features-\"],\n[class*=\"team-\"],\n[class*=\"projects-\"],\n[class*=\"pricing-\"],\n[class*=\"testimonials-\"],\n[class*=\"contactus-\"]{\n    padding: 80px 0;\n}\n\n\n@import 'sections/_headers';\n@import 'sections/_features';\n@import 'sections/_blogs';\n@import 'sections/_team';\n@import 'sections/_projects';\n@import 'sections/_pricing';\n@import 'sections/_testimonials';\n@import 'sections/_contactus';\n\n@import 'sections/_social-subscribe-lines';\n",".page-header{\n    .carousel .carousel-indicators{\n        bottom: 60px;\n    }\n\n    .container{\n        color: #FFFFFF;\n    }\n\n    .title{\n        color: $white-color;\n    }\n\n    &.header-small{\n        height: 65vh;\n        min-height: 65vh;\n\n        .container{\n            padding-top: 20vh;\n        }\n    }\n}\n\n.header-filter{\n    position: relative;\n\n    .container{\n        z-index: 2;\n        position: relative;\n    }\n\n    .info-title,\n    .info.info-horizontal .icon i,\n    .card-pricing.card-plain ul li{\n      color: $white-color;\n    }\n\n    &[filter-color=\"orange\"]{\n        @include linear-gradient(rgba($black-color,.20), rgba(224, 23, 3, 0.6));\n    }\n    &[filter-color=\"black\"]{\n        @include linear-gradient(rgba($black-color,.20), rgba(0, 0, 0, 0.7));\n    }\n}\n.clear-filter{\n    &:before{\n        display: none;\n    }\n}\n\n.iframe-container iframe{\n    width: 100%;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.3);\n}\n\n.header-1,\n.header-2,\n.header-3{\n    .wrapper{\n        background: #CCCCCC;\n    }\n    .content-center{\n        max-width: none !important;\n    }\n}\n\n.header-2,\n.header-1{\n    .page-header{\n        .card{\n            margin-top: 60px;\n        }\n    }\n}\n\n.header-3{\n    .btn{\n        margin: 0;\n    }\n    h6{\n        margin-bottom: 0;\n    }\n}\n",".phone-container{\n    img{\n        width: 100%;\n    }\n}\n\n.features-2,\n.features-1,\n.features-3{\n    text-align: center;\n}\n\n.features-4{\n    .card{\n        margin-top: 70px;\n    }\n}\n\n.features-2{\n    .info-title,\n    .title{\n        color: $white-color;\n    }\n}\n\n.features-5{\n    .info{\n        max-width: none;\n        margin: 0 auto;\n        padding: 10px 0 0px;\n    }\n    .phone-container{\n        max-width: 200px;\n        margin: 0 auto;\n    }\n}\n\n.features-6{\n    .phone-container{\n        max-width: 260px;\n        margin: 60px auto 0;\n    }\n    .info{\n        max-width: none;\n        margin: 0 auto;\n        padding: 10px 0 0px;\n    }\n    .info:first-child{\n        padding-top: 130px;\n    }\n}\n\n.features-7,\n.features-2,\n.features-8{\n    position: relative;\n\n    &:after{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        background-color: rgba(0,0,0,.5);\n    }\n\n    .container,\n    .container-fluid,\n    .title,\n    .description{\n        position: relative;\n        z-index: 2;\n    }\n}\n\n.features-8,\n.features-7{\n    .title{\n        color: #FFFFFF;\n    }\n}\n\n.features-8{\n    .title + .description{\n        margin-bottom: 70px;\n    }\n}\n\n.features-7{\n    overflow: hidden;\n\n    .info-title{\n        color: #FFFFFF;\n    }\n    .info-horizontal{\n        padding: 15px 0 0;\n\n        &:first-child{\n            padding-top: 45px;\n        }\n    }\n\n    .image-container{\n        max-width: 1200px;\n        position: relative;\n        height: 550px;\n        margin-top: 58px;\n\n        img{\n            max-width: 1200px;\n            left: 100px;\n            top: 0;\n            height: 100%;\n            position: absolute;\n        }\n    }\n}\n\n.tablet-container{\n    margin-top: 40px;\n}\n","[class*=\"blogs-\"]{\n    padding: 50px 0;\n}\n\n\n.blogs-1{\n    .card{\n        margin-bottom: 80px;\n    }\n}\n\n.blogs-4{\n    .card{\n        margin-bottom: 60px;\n        text-align: center;\n    }\n}\n",".team-2{\n    .card{\n        .card-title{\n            margin: 10px 0 0;\n        }\n        h6{\n            margin-top: 5px;\n        }\n    }\n\n    [class*=\"col-md-\"]:nth-child(2){\n        margin-top: 45px;\n    }\n}\n\n.team-3{\n    .card.card-profile{\n        .card-image a > img{\n            border-radius: 0;\n            border-bottom-left-radius: $border-radius-small;\n            border-top-left-radius: $border-radius-small;\n        }\n\n        .card-title{\n            margin-top: 15px;\n        }\n    }\n}\n\n\n.team-4{\n    .card{\n        text-align: left;\n\n        .footer{\n            margin-top: 0;\n        }\n    }\n}\n\n.team-5{\n    h5.description{\n        margin-bottom: 100px;\n    }\n\n    [class*=\"col-md-\"]{\n        margin-top: 50px;\n\n        &:nth-child(2){\n            margin-top: 95px;\n        }\n    }\n\n    .card.card-profile{\n        .card-title + .category{\n            margin-bottom: .625rem;\n        }\n    }\n}\n",".projects-1{\n    .card-title{\n        margin-top: 10px\n    }\n}\n\n.projects-2{\n    h2.title{\n        margin-top: 5px;\n        margin-bottom: 15px;\n    }\n    .card-title{\n        margin-bottom: 5px;\n    }\n    .category{\n        color: $default-color;\n        margin-top: 5px;\n    }\n    .card-description{\n        margin-top: 20px;\n    }\n    .card{\n        text-align: center;\n    }\n}\n\n.projects-3{\n    h2.title,\n    h3.title{\n        margin-bottom: 80px;\n        margin-top: 5px;\n    }\n\n    .card{\n        margin-bottom: 30px;\n        text-align: center;\n    }\n    .category{\n        margin-bottom: 5px;\n    }\n    .card-title{\n        margin-top: 10px;\n    }\n\n\n}\n\n.projects-5{\n    h2.title{\n        margin-top: 5px;\n        margin-bottom: 15px;\n    }\n\n    .info{\n        padding: 0;\n\n        p{\n            margin: 0;\n        }\n    }\n\n    .card-background{\n        margin-bottom: 0;\n\n         .card-body{\n            padding-top: 140px;\n            padding-bottom: 140px;\n        }\n    }\n    hr{\n        margin: 70px auto;\n        max-width: 970px;\n    }\n}\n",".pricing-1{\n    h2.title{\n        margin-bottom: 10px;\n    }\n\n    .card-separator{\n        width: 1px;\n        display: block;\n        height: 100%;\n        background-color: rgba($default-color, .2);\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n    // &.section-image:after{\n    //     background-color: rgba(0, 0, 0, 0.8);\n    // }\n}\n\n.pricing-2{\n    .nav-pills{\n        margin-bottom: 50px;\n    }\n\n}\n\n.pricing-5{\n    .nav-pills{\n        margin-top: 50px;\n        margin-bottom: 50px;\n    }\n}\n\n.pricing-3,\n.pricing-4{\n    .title{\n        margin-bottom: 10px;\n    }\n}\n",".testimonials-1{\n    .description{\n        margin-bottom: 50px;\n    }\n}\n\n.section-testimonials,\n.testimonials-2{\n        background-image: none;\n\n        .card-profile{\n            .card-title,\n            .card-description{\n                text-align: left !important;\n            }\n        }\n        .card-image{\n            margin: 0;\n        }\n        .carousel{\n            .carousel-inner{\n                box-shadow: none;\n            }\n\n            .carousel-control-prev,\n            .carousel-control-next{\n                i{\n                    color: $light-black;\n                }\n            }\n        }\n        .testimonials-people{\n            position: relative;\n\n            img{\n                position: absolute;\n                border-radius: 50%;\n                z-index: 4;\n            }\n            .left-first-person{\n                left: 2%;\n                top: 2%;\n                height: 70px;\n                width: 70px;\n            }\n            .left-second-person{\n                left: 65%;\n                top: 100%;\n                height: 70px;\n                width: 70px;\n            }\n            .left-third-person{\n                left: -25%;\n                top: 135%;\n                height: 120px;\n                width: 120px;\n            }\n            .left-fourth-person{\n                left: 40%;\n                top: 180%;\n                height: 40px;\n                width: 40px;\n            }\n            .left-fifth-person{\n                left: 95%;\n                top: 220%;\n                height: 45px;\n                width: 45px;\n            }\n            .left-sixth-person{\n                left: 40%;\n                top: 265%;\n                height: 95px;\n                width: 95px;\n            }\n            .right-first-person{\n                right: 2%;\n                top: 0;\n                height: 60px;\n                width: 60px;\n            }\n            .right-second-person{\n                right: 30%;\n                top: 60%;\n                height: 70px;\n                width: 70px;\n            }\n            .right-third-person{\n                right: 95%;\n                top: 95%;\n                height: 50px;\n                width: 50px;\n            }\n            .right-fourth-person{\n                right: 66%;\n                top: 145%;\n                height: 40px;\n                width: 40px;\n            }\n            .right-fifth-person{\n                right: 90%;\n                top: 210%;\n                height: 100px;\n                width: 100px;\n            }\n            .right-sixth-person{\n                right: 15%;\n                top: 240%;\n                height: 70px;\n                width: 70px;\n            }\n        }\n    }\n",".contactus-1{\n    .info{\n        padding: 0;\n        margin: 0;\n\n        &:first-child{\n            margin-top: 30px;\n        }\n\n        .info-title{\n            margin-top: 20px;\n            color: $white-color;\n        }\n\n        .icon{\n            margin-top: 19px;\n            color: $white-color;\n        }\n    }\n\n    .card-contact{\n        margin-top: 30px;\n    }\n}\n\n\n.contactus-2{\n    padding: 0;\n    position: relative;\n\n    .card-contact{\n        max-width: 560px;\n        margin: 80px 0 80px 150px;\n\n        .info{\n            padding: 0;\n            margin: 0;\n        }\n    }\n    .map{\n        width: 100%;\n        height: 100%;\n        position: absolute;\n    }\n\n    .info-horizontal .icon{\n        margin-top: 28px;\n\n        > i{\n            font-size: 2.2em;\n            max-width: 45px;\n\n        }\n    }\n}\n",".social-line-big-icons{\n    [class*=\"col-\"]{\n        border-right: 1px solid $light-gray;\n\n        &:last-child{\n            border: 0;\n        }\n    }\n\n    .btn{\n        margin: 0;\n        width: 100%;\n        padding-top: 30px !important;\n        padding-bottom: 30px !important;\n        height: auto;\n        border: 0;\n\n        .fab{\n            font-size: 25px;\n        }\n    }\n}\n\n.social-line{\n    padding: .85rem 0;\n}\n\n.subscribe-line{\n    padding: 15px * 2 0;\n\n    .card{\n        margin-top: 54px;\n\n        .card-block{\n            min-height: auto;\n        }\n    }\n    &.subscribe-line-image{\n        position: relative;\n\n        background-position: center center;\n        background-size: cover;\n\n        .description{\n            color: $opacity-8;\n        }\n\n        .title{\n            color: $white-color;\n        }\n        &:after{\n            position: absolute;\n            z-index: 1;\n            width: 100%;\n            height: 100%;\n            display: block;\n            left: 0;\n            top: 0;\n            content: \"\";\n            background-color: rgba(0,0,0,.66);\n        }\n\n        .container{\n            z-index: 2;\n            position: relative;\n        }\n    }\n}\n\n.social-line-white,\n.subscribe-line-white{\n    background-color: $white-color;\n}\n.social-line-black,\n.subscribe-line-black{\n    background-color: $black-color;\n\n    [class*=\"col-\"]{\n        border-color: rgba(255, 255, 255, 0.1);\n    }\n}\n\n[data-background-color]{\n    .social-line{\n        h1,h2,h3,h4,h5,h6{\n            color: initial;\n        }\n\n        .btn.btn-simple{\n            border: 0;\n        }\n    }\n}\n","@media screen and (max-width: 991px){\n    @include navbar-collapse();\n\n    .profile-photo .profile-photo-small{\n        margin-left: -2px;\n    }\n\n    [class*=\"navbar-toggleable-\"] .navbar-collapse{\n        width: 300px;\n    }\n\n    .button-dropdown{\n        display: none;\n    }\n\n    .section-nucleo-icons .container .row > [class*=\"col-\"]:first-child{\n        text-align: center;\n    }\n\n    .footer{\n        .copyright{\n            text-align: right;\n        }\n    }\n\n    .section-nucleo-icons .icons-container{\n        margin-top: 65px;\n    }\n\n    .section-images{\n        height: 500px;\n        max-height: 500px;\n\n        .hero-images-container{\n            max-width: 500px;\n        }\n\n        .hero-images-container-1{\n            right: 10%;\n            top: 68%;\n            max-width: 269px;\n        }\n\n        .hero-images-container-2{\n            right: 5%;\n            max-width: 135px;\n            top: 93%;\n        }\n    }\n\n    .nav-open{\n        .navbar-collapse{\n            @include transform-translate-x(0px);\n        }\n\n        .wrapper{\n            @include transform-translate-x(-150px);\n        }\n\n        .navbar-translate{\n            @include transform-translate-x(-300px);\n        }\n\n        .menu-on-left{\n            .navbar-collapse{\n                @include transform-translate-x(0px);\n            }\n\n            .navbar-translate{\n                @include transform-translate-x(300px);\n            }\n\n            .wrapper{\n                @include transform-translate-x(150px);\n            }\n\n            #bodyClick{\n                right: auto;\n                left: 300px;\n            }\n        }\n    }\n}\n\n@media screen and (min-width: 992px){\n    .navbar-nav{\n        .nav-link{\n            &.profile-photo{\n                padding: 0;\n                margin: 7px $padding-base-horizontal;\n            }\n\n            &.btn:not(.btn-sm){\n                margin: 0;\n            }\n        }\n\n        .nav-item:not(:last-child){\n            margin-right: 5px;\n        }\n\n    }\n    .navbar-collapse:not(.has-image){\n      background: transparent !important;\n    }\n\n    .card.card-form-horizontal{\n        [class*=\"col-sm-\"]:not(:last-child),\n        [class*=\"col-md-\"]:not(:last-child){\n            padding-right: 0;\n        }\n    }\n\n    .burger-menu{\n        @include navbar-collapse();\n\n        .navbar-toggler{\n          display: block;\n        }\n\n        .navbar-collapse {\n            display: block !important;\n\n            .navbar-nav {\n                position: relative;\n                max-height: calc(100vh - 75px);\n                min-height: 100%;\n                overflow: auto;\n                margin-top: 53px;\n                height: 100%;\n                z-index: 2;\n                position: relative;\n                display: -webkit-box;\n                display: -webkit-flex;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-orient: vertical;\n                -webkit-box-direction: normal;\n                -webkit-flex-direction: column;\n                -ms-flex-direction: column;\n                flex-direction: column;\n\n                .nav-item{\n                    margin: 0;\n                }\n            }\n        }\n\n        .navbar-nav .dropdown-menu{\n          position: static;\n          float: none;\n        }\n\n        &.menu-on-left{\n          .navbar-collapse{\n              right: auto;\n              left: 0;\n              @include transform-translate-x(-300px);\n          }\n\n          .navbar-translate {\n            flex-direction: row-reverse;\n          }\n        }\n\n        .navbar-toggleable-md{\n            .navbar-nav .dropdown-menu{\n                position: static;\n                float: none;\n            }\n\n            .navbar-toggler{\n                display: inline-block;\n            }\n        }\n\n        .nav-open &{\n            &.menu-on-left .navbar .navbar-translate{\n                @include transform-translate-x(300px);\n            }\n\n            .navbar .navbar-translate{\n                @include transform-translate-x(-300px);\n            }\n\n            &.menu-on-left .navbar-collapse,\n            .navbar-collapse{\n                @include transform-translate-x(0px);\n            }\n\n            &.menu-on-left #bodyClick{\n                right: auto;\n                left: 300px;\n            }\n        }\n\n        &.menu-on-left .navbar-brand{\n            float: right;\n            margin-right: 0;\n            margin-left: 1rem;\n        }\n    }\n\n\n\n    .section-nucleo-icons .icons-container{\n        margin: 0 0 0 auto;\n    }\n\n    .footer:not(.footer-big){\n        .copyright{\n            float: right;\n        }\n    }\n}\n\n@media screen and (min-width: 768px){\n    .image-container{\n        &.image-right{\n            top: 80px;\n            margin-left: - 100px;\n            margin-bottom: 130px;\n        }\n\n        &.image-left{\n            margin-right: -100px;\n        }\n    }\n}\n\n@media screen and (max-width: 768px){\n    .image-container{\n        &.image-left{\n            margin-bottom: 260px;\n\n            p.blockquote{\n                margin: 0 auto;\n                position: relative;\n                right: 0;\n            }\n        }\n    }\n\n    .profile-page{\n      .page-header{\n          min-height: 580px !important;\n      }\n    }\n\n    .header-2{\n        .card-form-horizontal .input-group, .card-form-horizontal .form-group{\n            margin-bottom: 10px;\n        }\n    }\n\n    .contactus-2 .card-contact{\n        max-width: inherit;\n        margin:0;\n        margin-top: 15px;\n    }\n\n    .section-story-overview .image-container + .category{\n        padding-top: 50px;\n    }\n\n    .features-7 .image-container img{\n        left: 0px;\n        top: 0;\n        max-width: inherit;\n        width: 100%;\n        height: auto;\n        position: relative;\n    }\n\n    .footer.footer-big .social-feed i{\n        padding-bottom: 10px;\n    }\n\n    .nav-tabs{\n        display: inline-block;\n        width: 100%;\n        padding-left: 100px;\n        padding-right: 100px;\n        text-align: center;\n\n        .nav-item > .nav-link{\n            margin-bottom: 5px;\n        }\n    }\n\n    .landing-page .section-story-overview .image-container:nth-child(2){\n        margin-left: 0;\n        margin-bottom: 30px;\n    }\n}\n\n@media screen and (max-width: 580px) {\n    .alert{\n        button.close{\n            position: absolute;\n            right: 6px;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n}\n\n\n\n@media screen and (max-width: 576px){\n    .navbar[class*='navbar-toggleable-'] .container{\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .typography-line span{\n        margin-left: 0;\n    }\n\n    .team-4{\n      .card-profile .card-footer{\n        text-align: center;\n      }\n    }\n\n    .nav-pills.nav-pills-just-icons{\n      justify-content: center;\n\n      .nav-item .nav-link{\n        margin-top: 15px;\n        margin-left: auto;\n        margin-right: auto;\n      }\n    }\n\n    .footer{\n      .pull-left,\n      .footer-brand,\n      .pull-right{\n        float: unset;\n      }\n    }\n\n    .media{\n      display: block;\n\n      .media{\n        padding-left: 35px;\n      }\n    }\n\n    .fileinput{\n      margin: 0 auto;\n      width: stretch;\n    }\n\n    .header-3{\n      .buttons{\n        text-align: center!important;\n      }\n    }\n\n    .blog-post{\n      .button-container > .btn:first-child{\n        display: block;\n      }\n    }\n\n    .testimonials-2{\n      .card-testimonial .card-body{\n        max-width: 350px;\n        min-height: 400px;\n        margin: 0 auto;\n      }\n    }\n\n    .footer{\n        .copyright{\n            text-align: center;\n        }\n    }\n\n    .projects-1{\n        .nav-pills{\n            display: block;\n\n            .nav-item{\n              min-width: 200px\n            }\n\n            &:not(.flex-column) .nav-item:not(:last-child) .nav-link{\n              margin-right: 0;\n            }\n\n            .nav-item .nav-link{\n                margin: 0 auto;\n                margin-bottom: 15px;\n            }\n        }\n    }\n\n\n\n    .subscribe-line .card-form-horizontal .btn{\n        margin-top: 10px;\n    }\n\n    .modal .modal-dialog .modal-header button.close{\n        font-size: 18px;\n        right: 12px;\n        top:10px;\n    }\n\n    .header-3 .btn{\n        margin-bottom: 10px;\n    }\n\n    .card.card-fashion:not(.card-background):before{\n        display: none;\n    }\n\n    .profile-page{\n        .content-center{\n            margin: 10px 0 0;\n\n            .content .social-description{\n                width: 105px;\n                max-width: 105px;\n            }\n        }\n    }\n\n    .section-nucleo-icons{\n        .icons-container{\n            i{\n                font-size: 30px;\n\n                &:nth-child(6){\n                    font-size: 48px;\n                }\n            }\n        }\n    }\n\n    .page-header{\n        .container h6.category-absolute{\n            width: 90%;\n        }\n    }\n}\n\n@media screen and (min-width: 991px) and (max-width: 1200px){\n    .section-images{\n        .hero-images-container-1{\n            right: 9%;\n            max-width: 370px;\n        }\n\n        .hero-images-container-2{\n            right: 2%;\n            max-width: 216px;\n        }\n    }\n}\n\n@media screen and (max-width: 768px){\n    .section-images{\n        height: 300px;\n        max-height: 300px;\n\n        .hero-images-container{\n            max-width: 380px;\n        }\n\n        .hero-images-container-1{\n            right: 7%;\n            top: 87%;\n            max-width: 210px;\n        }\n\n        .hero-images-container-2{\n            right: 1%;\n            max-width: 133px;\n            top: 99%;\n        }\n    }\n\n    .pricing-5{\n      .title{\n        text-align: center;\n      }\n\n      .nav-pills{\n        justify-content: center;\n      }\n    }\n\n    .footer nav{\n        display: block;\n        float: none;\n    }\n\n    #social-buttons > .row{\n        .col-md-1:nth-child(2) p,\n        .col-md-1:nth-child(3) p,\n        .col-md-3 p{\n            display: none;\n        }\n    }\n}\n\n@media screen and (max-width: 517px) {\n    .alert .alert-icon{\n        margin-top: 10px;\n    }\n}\n\n@media screen and (min-width: 1200px) {\n    .section-images{\n        .hero-images-container-1{\n            top: 51%;\n            right: 21%;\n        }\n\n        .hero-images-container-2{\n            top: 66%;\n            right: 14%;\n        }\n    }\n}\n\n@media only screen and (min-height: 950px) {\n  .index-page .page-header .category-absolute{\n    margin-top: -330px;\n  }\n}\n","@mixin navbar-responsive() {\n  .menu-on-left .navbar-translate {\n    flex-direction: row-reverse;\n  }\n\n  .navbar {\n    .navbar-nav {\n      margin-top: 53px;\n      position: relative;\n      max-height: calc(100vh - 75px);\n      min-height: 100%;\n      overflow: auto;\n\n      &.navbar-logo {\n        top: 0;\n        height: 53px;\n      }\n    }\n\n    .dropdown.show .dropdown-menu,\n    .dropdown .dropdown-menu {\n      background-color: transparent;\n      border: 0;\n      transition: none;\n      -webkit-box-shadow: none;\n      box-shadow: none;\n      width: auto;\n      margin: 0 1rem;\n      margin-bottom: 15px;\n      padding-top: 0;\n      height: 125px;\n      overflow-y: scroll;\n\n      &:before {\n        display: none;\n      }\n    }\n\n    .dropdown {\n      .dropdown-item {\n        padding-left: 2.5rem;\n      }\n\n      .dropdown-menu {\n        display: none;\n      }\n\n      &.show .dropdown-menu {\n        display: block;\n      }\n    }\n\n    .dropdown-menu .dropdown-item:focus,\n    .dropdown-menu .dropdown-item:hover {\n      color: $white-color;\n      border-radius: $border-radius-small;\n    }\n\n    .navbar-translate {\n      width: 100%;\n      position: relative;\n      display: flex;\n      -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n      -ms-flex-align: center;\n      align-items: center;\n      @include transform-translate-x(0px);\n      @include transition(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .navbar-toggler-bar {\n      display: block;\n      position: relative;\n      width: 22px;\n      height: 1px;\n      border-radius: 1px;\n      background: $white-bg;\n\n      & + .navbar-toggler-bar {\n        margin-top: 7px;\n      }\n\n      &.bar2 {\n        width: 17px;\n        transition: width 0.2s linear;\n      }\n    }\n\n    &.bg-white:not(.navbar-transparent) .navbar-toggler-bar {\n      background: $default-color;\n    }\n  }\n\n  // .bar1,\n  // .bar2,\n  // .bar3 {\n  //   outline: 1px solid transparent;\n  // }\n  // .bar1 {\n  //   top: 0px;\n  //   @include bar-animation($topbar-back);\n  // }\n  // .bar2 {\n  //   opacity: 1;\n  // }\n  // .bar3 {\n  //   bottom: 0px;\n  //   @include bar-animation($bottombar-back);\n  // }\n  // .toggled .bar1 {\n  //   top: 6px;\n  //   @include bar-animation($topbar-x);\n  // }\n  // .toggled .bar2 {\n  //   opacity: 0;\n  // }\n  // .toggled .bar3 {\n  //   bottom: 6px;\n  //   @include bar-animation($bottombar-x);\n  // }\n\n  .top-bar {\n    transform: rotate(0);\n  }\n  .middle-bar {\n    opacity: 1;\n  }\n  .bottom-bar {\n    transform: rotate(0);\n  }\n\n  .top-bar,\n  .middle-bar,\n  .bottom-bar {\n    transition: all 0.2s;\n  }\n\n  .toggled {\n    .top-bar {\n      transform: rotate(45deg);\n      transform-origin: 0%;\n    }\n    .bottom-bar {\n      transform: rotate(-45deg);\n      transform-origin: 0%;\n    }\n    .middle-bar {\n      opacity: 0;\n    }\n  }\n\n  //\n  // @include topbar-x-rotation();\n  // @include topbar-back-rotation();\n  // @include bottombar-x-rotation();\n  // @include bottombar-back-rotation();\n  //\n  // @-webkit-keyframes fadeIn {\n  //   0% {opacity: 0;}\n  //   100% {opacity: 1;}\n  // }\n  // @-moz-keyframes fadeIn {\n  //   0% {opacity: 0;}\n  //   100% {opacity: 1;}\n  // }\n  // @keyframes fadeIn {\n  //   0% {opacity: 0;}\n  //   100% {opacity: 1;}\n  // }\n}\n\n@mixin navbar-collapse() {\n  .navbar-collapse {\n    position: fixed;\n    display: block !important;\n    top: 0;\n    height: 100% !important;\n    width: 300px;\n    right: 0;\n    z-index: 1032;\n    visibility: visible;\n    background-color: #999;\n    overflow-y: visible;\n    border-top: none;\n    text-align: left;\n\n    max-height: none !important;\n\n    @include transform-translate-x(300px);\n    @include transition(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n    &:before {\n      background: $brand-primary; /* For browsers that do not support gradients */\n      background: -webkit-linear-gradient(\n        $brand-primary 0%,\n        #000 80%\n      ); /* For Safari 5.1 to 6.0 */\n      background: -o-linear-gradient(\n        $brand-primary 0%,\n        #000 80%\n      ); /* For Opera 11.1 to 12.0 */\n      background: -moz-linear-gradient(\n        $brand-primary 0%,\n        #000 80%\n      ); /* For Firefox 3.6 to 15 */\n      background: linear-gradient(\n        $brand-primary 0%,\n        #000 80%\n      ); /* Standard syntax (must be last) */\n      @include opacity(0.76);\n\n      display: block;\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      z-index: -1;\n    }\n\n    .navbar-nav:not(.navbar-logo) {\n      .nav-link {\n        margin: 0 1rem;\n        margin-top: 0.3125rem;\n\n        &:not(.btn) {\n          color: $white-color !important;\n        }\n      }\n    }\n\n    .dropdown-menu .dropdown-item {\n      color: $white-color;\n    }\n  }\n\n  @include navbar-responsive();\n\n  [class*=\"navbar-expand-\"] .navbar-collapse {\n    width: 300px;\n  }\n\n  .wrapper {\n    @include transition(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  }\n\n  #bodyClick {\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    left: auto;\n    right: 300px;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    @include transition(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  }\n}\n","/*! nouislider - 14.0.2 - 6/28/2019 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n/*\n\nThis file was modified by Creative-Tim\n\n*/\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 1px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 15px;\n  height: 15px;\n  left: -7px;\n  top: 0px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 15px;\n  height: 15px;\n  left: 0px;\n  top: -7px;\n}\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -7px;\n  left: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background-color: rgba(182, 182, 182, 0.3);\n  border-radius: 3px;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  // background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border-radius: 3px;\n  background: #FFF;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\n}\n.noUi-active {\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  width: 260px;\n  padding: 4px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: 0.125rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n\n  &:before {\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: -5px;\n    left: 10px;\n    right: auto;\n    color: #ffffff;\n    border-bottom: 0.4em solid;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n  }\n  &:after {\n    border-bottom: 0.4em solid #ffffff;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: -5px;\n    left: 10px;\n  }\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white-color !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  height: 30px;\n  line-height: 33px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover {\n    background-color: $primary-color !important;\n    color: $white-color;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      border-bottom: 1px solid #e3e3e3;\n      font-size: 12px;\n      text-transform: uppercase;\n      font-weight: inherit;\n      padding-bottom: 5px;\n      padding-top: 10px;\n    }\n    .rdtOld,\n    .rdtNew {\n      color: $medium-gray;\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker .dow {\n  width: 14.2857%;\n  border-bottom: none;\n}\n.rdtPicker th.rdtSwitch {\n  width: 50px;\n  padding: 5px;\n  border-radius: 4px;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 21px;\n  vertical-align: top;\n  border-radius: 50%;\n  line-height: 33px;\n}\n\n.rdtPicker {\n  .dow,\n  th.rdtSwitch,\n  th.rdtNext,\n  th.rdtPrev,\n  .rdtTimeToggle {\n    color: $primary-color;\n  }\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: inherit;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $primary-color;\n      border-radius: 50%;\n      border: 1px solid $primary-color;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $medium-gray;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive {\n      background-color: $primary-color !important;\n      color: $white-color;\n    }\n  }\n}\n","/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n\n\n/*\nThis file was modified entirely by Creative Tim for React-Select v2.0.0\n*/\n\n.react-select {\n  margin-bottom: 10px;\n  .react-select__menu{\n    border: 0;\n    box-shadow: 0 10px 50px 0 rgba(0,0,0,.2);\n    border-radius: .125rem;\n    transition: all .15s linear;\n    font-size: 14px;\n    color: #212529;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    margin-top: 0;\n    margin-bottom: .125rem;\n    padding: .5rem 0;\n    margin: .125rem 0 0;\n  }\n  .react-select__menu-list {\n    max-height: 198px;\n    overflow-y: auto;\n    padding-bottom: unset;\n    padding-top: unset;\n    position: relative;\n  }\n  .react-select__option {\n    font-size: 0.8571em;\n    padding-top: .6rem;\n    padding-bottom: .6rem;\n    margin-top: 5px;\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    display: block;\n    outline: none;\n    color: #292b2c;\n    &:first-child{\n      margin-top: 0;\n    }\n  }\n  .react-select__menu{\n    .react-select__option{\n      &,&:active{\n        background-color: transparent;\n      }\n      &.react-select__option--is-selected{\n        &,&.react-select__option--is-focused{\n          &,&:active{\n            background-color: $medium-gray;\n          }\n        }\n      }\n      &.react-select__option--is-focused {\n        &,&:active{\n          background-color: $smoke-bg;\n        }\n      }\n      &.react-select__option--is-disabled {\n        &,&:active{\n          color: #cccccc;\n          cursor: default;\n        }\n      }\n    }\n  }\n  .react-select__control{\n    border-radius: 30px;\n    min-height: 37px;\n    height: 37px;\n    box-sizing: border-box;\n    border-collapse: separate;\n    display: table;\n    width: 100%;\n    &,&:hover{\n      border: 1px solid $light-gray;\n      box-shadow: none;\n      background-color: transparent;\n    }\n    &.react-select__control--is-focused{\n      .react-select__dropdown-indicator{\n        &:after{\n          transform: rotate(180deg);\n          top: -4px;\n        }\n      }\n      &,&:hover{\n        border: 1px solid $primary-color;\n        box-shadow: none;\n      }\n    }\n    .react-select__value-container--has-value{\n      .react-select__multi-value{\n        display: inline-flex;\n        border-radius: 30px;\n        background-color: transparent;\n        & + div:not(.react-select__multi-value){\n          display: inline-flex;\n        }\n        .react-select__multi-value__label{\n          font-size: 0.9em;\n        }\n      }\n      .react-select__single-value{\n        top: 48%;\n        color: $black-color;\n      }\n    }\n    .react-select__placeholder{\n      color: $dark-gray;\n      line-height: normal;\n      font-size: 0.8571em;\n      top: 48%;\n    }\n    .react-select__value-container,\n    .react-select__indicators{\n      display: table-cell;\n    }\n    .react-select__indicators {\n      width: 60px;\n      padding-right: 10px;\n      align-items: flex-end;\n      vertical-align: middle;\n      text-align: right;\n      .react-select__indicator-separator{\n        display: none;\n      }\n      .react-select__indicator {\n        padding: 0;\n        display: inline-block;\n      }\n      .react-select__dropdown-indicator{\n        &:after{\n          transition: all 150ms ease 0s;\n          border-color: #999 transparent transparent;\n          border-style: solid;\n          border-width: 5px 5px 2.5px;\n          display: inline-block;\n          height: 0;\n          width: 0;\n          position: relative;\n          content: \"\";\n        }\n        &:hover:after{\n          border-top-color: $link-disabled-color;\n        }\n        & > * {\n          display: none;\n        }\n      }\n      .react-select__clear-indicator{\n        &:before{\n          content: \"\\D7\";\n          display: inline-block;\n          font-size: 18px;\n          line-height: 1;\n          top: 2px;\n          position: relative;\n          margin-right: 3px;\n        }\n        & > * {\n          display: none;\n        }\n      }\n    }\n  }\n  &.react-select-primary{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $primary-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $primary-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $primary-color;\n      .react-select__multi-value__remove{\n        color: $light-blue;\n        border-left: 1px solid $light-blue;\n        &:hover{\n          color: $primary-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.react-select-success{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $success-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $success-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $success-color;\n      .react-select__multi-value__remove{\n        color: $light-green;\n        border-left: 1px solid $light-green;\n        &:hover{\n          color: $success-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.react-select-info{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $info-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $info-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $info-color;\n      .react-select__multi-value__remove{\n        color: $light-azure;\n        border-left: 1px solid $light-azure;\n        &:hover{\n          color: $info-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.react-select-warning{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $warning-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $warning-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $warning-color;\n      .react-select__multi-value__remove{\n        color: $light-orange;\n        border-left: 1px solid $light-orange;\n        &:hover{\n          color: $warning-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.react-select-danger{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $danger-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $danger-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $danger-color;\n      .react-select__multi-value__remove{\n        color: $light-red;\n        border-left: 1px solid $light-red;\n        &:hover{\n          color: $danger-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  &.react-select-white{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $white-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $white-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $white-color;\n      .react-select__multi-value__remove{\n        color: $white-color;\n        border-left: 1px solid $white-color;\n        &:hover{\n          color: $white-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .react-select__multi-value{\n    border: 1px solid $dark-gray;\n    .react-select__multi-value__remove{\n      position: relative;\n      color: rgba(222,222,222, .8);\n      border-left: 1px solid rgba(222,222,222, .8);\n      &:hover{\n        color: $dark-gray;\n        background-color: transparent;\n      }\n    }\n  }\n  &.react-select--is-disabled{\n    .react-select__multi-value--is-disabled{\n      .react-select__multi-value__remove {\n        display: none;\n      }\n      &.react-select__multi-value{\n        background-color: #fcfcfc;\n        border: 1px solid #e3e3e3;\n      }\n    }\n    .react-select__control--is-disabled{\n      background-color: #f9f9f9;\n    }\n  }\n  .react-select__multi-value__remove {\n    border-radius: 0;\n  }\n}\n","// Based on the original react-tagsinput styles\n\n.react-tagsinput {\n  display: inline-block;\n  padding: 4px 6px;\n  max-width: 100%;\n  line-height: 22px;\n}\n\n.react-tagsinput-tag {\n  cursor: pointer;\n  margin: 5px 3px 5px 0;\n  position: relative;\n  padding: 3px 8px;\n  border-radius: 12px;\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 0.75em;\n  text-transform: uppercase;\n  display: inline-block;\n  line-height: 1.5em;\n  padding-left: 0.8em;\n}\n\n.react-tagsinput-remove {\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.react-tagsinput-tag a::before {\n  font-family: \"Nucleo Outline\";\n  content: \"\\ea53\";\n  padding: 0px 2px;\n}\n.react-tagsinput-tag a {\n  cursor: pointer;\n  position: absolute;\n  top: 3px;\n  right: 0px;\n  opacity: 0;\n  background-color: transparent;\n}\n\n.react-tagsinput-input {\n  background: transparent;\n  border: 0;\n  color: #777;\n  font-family: sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 6px;\n  margin-top: 1px;\n  outline: none;\n  padding: 5px;\n  width: 80px;\n}\n\n.react-tagsinput {\n  .react-tagsinput-tag {\n    -webkit-transition: all 300ms ease 0s;\n    -moz-transition: all 300ms ease 0s;\n    -o-transition: all 300ms ease 0s;\n    -ms-transition: all 300ms ease 0s;\n    transition: all 300ms ease 0s;\n\n    &:hover {\n      padding-right: 22px;\n\n      a {\n        opacity: 1;\n        padding-right: 4px;\n      }\n    }\n  }\n}\n","*:focus{\n  outline: none;\n}\n.navbar{\n  .input-group,\n  .form-group {\n    margin-bottom: 0;\n  }\n}\n",".blockquote{\n    &.blockquote-info{\n        border-color: $info-color;\n        color: $info-color;\n\n        small{\n            color: $info-color;\n        }\n    }\n}\n",".carousel-control-next, .carousel-control-prev {\n  z-index: 1000;\n}\n",".dropdown-menu a.dropdown-header[tabindex=\"-1\"]{\n  color: hsla(0,0%,71%,.6);\n  font-size: .7142em;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.dropdown-menu.dropdown-menu-right{\n  right: 0 !important;\n  left: auto !important;\n}\n",".fileinput input[type=file] {\n  display: none;\n}\n",".modal.modal-mini .modal-profile i {\n  color: $info-color;\n  font-size: 21px;\n}\n.modal .modal-login{\n  margin-right: auto;\n  margin-left: auto;\n}\n",".popover{\n  .arrow:before {\n    border-color: transparent !important;\n  }\n}\n\n.popover-primary{\n  .popover{\n    @include popover-color($primary-color, $white-color);\n    .arrow:after {\n      border-left-color: $primary-color;\n    }\n  }\n}\n\n.popover-info{\n  .popover{\n    @include popover-color($info-color, $white-color);\n    .arrow:after {\n      border-left-color: $info-color;\n    }\n  }\n}\n\n.popover-warning{\n  .popover{\n    @include popover-color($warning-color, $white-color);\n    .arrow:after {\n      border-left-color: $warning-color;\n    }\n  }\n}\n\n.popover-danger{\n  .popover{\n    @include popover-color($danger-color, $white-color);\n    .arrow:after {\n      border-left-color: $danger-color;\n    }\n  }\n}\n\n.popover-success{\n  .popover{\n    @include popover-color($success-color, $white-color);\n    .arrow:after {\n      border-left-color: $success-color;\n    }\n  }\n}\n",".bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before{\n  border-left-color: $white-bg;\n}\n.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before{\n  border-right-color: $white-bg;\n}\n.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before{\n  border-top-color: $white-bg;\n}\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before{\n  border-bottom-color: $white-bg;\n}\n",".page-header footer {\n  position: relative;\n}\n","[filter-color=\"blue\"],.clear-filter[filter-color=\"blue\"] {\n  @include linear-gradient(rgba($black-color,.20), rgba(3, 161, 224, 0.6));\n}\n[data-background-color=\"blue\"]{\n    background-color: $info-color;\n}\n.section-nucleo-icons .icons-container i:nth-child(6) {\n  color: $info-color;\n}\n.page-header{\n  &.page-header-small{\n    min-height: 60vh;\n    max-height: 640px;\n  }\n  > .content {\n    margin: 80px 0;\n  }\n}\n.signup-page .page-header {\n  display: flex;\n  align-items: center;\n}\n.login-page .page-header > .content, .signup-page .page-header > .content {\n  width: 100%;\n}\n.signup-page .card-signup {\n  margin-bottom: 0;\n}\n.login-page .page-header {\n  display: flex;\n  align-items: center;\n}\n","@media screen and (max-width: 991px){\n  .sidebar-collapse .navbar-collapse:before {\n    background: $info-color;\n    background: linear-gradient($info-color,$black-color 80%);\n  }\n  .navbar-nav .dropdown-menu {\n    position: static !important;\n  }\n}\n\n@media screen and (max-width: 768px){\n  .nav-tabs {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .login-page .page-header .content{\n    top: 30%;\n  }\n  .signup-page .page-header {\n    flex-direction: column;\n  }\n  .login-page .page-header{\n    flex-direction: column;\n    justify-content: space-between;\n    & > .content {\n      margin-top: 130px;\n    }\n  }\n}\n@media screen and (min-width: 768px){\n  .page-header footer {\n    position: absolute;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
